module.exports = {
    2024: [
        { "id": 17543, "year": 2024, "is_wenli": 2, "score": 709, "ranking": 10, "num": 10 },
        { "id": 17544, "year": 2024, "is_wenli": 2, "score": 708, "ranking": 13, "num": 3 },
        { "id": 17545, "year": 2024, "is_wenli": 2, "score": 707, "ranking": 17, "num": 4 },
        { "id": 17546, "year": 2024, "is_wenli": 2, "score": 706, "ranking": 21, "num": 4 },
        { "id": 17547, "year": 2024, "is_wenli": 2, "score": 705, "ranking": 23, "num": 2 },
        { "id": 17548, "year": 2024, "is_wenli": 2, "score": 704, "ranking": 28, "num": 5 },
        { "id": 17549, "year": 2024, "is_wenli": 2, "score": 703, "ranking": 33, "num": 5 },
        { "id": 17550, "year": 2024, "is_wenli": 2, "score": 702, "ranking": 38, "num": 5 },
        { "id": 17551, "year": 2024, "is_wenli": 2, "score": 701, "ranking": 43, "num": 5 },
        { "id": 17552, "year": 2024, "is_wenli": 2, "score": 700, "ranking": 52, "num": 9 },
        { "id": 17553, "year": 2024, "is_wenli": 2, "score": 699, "ranking": 64, "num": 12 },
        { "id": 17554, "year": 2024, "is_wenli": 2, "score": 698, "ranking": 75, "num": 11 },
        { "id": 17555, "year": 2024, "is_wenli": 2, "score": 697, "ranking": 81, "num": 6 },
        { "id": 17556, "year": 2024, "is_wenli": 2, "score": 696, "ranking": 94, "num": 13 },
        { "id": 17557, "year": 2024, "is_wenli": 2, "score": 695, "ranking": 111, "num": 17 },
        { "id": 17558, "year": 2024, "is_wenli": 2, "score": 694, "ranking": 128, "num": 17 },
        { "id": 17559, "year": 2024, "is_wenli": 2, "score": 693, "ranking": 150, "num": 22 },
        { "id": 17560, "year": 2024, "is_wenli": 2, "score": 692, "ranking": 174, "num": 24 },
        { "id": 17561, "year": 2024, "is_wenli": 2, "score": 691, "ranking": 193, "num": 19 },
        { "id": 17562, "year": 2024, "is_wenli": 2, "score": 690, "ranking": 215, "num": 22 },
        { "id": 17563, "year": 2024, "is_wenli": 2, "score": 689, "ranking": 239, "num": 24 },
        { "id": 17564, "year": 2024, "is_wenli": 2, "score": 688, "ranking": 274, "num": 35 },
        { "id": 17565, "year": 2024, "is_wenli": 2, "score": 687, "ranking": 304, "num": 30 },
        { "id": 17566, "year": 2024, "is_wenli": 2, "score": 686, "ranking": 341, "num": 37 },
        { "id": 17567, "year": 2024, "is_wenli": 2, "score": 685, "ranking": 369, "num": 28 },
        { "id": 17568, "year": 2024, "is_wenli": 2, "score": 684, "ranking": 408, "num": 39 }, { "id": 17569, "year": 2024, "is_wenli": 2, "score": 683, "ranking": 444, "num": 36 }, { "id": 17570, "year": 2024, "is_wenli": 2, "score": 682, "ranking": 491, "num": 47 }, { "id": 17571, "year": 2024, "is_wenli": 2, "score": 681, "ranking": 521, "num": 30 }, { "id": 17572, "year": 2024, "is_wenli": 2, "score": 680, "ranking": 573, "num": 52 }, { "id": 17573, "year": 2024, "is_wenli": 2, "score": 679, "ranking": 608, "num": 35 }, { "id": 17574, "year": 2024, "is_wenli": 2, "score": 678, "ranking": 684, "num": 76 }, { "id": 17575, "year": 2024, "is_wenli": 2, "score": 677, "ranking": 746, "num": 62 }, { "id": 17576, "year": 2024, "is_wenli": 2, "score": 676, "ranking": 812, "num": 66 }, { "id": 17577, "year": 2024, "is_wenli": 2, "score": 675, "ranking": 881, "num": 69 }, { "id": 17578, "year": 2024, "is_wenli": 2, "score": 674, "ranking": 958, "num": 77 }, { "id": 17579, "year": 2024, "is_wenli": 2, "score": 673, "ranking": 1024, "num": 66 }, { "id": 17580, "year": 2024, "is_wenli": 2, "score": 672, "ranking": 1095, "num": 71 }, { "id": 17581, "year": 2024, "is_wenli": 2, "score": 671, "ranking": 1180, "num": 85 }, { "id": 17582, "year": 2024, "is_wenli": 2, "score": 670, "ranking": 1246, "num": 66 }, { "id": 17583, "year": 2024, "is_wenli": 2, "score": 669, "ranking": 1318, "num": 72 }, { "id": 17584, "year": 2024, "is_wenli": 2, "score": 668, "ranking": 1410, "num": 92 }, { "id": 17585, "year": 2024, "is_wenli": 2, "score": 667, "ranking": 1509, "num": 99 }, { "id": 17586, "year": 2024, "is_wenli": 2, "score": 666, "ranking": 1604, "num": 95 }, { "id": 17587, "year": 2024, "is_wenli": 2, "score": 665, "ranking": 1714, "num": 110 }, { "id": 17588, "year": 2024, "is_wenli": 2, "score": 664, "ranking": 1823, "num": 109 }, { "id": 17589, "year": 2024, "is_wenli": 2, "score": 663, "ranking": 1942, "num": 119 }, { "id": 17590, "year": 2024, "is_wenli": 2, "score": 662, "ranking": 2051, "num": 109 }, { "id": 17591, "year": 2024, "is_wenli": 2, "score": 661, "ranking": 2157, "num": 106 }, { "id": 17592, "year": 2024, "is_wenli": 2, "score": 660, "ranking": 2272, "num": 115 }, { "id": 17593, "year": 2024, "is_wenli": 2, "score": 659, "ranking": 2405, "num": 133 }, { "id": 17594, "year": 2024, "is_wenli": 2, "score": 658, "ranking": 2546, "num": 141 }, { "id": 17595, "year": 2024, "is_wenli": 2, "score": 657, "ranking": 2662, "num": 116 }, { "id": 17596, "year": 2024, "is_wenli": 2, "score": 656, "ranking": 2809, "num": 147 }, { "id": 17597, "year": 2024, "is_wenli": 2, "score": 655, "ranking": 2955, "num": 146 }, { "id": 17598, "year": 2024, "is_wenli": 2, "score": 654, "ranking": 3120, "num": 165 }, { "id": 17599, "year": 2024, "is_wenli": 2, "score": 653, "ranking": 3287, "num": 167 }, { "id": 17600, "year": 2024, "is_wenli": 2, "score": 652, "ranking": 3441, "num": 154 }, { "id": 17601, "year": 2024, "is_wenli": 2, "score": 651, "ranking": 3608, "num": 167 }, { "id": 17602, "year": 2024, "is_wenli": 2, "score": 650, "ranking": 3784, "num": 176 }, { "id": 17603, "year": 2024, "is_wenli": 2, "score": 649, "ranking": 3955, "num": 171 }, { "id": 17604, "year": 2024, "is_wenli": 2, "score": 648, "ranking": 4153, "num": 198 }, { "id": 17605, "year": 2024, "is_wenli": 2, "score": 647, "ranking": 4332, "num": 179 }, { "id": 17606, "year": 2024, "is_wenli": 2, "score": 646, "ranking": 4551, "num": 219 }, { "id": 17607, "year": 2024, "is_wenli": 2, "score": 645, "ranking": 4744, "num": 193 }, { "id": 17608, "year": 2024, "is_wenli": 2, "score": 644, "ranking": 4966, "num": 222 }, { "id": 17609, "year": 2024, "is_wenli": 2, "score": 643, "ranking": 5177, "num": 211 }, { "id": 17610, "year": 2024, "is_wenli": 2, "score": 642, "ranking": 5385, "num": 208 }, { "id": 17611, "year": 2024, "is_wenli": 2, "score": 641, "ranking": 5635, "num": 250 }, { "id": 17612, "year": 2024, "is_wenli": 2, "score": 640, "ranking": 5855, "num": 220 }, { "id": 17613, "year": 2024, "is_wenli": 2, "score": 639, "ranking": 6120, "num": 265 }, { "id": 17614, "year": 2024, "is_wenli": 2, "score": 638, "ranking": 6413, "num": 293 }, { "id": 17615, "year": 2024, "is_wenli": 2, "score": 637, "ranking": 6669, "num": 256 }, { "id": 17616, "year": 2024, "is_wenli": 2, "score": 636, "ranking": 6965, "num": 296 }, { "id": 17617, "year": 2024, "is_wenli": 2, "score": 635, "ranking": 7249, "num": 284 }, { "id": 17618, "year": 2024, "is_wenli": 2, "score": 634, "ranking": 7548, "num": 299 }, { "id": 17619, "year": 2024, "is_wenli": 2, "score": 633, "ranking": 7831, "num": 283 }, { "id": 17620, "year": 2024, "is_wenli": 2, "score": 632, "ranking": 8139, "num": 308 }, { "id": 17621, "year": 2024, "is_wenli": 2, "score": 631, "ranking": 8444, "num": 305 }, { "id": 17622, "year": 2024, "is_wenli": 2, "score": 630, "ranking": 8810, "num": 366 }, { "id": 17623, "year": 2024, "is_wenli": 2, "score": 629, "ranking": 9133, "num": 323 }, { "id": 17624, "year": 2024, "is_wenli": 2, "score": 628, "ranking": 9498, "num": 365 }, { "id": 17625, "year": 2024, "is_wenli": 2, "score": 627, "ranking": 9839, "num": 341 }, { "id": 17626, "year": 2024, "is_wenli": 2, "score": 626, "ranking": 10188, "num": 349 }, { "id": 17627, "year": 2024, "is_wenli": 2, "score": 625, "ranking": 10592, "num": 404 }, { "id": 17628, "year": 2024, "is_wenli": 2, "score": 624, "ranking": 10962, "num": 370 }, { "id": 17629, "year": 2024, "is_wenli": 2, "score": 623, "ranking": 11363, "num": 401 }, { "id": 17630, "year": 2024, "is_wenli": 2, "score": 622, "ranking": 11767, "num": 404 }, { "id": 17631, "year": 2024, "is_wenli": 2, "score": 621, "ranking": 12204, "num": 437 }, { "id": 17632, "year": 2024, "is_wenli": 2, "score": 620, "ranking": 12607, "num": 403 }, { "id": 17633, "year": 2024, "is_wenli": 2, "score": 619, "ranking": 13028, "num": 421 }, { "id": 17634, "year": 2024, "is_wenli": 2, "score": 618, "ranking": 13475, "num": 447 }, { "id": 17635, "year": 2024, "is_wenli": 2, "score": 617, "ranking": 13941, "num": 466 }, { "id": 17636, "year": 2024, "is_wenli": 2, "score": 616, "ranking": 14396, "num": 455 }, { "id": 17637, "year": 2024, "is_wenli": 2, "score": 615, "ranking": 14891, "num": 495 }, { "id": 17638, "year": 2024, "is_wenli": 2, "score": 614, "ranking": 15402, "num": 511 }, { "id": 17639, "year": 2024, "is_wenli": 2, "score": 613, "ranking": 15913, "num": 511 }, { "id": 17640, "year": 2024, "is_wenli": 2, "score": 612, "ranking": 16488, "num": 575 }, { "id": 17641, "year": 2024, "is_wenli": 2, "score": 611, "ranking": 16982, "num": 494 }, { "id": 17642, "year": 2024, "is_wenli": 2, "score": 610, "ranking": 17519, "num": 537 }, { "id": 17643, "year": 2024, "is_wenli": 2, "score": 609, "ranking": 18059, "num": 540 }, { "id": 17644, "year": 2024, "is_wenli": 2, "score": 608, "ranking": 18642, "num": 583 }, { "id": 17645, "year": 2024, "is_wenli": 2, "score": 607, "ranking": 19256, "num": 614 }, { "id": 17646, "year": 2024, "is_wenli": 2, "score": 606, "ranking": 19869, "num": 613 }, { "id": 17647, "year": 2024, "is_wenli": 2, "score": 605, "ranking": 20456, "num": 587 }, { "id": 17648, "year": 2024, "is_wenli": 2, "score": 604, "ranking": 21039, "num": 583 }, { "id": 17649, "year": 2024, "is_wenli": 2, "score": 603, "ranking": 21656, "num": 617 }, { "id": 17650, "year": 2024, "is_wenli": 2, "score": 602, "ranking": 22336, "num": 680 }, { "id": 17651, "year": 2024, "is_wenli": 2, "score": 601, "ranking": 22963, "num": 627 }, { "id": 17652, "year": 2024, "is_wenli": 2, "score": 600, "ranking": 23638, "num": 675 }, { "id": 17653, "year": 2024, "is_wenli": 2, "score": 599, "ranking": 24309, "num": 671 }, { "id": 17654, "year": 2024, "is_wenli": 2, "score": 598, "ranking": 25049, "num": 740 }, { "id": 17655, "year": 2024, "is_wenli": 2, "score": 597, "ranking": 25762, "num": 713 }, { "id": 17656, "year": 2024, "is_wenli": 2, "score": 596, "ranking": 26465, "num": 703 }, { "id": 17657, "year": 2024, "is_wenli": 2, "score": 595, "ranking": 27214, "num": 749 }, { "id": 17658, "year": 2024, "is_wenli": 2, "score": 594, "ranking": 27919, "num": 705 }, { "id": 17659, "year": 2024, "is_wenli": 2, "score": 593, "ranking": 28637, "num": 718 }, { "id": 17660, "year": 2024, "is_wenli": 2, "score": 592, "ranking": 29369, "num": 732 }, { "id": 17661, "year": 2024, "is_wenli": 2, "score": 591, "ranking": 30123, "num": 754 }, { "id": 17662, "year": 2024, "is_wenli": 2, "score": 590, "ranking": 30887, "num": 764 }, { "id": 17663, "year": 2024, "is_wenli": 2, "score": 589, "ranking": 31680, "num": 793 }, { "id": 17664, "year": 2024, "is_wenli": 2, "score": 588, "ranking": 32528, "num": 848 }, { "id": 17665, "year": 2024, "is_wenli": 2, "score": 587, "ranking": 33383, "num": 855 }, { "id": 17666, "year": 2024, "is_wenli": 2, "score": 586, "ranking": 34230, "num": 847 }, { "id": 17667, "year": 2024, "is_wenli": 2, "score": 585, "ranking": 35066, "num": 836 }, { "id": 17668, "year": 2024, "is_wenli": 2, "score": 584, "ranking": 35948, "num": 882 }, { "id": 17669, "year": 2024, "is_wenli": 2, "score": 583, "ranking": 36841, "num": 893 }, { "id": 17670, "year": 2024, "is_wenli": 2, "score": 582, "ranking": 37744, "num": 903 }, { "id": 17671, "year": 2024, "is_wenli": 2, "score": 581, "ranking": 38682, "num": 938 }, { "id": 17672, "year": 2024, "is_wenli": 2, "score": 580, "ranking": 39605, "num": 923 }, { "id": 17673, "year": 2024, "is_wenli": 2, "score": 579, "ranking": 40541, "num": 936 }, { "id": 17674, "year": 2024, "is_wenli": 2, "score": 578, "ranking": 41509, "num": 968 }, { "id": 17675, "year": 2024, "is_wenli": 2, "score": 577, "ranking": 42445, "num": 936 }, { "id": 17676, "year": 2024, "is_wenli": 2, "score": 576, "ranking": 43459, "num": 1014 }, { "id": 17677, "year": 2024, "is_wenli": 2, "score": 575, "ranking": 44463, "num": 1004 }, { "id": 17678, "year": 2024, "is_wenli": 2, "score": 574, "ranking": 45456, "num": 993 }, { "id": 17679, "year": 2024, "is_wenli": 2, "score": 573, "ranking": 46513, "num": 1057 }, { "id": 17680, "year": 2024, "is_wenli": 2, "score": 572, "ranking": 47548, "num": 1035 }, { "id": 17681, "year": 2024, "is_wenli": 2, "score": 571, "ranking": 48594, "num": 1046 }, { "id": 17682, "year": 2024, "is_wenli": 2, "score": 570, "ranking": 49566, "num": 972 }, { "id": 17683, "year": 2024, "is_wenli": 2, "score": 569, "ranking": 50642, "num": 1076 }, { "id": 17684, "year": 2024, "is_wenli": 2, "score": 568, "ranking": 51686, "num": 1044 }, { "id": 17685, "year": 2024, "is_wenli": 2, "score": 567, "ranking": 52721, "num": 1035 }, { "id": 17686, "year": 2024, "is_wenli": 2, "score": 566, "ranking": 53909, "num": 1188 }, { "id": 17687, "year": 2024, "is_wenli": 2, "score": 565, "ranking": 55035, "num": 1126 }, { "id": 17688, "year": 2024, "is_wenli": 2, "score": 564, "ranking": 56189, "num": 1154 }, { "id": 17689, "year": 2024, "is_wenli": 2, "score": 563, "ranking": 57281, "num": 1092 }, { "id": 17690, "year": 2024, "is_wenli": 2, "score": 562, "ranking": 58400, "num": 1119 }, { "id": 17691, "year": 2024, "is_wenli": 2, "score": 561, "ranking": 59579, "num": 1179 }, { "id": 17692, "year": 2024, "is_wenli": 2, "score": 560, "ranking": 60745, "num": 1166 }, { "id": 17693, "year": 2024, "is_wenli": 2, "score": 559, "ranking": 61939, "num": 1194 }, { "id": 17694, "year": 2024, "is_wenli": 2, "score": 558, "ranking": 63132, "num": 1193 }, { "id": 17695, "year": 2024, "is_wenli": 2, "score": 557, "ranking": 64313, "num": 1181 }, { "id": 17696, "year": 2024, "is_wenli": 2, "score": 556, "ranking": 65558, "num": 1245 }, { "id": 17697, "year": 2024, "is_wenli": 2, "score": 555, "ranking": 66810, "num": 1252 }, { "id": 17698, "year": 2024, "is_wenli": 2, "score": 554, "ranking": 68050, "num": 1240 }, { "id": 17699, "year": 2024, "is_wenli": 2, "score": 553, "ranking": 69342, "num": 1292 }, { "id": 17700, "year": 2024, "is_wenli": 2, "score": 552, "ranking": 70602, "num": 1260 }, { "id": 17701, "year": 2024, "is_wenli": 2, "score": 551, "ranking": 71851, "num": 1249 }, { "id": 17702, "year": 2024, "is_wenli": 2, "score": 550, "ranking": 73108, "num": 1257 }, { "id": 17703, "year": 2024, "is_wenli": 2, "score": 549, "ranking": 74409, "num": 1301 }, { "id": 17704, "year": 2024, "is_wenli": 2, "score": 548, "ranking": 75686, "num": 1277 }, { "id": 17705, "year": 2024, "is_wenli": 2, "score": 547, "ranking": 77002, "num": 1316 }, { "id": 17706, "year": 2024, "is_wenli": 2, "score": 546, "ranking": 78339, "num": 1337 }, { "id": 17707, "year": 2024, "is_wenli": 2, "score": 545, "ranking": 79655, "num": 1316 }, { "id": 17708, "year": 2024, "is_wenli": 2, "score": 544, "ranking": 80952, "num": 1297 }, { "id": 17709, "year": 2024, "is_wenli": 2, "score": 543, "ranking": 82340, "num": 1388 }, { "id": 17710, "year": 2024, "is_wenli": 2, "score": 542, "ranking": 83672, "num": 1332 }, { "id": 17711, "year": 2024, "is_wenli": 2, "score": 541, "ranking": 84991, "num": 1319 }, { "id": 17712, "year": 2024, "is_wenli": 2, "score": 540, "ranking": 86324, "num": 1333 }, { "id": 17713, "year": 2024, "is_wenli": 2, "score": 539, "ranking": 87758, "num": 1434 }, { "id": 17714, "year": 2024, "is_wenli": 2, "score": 538, "ranking": 89194, "num": 1436 }, { "id": 17715, "year": 2024, "is_wenli": 2, "score": 537, "ranking": 90628, "num": 1434 }, { "id": 17716, "year": 2024, "is_wenli": 2, "score": 536, "ranking": 92030, "num": 1402 }, { "id": 17717, "year": 2024, "is_wenli": 2, "score": 535, "ranking": 93451, "num": 1421 }, { "id": 17718, "year": 2024, "is_wenli": 2, "score": 534, "ranking": 94894, "num": 1443 }, { "id": 17719, "year": 2024, "is_wenli": 2, "score": 533, "ranking": 96379, "num": 1485 }, { "id": 17720, "year": 2024, "is_wenli": 2, "score": 532, "ranking": 97837, "num": 1458 }, { "id": 17721, "year": 2024, "is_wenli": 2, "score": 531, "ranking": 99299, "num": 1462 }, { "id": 17722, "year": 2024, "is_wenli": 2, "score": 530, "ranking": 100737, "num": 1438 }, { "id": 17723, "year": 2024, "is_wenli": 2, "score": 529, "ranking": 102211, "num": 1474 }, { "id": 17724, "year": 2024, "is_wenli": 2, "score": 528, "ranking": 103674, "num": 1463 }, { "id": 17725, "year": 2024, "is_wenli": 2, "score": 527, "ranking": 105160, "num": 1486 }, { "id": 17726, "year": 2024, "is_wenli": 2, "score": 526, "ranking": 106610, "num": 1450 }, { "id": 17727, "year": 2024, "is_wenli": 2, "score": 525, "ranking": 108197, "num": 1587 }, { "id": 17728, "year": 2024, "is_wenli": 2, "score": 524, "ranking": 109654, "num": 1457 }, { "id": 17729, "year": 2024, "is_wenli": 2, "score": 523, "ranking": 111166, "num": 1512 }, { "id": 17730, "year": 2024, "is_wenli": 2, "score": 522, "ranking": 112738, "num": 1572 }, { "id": 17731, "year": 2024, "is_wenli": 2, "score": 521, "ranking": 114271, "num": 1533 }, { "id": 17732, "year": 2024, "is_wenli": 2, "score": 520, "ranking": 115830, "num": 1559 }, { "id": 17733, "year": 2024, "is_wenli": 2, "score": 519, "ranking": 117381, "num": 1551 }, { "id": 17734, "year": 2024, "is_wenli": 2, "score": 518, "ranking": 118997, "num": 1616 }, { "id": 17735, "year": 2024, "is_wenli": 2, "score": 517, "ranking": 120583, "num": 1586 }, { "id": 17736, "year": 2024, "is_wenli": 2, "score": 516, "ranking": 122158, "num": 1575 }, { "id": 17737, "year": 2024, "is_wenli": 2, "score": 515, "ranking": 123701, "num": 1543 }, { "id": 17738, "year": 2024, "is_wenli": 2, "score": 514, "ranking": 125279, "num": 1578 }, { "id": 17739, "year": 2024, "is_wenli": 2, "score": 513, "ranking": 126985, "num": 1706 }, { "id": 17740, "year": 2024, "is_wenli": 2, "score": 512, "ranking": 128582, "num": 1597 }, { "id": 17741, "year": 2024, "is_wenli": 2, "score": 511, "ranking": 130195, "num": 1613 }, { "id": 17742, "year": 2024, "is_wenli": 2, "score": 510, "ranking": 131720, "num": 1525 }, { "id": 17743, "year": 2024, "is_wenli": 2, "score": 509, "ranking": 133259, "num": 1539 }, { "id": 17744, "year": 2024, "is_wenli": 2, "score": 508, "ranking": 134903, "num": 1644 }, { "id": 17745, "year": 2024, "is_wenli": 2, "score": 507, "ranking": 136483, "num": 1580 }, { "id": 17746, "year": 2024, "is_wenli": 2, "score": 506, "ranking": 138119, "num": 1636 }, { "id": 17747, "year": 2024, "is_wenli": 2, "score": 505, "ranking": 139708, "num": 1589 }, { "id": 17748, "year": 2024, "is_wenli": 2, "score": 504, "ranking": 141292, "num": 1584 }, { "id": 17749, "year": 2024, "is_wenli": 2, "score": 503, "ranking": 142935, "num": 1643 }, { "id": 17750, "year": 2024, "is_wenli": 2, "score": 502, "ranking": 144581, "num": 1646 }, { "id": 17751, "year": 2024, "is_wenli": 2, "score": 501, "ranking": 146167, "num": 1586 }, { "id": 17752, "year": 2024, "is_wenli": 2, "score": 500, "ranking": 147838, "num": 1671 }, { "id": 17753, "year": 2024, "is_wenli": 2, "score": 499, "ranking": 149493, "num": 1655 }, { "id": 17754, "year": 2024, "is_wenli": 2, "score": 498, "ranking": 151084, "num": 1591 }, { "id": 17755, "year": 2024, "is_wenli": 2, "score": 497, "ranking": 152728, "num": 1644 }, { "id": 17756, "year": 2024, "is_wenli": 2, "score": 496, "ranking": 154335, "num": 1607 }, { "id": 17757, "year": 2024, "is_wenli": 2, "score": 495, "ranking": 156006, "num": 1671 }, { "id": 17758, "year": 2024, "is_wenli": 2, "score": 494, "ranking": 157652, "num": 1646 }, { "id": 17759, "year": 2024, "is_wenli": 2, "score": 493, "ranking": 159343, "num": 1691 }, { "id": 17760, "year": 2024, "is_wenli": 2, "score": 492, "ranking": 161015, "num": 1672 }, { "id": 17761, "year": 2024, "is_wenli": 2, "score": 491, "ranking": 162618, "num": 1603 }, { "id": 17762, "year": 2024, "is_wenli": 2, "score": 490, "ranking": 164286, "num": 1668 }, { "id": 17763, "year": 2024, "is_wenli": 2, "score": 489, "ranking": 165958, "num": 1672 }, { "id": 17764, "year": 2024, "is_wenli": 2, "score": 488, "ranking": 167608, "num": 1650 }, { "id": 17765, "year": 2024, "is_wenli": 2, "score": 487, "ranking": 169371, "num": 1763 }, { "id": 17766, "year": 2024, "is_wenli": 2, "score": 486, "ranking": 171003, "num": 1632 }, { "id": 17767, "year": 2024, "is_wenli": 2, "score": 485, "ranking": 172731, "num": 1728 }, { "id": 17768, "year": 2024, "is_wenli": 2, "score": 484, "ranking": 174483, "num": 1752 }, { "id": 17769, "year": 2024, "is_wenli": 2, "score": 483, "ranking": 176170, "num": 1687 }, { "id": 17770, "year": 2024, "is_wenli": 2, "score": 482, "ranking": 177930, "num": 1760 }, { "id": 17771, "year": 2024, "is_wenli": 2, "score": 481, "ranking": 179627, "num": 1697 }, { "id": 17772, "year": 2024, "is_wenli": 2, "score": 480, "ranking": 181368, "num": 1741 }, { "id": 17773, "year": 2024, "is_wenli": 2, "score": 479, "ranking": 183057, "num": 1689 }, { "id": 17774, "year": 2024, "is_wenli": 2, "score": 478, "ranking": 184813, "num": 1756 }, { "id": 17775, "year": 2024, "is_wenli": 2, "score": 477, "ranking": 186562, "num": 1749 }, { "id": 17776, "year": 2024, "is_wenli": 2, "score": 476, "ranking": 188251, "num": 1689 }, { "id": 17777, "year": 2024, "is_wenli": 2, "score": 475, "ranking": 190019, "num": 1768 }, { "id": 17778, "year": 2024, "is_wenli": 2, "score": 474, "ranking": 191769, "num": 1750 }, { "id": 17779, "year": 2024, "is_wenli": 2, "score": 473, "ranking": 193459, "num": 1690 }, { "id": 17780, "year": 2024, "is_wenli": 2, "score": 472, "ranking": 195178, "num": 1719 }, { "id": 17781, "year": 2024, "is_wenli": 2, "score": 471, "ranking": 196900, "num": 1722 }, { "id": 17782, "year": 2024, "is_wenli": 2, "score": 470, "ranking": 198702, "num": 1802 }, { "id": 17783, "year": 2024, "is_wenli": 2, "score": 469, "ranking": 200513, "num": 1811 }, { "id": 17784, "year": 2024, "is_wenli": 2, "score": 468, "ranking": 202264, "num": 1751 }, { "id": 17785, "year": 2024, "is_wenli": 2, "score": 467, "ranking": 203994, "num": 1730 }, { "id": 17786, "year": 2024, "is_wenli": 2, "score": 466, "ranking": 205769, "num": 1775 }, { "id": 17787, "year": 2024, "is_wenli": 2, "score": 465, "ranking": 207458, "num": 1689 }, { "id": 17788, "year": 2024, "is_wenli": 2, "score": 464, "ranking": 209249, "num": 1791 }, { "id": 17789, "year": 2024, "is_wenli": 2, "score": 463, "ranking": 211008, "num": 1759 }, { "id": 17790, "year": 2024, "is_wenli": 2, "score": 462, "ranking": 212758, "num": 1750 }, { "id": 17791, "year": 2024, "is_wenli": 2, "score": 461, "ranking": 214397, "num": 1639 }, { "id": 17792, "year": 2024, "is_wenli": 2, "score": 460, "ranking": 216209, "num": 1812 }, { "id": 17793, "year": 2024, "is_wenli": 2, "score": 459, "ranking": 217964, "num": 1755 }, { "id": 17794, "year": 2024, "is_wenli": 2, "score": 458, "ranking": 219683, "num": 1719 }, { "id": 17795, "year": 2024, "is_wenli": 2, "score": 457, "ranking": 221441, "num": 1758 }, { "id": 17796, "year": 2024, "is_wenli": 2, "score": 456, "ranking": 223279, "num": 1838 }, { "id": 17797, "year": 2024, "is_wenli": 2, "score": 455, "ranking": 225087, "num": 1808 }, { "id": 17798, "year": 2024, "is_wenli": 2, "score": 454, "ranking": 226897, "num": 1810 }, { "id": 17799, "year": 2024, "is_wenli": 2, "score": 453, "ranking": 228675, "num": 1778 }, { "id": 17800, "year": 2024, "is_wenli": 2, "score": 452, "ranking": 230437, "num": 1762 }, { "id": 17801, "year": 2024, "is_wenli": 2, "score": 451, "ranking": 232242, "num": 1805 }, { "id": 17802, "year": 2024, "is_wenli": 2, "score": 450, "ranking": 234011, "num": 1769 }, { "id": 17803, "year": 2024, "is_wenli": 2, "score": 449, "ranking": 235779, "num": 1768 }, { "id": 17804, "year": 2024, "is_wenli": 2, "score": 448, "ranking": 237583, "num": 1804 }, { "id": 17805, "year": 2024, "is_wenli": 2, "score": 447, "ranking": 239333, "num": 1750 }, { "id": 17806, "year": 2024, "is_wenli": 2, "score": 446, "ranking": 241179, "num": 1846 }, { "id": 17807, "year": 2024, "is_wenli": 2, "score": 445, "ranking": 242940, "num": 1761 }, { "id": 17808, "year": 2024, "is_wenli": 2, "score": 444, "ranking": 244694, "num": 1754 }, { "id": 17809, "year": 2024, "is_wenli": 2, "score": 443, "ranking": 246430, "num": 1736 }, { "id": 17810, "year": 2024, "is_wenli": 2, "score": 442, "ranking": 248270, "num": 1840 }, { "id": 17811, "year": 2024, "is_wenli": 2, "score": 441, "ranking": 250029, "num": 1759 }, { "id": 17812, "year": 2024, "is_wenli": 2, "score": 440, "ranking": 251873, "num": 1844 }, { "id": 17813, "year": 2024, "is_wenli": 2, "score": 439, "ranking": 253700, "num": 1827 }, { "id": 17814, "year": 2024, "is_wenli": 2, "score": 438, "ranking": 255455, "num": 1755 }, { "id": 17815, "year": 2024, "is_wenli": 2, "score": 437, "ranking": 257272, "num": 1817 }, { "id": 17816, "year": 2024, "is_wenli": 2, "score": 436, "ranking": 259136, "num": 1864 }, { "id": 17817, "year": 2024, "is_wenli": 2, "score": 435, "ranking": 260986, "num": 1850 }, { "id": 17818, "year": 2024, "is_wenli": 2, "score": 434, "ranking": 262825, "num": 1839 }, { "id": 17819, "year": 2024, "is_wenli": 2, "score": 433, "ranking": 264630, "num": 1805 }, { "id": 17820, "year": 2024, "is_wenli": 2, "score": 432, "ranking": 266394, "num": 1764 }, { "id": 17821, "year": 2024, "is_wenli": 2, "score": 431, "ranking": 268186, "num": 1792 }, { "id": 17822, "year": 2024, "is_wenli": 2, "score": 430, "ranking": 269913, "num": 1727 }, { "id": 17823, "year": 2024, "is_wenli": 2, "score": 429, "ranking": 271716, "num": 1803 }, { "id": 17824, "year": 2024, "is_wenli": 2, "score": 428, "ranking": 273476, "num": 1760 }, { "id": 17825, "year": 2024, "is_wenli": 2, "score": 427, "ranking": 275266, "num": 1790 }, { "id": 17826, "year": 2024, "is_wenli": 2, "score": 426, "ranking": 277048, "num": 1782 }, { "id": 17827, "year": 2024, "is_wenli": 2, "score": 425, "ranking": 278855, "num": 1807 }, { "id": 17828, "year": 2024, "is_wenli": 2, "score": 424, "ranking": 280612, "num": 1757 }, { "id": 17829, "year": 2024, "is_wenli": 2, "score": 423, "ranking": 282437, "num": 1825 }, { "id": 17830, "year": 2024, "is_wenli": 2, "score": 422, "ranking": 284235, "num": 1798 }, { "id": 17831, "year": 2024, "is_wenli": 2, "score": 421, "ranking": 285999, "num": 1764 }, { "id": 17832, "year": 2024, "is_wenli": 2, "score": 420, "ranking": 287723, "num": 1724 }, { "id": 17833, "year": 2024, "is_wenli": 2, "score": 419, "ranking": 289496, "num": 1773 }, { "id": 17834, "year": 2024, "is_wenli": 2, "score": 418, "ranking": 291288, "num": 1792 }, { "id": 17835, "year": 2024, "is_wenli": 2, "score": 417, "ranking": 293048, "num": 1760 }, { "id": 17836, "year": 2024, "is_wenli": 2, "score": 416, "ranking": 294822, "num": 1774 }, { "id": 17837, "year": 2024, "is_wenli": 2, "score": 415, "ranking": 296534, "num": 1712 }, { "id": 17838, "year": 2024, "is_wenli": 2, "score": 414, "ranking": 298277, "num": 1743 }, { "id": 17839, "year": 2024, "is_wenli": 2, "score": 413, "ranking": 300034, "num": 1757 }, { "id": 17840, "year": 2024, "is_wenli": 2, "score": 412, "ranking": 301799, "num": 1765 }, { "id": 17841, "year": 2024, "is_wenli": 2, "score": 411, "ranking": 303568, "num": 1769 }, { "id": 17842, "year": 2024, "is_wenli": 2, "score": 410, "ranking": 305325, "num": 1757 }, { "id": 17843, "year": 2024, "is_wenli": 2, "score": 409, "ranking": 307060, "num": 1735 }, { "id": 17844, "year": 2024, "is_wenli": 2, "score": 408, "ranking": 308792, "num": 1732 }, { "id": 17845, "year": 2024, "is_wenli": 2, "score": 407, "ranking": 310571, "num": 1779 }, { "id": 17846, "year": 2024, "is_wenli": 2, "score": 406, "ranking": 312314, "num": 1743 }, { "id": 17847, "year": 2024, "is_wenli": 2, "score": 405, "ranking": 314080, "num": 1766 }, { "id": 17848, "year": 2024, "is_wenli": 2, "score": 404, "ranking": 315812, "num": 1732 }, { "id": 17849, "year": 2024, "is_wenli": 2, "score": 403, "ranking": 317600, "num": 1788 }, { "id": 17850, "year": 2024, "is_wenli": 2, "score": 402, "ranking": 319291, "num": 1691 }, { "id": 17851, "year": 2024, "is_wenli": 2, "score": 401, "ranking": 320980, "num": 1689 }, { "id": 17852, "year": 2024, "is_wenli": 2, "score": 400, "ranking": 322650, "num": 1670 }, { "id": 17853, "year": 2024, "is_wenli": 2, "score": 399, "ranking": 324400, "num": 1750 }, { "id": 17854, "year": 2024, "is_wenli": 2, "score": 398, "ranking": 326147, "num": 1747 }, { "id": 17855, "year": 2024, "is_wenli": 2, "score": 397, "ranking": 327848, "num": 1701 }, { "id": 17856, "year": 2024, "is_wenli": 2, "score": 396, "ranking": 329573, "num": 1725 }, { "id": 17857, "year": 2024, "is_wenli": 2, "score": 395, "ranking": 331325, "num": 1752 }, { "id": 17858, "year": 2024, "is_wenli": 2, "score": 394, "ranking": 333030, "num": 1705 }, { "id": 17859, "year": 2024, "is_wenli": 2, "score": 393, "ranking": 334686, "num": 1656 }, { "id": 17860, "year": 2024, "is_wenli": 2, "score": 392, "ranking": 336443, "num": 1757 }, { "id": 17861, "year": 2024, "is_wenli": 2, "score": 391, "ranking": 338138, "num": 1695 }, { "id": 17862, "year": 2024, "is_wenli": 2, "score": 390, "ranking": 339808, "num": 1670 }, { "id": 17863, "year": 2024, "is_wenli": 2, "score": 389, "ranking": 341412, "num": 1604 }, { "id": 17864, "year": 2024, "is_wenli": 2, "score": 388, "ranking": 343097, "num": 1685 }, { "id": 17865, "year": 2024, "is_wenli": 2, "score": 387, "ranking": 344813, "num": 1716 }, { "id": 17866, "year": 2024, "is_wenli": 2, "score": 386, "ranking": 346485, "num": 1672 }, { "id": 17867, "year": 2024, "is_wenli": 2, "score": 385, "ranking": 348182, "num": 1697 }, { "id": 17868, "year": 2024, "is_wenli": 2, "score": 384, "ranking": 349846, "num": 1664 }, { "id": 17869, "year": 2024, "is_wenli": 2, "score": 383, "ranking": 351526, "num": 1680 }, { "id": 17870, "year": 2024, "is_wenli": 2, "score": 382, "ranking": 353188, "num": 1662 }, { "id": 17871, "year": 2024, "is_wenli": 2, "score": 381, "ranking": 354786, "num": 1598 }, { "id": 17872, "year": 2024, "is_wenli": 2, "score": 380, "ranking": 356412, "num": 1626 }, { "id": 17873, "year": 2024, "is_wenli": 2, "score": 379, "ranking": 358004, "num": 1592 }, { "id": 17874, "year": 2024, "is_wenli": 2, "score": 378, "ranking": 359547, "num": 1543 }, { "id": 17875, "year": 2024, "is_wenli": 2, "score": 377, "ranking": 361135, "num": 1588 }, { "id": 17876, "year": 2024, "is_wenli": 2, "score": 376, "ranking": 362693, "num": 1558 }, { "id": 17877, "year": 2024, "is_wenli": 2, "score": 375, "ranking": 364280, "num": 1587 }, { "id": 17878, "year": 2024, "is_wenli": 2, "score": 374, "ranking": 365905, "num": 1625 }, { "id": 17879, "year": 2024, "is_wenli": 2, "score": 373, "ranking": 367585, "num": 1680 }, { "id": 17880, "year": 2024, "is_wenli": 2, "score": 372, "ranking": 369159, "num": 1574 }, { "id": 17881, "year": 2024, "is_wenli": 2, "score": 371, "ranking": 370743, "num": 1584 }, { "id": 17882, "year": 2024, "is_wenli": 2, "score": 370, "ranking": 372350, "num": 1607 }, { "id": 17883, "year": 2024, "is_wenli": 2, "score": 369, "ranking": 373892, "num": 1542 }, { "id": 17884, "year": 2024, "is_wenli": 2, "score": 368, "ranking": 375509, "num": 1617 }, { "id": 17885, "year": 2024, "is_wenli": 2, "score": 367, "ranking": 377065, "num": 1556 }, { "id": 17886, "year": 2024, "is_wenli": 2, "score": 366, "ranking": 378641, "num": 1576 }, { "id": 17887, "year": 2024, "is_wenli": 2, "score": 365, "ranking": 380189, "num": 1548 }, { "id": 17888, "year": 2024, "is_wenli": 2, "score": 364, "ranking": 381755, "num": 1566 }, { "id": 17889, "year": 2024, "is_wenli": 2, "score": 363, "ranking": 383398, "num": 1643 }, { "id": 17890, "year": 2024, "is_wenli": 2, "score": 362, "ranking": 384919, "num": 1521 }, { "id": 17891, "year": 2024, "is_wenli": 2, "score": 361, "ranking": 386390, "num": 1471 }, { "id": 17892, "year": 2024, "is_wenli": 2, "score": 360, "ranking": 387938, "num": 1548 }, { "id": 17893, "year": 2024, "is_wenli": 2, "score": 359, "ranking": 389572, "num": 1634 }, { "id": 17894, "year": 2024, "is_wenli": 2, "score": 358, "ranking": 391042, "num": 1470 }, { "id": 17895, "year": 2024, "is_wenli": 2, "score": 357, "ranking": 392568, "num": 1526 }, { "id": 17896, "year": 2024, "is_wenli": 2, "score": 356, "ranking": 394052, "num": 1484 }, { "id": 17897, "year": 2024, "is_wenli": 2, "score": 355, "ranking": 395540, "num": 1488 }, { "id": 17898, "year": 2024, "is_wenli": 2, "score": 354, "ranking": 397043, "num": 1503 }, { "id": 17899, "year": 2024, "is_wenli": 2, "score": 353, "ranking": 398566, "num": 1523 }, { "id": 17900, "year": 2024, "is_wenli": 2, "score": 352, "ranking": 400052, "num": 1486 }, { "id": 17901, "year": 2024, "is_wenli": 2, "score": 351, "ranking": 401555, "num": 1503 }, { "id": 17902, "year": 2024, "is_wenli": 2, "score": 350, "ranking": 402997, "num": 1442 }, { "id": 17903, "year": 2024, "is_wenli": 2, "score": 349, "ranking": 404491, "num": 1494 }, { "id": 17904, "year": 2024, "is_wenli": 2, "score": 348, "ranking": 405932, "num": 1441 }, { "id": 17905, "year": 2024, "is_wenli": 2, "score": 347, "ranking": 407394, "num": 1462 }, { "id": 17906, "year": 2024, "is_wenli": 2, "score": 346, "ranking": 408869, "num": 1475 }, { "id": 17907, "year": 2024, "is_wenli": 2, "score": 345, "ranking": 410328, "num": 1459 }, { "id": 17908, "year": 2024, "is_wenli": 2, "score": 344, "ranking": 411855, "num": 1527 }, { "id": 17909, "year": 2024, "is_wenli": 2, "score": 343, "ranking": 413310, "num": 1455 }, { "id": 17910, "year": 2024, "is_wenli": 2, "score": 342, "ranking": 414729, "num": 1419 }, { "id": 17911, "year": 2024, "is_wenli": 2, "score": 341, "ranking": 416122, "num": 1393 }, { "id": 17912, "year": 2024, "is_wenli": 2, "score": 340, "ranking": 417577, "num": 1455 }, { "id": 17913, "year": 2024, "is_wenli": 2, "score": 339, "ranking": 418987, "num": 1410 }, { "id": 17914, "year": 2024, "is_wenli": 2, "score": 338, "ranking": 420442, "num": 1455 }, { "id": 17915, "year": 2024, "is_wenli": 2, "score": 337, "ranking": 421837, "num": 1395 }, { "id": 17916, "year": 2024, "is_wenli": 2, "score": 336, "ranking": 423218, "num": 1381 }, { "id": 17917, "year": 2024, "is_wenli": 2, "score": 335, "ranking": 424687, "num": 1469 }, { "id": 17918, "year": 2024, "is_wenli": 2, "score": 334, "ranking": 426115, "num": 1428 }, { "id": 17919, "year": 2024, "is_wenli": 2, "score": 333, "ranking": 427506, "num": 1391 }, { "id": 17920, "year": 2024, "is_wenli": 2, "score": 332, "ranking": 428876, "num": 1370 }, { "id": 17921, "year": 2024, "is_wenli": 2, "score": 331, "ranking": 430343, "num": 1467 }, { "id": 17922, "year": 2024, "is_wenli": 2, "score": 330, "ranking": 431669, "num": 1326 }, { "id": 17923, "year": 2024, "is_wenli": 2, "score": 329, "ranking": 432982, "num": 1313 }, { "id": 17924, "year": 2024, "is_wenli": 2, "score": 328, "ranking": 434379, "num": 1397 }, { "id": 17925, "year": 2024, "is_wenli": 2, "score": 327, "ranking": 435646, "num": 1267 }, { "id": 17926, "year": 2024, "is_wenli": 2, "score": 326, "ranking": 437003, "num": 1357 }, { "id": 17927, "year": 2024, "is_wenli": 2, "score": 325, "ranking": 438282, "num": 1279 }, { "id": 17928, "year": 2024, "is_wenli": 2, "score": 324, "ranking": 439640, "num": 1358 }, { "id": 17929, "year": 2024, "is_wenli": 2, "score": 323, "ranking": 440920, "num": 1280 }, { "id": 17930, "year": 2024, "is_wenli": 2, "score": 322, "ranking": 442270, "num": 1350 }, { "id": 17931, "year": 2024, "is_wenli": 2, "score": 321, "ranking": 443519, "num": 1249 }, { "id": 17932, "year": 2024, "is_wenli": 2, "score": 320, "ranking": 444801, "num": 1282 }, { "id": 17933, "year": 2024, "is_wenli": 2, "score": 319, "ranking": 446076, "num": 1275 }, { "id": 17934, "year": 2024, "is_wenli": 2, "score": 318, "ranking": 447407, "num": 1331 }, { "id": 17935, "year": 2024, "is_wenli": 2, "score": 317, "ranking": 448615, "num": 1208 }, { "id": 17936, "year": 2024, "is_wenli": 2, "score": 316, "ranking": 449896, "num": 1281 }, { "id": 17937, "year": 2024, "is_wenli": 2, "score": 315, "ranking": 451087, "num": 1191 }, { "id": 17938, "year": 2024, "is_wenli": 2, "score": 314, "ranking": 452338, "num": 1251 }, { "id": 17939, "year": 2024, "is_wenli": 2, "score": 313, "ranking": 453595, "num": 1257 }, { "id": 17940, "year": 2024, "is_wenli": 2, "score": 312, "ranking": 454827, "num": 1232 }, { "id": 17941, "year": 2024, "is_wenli": 2, "score": 311, "ranking": 456086, "num": 1259 }, { "id": 17942, "year": 2024, "is_wenli": 2, "score": 310, "ranking": 457279, "num": 1193 }, { "id": 17943, "year": 2024, "is_wenli": 2, "score": 309, "ranking": 458497, "num": 1218 }, { "id": 17944, "year": 2024, "is_wenli": 2, "score": 308, "ranking": 459738, "num": 1241 }, { "id": 17945, "year": 2024, "is_wenli": 2, "score": 307, "ranking": 460904, "num": 1166 }, { "id": 17946, "year": 2024, "is_wenli": 2, "score": 306, "ranking": 462082, "num": 1178 }, { "id": 17947, "year": 2024, "is_wenli": 2, "score": 305, "ranking": 463282, "num": 1200 }, { "id": 17948, "year": 2024, "is_wenli": 2, "score": 304, "ranking": 464500, "num": 1218 }, { "id": 17949, "year": 2024, "is_wenli": 2, "score": 303, "ranking": 465697, "num": 1197 }, { "id": 17950, "year": 2024, "is_wenli": 2, "score": 302, "ranking": 466873, "num": 1176 }, { "id": 17951, "year": 2024, "is_wenli": 2, "score": 301, "ranking": 467960, "num": 1087 }, { "id": 17952, "year": 2024, "is_wenli": 2, "score": 300, "ranking": 469081, "num": 1121 }, { "id": 17953, "year": 2024, "is_wenli": 2, "score": 299, "ranking": 470186, "num": 1105 }, { "id": 17954, "year": 2024, "is_wenli": 2, "score": 298, "ranking": 471278, "num": 1092 }, { "id": 17955, "year": 2024, "is_wenli": 2, "score": 297, "ranking": 472334, "num": 1056 }, { "id": 17956, "year": 2024, "is_wenli": 2, "score": 296, "ranking": 473469, "num": 1135 }, { "id": 17957, "year": 2024, "is_wenli": 2, "score": 295, "ranking": 474593, "num": 1124 }, { "id": 17958, "year": 2024, "is_wenli": 2, "score": 294, "ranking": 475770, "num": 1177 }, { "id": 17959, "year": 2024, "is_wenli": 2, "score": 293, "ranking": 476885, "num": 1115 }, { "id": 17960, "year": 2024, "is_wenli": 2, "score": 292, "ranking": 478010, "num": 1125 }, { "id": 17961, "year": 2024, "is_wenli": 2, "score": 291, "ranking": 479066, "num": 1056 }, { "id": 17962, "year": 2024, "is_wenli": 2, "score": 290, "ranking": 480129, "num": 1063 }, { "id": 17963, "year": 2024, "is_wenli": 2, "score": 289, "ranking": 481202, "num": 1073 }, { "id": 17964, "year": 2024, "is_wenli": 2, "score": 288, "ranking": 482229, "num": 1027 }, { "id": 17965, "year": 2024, "is_wenli": 2, "score": 287, "ranking": 483260, "num": 1031 }, { "id": 17966, "year": 2024, "is_wenli": 2, "score": 286, "ranking": 484294, "num": 1034 }, { "id": 17967, "year": 2024, "is_wenli": 2, "score": 285, "ranking": 485358, "num": 1064 }, { "id": 17968, "year": 2024, "is_wenli": 2, "score": 284, "ranking": 486358, "num": 1000 }, { "id": 17969, "year": 2024, "is_wenli": 2, "score": 283, "ranking": 487369, "num": 1011 }, { "id": 17970, "year": 2024, "is_wenli": 2, "score": 282, "ranking": 488399, "num": 1030 }, { "id": 17971, "year": 2024, "is_wenli": 2, "score": 281, "ranking": 489411, "num": 1012 }, { "id": 17972, "year": 2024, "is_wenli": 2, "score": 280, "ranking": 490447, "num": 1036 }, { "id": 17973, "year": 2024, "is_wenli": 2, "score": 279, "ranking": 491400, "num": 953 }, { "id": 17974, "year": 2024, "is_wenli": 2, "score": 278, "ranking": 492429, "num": 1029 }, { "id": 17975, "year": 2024, "is_wenli": 2, "score": 277, "ranking": 493443, "num": 1014 }, { "id": 17976, "year": 2024, "is_wenli": 2, "score": 276, "ranking": 494424, "num": 981 }, { "id": 17977, "year": 2024, "is_wenli": 2, "score": 275, "ranking": 495385, "num": 961 }, { "id": 17978, "year": 2024, "is_wenli": 2, "score": 274, "ranking": 496336, "num": 951 }, { "id": 17979, "year": 2024, "is_wenli": 2, "score": 273, "ranking": 497351, "num": 1015 }, { "id": 17980, "year": 2024, "is_wenli": 2, "score": 272, "ranking": 498266, "num": 915 }, { "id": 17981, "year": 2024, "is_wenli": 2, "score": 271, "ranking": 499235, "num": 969 }, { "id": 17982, "year": 2024, "is_wenli": 2, "score": 270, "ranking": 500157, "num": 922 }, { "id": 17983, "year": 2024, "is_wenli": 2, "score": 269, "ranking": 501144, "num": 987 }, { "id": 17984, "year": 2024, "is_wenli": 2, "score": 268, "ranking": 502079, "num": 935 }, { "id": 17985, "year": 2024, "is_wenli": 2, "score": 267, "ranking": 503082, "num": 1003 }, { "id": 17986, "year": 2024, "is_wenli": 2, "score": 266, "ranking": 504037, "num": 955 }, { "id": 17987, "year": 2024, "is_wenli": 2, "score": 265, "ranking": 504929, "num": 892 }, { "id": 17988, "year": 2024, "is_wenli": 2, "score": 264, "ranking": 505858, "num": 929 }, { "id": 17989, "year": 2024, "is_wenli": 2, "score": 263, "ranking": 506744, "num": 886 }, { "id": 17990, "year": 2024, "is_wenli": 2, "score": 262, "ranking": 507586, "num": 842 }, { "id": 17991, "year": 2024, "is_wenli": 2, "score": 261, "ranking": 508493, "num": 907 }, { "id": 17992, "year": 2024, "is_wenli": 2, "score": 260, "ranking": 509356, "num": 863 }, { "id": 17993, "year": 2024, "is_wenli": 2, "score": 259, "ranking": 510265, "num": 909 }, { "id": 17994, "year": 2024, "is_wenli": 2, "score": 258, "ranking": 511157, "num": 892 }, { "id": 17995, "year": 2024, "is_wenli": 2, "score": 257, "ranking": 512029, "num": 872 }, { "id": 17996, "year": 2024, "is_wenli": 2, "score": 256, "ranking": 512961, "num": 932 }, { "id": 17997, "year": 2024, "is_wenli": 2, "score": 255, "ranking": 513769, "num": 808 }, { "id": 17998, "year": 2024, "is_wenli": 2, "score": 254, "ranking": 514601, "num": 832 }, { "id": 17999, "year": 2024, "is_wenli": 2, "score": 253, "ranking": 515443, "num": 842 }, { "id": 18000, "year": 2024, "is_wenli": 2, "score": 252, "ranking": 516260, "num": 817 }, { "id": 18001, "year": 2024, "is_wenli": 2, "score": 251, "ranking": 517087, "num": 827 }, { "id": 18002, "year": 2024, "is_wenli": 2, "score": 250, "ranking": 517889, "num": 802 }, { "id": 18003, "year": 2024, "is_wenli": 2, "score": 249, "ranking": 518678, "num": 789 }, { "id": 18004, "year": 2024, "is_wenli": 2, "score": 248, "ranking": 519509, "num": 831 }, { "id": 18005, "year": 2024, "is_wenli": 2, "score": 247, "ranking": 520315, "num": 806 }, { "id": 18006, "year": 2024, "is_wenli": 2, "score": 246, "ranking": 521157, "num": 842 }, { "id": 18007, "year": 2024, "is_wenli": 2, "score": 245, "ranking": 521977, "num": 820 }, { "id": 18008, "year": 2024, "is_wenli": 2, "score": 244, "ranking": 522777, "num": 800 }, { "id": 18009, "year": 2024, "is_wenli": 2, "score": 243, "ranking": 523553, "num": 776 }, { "id": 18010, "year": 2024, "is_wenli": 2, "score": 242, "ranking": 524312, "num": 759 }, { "id": 18011, "year": 2024, "is_wenli": 2, "score": 241, "ranking": 525118, "num": 806 }, { "id": 18012, "year": 2024, "is_wenli": 2, "score": 240, "ranking": 525852, "num": 734 }, { "id": 18013, "year": 2024, "is_wenli": 2, "score": 239, "ranking": 526660, "num": 808 }, { "id": 18014, "year": 2024, "is_wenli": 2, "score": 238, "ranking": 527453, "num": 793 }, { "id": 18015, "year": 2024, "is_wenli": 2, "score": 237, "ranking": 528236, "num": 783 }, { "id": 18016, "year": 2024, "is_wenli": 2, "score": 236, "ranking": 528986, "num": 750 }, { "id": 18017, "year": 2024, "is_wenli": 2, "score": 235, "ranking": 529721, "num": 735 }, { "id": 18018, "year": 2024, "is_wenli": 2, "score": 234, "ranking": 530460, "num": 739 }, { "id": 18019, "year": 2024, "is_wenli": 2, "score": 233, "ranking": 531212, "num": 752 }, { "id": 18020, "year": 2024, "is_wenli": 2, "score": 232, "ranking": 531944, "num": 732 }, { "id": 18021, "year": 2024, "is_wenli": 2, "score": 231, "ranking": 532696, "num": 752 }, { "id": 18022, "year": 2024, "is_wenli": 2, "score": 230, "ranking": 533383, "num": 687 }, { "id": 18023, "year": 2024, "is_wenli": 2, "score": 229, "ranking": 534127, "num": 744 }, { "id": 18024, "year": 2024, "is_wenli": 2, "score": 228, "ranking": 534851, "num": 724 }, { "id": 18025, "year": 2024, "is_wenli": 2, "score": 227, "ranking": 535605, "num": 754 }, { "id": 18026, "year": 2024, "is_wenli": 2, "score": 226, "ranking": 536267, "num": 662 }, { "id": 18027, "year": 2024, "is_wenli": 2, "score": 225, "ranking": 536960, "num": 693 }, { "id": 18028, "year": 2024, "is_wenli": 2, "score": 224, "ranking": 537637, "num": 677 }, { "id": 18029, "year": 2024, "is_wenli": 2, "score": 223, "ranking": 538339, "num": 702 }, { "id": 18030, "year": 2024, "is_wenli": 2, "score": 222, "ranking": 539012, "num": 673 }, { "id": 18031, "year": 2024, "is_wenli": 2, "score": 221, "ranking": 539735, "num": 723 }, { "id": 18032, "year": 2024, "is_wenli": 2, "score": 220, "ranking": 540386, "num": 651 }, { "id": 18033, "year": 2024, "is_wenli": 2, "score": 219, "ranking": 541055, "num": 669 }, { "id": 18034, "year": 2024, "is_wenli": 2, "score": 218, "ranking": 541667, "num": 612 }, { "id": 18035, "year": 2024, "is_wenli": 2, "score": 217, "ranking": 542336, "num": 669 }, { "id": 18036, "year": 2024, "is_wenli": 2, "score": 216, "ranking": 542972, "num": 636 }, { "id": 18037, "year": 2024, "is_wenli": 2, "score": 215, "ranking": 543577, "num": 605 }, { "id": 18038, "year": 2024, "is_wenli": 2, "score": 214, "ranking": 544203, "num": 626 }, { "id": 18039, "year": 2024, "is_wenli": 2, "score": 213, "ranking": 544830, "num": 627 }, { "id": 18040, "year": 2024, "is_wenli": 2, "score": 212, "ranking": 545447, "num": 617 }, { "id": 18041, "year": 2024, "is_wenli": 2, "score": 211, "ranking": 546033, "num": 586 }, { "id": 18042, "year": 2024, "is_wenli": 2, "score": 210, "ranking": 546631, "num": 598 }, { "id": 18043, "year": 2024, "is_wenli": 2, "score": 209, "ranking": 547205, "num": 574 }, { "id": 18044, "year": 2024, "is_wenli": 2, "score": 208, "ranking": 547765, "num": 560 }, { "id": 18045, "year": 2024, "is_wenli": 2, "score": 207, "ranking": 548350, "num": 585 }, { "id": 18046, "year": 2024, "is_wenli": 2, "score": 206, "ranking": 548951, "num": 601 }, { "id": 18047, "year": 2024, "is_wenli": 2, "score": 205, "ranking": 549584, "num": 633 }, { "id": 18048, "year": 2024, "is_wenli": 2, "score": 204, "ranking": 550156, "num": 572 }, { "id": 18049, "year": 2024, "is_wenli": 2, "score": 203, "ranking": 550715, "num": 559 }, { "id": 18050, "year": 2024, "is_wenli": 2, "score": 202, "ranking": 551249, "num": 534 }, { "id": 18051, "year": 2024, "is_wenli": 2, "score": 201, "ranking": 551777, "num": 528 }, { "id": 18052, "year": 2024, "is_wenli": 2, "score": 200, "ranking": 552326, "num": 549 }, { "id": 18053, "year": 2024, "is_wenli": 2, "score": 199, "ranking": 552860, "num": 534 }, { "id": 18054, "year": 2024, "is_wenli": 2, "score": 198, "ranking": 553404, "num": 544 }, { "id": 18055, "year": 2024, "is_wenli": 2, "score": 197, "ranking": 553917, "num": 513 }, { "id": 18056, "year": 2024, "is_wenli": 2, "score": 196, "ranking": 554418, "num": 501 }, { "id": 18057, "year": 2024, "is_wenli": 2, "score": 195, "ranking": 554921, "num": 503 }, { "id": 18058, "year": 2024, "is_wenli": 2, "score": 194, "ranking": 555396, "num": 475 }, { "id": 18059, "year": 2024, "is_wenli": 2, "score": 193, "ranking": 555844, "num": 448 }, { "id": 18060, "year": 2024, "is_wenli": 2, "score": 192, "ranking": 556344, "num": 500 }, { "id": 18061, "year": 2024, "is_wenli": 2, "score": 191, "ranking": 556833, "num": 489 }, { "id": 18062, "year": 2024, "is_wenli": 2, "score": 190, "ranking": 557281, "num": 448 }, { "id": 18063, "year": 2024, "is_wenli": 2, "score": 189, "ranking": 557740, "num": 459 }, { "id": 18064, "year": 2024, "is_wenli": 2, "score": 188, "ranking": 558199, "num": 459 }, { "id": 18065, "year": 2024, "is_wenli": 2, "score": 187, "ranking": 558653, "num": 454 }, { "id": 18066, "year": 2024, "is_wenli": 2, "score": 186, "ranking": 559121, "num": 468 }, { "id": 18067, "year": 2024, "is_wenli": 2, "score": 185, "ranking": 559544, "num": 423 }, { "id": 18068, "year": 2024, "is_wenli": 2, "score": 184, "ranking": 559969, "num": 425 }, { "id": 18069, "year": 2024, "is_wenli": 2, "score": 183, "ranking": 560368, "num": 399 }, { "id": 18070, "year": 2024, "is_wenli": 2, "score": 182, "ranking": 560795, "num": 427 }, { "id": 18071, "year": 2024, "is_wenli": 2, "score": 181, "ranking": 561190, "num": 395 }, { "id": 18072, "year": 2024, "is_wenli": 2, "score": 180, "ranking": 561585, "num": 395 }, { "id": 18073, "year": 2024, "is_wenli": 2, "score": 179, "ranking": 561951, "num": 366 }, { "id": 18074, "year": 2024, "is_wenli": 2, "score": 178, "ranking": 562344, "num": 393 }, { "id": 18075, "year": 2024, "is_wenli": 2, "score": 177, "ranking": 562710, "num": 366 }, { "id": 18076, "year": 2024, "is_wenli": 2, "score": 176, "ranking": 563081, "num": 371 }, { "id": 18077, "year": 2024, "is_wenli": 2, "score": 175, "ranking": 563462, "num": 381 }, { "id": 18078, "year": 2024, "is_wenli": 2, "score": 174, "ranking": 563839, "num": 377 }, { "id": 18079, "year": 2024, "is_wenli": 2, "score": 173, "ranking": 564187, "num": 348 }, { "id": 18080, "year": 2024, "is_wenli": 2, "score": 172, "ranking": 564573, "num": 386 }, { "id": 18081, "year": 2024, "is_wenli": 2, "score": 171, "ranking": 564891, "num": 318 }, { "id": 18082, "year": 2024, "is_wenli": 2, "score": 170, "ranking": 565217, "num": 326 }, { "id": 18083, "year": 2024, "is_wenli": 2, "score": 169, "ranking": 565534, "num": 317 }, { "id": 18084, "year": 2024, "is_wenli": 2, "score": 168, "ranking": 565868, "num": 334 }, { "id": 18085, "year": 2024, "is_wenli": 2, "score": 167, "ranking": 566160, "num": 292 }, { "id": 18086, "year": 2024, "is_wenli": 2, "score": 166, "ranking": 566412, "num": 252 }, { "id": 18087, "year": 2024, "is_wenli": 2, "score": 165, "ranking": 566693, "num": 281 }, { "id": 18088, "year": 2024, "is_wenli": 2, "score": 164, "ranking": 566986, "num": 293 }, { "id": 18089, "year": 2024, "is_wenli": 2, "score": 163, "ranking": 567295, "num": 309 }, { "id": 18090, "year": 2024, "is_wenli": 2, "score": 162, "ranking": 567545, "num": 250 }, { "id": 18091, "year": 2024, "is_wenli": 2, "score": 161, "ranking": 567828, "num": 283 }, { "id": 18092, "year": 2024, "is_wenli": 2, "score": 160, "ranking": 568095, "num": 267 }, { "id": 18093, "year": 2024, "is_wenli": 2, "score": 159, "ranking": 568355, "num": 260 }, { "id": 18094, "year": 2024, "is_wenli": 2, "score": 158, "ranking": 568567, "num": 212 }, { "id": 18095, "year": 2024, "is_wenli": 2, "score": 157, "ranking": 568785, "num": 218 }, { "id": 18096, "year": 2024, "is_wenli": 2, "score": 156, "ranking": 569016, "num": 231 }, { "id": 18097, "year": 2024, "is_wenli": 2, "score": 155, "ranking": 569220, "num": 204 }, { "id": 18098, "year": 2024, "is_wenli": 2, "score": 154, "ranking": 569414, "num": 194 }, { "id": 18099, "year": 2024, "is_wenli": 2, "score": 153, "ranking": 569621, "num": 207 }, { "id": 18100, "year": 2024, "is_wenli": 2, "score": 152, "ranking": 569834, "num": 213 }, { "id": 18101, "year": 2024, "is_wenli": 2, "score": 151, "ranking": 570010, "num": 176 }, { "id": 18102, "year": 2024, "is_wenli": 2, "score": 150, "ranking": 570200, "num": 190 }, { "id": 18103, "year": 2024, "is_wenli": 2, "score": 149, "ranking": 570357, "num": 157 }, { "id": 18104, "year": 2024, "is_wenli": 2, "score": 148, "ranking": 570525, "num": 168 }, { "id": 18105, "year": 2024, "is_wenli": 2, "score": 147, "ranking": 570673, "num": 148 }, { "id": 18106, "year": 2024, "is_wenli": 2, "score": 146, "ranking": 570832, "num": 159 }, { "id": 18107, "year": 2024, "is_wenli": 2, "score": 145, "ranking": 570980, "num": 148 }, { "id": 18108, "year": 2024, "is_wenli": 2, "score": 144, "ranking": 571114, "num": 134 }, { "id": 18109, "year": 2024, "is_wenli": 2, "score": 143, "ranking": 571247, "num": 133 }, { "id": 18110, "year": 2024, "is_wenli": 2, "score": 142, "ranking": 571356, "num": 109 }, { "id": 18111, "year": 2024, "is_wenli": 2, "score": 141, "ranking": 571466, "num": 110 }, { "id": 18112, "year": 2024, "is_wenli": 2, "score": 140, "ranking": 571582, "num": 116 }, { "id": 18113, "year": 2024, "is_wenli": 2, "score": 139, "ranking": 571699, "num": 117 }, { "id": 18114, "year": 2024, "is_wenli": 2, "score": 138, "ranking": 571803, "num": 104 }, { "id": 18115, "year": 2024, "is_wenli": 2, "score": 137, "ranking": 571896, "num": 93 }, { "id": 18116, "year": 2024, "is_wenli": 2, "score": 136, "ranking": 572005, "num": 109 }, { "id": 18117, "year": 2024, "is_wenli": 2, "score": 135, "ranking": 572104, "num": 99 }, { "id": 18118, "year": 2024, "is_wenli": 2, "score": 134, "ranking": 572189, "num": 85 }, { "id": 18119, "year": 2024, "is_wenli": 2, "score": 133, "ranking": 572267, "num": 78 }, { "id": 18120, "year": 2024, "is_wenli": 2, "score": 132, "ranking": 572341, "num": 74 }, { "id": 18121, "year": 2024, "is_wenli": 2, "score": 131, "ranking": 572421, "num": 80 }, { "id": 18122, "year": 2024, "is_wenli": 2, "score": 130, "ranking": 572487, "num": 66 }, { "id": 18123, "year": 2024, "is_wenli": 2, "score": 129, "ranking": 572552, "num": 65 }, { "id": 18124, "year": 2024, "is_wenli": 2, "score": 128, "ranking": 572617, "num": 65 }, { "id": 18125, "year": 2024, "is_wenli": 2, "score": 127, "ranking": 572671, "num": 54 }, { "id": 18126, "year": 2024, "is_wenli": 2, "score": 126, "ranking": 572717, "num": 46 }, { "id": 18127, "year": 2024, "is_wenli": 2, "score": 125, "ranking": 572764, "num": 47 }, { "id": 18128, "year": 2024, "is_wenli": 2, "score": 124, "ranking": 572818, "num": 54 }, { "id": 18129, "year": 2024, "is_wenli": 2, "score": 123, "ranking": 572869, "num": 51 }, { "id": 18130, "year": 2024, "is_wenli": 2, "score": 122, "ranking": 572910, "num": 41 }, { "id": 18131, "year": 2024, "is_wenli": 2, "score": 121, "ranking": 572945, "num": 35 }, { "id": 18132, "year": 2024, "is_wenli": 2, "score": 120, "ranking": 572998, "num": 53 }, { "id": 18133, "year": 2024, "is_wenli": 2, "score": 119, "ranking": 573033, "num": 35 }, { "id": 18134, "year": 2024, "is_wenli": 2, "score": 118, "ranking": 573069, "num": 36 }, { "id": 18135, "year": 2024, "is_wenli": 2, "score": 117, "ranking": 573103, "num": 34 }, { "id": 18136, "year": 2024, "is_wenli": 2, "score": 116, "ranking": 573145, "num": 42 }, { "id": 18137, "year": 2024, "is_wenli": 2, "score": 115, "ranking": 573179, "num": 34 }, { "id": 18138, "year": 2024, "is_wenli": 2, "score": 114, "ranking": 573205, "num": 26 }, { "id": 18139, "year": 2024, "is_wenli": 2, "score": 113, "ranking": 573241, "num": 36 }, { "id": 18140, "year": 2024, "is_wenli": 2, "score": 112, "ranking": 573264, "num": 23 }, { "id": 18141, "year": 2024, "is_wenli": 2, "score": 111, "ranking": 573292, "num": 28 }, { "id": 18142, "year": 2024, "is_wenli": 2, "score": 110, "ranking": 573319, "num": 27 }, { "id": 18143, "year": 2024, "is_wenli": 2, "score": 109, "ranking": 573343, "num": 24 }, { "id": 18144, "year": 2024, "is_wenli": 2, "score": 108, "ranking": 573363, "num": 20 }, { "id": 18145, "year": 2024, "is_wenli": 2, "score": 107, "ranking": 573389, "num": 26 }, { "id": 18146, "year": 2024, "is_wenli": 2, "score": 106, "ranking": 573404, "num": 15 }, { "id": 18147, "year": 2024, "is_wenli": 2, "score": 105, "ranking": 573427, "num": 23 }, { "id": 18148, "year": 2024, "is_wenli": 2, "score": 104, "ranking": 573452, "num": 25 }, { "id": 18149, "year": 2024, "is_wenli": 2, "score": 103, "ranking": 573475, "num": 23 }, { "id": 18150, "year": 2024, "is_wenli": 2, "score": 102, "ranking": 573489, "num": 14 }, { "id": 18151, "year": 2024, "is_wenli": 2, "score": 101, "ranking": 573507, "num": 18 }, { "id": 18152, "year": 2024, "is_wenli": 2, "score": 100, "ranking": 573517, "num": 10 }
    ]
    ,
    2023: [
        { "id": 16350, "year": 2023, "is_wenli": 2, "score": 710, "ranking": 11, "num": 11 }, { "id": 16351, "year": 2023, "is_wenli": 2, "score": 709, "ranking": 12, "num": 1 }, { "id": 16352, "year": 2023, "is_wenli": 2, "score": 708, "ranking": 16, "num": 4 }, { "id": 16353, "year": 2023, "is_wenli": 2, "score": 707, "ranking": 21, "num": 5 }, { "id": 16354, "year": 2023, "is_wenli": 2, "score": 706, "ranking": 28, "num": 7 }, { "id": 16355, "year": 2023, "is_wenli": 2, "score": 705, "ranking": 34, "num": 6 }, { "id": 16356, "year": 2023, "is_wenli": 2, "score": 704, "ranking": 40, "num": 6 }, { "id": 16357, "year": 2023, "is_wenli": 2, "score": 703, "ranking": 45, "num": 5 }, { "id": 16358, "year": 2023, "is_wenli": 2, "score": 702, "ranking": 55, "num": 10 }, { "id": 16359, "year": 2023, "is_wenli": 2, "score": 701, "ranking": 63, "num": 8 }, { "id": 16360, "year": 2023, "is_wenli": 2, "score": 700, "ranking": 74, "num": 11 }, { "id": 16361, "year": 2023, "is_wenli": 2, "score": 699, "ranking": 80, "num": 6 }, { "id": 16362, "year": 2023, "is_wenli": 2, "score": 698, "ranking": 94, "num": 14 }, { "id": 16363, "year": 2023, "is_wenli": 2, "score": 697, "ranking": 98, "num": 4 }, { "id": 16364, "year": 2023, "is_wenli": 2, "score": 696, "ranking": 109, "num": 11 }, { "id": 16365, "year": 2023, "is_wenli": 2, "score": 695, "ranking": 127, "num": 18 }, { "id": 16366, "year": 2023, "is_wenli": 2, "score": 694, "ranking": 147, "num": 20 }, { "id": 16367, "year": 2023, "is_wenli": 2, "score": 693, "ranking": 163, "num": 16 }, { "id": 16368, "year": 2023, "is_wenli": 2, "score": 692, "ranking": 170, "num": 7 }, { "id": 16369, "year": 2023, "is_wenli": 2, "score": 691, "ranking": 198, "num": 28 }, { "id": 16370, "year": 2023, "is_wenli": 2, "score": 690, "ranking": 219, "num": 21 }, { "id": 16371, "year": 2023, "is_wenli": 2, "score": 689, "ranking": 239, "num": 20 }, { "id": 16372, "year": 2023, "is_wenli": 2, "score": 688, "ranking": 270, "num": 31 }, { "id": 16373, "year": 2023, "is_wenli": 2, "score": 687, "ranking": 297, "num": 27 }, { "id": 16374, "year": 2023, "is_wenli": 2, "score": 686, "ranking": 327, "num": 30 }, { "id": 16375, "year": 2023, "is_wenli": 2, "score": 685, "ranking": 358, "num": 31 }, { "id": 16376, "year": 2023, "is_wenli": 2, "score": 684, "ranking": 394, "num": 36 }, { "id": 16377, "year": 2023, "is_wenli": 2, "score": 683, "ranking": 431, "num": 37 }, { "id": 16378, "year": 2023, "is_wenli": 2, "score": 682, "ranking": 481, "num": 50 }, { "id": 16379, "year": 2023, "is_wenli": 2, "score": 681, "ranking": 518, "num": 37 }, { "id": 16380, "year": 2023, "is_wenli": 2, "score": 680, "ranking": 546, "num": 28 }, { "id": 16381, "year": 2023, "is_wenli": 2, "score": 679, "ranking": 585, "num": 39 }, { "id": 16382, "year": 2023, "is_wenli": 2, "score": 678, "ranking": 621, "num": 36 }, { "id": 16383, "year": 2023, "is_wenli": 2, "score": 677, "ranking": 682, "num": 61 }, { "id": 16384, "year": 2023, "is_wenli": 2, "score": 676, "ranking": 738, "num": 56 }, { "id": 16385, "year": 2023, "is_wenli": 2, "score": 675, "ranking": 784, "num": 46 }, { "id": 16386, "year": 2023, "is_wenli": 2, "score": 674, "ranking": 852, "num": 68 }, { "id": 16387, "year": 2023, "is_wenli": 2, "score": 673, "ranking": 914, "num": 62 }, { "id": 16388, "year": 2023, "is_wenli": 2, "score": 672, "ranking": 969, "num": 55 }, { "id": 16389, "year": 2023, "is_wenli": 2, "score": 671, "ranking": 1031, "num": 62 }, { "id": 16390, "year": 2023, "is_wenli": 2, "score": 670, "ranking": 1089, "num": 58 }, { "id": 16391, "year": 2023, "is_wenli": 2, "score": 669, "ranking": 1165, "num": 76 }, { "id": 16392, "year": 2023, "is_wenli": 2, "score": 668, "ranking": 1232, "num": 67 }, { "id": 16393, "year": 2023, "is_wenli": 2, "score": 667, "ranking": 1319, "num": 87 }, { "id": 16394, "year": 2023, "is_wenli": 2, "score": 666, "ranking": 1407, "num": 88 }, { "id": 16395, "year": 2023, "is_wenli": 2, "score": 665, "ranking": 1482, "num": 75 }, { "id": 16396, "year": 2023, "is_wenli": 2, "score": 664, "ranking": 1571, "num": 89 }, { "id": 16397, "year": 2023, "is_wenli": 2, "score": 663, "ranking": 1652, "num": 81 }, { "id": 16398, "year": 2023, "is_wenli": 2, "score": 662, "ranking": 1741, "num": 89 }, { "id": 16399, "year": 2023, "is_wenli": 2, "score": 661, "ranking": 1842, "num": 101 }, { "id": 16400, "year": 2023, "is_wenli": 2, "score": 660, "ranking": 1934, "num": 92 }, { "id": 16401, "year": 2023, "is_wenli": 2, "score": 659, "ranking": 2043, "num": 109 }, { "id": 16402, "year": 2023, "is_wenli": 2, "score": 658, "ranking": 2159, "num": 116 }, { "id": 16403, "year": 2023, "is_wenli": 2, "score": 657, "ranking": 2272, "num": 113 }, { "id": 16404, "year": 2023, "is_wenli": 2, "score": 656, "ranking": 2390, "num": 118 }, { "id": 16405, "year": 2023, "is_wenli": 2, "score": 655, "ranking": 2514, "num": 124 }, { "id": 16406, "year": 2023, "is_wenli": 2, "score": 654, "ranking": 2672, "num": 158 }, { "id": 16407, "year": 2023, "is_wenli": 2, "score": 653, "ranking": 2804, "num": 132 }, { "id": 16408, "year": 2023, "is_wenli": 2, "score": 652, "ranking": 2956, "num": 152 }, { "id": 16409, "year": 2023, "is_wenli": 2, "score": 651, "ranking": 3116, "num": 160 }, { "id": 16410, "year": 2023, "is_wenli": 2, "score": 650, "ranking": 3275, "num": 159 }, { "id": 16411, "year": 2023, "is_wenli": 2, "score": 649, "ranking": 3414, "num": 139 }, { "id": 16412, "year": 2023, "is_wenli": 2, "score": 648, "ranking": 3581, "num": 167 }, { "id": 16413, "year": 2023, "is_wenli": 2, "score": 647, "ranking": 3746, "num": 165 }, { "id": 16414, "year": 2023, "is_wenli": 2, "score": 646, "ranking": 3921, "num": 175 }, { "id": 16415, "year": 2023, "is_wenli": 2, "score": 645, "ranking": 4102, "num": 181 }, { "id": 16416, "year": 2023, "is_wenli": 2, "score": 644, "ranking": 4301, "num": 199 }, { "id": 16417, "year": 2023, "is_wenli": 2, "score": 643, "ranking": 4496, "num": 195 }, { "id": 16418, "year": 2023, "is_wenli": 2, "score": 642, "ranking": 4712, "num": 216 }, { "id": 16419, "year": 2023, "is_wenli": 2, "score": 641, "ranking": 4934, "num": 222 }, { "id": 16420, "year": 2023, "is_wenli": 2, "score": 640, "ranking": 5126, "num": 192 }, { "id": 16421, "year": 2023, "is_wenli": 2, "score": 639, "ranking": 5359, "num": 233 }, { "id": 16422, "year": 2023, "is_wenli": 2, "score": 638, "ranking": 5568, "num": 209 }, { "id": 16423, "year": 2023, "is_wenli": 2, "score": 637, "ranking": 5800, "num": 232 }, { "id": 16424, "year": 2023, "is_wenli": 2, "score": 636, "ranking": 6059, "num": 259 }, { "id": 16425, "year": 2023, "is_wenli": 2, "score": 635, "ranking": 6311, "num": 252 }, { "id": 16426, "year": 2023, "is_wenli": 2, "score": 634, "ranking": 6603, "num": 292 }, { "id": 16427, "year": 2023, "is_wenli": 2, "score": 633, "ranking": 6878, "num": 275 }, { "id": 16428, "year": 2023, "is_wenli": 2, "score": 632, "ranking": 7185, "num": 307 }, { "id": 16429, "year": 2023, "is_wenli": 2, "score": 631, "ranking": 7493, "num": 308 }, { "id": 16430, "year": 2023, "is_wenli": 2, "score": 630, "ranking": 7810, "num": 317 }, { "id": 16431, "year": 2023, "is_wenli": 2, "score": 629, "ranking": 8100, "num": 290 }, { "id": 16432, "year": 2023, "is_wenli": 2, "score": 628, "ranking": 8437, "num": 337 }, { "id": 16433, "year": 2023, "is_wenli": 2, "score": 627, "ranking": 8771, "num": 334 }, { "id": 16434, "year": 2023, "is_wenli": 2, "score": 626, "ranking": 9098, "num": 327 }, { "id": 16435, "year": 2023, "is_wenli": 2, "score": 625, "ranking": 9462, "num": 364 }, { "id": 16436, "year": 2023, "is_wenli": 2, "score": 624, "ranking": 9823, "num": 361 }, { "id": 16437, "year": 2023, "is_wenli": 2, "score": 623, "ranking": 10186, "num": 363 }, { "id": 16438, "year": 2023, "is_wenli": 2, "score": 622, "ranking": 10580, "num": 394 }, { "id": 16439, "year": 2023, "is_wenli": 2, "score": 621, "ranking": 10964, "num": 384 }, { "id": 16440, "year": 2023, "is_wenli": 2, "score": 620, "ranking": 11310, "num": 346 }, { "id": 16441, "year": 2023, "is_wenli": 2, "score": 619, "ranking": 11731, "num": 421 }, { "id": 16442, "year": 2023, "is_wenli": 2, "score": 618, "ranking": 12162, "num": 431 }, { "id": 16443, "year": 2023, "is_wenli": 2, "score": 617, "ranking": 12626, "num": 464 }, { "id": 16444, "year": 2023, "is_wenli": 2, "score": 616, "ranking": 13053, "num": 427 }, { "id": 16445, "year": 2023, "is_wenli": 2, "score": 615, "ranking": 13508, "num": 455 }, { "id": 16446, "year": 2023, "is_wenli": 2, "score": 614, "ranking": 13937, "num": 429 }, { "id": 16447, "year": 2023, "is_wenli": 2, "score": 613, "ranking": 14404, "num": 467 }, { "id": 16448, "year": 2023, "is_wenli": 2, "score": 612, "ranking": 14902, "num": 498 }, { "id": 16449, "year": 2023, "is_wenli": 2, "score": 611, "ranking": 15415, "num": 513 }, { "id": 16450, "year": 2023, "is_wenli": 2, "score": 610, "ranking": 15925, "num": 510 }, { "id": 16451, "year": 2023, "is_wenli": 2, "score": 609, "ranking": 16466, "num": 541 }, { "id": 16452, "year": 2023, "is_wenli": 2, "score": 608, "ranking": 17028, "num": 562 }, { "id": 16453, "year": 2023, "is_wenli": 2, "score": 607, "ranking": 17545, "num": 517 }, { "id": 16454, "year": 2023, "is_wenli": 2, "score": 606, "ranking": 18105, "num": 560 }, { "id": 16455, "year": 2023, "is_wenli": 2, "score": 605, "ranking": 18689, "num": 584 }, { "id": 16456, "year": 2023, "is_wenli": 2, "score": 604, "ranking": 19248, "num": 559 }, { "id": 16457, "year": 2023, "is_wenli": 2, "score": 603, "ranking": 19849, "num": 601 }, { "id": 16458, "year": 2023, "is_wenli": 2, "score": 602, "ranking": 20418, "num": 569 }, { "id": 16459, "year": 2023, "is_wenli": 2, "score": 601, "ranking": 21021, "num": 603 }, { "id": 16460, "year": 2023, "is_wenli": 2, "score": 600, "ranking": 21690, "num": 669 }, { "id": 16461, "year": 2023, "is_wenli": 2, "score": 599, "ranking": 22358, "num": 668 }, { "id": 16462, "year": 2023, "is_wenli": 2, "score": 598, "ranking": 23029, "num": 671 }, { "id": 16463, "year": 2023, "is_wenli": 2, "score": 597, "ranking": 23710, "num": 681 }, { "id": 16464, "year": 2023, "is_wenli": 2, "score": 596, "ranking": 24444, "num": 734 }, { "id": 16465, "year": 2023, "is_wenli": 2, "score": 595, "ranking": 25156, "num": 712 }, { "id": 16466, "year": 2023, "is_wenli": 2, "score": 594, "ranking": 25874, "num": 718 }, { "id": 16467, "year": 2023, "is_wenli": 2, "score": 593, "ranking": 26587, "num": 713 }, { "id": 16468, "year": 2023, "is_wenli": 2, "score": 592, "ranking": 27318, "num": 731 }, { "id": 16469, "year": 2023, "is_wenli": 2, "score": 591, "ranking": 28052, "num": 734 }, { "id": 16470, "year": 2023, "is_wenli": 2, "score": 590, "ranking": 28881, "num": 829 }, { "id": 16471, "year": 2023, "is_wenli": 2, "score": 589, "ranking": 29681, "num": 800 }, { "id": 16472, "year": 2023, "is_wenli": 2, "score": 588, "ranking": 30481, "num": 800 }, { "id": 16473, "year": 2023, "is_wenli": 2, "score": 587, "ranking": 31315, "num": 834 }, { "id": 16474, "year": 2023, "is_wenli": 2, "score": 586, "ranking": 32135, "num": 820 }, { "id": 16475, "year": 2023, "is_wenli": 2, "score": 585, "ranking": 33012, "num": 877 }, { "id": 16476, "year": 2023, "is_wenli": 2, "score": 584, "ranking": 33845, "num": 833 }, { "id": 16477, "year": 2023, "is_wenli": 2, "score": 583, "ranking": 34767, "num": 922 }, { "id": 16478, "year": 2023, "is_wenli": 2, "score": 582, "ranking": 35635, "num": 868 }, { "id": 16479, "year": 2023, "is_wenli": 2, "score": 581, "ranking": 36540, "num": 905 }, { "id": 16480, "year": 2023, "is_wenli": 2, "score": 580, "ranking": 37479, "num": 939 }, { "id": 16481, "year": 2023, "is_wenli": 2, "score": 579, "ranking": 38365, "num": 886 }, { "id": 16482, "year": 2023, "is_wenli": 2, "score": 578, "ranking": 39314, "num": 949 }, { "id": 16483, "year": 2023, "is_wenli": 2, "score": 577, "ranking": 40252, "num": 938 }, { "id": 16484, "year": 2023, "is_wenli": 2, "score": 576, "ranking": 41196, "num": 944 }, { "id": 16485, "year": 2023, "is_wenli": 2, "score": 575, "ranking": 42149, "num": 953 }, { "id": 16486, "year": 2023, "is_wenli": 2, "score": 574, "ranking": 43114, "num": 965 }, { "id": 16487, "year": 2023, "is_wenli": 2, "score": 573, "ranking": 44106, "num": 992 }, { "id": 16488, "year": 2023, "is_wenli": 2, "score": 572, "ranking": 45094, "num": 988 }, { "id": 16489, "year": 2023, "is_wenli": 2, "score": 571, "ranking": 46132, "num": 1038 }, { "id": 16490, "year": 2023, "is_wenli": 2, "score": 570, "ranking": 47216, "num": 1084 }, { "id": 16491, "year": 2023, "is_wenli": 2, "score": 569, "ranking": 48276, "num": 1060 }, { "id": 16492, "year": 2023, "is_wenli": 2, "score": 568, "ranking": 49343, "num": 1067 }, { "id": 16493, "year": 2023, "is_wenli": 2, "score": 567, "ranking": 50409, "num": 1066 }, { "id": 16494, "year": 2023, "is_wenli": 2, "score": 566, "ranking": 51529, "num": 1120 }, { "id": 16495, "year": 2023, "is_wenli": 2, "score": 565, "ranking": 52597, "num": 1068 }, { "id": 16496, "year": 2023, "is_wenli": 2, "score": 564, "ranking": 53716, "num": 1119 }, { "id": 16497, "year": 2023, "is_wenli": 2, "score": 563, "ranking": 54864, "num": 1148 }, { "id": 16498, "year": 2023, "is_wenli": 2, "score": 562, "ranking": 55999, "num": 1135 }, { "id": 16499, "year": 2023, "is_wenli": 2, "score": 561, "ranking": 57115, "num": 1116 }, { "id": 16500, "year": 2023, "is_wenli": 2, "score": 560, "ranking": 58304, "num": 1189 }, { "id": 16501, "year": 2023, "is_wenli": 2, "score": 559, "ranking": 59481, "num": 1177 }, { "id": 16502, "year": 2023, "is_wenli": 2, "score": 558, "ranking": 60657, "num": 1176 }, { "id": 16503, "year": 2023, "is_wenli": 2, "score": 557, "ranking": 61944, "num": 1287 }, { "id": 16504, "year": 2023, "is_wenli": 2, "score": 556, "ranking": 63193, "num": 1249 }, { "id": 16505, "year": 2023, "is_wenli": 2, "score": 555, "ranking": 64505, "num": 1312 }, { "id": 16506, "year": 2023, "is_wenli": 2, "score": 554, "ranking": 65789, "num": 1284 }, { "id": 16507, "year": 2023, "is_wenli": 2, "score": 553, "ranking": 67050, "num": 1261 }, { "id": 16508, "year": 2023, "is_wenli": 2, "score": 552, "ranking": 68278, "num": 1228 }, { "id": 16509, "year": 2023, "is_wenli": 2, "score": 551, "ranking": 69662, "num": 1384 }, { "id": 16510, "year": 2023, "is_wenli": 2, "score": 550, "ranking": 70991, "num": 1329 }, { "id": 16511, "year": 2023, "is_wenli": 2, "score": 549, "ranking": 72337, "num": 1346 }, { "id": 16512, "year": 2023, "is_wenli": 2, "score": 548, "ranking": 73607, "num": 1270 }, { "id": 16513, "year": 2023, "is_wenli": 2, "score": 547, "ranking": 74961, "num": 1354 }, { "id": 16514, "year": 2023, "is_wenli": 2, "score": 546, "ranking": 76354, "num": 1393 }, { "id": 16515, "year": 2023, "is_wenli": 2, "score": 545, "ranking": 77768, "num": 1414 }, { "id": 16516, "year": 2023, "is_wenli": 2, "score": 544, "ranking": 79143, "num": 1375 }, { "id": 16517, "year": 2023, "is_wenli": 2, "score": 543, "ranking": 80568, "num": 1425 }, { "id": 16518, "year": 2023, "is_wenli": 2, "score": 542, "ranking": 81975, "num": 1407 }, { "id": 16519, "year": 2023, "is_wenli": 2, "score": 541, "ranking": 83430, "num": 1455 }, { "id": 16520, "year": 2023, "is_wenli": 2, "score": 540, "ranking": 84884, "num": 1454 }, { "id": 16521, "year": 2023, "is_wenli": 2, "score": 539, "ranking": 86255, "num": 1371 }, { "id": 16522, "year": 2023, "is_wenli": 2, "score": 538, "ranking": 87738, "num": 1483 }, { "id": 16523, "year": 2023, "is_wenli": 2, "score": 537, "ranking": 89231, "num": 1493 }, { "id": 16524, "year": 2023, "is_wenli": 2, "score": 536, "ranking": 90770, "num": 1539 }, { "id": 16525, "year": 2023, "is_wenli": 2, "score": 535, "ranking": 92225, "num": 1455 }, { "id": 16526, "year": 2023, "is_wenli": 2, "score": 534, "ranking": 93677, "num": 1452 }, { "id": 16527, "year": 2023, "is_wenli": 2, "score": 533, "ranking": 95116, "num": 1439 }, { "id": 16528, "year": 2023, "is_wenli": 2, "score": 532, "ranking": 96633, "num": 1517 }, { "id": 16529, "year": 2023, "is_wenli": 2, "score": 531, "ranking": 98157, "num": 1524 }, { "id": 16530, "year": 2023, "is_wenli": 2, "score": 530, "ranking": 99673, "num": 1516 }, { "id": 16531, "year": 2023, "is_wenli": 2, "score": 529, "ranking": 101260, "num": 1587 }, { "id": 16532, "year": 2023, "is_wenli": 2, "score": 528, "ranking": 102802, "num": 1542 }, { "id": 16533, "year": 2023, "is_wenli": 2, "score": 527, "ranking": 104360, "num": 1558 }, { "id": 16534, "year": 2023, "is_wenli": 2, "score": 526, "ranking": 105904, "num": 1544 }, { "id": 16535, "year": 2023, "is_wenli": 2, "score": 525, "ranking": 107463, "num": 1559 }, { "id": 16536, "year": 2023, "is_wenli": 2, "score": 524, "ranking": 109013, "num": 1550 }, { "id": 16537, "year": 2023, "is_wenli": 2, "score": 523, "ranking": 110642, "num": 1629 }, { "id": 16538, "year": 2023, "is_wenli": 2, "score": 522, "ranking": 112300, "num": 1658 }, { "id": 16539, "year": 2023, "is_wenli": 2, "score": 521, "ranking": 113938, "num": 1638 }, { "id": 16540, "year": 2023, "is_wenli": 2, "score": 520, "ranking": 115516, "num": 1578 }, { "id": 16541, "year": 2023, "is_wenli": 2, "score": 519, "ranking": 117138, "num": 1622 }, { "id": 16542, "year": 2023, "is_wenli": 2, "score": 518, "ranking": 118760, "num": 1622 }, { "id": 16543, "year": 2023, "is_wenli": 2, "score": 517, "ranking": 120414, "num": 1654 }, { "id": 16544, "year": 2023, "is_wenli": 2, "score": 516, "ranking": 122128, "num": 1714 }, { "id": 16545, "year": 2023, "is_wenli": 2, "score": 515, "ranking": 123771, "num": 1643 }, { "id": 16546, "year": 2023, "is_wenli": 2, "score": 514, "ranking": 125465, "num": 1694 }, { "id": 16547, "year": 2023, "is_wenli": 2, "score": 513, "ranking": 127155, "num": 1690 }, { "id": 16548, "year": 2023, "is_wenli": 2, "score": 512, "ranking": 128863, "num": 1708 }, { "id": 16549, "year": 2023, "is_wenli": 2, "score": 511, "ranking": 130500, "num": 1637 }, { "id": 16550, "year": 2023, "is_wenli": 2, "score": 510, "ranking": 132206, "num": 1706 }, { "id": 16551, "year": 2023, "is_wenli": 2, "score": 509, "ranking": 133928, "num": 1722 }, { "id": 16552, "year": 2023, "is_wenli": 2, "score": 508, "ranking": 135648, "num": 1720 }, { "id": 16553, "year": 2023, "is_wenli": 2, "score": 507, "ranking": 137351, "num": 1703 }, { "id": 16554, "year": 2023, "is_wenli": 2, "score": 506, "ranking": 139053, "num": 1702 }, { "id": 16555, "year": 2023, "is_wenli": 2, "score": 505, "ranking": 140854, "num": 1801 }, { "id": 16556, "year": 2023, "is_wenli": 2, "score": 504, "ranking": 142648, "num": 1794 }, { "id": 16557, "year": 2023, "is_wenli": 2, "score": 503, "ranking": 144399, "num": 1751 }, { "id": 16558, "year": 2023, "is_wenli": 2, "score": 502, "ranking": 146079, "num": 1680 }, { "id": 16559, "year": 2023, "is_wenli": 2, "score": 501, "ranking": 147888, "num": 1809 }, { "id": 16560, "year": 2023, "is_wenli": 2, "score": 500, "ranking": 149644, "num": 1756 }, { "id": 16561, "year": 2023, "is_wenli": 2, "score": 499, "ranking": 151419, "num": 1775 }, { "id": 16562, "year": 2023, "is_wenli": 2, "score": 498, "ranking": 153160, "num": 1741 }, { "id": 16563, "year": 2023, "is_wenli": 2, "score": 497, "ranking": 154946, "num": 1786 }, { "id": 16564, "year": 2023, "is_wenli": 2, "score": 496, "ranking": 156724, "num": 1778 }, { "id": 16565, "year": 2023, "is_wenli": 2, "score": 495, "ranking": 158506, "num": 1782 }, { "id": 16566, "year": 2023, "is_wenli": 2, "score": 494, "ranking": 160353, "num": 1847 }, { "id": 16567, "year": 2023, "is_wenli": 2, "score": 493, "ranking": 162074, "num": 1721 }, { "id": 16568, "year": 2023, "is_wenli": 2, "score": 492, "ranking": 163896, "num": 1822 }, { "id": 16569, "year": 2023, "is_wenli": 2, "score": 491, "ranking": 165708, "num": 1812 }, { "id": 16570, "year": 2023, "is_wenli": 2, "score": 490, "ranking": 167514, "num": 1806 }, { "id": 16571, "year": 2023, "is_wenli": 2, "score": 489, "ranking": 169362, "num": 1848 }, { "id": 16572, "year": 2023, "is_wenli": 2, "score": 488, "ranking": 171116, "num": 1754 }, { "id": 16573, "year": 2023, "is_wenli": 2, "score": 487, "ranking": 172946, "num": 1830 }, { "id": 16574, "year": 2023, "is_wenli": 2, "score": 486, "ranking": 174777, "num": 1831 }, { "id": 16575, "year": 2023, "is_wenli": 2, "score": 485, "ranking": 176563, "num": 1786 }, { "id": 16576, "year": 2023, "is_wenli": 2, "score": 484, "ranking": 178469, "num": 1906 }, { "id": 16577, "year": 2023, "is_wenli": 2, "score": 483, "ranking": 180297, "num": 1828 }, { "id": 16578, "year": 2023, "is_wenli": 2, "score": 482, "ranking": 182126, "num": 1829 }, { "id": 16579, "year": 2023, "is_wenli": 2, "score": 481, "ranking": 184018, "num": 1892 }, { "id": 16580, "year": 2023, "is_wenli": 2, "score": 480, "ranking": 185833, "num": 1815 }, { "id": 16581, "year": 2023, "is_wenli": 2, "score": 479, "ranking": 187640, "num": 1807 }, { "id": 16582, "year": 2023, "is_wenli": 2, "score": 478, "ranking": 189445, "num": 1805 }, { "id": 16583, "year": 2023, "is_wenli": 2, "score": 477, "ranking": 191323, "num": 1878 }, { "id": 16584, "year": 2023, "is_wenli": 2, "score": 476, "ranking": 193156, "num": 1833 }, { "id": 16585, "year": 2023, "is_wenli": 2, "score": 475, "ranking": 195041, "num": 1885 }, { "id": 16586, "year": 2023, "is_wenli": 2, "score": 474, "ranking": 197003, "num": 1962 }, { "id": 16587, "year": 2023, "is_wenli": 2, "score": 473, "ranking": 198806, "num": 1803 }, { "id": 16588, "year": 2023, "is_wenli": 2, "score": 472, "ranking": 200616, "num": 1810 }, { "id": 16589, "year": 2023, "is_wenli": 2, "score": 471, "ranking": 202505, "num": 1889 }, { "id": 16590, "year": 2023, "is_wenli": 2, "score": 470, "ranking": 204468, "num": 1963 }, { "id": 16591, "year": 2023, "is_wenli": 2, "score": 469, "ranking": 206385, "num": 1917 }, { "id": 16592, "year": 2023, "is_wenli": 2, "score": 468, "ranking": 208260, "num": 1875 }, { "id": 16593, "year": 2023, "is_wenli": 2, "score": 467, "ranking": 210220, "num": 1960 }, { "id": 16594, "year": 2023, "is_wenli": 2, "score": 466, "ranking": 212192, "num": 1972 }, { "id": 16595, "year": 2023, "is_wenli": 2, "score": 465, "ranking": 214176, "num": 1984 }, { "id": 16596, "year": 2023, "is_wenli": 2, "score": 464, "ranking": 216090, "num": 1914 }, { "id": 16597, "year": 2023, "is_wenli": 2, "score": 463, "ranking": 217952, "num": 1862 }, { "id": 16598, "year": 2023, "is_wenli": 2, "score": 462, "ranking": 219911, "num": 1959 }, { "id": 16599, "year": 2023, "is_wenli": 2, "score": 461, "ranking": 221856, "num": 1945 }, { "id": 16600, "year": 2023, "is_wenli": 2, "score": 460, "ranking": 223738, "num": 1882 }, { "id": 16601, "year": 2023, "is_wenli": 2, "score": 459, "ranking": 225698, "num": 1960 }, { "id": 16602, "year": 2023, "is_wenli": 2, "score": 458, "ranking": 227633, "num": 1935 }, { "id": 16603, "year": 2023, "is_wenli": 2, "score": 457, "ranking": 229602, "num": 1969 }, { "id": 16604, "year": 2023, "is_wenli": 2, "score": 456, "ranking": 231580, "num": 1978 }, { "id": 16605, "year": 2023, "is_wenli": 2, "score": 455, "ranking": 233549, "num": 1969 }, { "id": 16606, "year": 2023, "is_wenli": 2, "score": 454, "ranking": 235469, "num": 1920 }, { "id": 16607, "year": 2023, "is_wenli": 2, "score": 453, "ranking": 237404, "num": 1935 }, { "id": 16608, "year": 2023, "is_wenli": 2, "score": 452, "ranking": 239276, "num": 1872 }, { "id": 16609, "year": 2023, "is_wenli": 2, "score": 451, "ranking": 241174, "num": 1898 }, { "id": 16610, "year": 2023, "is_wenli": 2, "score": 450, "ranking": 243094, "num": 1920 }, { "id": 16611, "year": 2023, "is_wenli": 2, "score": 449, "ranking": 245035, "num": 1941 }, { "id": 16612, "year": 2023, "is_wenli": 2, "score": 448, "ranking": 247029, "num": 1994 }, { "id": 16613, "year": 2023, "is_wenli": 2, "score": 447, "ranking": 249000, "num": 1971 }, { "id": 16614, "year": 2023, "is_wenli": 2, "score": 446, "ranking": 250931, "num": 1931 }, { "id": 16615, "year": 2023, "is_wenli": 2, "score": 445, "ranking": 252817, "num": 1886 }, { "id": 16616, "year": 2023, "is_wenli": 2, "score": 444, "ranking": 254693, "num": 1876 }, { "id": 16617, "year": 2023, "is_wenli": 2, "score": 443, "ranking": 256642, "num": 1949 }, { "id": 16618, "year": 2023, "is_wenli": 2, "score": 442, "ranking": 258525, "num": 1883 }, { "id": 16619, "year": 2023, "is_wenli": 2, "score": 441, "ranking": 260429, "num": 1904 }, { "id": 16620, "year": 2023, "is_wenli": 2, "score": 440, "ranking": 262241, "num": 1812 }, { "id": 16621, "year": 2023, "is_wenli": 2, "score": 439, "ranking": 264262, "num": 2021 }, { "id": 16622, "year": 2023, "is_wenli": 2, "score": 438, "ranking": 266148, "num": 1886 }, { "id": 16623, "year": 2023, "is_wenli": 2, "score": 437, "ranking": 268026, "num": 1878 }, { "id": 16624, "year": 2023, "is_wenli": 2, "score": 436, "ranking": 269959, "num": 1933 }, { "id": 16625, "year": 2023, "is_wenli": 2, "score": 435, "ranking": 271868, "num": 1909 }, { "id": 16626, "year": 2023, "is_wenli": 2, "score": 434, "ranking": 273775, "num": 1907 }, { "id": 16627, "year": 2023, "is_wenli": 2, "score": 433, "ranking": 275766, "num": 1991 }, { "id": 16628, "year": 2023, "is_wenli": 2, "score": 432, "ranking": 277702, "num": 1936 }, { "id": 16629, "year": 2023, "is_wenli": 2, "score": 431, "ranking": 279582, "num": 1880 }, { "id": 16630, "year": 2023, "is_wenli": 2, "score": 430, "ranking": 281485, "num": 1903 }, { "id": 16631, "year": 2023, "is_wenli": 2, "score": 429, "ranking": 283404, "num": 1919 }, { "id": 16632, "year": 2023, "is_wenli": 2, "score": 428, "ranking": 285277, "num": 1873 }, { "id": 16633, "year": 2023, "is_wenli": 2, "score": 427, "ranking": 287135, "num": 1858 }, { "id": 16634, "year": 2023, "is_wenli": 2, "score": 426, "ranking": 289014, "num": 1879 }, { "id": 16635, "year": 2023, "is_wenli": 2, "score": 425, "ranking": 290883, "num": 1869 }, { "id": 16636, "year": 2023, "is_wenli": 2, "score": 424, "ranking": 292709, "num": 1826 }, { "id": 16637, "year": 2023, "is_wenli": 2, "score": 423, "ranking": 294589, "num": 1880 }, { "id": 16638, "year": 2023, "is_wenli": 2, "score": 422, "ranking": 296409, "num": 1820 }, { "id": 16639, "year": 2023, "is_wenli": 2, "score": 421, "ranking": 298246, "num": 1837 }, { "id": 16640, "year": 2023, "is_wenli": 2, "score": 420, "ranking": 300076, "num": 1830 }, { "id": 16641, "year": 2023, "is_wenli": 2, "score": 419, "ranking": 301909, "num": 1833 }, { "id": 16642, "year": 2023, "is_wenli": 2, "score": 418, "ranking": 303789, "num": 1880 }, { "id": 16643, "year": 2023, "is_wenli": 2, "score": 417, "ranking": 305605, "num": 1816 }, { "id": 16644, "year": 2023, "is_wenli": 2, "score": 416, "ranking": 307409, "num": 1804 }, { "id": 16645, "year": 2023, "is_wenli": 2, "score": 415, "ranking": 309237, "num": 1828 }, { "id": 16646, "year": 2023, "is_wenli": 2, "score": 414, "ranking": 311112, "num": 1875 }, { "id": 16647, "year": 2023, "is_wenli": 2, "score": 413, "ranking": 312965, "num": 1853 }, { "id": 16648, "year": 2023, "is_wenli": 2, "score": 412, "ranking": 314815, "num": 1850 }, { "id": 16649, "year": 2023, "is_wenli": 2, "score": 411, "ranking": 316583, "num": 1768 }, { "id": 16650, "year": 2023, "is_wenli": 2, "score": 410, "ranking": 318459, "num": 1876 }, { "id": 16651, "year": 2023, "is_wenli": 2, "score": 409, "ranking": 320263, "num": 1804 }, { "id": 16652, "year": 2023, "is_wenli": 2, "score": 408, "ranking": 322041, "num": 1778 }, { "id": 16653, "year": 2023, "is_wenli": 2, "score": 407, "ranking": 323853, "num": 1812 }, { "id": 16654, "year": 2023, "is_wenli": 2, "score": 406, "ranking": 325658, "num": 1805 }, { "id": 16655, "year": 2023, "is_wenli": 2, "score": 405, "ranking": 327414, "num": 1756 }, { "id": 16656, "year": 2023, "is_wenli": 2, "score": 404, "ranking": 329152, "num": 1738 }, { "id": 16657, "year": 2023, "is_wenli": 2, "score": 403, "ranking": 330867, "num": 1715 }, { "id": 16658, "year": 2023, "is_wenli": 2, "score": 402, "ranking": 332667, "num": 1800 }, { "id": 16659, "year": 2023, "is_wenli": 2, "score": 401, "ranking": 334434, "num": 1767 }, { "id": 16660, "year": 2023, "is_wenli": 2, "score": 400, "ranking": 336219, "num": 1785 }, { "id": 16661, "year": 2023, "is_wenli": 2, "score": 399, "ranking": 337950, "num": 1731 }, { "id": 16662, "year": 2023, "is_wenli": 2, "score": 398, "ranking": 339673, "num": 1723 }, { "id": 16663, "year": 2023, "is_wenli": 2, "score": 397, "ranking": 341393, "num": 1720 }, { "id": 16664, "year": 2023, "is_wenli": 2, "score": 396, "ranking": 343060, "num": 1667 }, { "id": 16665, "year": 2023, "is_wenli": 2, "score": 395, "ranking": 344766, "num": 1706 }, { "id": 16666, "year": 2023, "is_wenli": 2, "score": 394, "ranking": 346484, "num": 1718 }, { "id": 16667, "year": 2023, "is_wenli": 2, "score": 393, "ranking": 348187, "num": 1703 }, { "id": 16668, "year": 2023, "is_wenli": 2, "score": 392, "ranking": 349831, "num": 1644 }, { "id": 16669, "year": 2023, "is_wenli": 2, "score": 391, "ranking": 351493, "num": 1662 }, { "id": 16670, "year": 2023, "is_wenli": 2, "score": 390, "ranking": 353148, "num": 1655 }, { "id": 16671, "year": 2023, "is_wenli": 2, "score": 389, "ranking": 354813, "num": 1665 }, { "id": 16672, "year": 2023, "is_wenli": 2, "score": 388, "ranking": 356437, "num": 1624 }, { "id": 16673, "year": 2023, "is_wenli": 2, "score": 387, "ranking": 358073, "num": 1636 }, { "id": 16674, "year": 2023, "is_wenli": 2, "score": 386, "ranking": 359611, "num": 1538 }, { "id": 16675, "year": 2023, "is_wenli": 2, "score": 385, "ranking": 361205, "num": 1594 }, { "id": 16676, "year": 2023, "is_wenli": 2, "score": 384, "ranking": 362807, "num": 1602 }, { "id": 16677, "year": 2023, "is_wenli": 2, "score": 383, "ranking": 364431, "num": 1624 }, { "id": 16678, "year": 2023, "is_wenli": 2, "score": 382, "ranking": 365991, "num": 1560 }, { "id": 16679, "year": 2023, "is_wenli": 2, "score": 381, "ranking": 367562, "num": 1571 }, { "id": 16680, "year": 2023, "is_wenli": 2, "score": 380, "ranking": 369185, "num": 1623 }, { "id": 16681, "year": 2023, "is_wenli": 2, "score": 379, "ranking": 370708, "num": 1523 }, { "id": 16682, "year": 2023, "is_wenli": 2, "score": 378, "ranking": 372260, "num": 1552 }, { "id": 16683, "year": 2023, "is_wenli": 2, "score": 377, "ranking": 373803, "num": 1543 }, { "id": 16684, "year": 2023, "is_wenli": 2, "score": 376, "ranking": 375417, "num": 1614 }, { "id": 16685, "year": 2023, "is_wenli": 2, "score": 375, "ranking": 376940, "num": 1523 }, { "id": 16686, "year": 2023, "is_wenli": 2, "score": 374, "ranking": 378425, "num": 1485 }, { "id": 16687, "year": 2023, "is_wenli": 2, "score": 373, "ranking": 379936, "num": 1511 }, { "id": 16688, "year": 2023, "is_wenli": 2, "score": 372, "ranking": 381419, "num": 1483 }, { "id": 16689, "year": 2023, "is_wenli": 2, "score": 371, "ranking": 382929, "num": 1510 }, { "id": 16690, "year": 2023, "is_wenli": 2, "score": 370, "ranking": 384414, "num": 1485 }, { "id": 16691, "year": 2023, "is_wenli": 2, "score": 369, "ranking": 385935, "num": 1521 }, { "id": 16692, "year": 2023, "is_wenli": 2, "score": 368, "ranking": 387410, "num": 1475 }, { "id": 16693, "year": 2023, "is_wenli": 2, "score": 367, "ranking": 388876, "num": 1466 }, { "id": 16694, "year": 2023, "is_wenli": 2, "score": 366, "ranking": 390311, "num": 1435 }, { "id": 16695, "year": 2023, "is_wenli": 2, "score": 365, "ranking": 391850, "num": 1539 }, { "id": 16696, "year": 2023, "is_wenli": 2, "score": 364, "ranking": 393328, "num": 1478 }, { "id": 16697, "year": 2023, "is_wenli": 2, "score": 363, "ranking": 394738, "num": 1410 }, { "id": 16698, "year": 2023, "is_wenli": 2, "score": 362, "ranking": 396151, "num": 1413 }, { "id": 16699, "year": 2023, "is_wenli": 2, "score": 361, "ranking": 397644, "num": 1493 }, { "id": 16700, "year": 2023, "is_wenli": 2, "score": 360, "ranking": 399057, "num": 1413 }, { "id": 16701, "year": 2023, "is_wenli": 2, "score": 359, "ranking": 400479, "num": 1422 }, { "id": 16702, "year": 2023, "is_wenli": 2, "score": 358, "ranking": 401910, "num": 1431 }, { "id": 16703, "year": 2023, "is_wenli": 2, "score": 357, "ranking": 403331, "num": 1421 }, { "id": 16704, "year": 2023, "is_wenli": 2, "score": 356, "ranking": 404675, "num": 1344 }, { "id": 16705, "year": 2023, "is_wenli": 2, "score": 355, "ranking": 406034, "num": 1359 }, { "id": 16706, "year": 2023, "is_wenli": 2, "score": 354, "ranking": 407397, "num": 1363 }, { "id": 16707, "year": 2023, "is_wenli": 2, "score": 353, "ranking": 408748, "num": 1351 }, { "id": 16708, "year": 2023, "is_wenli": 2, "score": 352, "ranking": 410156, "num": 1408 }, { "id": 16709, "year": 2023, "is_wenli": 2, "score": 351, "ranking": 411520, "num": 1364 }, { "id": 16710, "year": 2023, "is_wenli": 2, "score": 350, "ranking": 412838, "num": 1318 }, { "id": 16711, "year": 2023, "is_wenli": 2, "score": 349, "ranking": 414124, "num": 1286 }, { "id": 16712, "year": 2023, "is_wenli": 2, "score": 348, "ranking": 415452, "num": 1328 }, { "id": 16713, "year": 2023, "is_wenli": 2, "score": 347, "ranking": 416744, "num": 1292 }, { "id": 16714, "year": 2023, "is_wenli": 2, "score": 346, "ranking": 417958, "num": 1214 }, { "id": 16715, "year": 2023, "is_wenli": 2, "score": 345, "ranking": 419253, "num": 1295 }, { "id": 16716, "year": 2023, "is_wenli": 2, "score": 344, "ranking": 420575, "num": 1322 }, { "id": 16717, "year": 2023, "is_wenli": 2, "score": 343, "ranking": 421775, "num": 1200 }, { "id": 16718, "year": 2023, "is_wenli": 2, "score": 342, "ranking": 423067, "num": 1292 }, { "id": 16719, "year": 2023, "is_wenli": 2, "score": 341, "ranking": 424296, "num": 1229 }, { "id": 16720, "year": 2023, "is_wenli": 2, "score": 340, "ranking": 425527, "num": 1231 }, { "id": 16721, "year": 2023, "is_wenli": 2, "score": 339, "ranking": 426745, "num": 1218 }, { "id": 16722, "year": 2023, "is_wenli": 2, "score": 338, "ranking": 427945, "num": 1200 }, { "id": 16723, "year": 2023, "is_wenli": 2, "score": 337, "ranking": 429138, "num": 1193 }, { "id": 16724, "year": 2023, "is_wenli": 2, "score": 336, "ranking": 430374, "num": 1236 }, { "id": 16725, "year": 2023, "is_wenli": 2, "score": 335, "ranking": 431597, "num": 1223 }, { "id": 16726, "year": 2023, "is_wenli": 2, "score": 334, "ranking": 432766, "num": 1169 }, { "id": 16727, "year": 2023, "is_wenli": 2, "score": 333, "ranking": 433940, "num": 1174 }, { "id": 16728, "year": 2023, "is_wenli": 2, "score": 332, "ranking": 435117, "num": 1177 }, { "id": 16729, "year": 2023, "is_wenli": 2, "score": 331, "ranking": 436250, "num": 1133 }, { "id": 16730, "year": 2023, "is_wenli": 2, "score": 330, "ranking": 437365, "num": 1115 }, { "id": 16731, "year": 2023, "is_wenli": 2, "score": 329, "ranking": 438472, "num": 1107 }, { "id": 16732, "year": 2023, "is_wenli": 2, "score": 328, "ranking": 439523, "num": 1051 }, { "id": 16733, "year": 2023, "is_wenli": 2, "score": 327, "ranking": 440703, "num": 1180 }, { "id": 16734, "year": 2023, "is_wenli": 2, "score": 326, "ranking": 441852, "num": 1149 }, { "id": 16735, "year": 2023, "is_wenli": 2, "score": 325, "ranking": 442932, "num": 1080 }, { "id": 16736, "year": 2023, "is_wenli": 2, "score": 324, "ranking": 444009, "num": 1077 }, { "id": 16737, "year": 2023, "is_wenli": 2, "score": 323, "ranking": 445062, "num": 1053 }, { "id": 16738, "year": 2023, "is_wenli": 2, "score": 322, "ranking": 446084, "num": 1022 }, { "id": 16739, "year": 2023, "is_wenli": 2, "score": 321, "ranking": 447113, "num": 1029 }, { "id": 16740, "year": 2023, "is_wenli": 2, "score": 320, "ranking": 448216, "num": 1103 }, { "id": 16741, "year": 2023, "is_wenli": 2, "score": 319, "ranking": 449238, "num": 1022 }, { "id": 16742, "year": 2023, "is_wenli": 2, "score": 318, "ranking": 450231, "num": 993 }, { "id": 16743, "year": 2023, "is_wenli": 2, "score": 317, "ranking": 451317, "num": 1086 }, { "id": 16744, "year": 2023, "is_wenli": 2, "score": 316, "ranking": 452359, "num": 1042 }, { "id": 16745, "year": 2023, "is_wenli": 2, "score": 315, "ranking": 453433, "num": 1074 }, { "id": 16746, "year": 2023, "is_wenli": 2, "score": 314, "ranking": 454489, "num": 1056 }, { "id": 16747, "year": 2023, "is_wenli": 2, "score": 313, "ranking": 455496, "num": 1007 }, { "id": 16748, "year": 2023, "is_wenli": 2, "score": 312, "ranking": 456434, "num": 938 }, { "id": 16749, "year": 2023, "is_wenli": 2, "score": 311, "ranking": 457427, "num": 993 }, { "id": 16750, "year": 2023, "is_wenli": 2, "score": 310, "ranking": 458405, "num": 978 }, { "id": 16751, "year": 2023, "is_wenli": 2, "score": 309, "ranking": 459368, "num": 963 }, { "id": 16752, "year": 2023, "is_wenli": 2, "score": 308, "ranking": 460325, "num": 957 }, { "id": 16753, "year": 2023, "is_wenli": 2, "score": 307, "ranking": 461254, "num": 929 }, { "id": 16754, "year": 2023, "is_wenli": 2, "score": 306, "ranking": 462201, "num": 947 }, { "id": 16755, "year": 2023, "is_wenli": 2, "score": 305, "ranking": 463158, "num": 957 }, { "id": 16756, "year": 2023, "is_wenli": 2, "score": 304, "ranking": 464089, "num": 931 }, { "id": 16757, "year": 2023, "is_wenli": 2, "score": 303, "ranking": 465045, "num": 956 }, { "id": 16758, "year": 2023, "is_wenli": 2, "score": 302, "ranking": 465996, "num": 951 }, { "id": 16759, "year": 2023, "is_wenli": 2, "score": 301, "ranking": 466903, "num": 907 }, { "id": 16760, "year": 2023, "is_wenli": 2, "score": 300, "ranking": 467829, "num": 926 }, { "id": 16761, "year": 2023, "is_wenli": 2, "score": 299, "ranking": 468732, "num": 903 }, { "id": 16762, "year": 2023, "is_wenli": 2, "score": 298, "ranking": 469573, "num": 841 }, { "id": 16763, "year": 2023, "is_wenli": 2, "score": 297, "ranking": 470468, "num": 895 }, { "id": 16764, "year": 2023, "is_wenli": 2, "score": 296, "ranking": 471371, "num": 903 }, { "id": 16765, "year": 2023, "is_wenli": 2, "score": 295, "ranking": 472240, "num": 869 }, { "id": 16766, "year": 2023, "is_wenli": 2, "score": 294, "ranking": 473089, "num": 849 }, { "id": 16767, "year": 2023, "is_wenli": 2, "score": 293, "ranking": 473931, "num": 842 }, { "id": 16768, "year": 2023, "is_wenli": 2, "score": 292, "ranking": 474762, "num": 831 }, { "id": 16769, "year": 2023, "is_wenli": 2, "score": 291, "ranking": 475558, "num": 796 }, { "id": 16770, "year": 2023, "is_wenli": 2, "score": 290, "ranking": 476377, "num": 819 }, { "id": 16771, "year": 2023, "is_wenli": 2, "score": 289, "ranking": 477210, "num": 833 }, { "id": 16772, "year": 2023, "is_wenli": 2, "score": 288, "ranking": 478024, "num": 814 }, { "id": 16773, "year": 2023, "is_wenli": 2, "score": 287, "ranking": 478838, "num": 814 }, { "id": 16774, "year": 2023, "is_wenli": 2, "score": 286, "ranking": 479626, "num": 788 }, { "id": 16775, "year": 2023, "is_wenli": 2, "score": 285, "ranking": 480404, "num": 778 }, { "id": 16776, "year": 2023, "is_wenli": 2, "score": 284, "ranking": 481234, "num": 830 }, { "id": 16777, "year": 2023, "is_wenli": 2, "score": 283, "ranking": 482005, "num": 771 }, { "id": 16778, "year": 2023, "is_wenli": 2, "score": 282, "ranking": 482832, "num": 827 }, { "id": 16779, "year": 2023, "is_wenli": 2, "score": 281, "ranking": 483613, "num": 781 }, { "id": 16780, "year": 2023, "is_wenli": 2, "score": 280, "ranking": 484365, "num": 752 }, { "id": 16781, "year": 2023, "is_wenli": 2, "score": 279, "ranking": 485079, "num": 714 }, { "id": 16782, "year": 2023, "is_wenli": 2, "score": 278, "ranking": 485850, "num": 771 }, { "id": 16783, "year": 2023, "is_wenli": 2, "score": 277, "ranking": 486615, "num": 765 }, { "id": 16784, "year": 2023, "is_wenli": 2, "score": 276, "ranking": 487334, "num": 719 }, { "id": 16785, "year": 2023, "is_wenli": 2, "score": 275, "ranking": 488039, "num": 705 }, { "id": 16786, "year": 2023, "is_wenli": 2, "score": 274, "ranking": 488776, "num": 737 }, { "id": 16787, "year": 2023, "is_wenli": 2, "score": 273, "ranking": 489497, "num": 721 }, { "id": 16788, "year": 2023, "is_wenli": 2, "score": 272, "ranking": 490229, "num": 732 }, { "id": 16789, "year": 2023, "is_wenli": 2, "score": 271, "ranking": 490946, "num": 717 }, { "id": 16790, "year": 2023, "is_wenli": 2, "score": 270, "ranking": 491651, "num": 705 }, { "id": 16791, "year": 2023, "is_wenli": 2, "score": 269, "ranking": 492339, "num": 688 }, { "id": 16792, "year": 2023, "is_wenli": 2, "score": 268, "ranking": 493044, "num": 705 }, { "id": 16793, "year": 2023, "is_wenli": 2, "score": 267, "ranking": 493735, "num": 691 }, { "id": 16794, "year": 2023, "is_wenli": 2, "score": 266, "ranking": 494386, "num": 651 }, { "id": 16795, "year": 2023, "is_wenli": 2, "score": 265, "ranking": 495041, "num": 655 }, { "id": 16796, "year": 2023, "is_wenli": 2, "score": 264, "ranking": 495691, "num": 650 }, { "id": 16797, "year": 2023, "is_wenli": 2, "score": 263, "ranking": 496320, "num": 629 }, { "id": 16798, "year": 2023, "is_wenli": 2, "score": 262, "ranking": 497020, "num": 700 }, { "id": 16799, "year": 2023, "is_wenli": 2, "score": 261, "ranking": 497702, "num": 682 }, { "id": 16800, "year": 2023, "is_wenli": 2, "score": 260, "ranking": 498297, "num": 595 }, { "id": 16801, "year": 2023, "is_wenli": 2, "score": 259, "ranking": 498867, "num": 570 }, { "id": 16802, "year": 2023, "is_wenli": 2, "score": 258, "ranking": 499495, "num": 628 }, { "id": 16803, "year": 2023, "is_wenli": 2, "score": 257, "ranking": 500110, "num": 615 }, { "id": 16804, "year": 2023, "is_wenli": 2, "score": 256, "ranking": 500715, "num": 605 }, { "id": 16805, "year": 2023, "is_wenli": 2, "score": 255, "ranking": 501333, "num": 618 }, { "id": 16806, "year": 2023, "is_wenli": 2, "score": 254, "ranking": 501942, "num": 609 }, { "id": 16807, "year": 2023, "is_wenli": 2, "score": 253, "ranking": 502523, "num": 581 }, { "id": 16808, "year": 2023, "is_wenli": 2, "score": 252, "ranking": 503122, "num": 599 }, { "id": 16809, "year": 2023, "is_wenli": 2, "score": 251, "ranking": 503678, "num": 556 }, { "id": 16810, "year": 2023, "is_wenli": 2, "score": 250, "ranking": 504210, "num": 532 }, { "id": 16811, "year": 2023, "is_wenli": 2, "score": 249, "ranking": 504764, "num": 554 }, { "id": 16812, "year": 2023, "is_wenli": 2, "score": 248, "ranking": 505329, "num": 565 }, { "id": 16813, "year": 2023, "is_wenli": 2, "score": 247, "ranking": 505897, "num": 568 }, { "id": 16814, "year": 2023, "is_wenli": 2, "score": 246, "ranking": 506431, "num": 534 }, { "id": 16815, "year": 2023, "is_wenli": 2, "score": 245, "ranking": 506952, "num": 521 }, { "id": 16816, "year": 2023, "is_wenli": 2, "score": 244, "ranking": 507519, "num": 567 }, { "id": 16817, "year": 2023, "is_wenli": 2, "score": 243, "ranking": 508043, "num": 524 }, { "id": 16818, "year": 2023, "is_wenli": 2, "score": 242, "ranking": 508538, "num": 495 }, { "id": 16819, "year": 2023, "is_wenli": 2, "score": 241, "ranking": 509042, "num": 504 }, { "id": 16820, "year": 2023, "is_wenli": 2, "score": 240, "ranking": 509566, "num": 524 }, { "id": 16821, "year": 2023, "is_wenli": 2, "score": 239, "ranking": 510069, "num": 503 }, { "id": 16822, "year": 2023, "is_wenli": 2, "score": 238, "ranking": 510601, "num": 532 }, { "id": 16823, "year": 2023, "is_wenli": 2, "score": 237, "ranking": 511074, "num": 473 }, { "id": 16824, "year": 2023, "is_wenli": 2, "score": 236, "ranking": 511560, "num": 486 }, { "id": 16825, "year": 2023, "is_wenli": 2, "score": 235, "ranking": 512041, "num": 481 }, { "id": 16826, "year": 2023, "is_wenli": 2, "score": 234, "ranking": 512496, "num": 455 }, { "id": 16827, "year": 2023, "is_wenli": 2, "score": 233, "ranking": 512975, "num": 479 }, { "id": 16828, "year": 2023, "is_wenli": 2, "score": 232, "ranking": 513444, "num": 469 }, { "id": 16829, "year": 2023, "is_wenli": 2, "score": 231, "ranking": 513924, "num": 480 }, { "id": 16830, "year": 2023, "is_wenli": 2, "score": 230, "ranking": 514374, "num": 450 }, { "id": 16831, "year": 2023, "is_wenli": 2, "score": 229, "ranking": 514826, "num": 452 }, { "id": 16832, "year": 2023, "is_wenli": 2, "score": 228, "ranking": 515297, "num": 471 }, { "id": 16833, "year": 2023, "is_wenli": 2, "score": 227, "ranking": 515771, "num": 474 }, { "id": 16834, "year": 2023, "is_wenli": 2, "score": 226, "ranking": 516153, "num": 382 }, { "id": 16835, "year": 2023, "is_wenli": 2, "score": 225, "ranking": 516558, "num": 405 }, { "id": 16836, "year": 2023, "is_wenli": 2, "score": 224, "ranking": 516985, "num": 427 }, { "id": 16837, "year": 2023, "is_wenli": 2, "score": 223, "ranking": 517413, "num": 428 }, { "id": 16838, "year": 2023, "is_wenli": 2, "score": 222, "ranking": 517847, "num": 434 }, { "id": 16839, "year": 2023, "is_wenli": 2, "score": 221, "ranking": 518252, "num": 405 }, { "id": 16840, "year": 2023, "is_wenli": 2, "score": 220, "ranking": 518671, "num": 419 }, { "id": 16841, "year": 2023, "is_wenli": 2, "score": 219, "ranking": 519061, "num": 390 }, { "id": 16842, "year": 2023, "is_wenli": 2, "score": 218, "ranking": 519481, "num": 420 }, { "id": 16843, "year": 2023, "is_wenli": 2, "score": 217, "ranking": 519900, "num": 419 }, { "id": 16844, "year": 2023, "is_wenli": 2, "score": 216, "ranking": 520315, "num": 415 }, { "id": 16845, "year": 2023, "is_wenli": 2, "score": 215, "ranking": 520732, "num": 417 }, { "id": 16846, "year": 2023, "is_wenli": 2, "score": 214, "ranking": 521127, "num": 395 }, { "id": 16847, "year": 2023, "is_wenli": 2, "score": 213, "ranking": 521486, "num": 359 }, { "id": 16848, "year": 2023, "is_wenli": 2, "score": 212, "ranking": 521851, "num": 365 }, { "id": 16849, "year": 2023, "is_wenli": 2, "score": 211, "ranking": 522209, "num": 358 }, { "id": 16850, "year": 2023, "is_wenli": 2, "score": 210, "ranking": 522555, "num": 346 }, { "id": 16851, "year": 2023, "is_wenli": 2, "score": 209, "ranking": 522908, "num": 353 }, { "id": 16852, "year": 2023, "is_wenli": 2, "score": 208, "ranking": 523255, "num": 347 }, { "id": 16853, "year": 2023, "is_wenli": 2, "score": 207, "ranking": 523586, "num": 331 }, { "id": 16854, "year": 2023, "is_wenli": 2, "score": 206, "ranking": 523962, "num": 376 }, { "id": 16855, "year": 2023, "is_wenli": 2, "score": 205, "ranking": 524279, "num": 317 }, { "id": 16856, "year": 2023, "is_wenli": 2, "score": 204, "ranking": 524617, "num": 338 }, { "id": 16857, "year": 2023, "is_wenli": 2, "score": 203, "ranking": 524909, "num": 292 }, { "id": 16858, "year": 2023, "is_wenli": 2, "score": 202, "ranking": 525240, "num": 331 }, { "id": 16859, "year": 2023, "is_wenli": 2, "score": 201, "ranking": 525566, "num": 326 }, { "id": 16860, "year": 2023, "is_wenli": 2, "score": 200, "ranking": 525869, "num": 303 }, { "id": 16861, "year": 2023, "is_wenli": 2, "score": 199, "ranking": 526202, "num": 333 }, { "id": 16862, "year": 2023, "is_wenli": 2, "score": 198, "ranking": 526527, "num": 325 }, { "id": 16863, "year": 2023, "is_wenli": 2, "score": 197, "ranking": 526794, "num": 267 }, { "id": 16864, "year": 2023, "is_wenli": 2, "score": 196, "ranking": 527083, "num": 289 }, { "id": 16865, "year": 2023, "is_wenli": 2, "score": 195, "ranking": 527376, "num": 293 }, { "id": 16866, "year": 2023, "is_wenli": 2, "score": 194, "ranking": 527682, "num": 306 }, { "id": 16867, "year": 2023, "is_wenli": 2, "score": 193, "ranking": 527980, "num": 298 }, { "id": 16868, "year": 2023, "is_wenli": 2, "score": 192, "ranking": 528264, "num": 284 }, { "id": 16869, "year": 2023, "is_wenli": 2, "score": 191, "ranking": 528543, "num": 279 }, { "id": 16870, "year": 2023, "is_wenli": 2, "score": 190, "ranking": 528805, "num": 262 }, { "id": 16871, "year": 2023, "is_wenli": 2, "score": 189, "ranking": 529067, "num": 262 }, { "id": 16872, "year": 2023, "is_wenli": 2, "score": 188, "ranking": 529323, "num": 256 }, { "id": 16873, "year": 2023, "is_wenli": 2, "score": 187, "ranking": 529591, "num": 268 }, { "id": 16874, "year": 2023, "is_wenli": 2, "score": 186, "ranking": 529851, "num": 260 }, { "id": 16875, "year": 2023, "is_wenli": 2, "score": 185, "ranking": 530084, "num": 233 }, { "id": 16876, "year": 2023, "is_wenli": 2, "score": 184, "ranking": 530343, "num": 259 }, { "id": 16877, "year": 2023, "is_wenli": 2, "score": 183, "ranking": 530569, "num": 226 }, { "id": 16878, "year": 2023, "is_wenli": 2, "score": 182, "ranking": 530792, "num": 223 }, { "id": 16879, "year": 2023, "is_wenli": 2, "score": 181, "ranking": 531035, "num": 243 }, { "id": 16880, "year": 2023, "is_wenli": 2, "score": 180, "ranking": 531281, "num": 246 }, { "id": 16881, "year": 2023, "is_wenli": 2, "score": 179, "ranking": 531523, "num": 242 }, { "id": 16882, "year": 2023, "is_wenli": 2, "score": 178, "ranking": 531750, "num": 227 }, { "id": 16883, "year": 2023, "is_wenli": 2, "score": 177, "ranking": 531955, "num": 205 }, { "id": 16884, "year": 2023, "is_wenli": 2, "score": 176, "ranking": 532146, "num": 191 }, { "id": 16885, "year": 2023, "is_wenli": 2, "score": 175, "ranking": 532350, "num": 204 }, { "id": 16886, "year": 2023, "is_wenli": 2, "score": 174, "ranking": 532546, "num": 196 }, { "id": 16887, "year": 2023, "is_wenli": 2, "score": 173, "ranking": 532756, "num": 210 }, { "id": 16888, "year": 2023, "is_wenli": 2, "score": 172, "ranking": 532966, "num": 210 }, { "id": 16889, "year": 2023, "is_wenli": 2, "score": 171, "ranking": 533133, "num": 167 }, { "id": 16890, "year": 2023, "is_wenli": 2, "score": 170, "ranking": 533355, "num": 222 }, { "id": 16891, "year": 2023, "is_wenli": 2, "score": 169, "ranking": 533551, "num": 196 }, { "id": 16892, "year": 2023, "is_wenli": 2, "score": 168, "ranking": 533743, "num": 192 }, { "id": 16893, "year": 2023, "is_wenli": 2, "score": 167, "ranking": 533923, "num": 180 }, { "id": 16894, "year": 2023, "is_wenli": 2, "score": 166, "ranking": 534104, "num": 181 }, { "id": 16895, "year": 2023, "is_wenli": 2, "score": 165, "ranking": 534287, "num": 183 }, { "id": 16896, "year": 2023, "is_wenli": 2, "score": 164, "ranking": 534463, "num": 176 }, { "id": 16897, "year": 2023, "is_wenli": 2, "score": 163, "ranking": 534627, "num": 164 }, { "id": 16898, "year": 2023, "is_wenli": 2, "score": 162, "ranking": 534794, "num": 167 }, { "id": 16899, "year": 2023, "is_wenli": 2, "score": 161, "ranking": 534953, "num": 159 }, { "id": 16900, "year": 2023, "is_wenli": 2, "score": 160, "ranking": 535103, "num": 150 }, { "id": 16901, "year": 2023, "is_wenli": 2, "score": 159, "ranking": 535236, "num": 133 }, { "id": 16902, "year": 2023, "is_wenli": 2, "score": 158, "ranking": 535398, "num": 162 }, { "id": 16903, "year": 2023, "is_wenli": 2, "score": 157, "ranking": 535538, "num": 140 }, { "id": 16904, "year": 2023, "is_wenli": 2, "score": 156, "ranking": 535696, "num": 158 }, { "id": 16905, "year": 2023, "is_wenli": 2, "score": 155, "ranking": 535848, "num": 152 }, { "id": 16906, "year": 2023, "is_wenli": 2, "score": 154, "ranking": 535981, "num": 133 }, { "id": 16907, "year": 2023, "is_wenli": 2, "score": 153, "ranking": 536103, "num": 122 }, { "id": 16908, "year": 2023, "is_wenli": 2, "score": 152, "ranking": 536252, "num": 149 }, { "id": 16909, "year": 2023, "is_wenli": 2, "score": 151, "ranking": 536360, "num": 108 }, { "id": 16910, "year": 2023, "is_wenli": 2, "score": 150, "ranking": 536487, "num": 127 }, { "id": 16911, "year": 2023, "is_wenli": 2, "score": 149, "ranking": 536599, "num": 112 }, { "id": 16912, "year": 2023, "is_wenli": 2, "score": 148, "ranking": 536721, "num": 122 }, { "id": 16913, "year": 2023, "is_wenli": 2, "score": 147, "ranking": 536824, "num": 103 }, { "id": 16914, "year": 2023, "is_wenli": 2, "score": 146, "ranking": 536943, "num": 119 }, { "id": 16915, "year": 2023, "is_wenli": 2, "score": 145, "ranking": 537057, "num": 114 }, { "id": 16916, "year": 2023, "is_wenli": 2, "score": 144, "ranking": 537165, "num": 108 }, { "id": 16917, "year": 2023, "is_wenli": 2, "score": 143, "ranking": 537248, "num": 83 }, { "id": 16918, "year": 2023, "is_wenli": 2, "score": 142, "ranking": 537348, "num": 100 }, { "id": 16919, "year": 2023, "is_wenli": 2, "score": 141, "ranking": 537439, "num": 91 }, { "id": 16920, "year": 2023, "is_wenli": 2, "score": 140, "ranking": 537541, "num": 102 }, { "id": 16921, "year": 2023, "is_wenli": 2, "score": 139, "ranking": 537632, "num": 91 }, { "id": 16922, "year": 2023, "is_wenli": 2, "score": 138, "ranking": 537708, "num": 76 }, { "id": 16923, "year": 2023, "is_wenli": 2, "score": 137, "ranking": 537788, "num": 80 }, { "id": 16924, "year": 2023, "is_wenli": 2, "score": 136, "ranking": 537867, "num": 79 }, { "id": 16925, "year": 2023, "is_wenli": 2, "score": 135, "ranking": 537951, "num": 84 }, { "id": 16926, "year": 2023, "is_wenli": 2, "score": 134, "ranking": 538016, "num": 65 }, { "id": 16927, "year": 2023, "is_wenli": 2, "score": 133, "ranking": 538090, "num": 74 }, { "id": 16928, "year": 2023, "is_wenli": 2, "score": 132, "ranking": 538156, "num": 66 }, { "id": 16929, "year": 2023, "is_wenli": 2, "score": 131, "ranking": 538227, "num": 71 }, { "id": 16930, "year": 2023, "is_wenli": 2, "score": 130, "ranking": 538306, "num": 79 }, { "id": 16931, "year": 2023, "is_wenli": 2, "score": 129, "ranking": 538368, "num": 62 }, { "id": 16932, "year": 2023, "is_wenli": 2, "score": 128, "ranking": 538426, "num": 58 }, { "id": 16933, "year": 2023, "is_wenli": 2, "score": 127, "ranking": 538487, "num": 61 }, { "id": 16934, "year": 2023, "is_wenli": 2, "score": 126, "ranking": 538535, "num": 48 }, { "id": 16935, "year": 2023, "is_wenli": 2, "score": 125, "ranking": 538582, "num": 47 }, { "id": 16936, "year": 2023, "is_wenli": 2, "score": 124, "ranking": 538634, "num": 52 }, { "id": 16937, "year": 2023, "is_wenli": 2, "score": 123, "ranking": 538687, "num": 53 }, { "id": 16938, "year": 2023, "is_wenli": 2, "score": 122, "ranking": 538722, "num": 35 }, { "id": 16939, "year": 2023, "is_wenli": 2, "score": 121, "ranking": 538768, "num": 46 }, { "id": 16940, "year": 2023, "is_wenli": 2, "score": 120, "ranking": 538818, "num": 50 }, { "id": 16941, "year": 2023, "is_wenli": 2, "score": 119, "ranking": 538856, "num": 38 }, { "id": 16942, "year": 2023, "is_wenli": 2, "score": 118, "ranking": 538902, "num": 46 }, { "id": 16943, "year": 2023, "is_wenli": 2, "score": 117, "ranking": 538948, "num": 46 }, { "id": 16944, "year": 2023, "is_wenli": 2, "score": 116, "ranking": 538984, "num": 36 }, { "id": 16945, "year": 2023, "is_wenli": 2, "score": 115, "ranking": 539030, "num": 46 }, { "id": 16946, "year": 2023, "is_wenli": 2, "score": 114, "ranking": 539069, "num": 39 }, { "id": 16947, "year": 2023, "is_wenli": 2, "score": 113, "ranking": 539110, "num": 41 }, { "id": 16948, "year": 2023, "is_wenli": 2, "score": 112, "ranking": 539143, "num": 33 }, { "id": 16949, "year": 2023, "is_wenli": 2, "score": 111, "ranking": 539172, "num": 29 }, { "id": 16950, "year": 2023, "is_wenli": 2, "score": 110, "ranking": 539201, "num": 29 }, { "id": 16951, "year": 2023, "is_wenli": 2, "score": 109, "ranking": 539229, "num": 28 }, { "id": 16952, "year": 2023, "is_wenli": 2, "score": 108, "ranking": 539249, "num": 20 }, { "id": 16953, "year": 2023, "is_wenli": 2, "score": 107, "ranking": 539276, "num": 27 }, { "id": 16954, "year": 2023, "is_wenli": 2, "score": 106, "ranking": 539301, "num": 25 }, { "id": 16955, "year": 2023, "is_wenli": 2, "score": 105, "ranking": 539327, "num": 26 }, { "id": 16956, "year": 2023, "is_wenli": 2, "score": 104, "ranking": 539350, "num": 23 }, { "id": 16957, "year": 2023, "is_wenli": 2, "score": 103, "ranking": 539376, "num": 26 }, { "id": 16958, "year": 2023, "is_wenli": 2, "score": 102, "ranking": 539394, "num": 18 }, { "id": 16959, "year": 2023, "is_wenli": 2, "score": 101, "ranking": 539419, "num": 25 }, { "id": 16960, "year": 2023, "is_wenli": 2, "score": 100, "ranking": 539447, "num": 28 }
    ]
    ,
    2022: [
        {
            "id": 15141,
            "year": 2022,
            "is_wenli": 2,
            "score": 698,
            "ranking": 10,
            "num": 10
        },

        {
            "id": 15142,
            "year": 2022,
            "is_wenli": 2,
            "score": 696,
            "ranking": 11,
            "num": 1
        },

        {
            "id": 15143,
            "year": 2022,
            "is_wenli": 2,
            "score": 695,
            "ranking": 13,
            "num": 2
        },

        {
            "id": 15144,
            "year": 2022,
            "is_wenli": 2,
            "score": 694,
            "ranking": 14,
            "num": 1
        },

        {
            "id": 15145,
            "year": 2022,
            "is_wenli": 2,
            "score": 693,
            "ranking": 16,
            "num": 2
        },

        {
            "id": 15146,
            "year": 2022,
            "is_wenli": 2,
            "score": 692,
            "ranking": 24,
            "num": 8
        },

        {
            "id": 15147,
            "year": 2022,
            "is_wenli": 2,
            "score": 691,
            "ranking": 27,
            "num": 3
        },

        {
            "id": 15148,
            "year": 2022,
            "is_wenli": 2,
            "score": 690,
            "ranking": 31,
            "num": 4
        },

        {
            "id": 15149,
            "year": 2022,
            "is_wenli": 2,
            "score": 689,
            "ranking": 42,
            "num": 11
        },

        {
            "id": 15150,
            "year": 2022,
            "is_wenli": 2,
            "score": 688,
            "ranking": 48,
            "num": 6
        },

        {
            "id": 15151,
            "year": 2022,
            "is_wenli": 2,
            "score": 687,
            "ranking": 56,
            "num": 8
        },

        {
            "id": 15152,
            "year": 2022,
            "is_wenli": 2,
            "score": 686,
            "ranking": 68,
            "num": 12
        },

        {
            "id": 15153,
            "year": 2022,
            "is_wenli": 2,
            "score": 685,
            "ranking": 71,
            "num": 3
        },

        {
            "id": 15154,
            "year": 2022,
            "is_wenli": 2,
            "score": 684,
            "ranking": 82,
            "num": 11
        },

        {
            "id": 15155,
            "year": 2022,
            "is_wenli": 2,
            "score": 683,
            "ranking": 95,
            "num": 13
        },

        {
            "id": 15156,
            "year": 2022,
            "is_wenli": 2,
            "score": 682,
            "ranking": 113,
            "num": 18
        },

        {
            "id": 15157,
            "year": 2022,
            "is_wenli": 2,
            "score": 681,
            "ranking": 136,
            "num": 23
        },

        {
            "id": 15158,
            "year": 2022,
            "is_wenli": 2,
            "score": 680,
            "ranking": 162,
            "num": 26
        },

        {
            "id": 15159,
            "year": 2022,
            "is_wenli": 2,
            "score": 679,
            "ranking": 176,
            "num": 14
        },

        {
            "id": 15160,
            "year": 2022,
            "is_wenli": 2,
            "score": 678,
            "ranking": 198,
            "num": 22
        },

        {
            "id": 15161,
            "year": 2022,
            "is_wenli": 2,
            "score": 677,
            "ranking": 223,
            "num": 25
        },

        {
            "id": 15162,
            "year": 2022,
            "is_wenli": 2,
            "score": 676,
            "ranking": 248,
            "num": 25
        },

        {
            "id": 15163,
            "year": 2022,
            "is_wenli": 2,
            "score": 675,
            "ranking": 276,
            "num": 28
        },

        {
            "id": 15164,
            "year": 2022,
            "is_wenli": 2,
            "score": 674,
            "ranking": 307,
            "num": 31
        },

        {
            "id": 15165,
            "year": 2022,
            "is_wenli": 2,
            "score": 673,
            "ranking": 331,
            "num": 24
        },

        {
            "id": 15166,
            "year": 2022,
            "is_wenli": 2,
            "score": 672,
            "ranking": 369,
            "num": 38
        },

        {
            "id": 15167,
            "year": 2022,
            "is_wenli": 2,
            "score": 671,
            "ranking": 397,
            "num": 28
        },

        {
            "id": 15168,
            "year": 2022,
            "is_wenli": 2,
            "score": 670,
            "ranking": 428,
            "num": 31
        },

        {
            "id": 15169,
            "year": 2022,
            "is_wenli": 2,
            "score": 669,
            "ranking": 451,
            "num": 23
        },

        {
            "id": 15170,
            "year": 2022,
            "is_wenli": 2,
            "score": 668,
            "ranking": 488,
            "num": 37
        },

        {
            "id": 15171,
            "year": 2022,
            "is_wenli": 2,
            "score": 667,
            "ranking": 525,
            "num": 37
        },

        {
            "id": 15172,
            "year": 2022,
            "is_wenli": 2,
            "score": 666,
            "ranking": 574,
            "num": 49
        },

        {
            "id": 15173,
            "year": 2022,
            "is_wenli": 2,
            "score": 665,
            "ranking": 625,
            "num": 51
        },

        {
            "id": 15174,
            "year": 2022,
            "is_wenli": 2,
            "score": 664,
            "ranking": 681,
            "num": 56
        },

        {
            "id": 15175,
            "year": 2022,
            "is_wenli": 2,
            "score": 663,
            "ranking": 734,
            "num": 53
        },

        {
            "id": 15176,
            "year": 2022,
            "is_wenli": 2,
            "score": 662,
            "ranking": 776,
            "num": 42
        },

        {
            "id": 15177,
            "year": 2022,
            "is_wenli": 2,
            "score": 661,
            "ranking": 831,
            "num": 55
        },

        {
            "id": 15178,
            "year": 2022,
            "is_wenli": 2,
            "score": 660,
            "ranking": 895,
            "num": 64
        },

        {
            "id": 15179,
            "year": 2022,
            "is_wenli": 2,
            "score": 659,
            "ranking": 955,
            "num": 60
        },

        {
            "id": 15180,
            "year": 2022,
            "is_wenli": 2,
            "score": 658,
            "ranking": 1016,
            "num": 61
        },

        {
            "id": 15181,
            "year": 2022,
            "is_wenli": 2,
            "score": 657,
            "ranking": 1071,
            "num": 55
        },

        {
            "id": 15182,
            "year": 2022,
            "is_wenli": 2,
            "score": 656,
            "ranking": 1147,
            "num": 76
        },

        {
            "id": 15183,
            "year": 2022,
            "is_wenli": 2,
            "score": 655,
            "ranking": 1232,
            "num": 85
        },

        {
            "id": 15184,
            "year": 2022,
            "is_wenli": 2,
            "score": 654,
            "ranking": 1314,
            "num": 82
        },

        {
            "id": 15185,
            "year": 2022,
            "is_wenli": 2,
            "score": 653,
            "ranking": 1397,
            "num": 83
        },

        {
            "id": 15186,
            "year": 2022,
            "is_wenli": 2,
            "score": 652,
            "ranking": 1487,
            "num": 90
        },

        {
            "id": 15187,
            "year": 2022,
            "is_wenli": 2,
            "score": 651,
            "ranking": 1570,
            "num": 83
        },

        {
            "id": 15188,
            "year": 2022,
            "is_wenli": 2,
            "score": 650,
            "ranking": 1663,
            "num": 93
        },

        {
            "id": 15189,
            "year": 2022,
            "is_wenli": 2,
            "score": 649,
            "ranking": 1778,
            "num": 115
        },

        {
            "id": 15190,
            "year": 2022,
            "is_wenli": 2,
            "score": 648,
            "ranking": 1888,
            "num": 110
        },

        {
            "id": 15191,
            "year": 2022,
            "is_wenli": 2,
            "score": 647,
            "ranking": 1990,
            "num": 102
        },

        {
            "id": 15192,
            "year": 2022,
            "is_wenli": 2,
            "score": 646,
            "ranking": 2107,
            "num": 117
        },

        {
            "id": 15193,
            "year": 2022,
            "is_wenli": 2,
            "score": 645,
            "ranking": 2236,
            "num": 129
        },

        {
            "id": 15194,
            "year": 2022,
            "is_wenli": 2,
            "score": 644,
            "ranking": 2336,
            "num": 100
        },

        {
            "id": 15195,
            "year": 2022,
            "is_wenli": 2,
            "score": 643,
            "ranking": 2458,
            "num": 122
        },

        {
            "id": 15196,
            "year": 2022,
            "is_wenli": 2,
            "score": 642,
            "ranking": 2581,
            "num": 123
        },

        {
            "id": 15197,
            "year": 2022,
            "is_wenli": 2,
            "score": 641,
            "ranking": 2684,
            "num": 103
        },

        {
            "id": 15198,
            "year": 2022,
            "is_wenli": 2,
            "score": 640,
            "ranking": 2844,
            "num": 160
        },

        {
            "id": 15199,
            "year": 2022,
            "is_wenli": 2,
            "score": 639,
            "ranking": 3002,
            "num": 158
        },

        {
            "id": 15200,
            "year": 2022,
            "is_wenli": 2,
            "score": 638,
            "ranking": 3161,
            "num": 159
        },

        {
            "id": 15201,
            "year": 2022,
            "is_wenli": 2,
            "score": 637,
            "ranking": 3333,
            "num": 172
        },

        {
            "id": 15202,
            "year": 2022,
            "is_wenli": 2,
            "score": 636,
            "ranking": 3480,
            "num": 147
        },

        {
            "id": 15203,
            "year": 2022,
            "is_wenli": 2,
            "score": 635,
            "ranking": 3650,
            "num": 170
        },

        {
            "id": 15204,
            "year": 2022,
            "is_wenli": 2,
            "score": 634,
            "ranking": 3843,
            "num": 193
        },

        {
            "id": 15205,
            "year": 2022,
            "is_wenli": 2,
            "score": 633,
            "ranking": 4040,
            "num": 197
        },

        {
            "id": 15206,
            "year": 2022,
            "is_wenli": 2,
            "score": 632,
            "ranking": 4233,
            "num": 193
        },

        {
            "id": 15207,
            "year": 2022,
            "is_wenli": 2,
            "score": 631,
            "ranking": 4434,
            "num": 201
        },

        {
            "id": 15208,
            "year": 2022,
            "is_wenli": 2,
            "score": 630,
            "ranking": 4629,
            "num": 195
        },

        {
            "id": 15209,
            "year": 2022,
            "is_wenli": 2,
            "score": 629,
            "ranking": 4848,
            "num": 219
        },

        {
            "id": 15210,
            "year": 2022,
            "is_wenli": 2,
            "score": 628,
            "ranking": 5058,
            "num": 210
        },

        {
            "id": 15211,
            "year": 2022,
            "is_wenli": 2,
            "score": 627,
            "ranking": 5267,
            "num": 209
        },

        {
            "id": 15212,
            "year": 2022,
            "is_wenli": 2,
            "score": 626,
            "ranking": 5504,
            "num": 237
        },

        {
            "id": 15213,
            "year": 2022,
            "is_wenli": 2,
            "score": 625,
            "ranking": 5771,
            "num": 267
        },

        {
            "id": 15214,
            "year": 2022,
            "is_wenli": 2,
            "score": 624,
            "ranking": 6028,
            "num": 257
        },

        {
            "id": 15215,
            "year": 2022,
            "is_wenli": 2,
            "score": 623,
            "ranking": 6309,
            "num": 281
        },

        {
            "id": 15216,
            "year": 2022,
            "is_wenli": 2,
            "score": 622,
            "ranking": 6598,
            "num": 289
        },

        {
            "id": 15217,
            "year": 2022,
            "is_wenli": 2,
            "score": 621,
            "ranking": 6875,
            "num": 277
        },

        {
            "id": 15218,
            "year": 2022,
            "is_wenli": 2,
            "score": 620,
            "ranking": 7180,
            "num": 305
        },

        {
            "id": 15219,
            "year": 2022,
            "is_wenli": 2,
            "score": 619,
            "ranking": 7490,
            "num": 310
        },

        {
            "id": 15220,
            "year": 2022,
            "is_wenli": 2,
            "score": 618,
            "ranking": 7814,
            "num": 324
        },

        {
            "id": 15221,
            "year": 2022,
            "is_wenli": 2,
            "score": 617,
            "ranking": 8122,
            "num": 308
        },

        {
            "id": 15222,
            "year": 2022,
            "is_wenli": 2,
            "score": 616,
            "ranking": 8467,
            "num": 345
        },

        {
            "id": 15223,
            "year": 2022,
            "is_wenli": 2,
            "score": 615,
            "ranking": 8816,
            "num": 349
        },

        {
            "id": 15224,
            "year": 2022,
            "is_wenli": 2,
            "score": 614,
            "ranking": 9163,
            "num": 347
        },

        {
            "id": 15225,
            "year": 2022,
            "is_wenli": 2,
            "score": 613,
            "ranking": 9522,
            "num": 359
        },

        {
            "id": 15226,
            "year": 2022,
            "is_wenli": 2,
            "score": 612,
            "ranking": 9863,
            "num": 341
        },

        {
            "id": 15227,
            "year": 2022,
            "is_wenli": 2,
            "score": 611,
            "ranking": 10304,
            "num": 441
        },

        {
            "id": 15228,
            "year": 2022,
            "is_wenli": 2,
            "score": 610,
            "ranking": 10741,
            "num": 437
        },

        {
            "id": 15229,
            "year": 2022,
            "is_wenli": 2,
            "score": 609,
            "ranking": 11202,
            "num": 461
        },

        {
            "id": 15230,
            "year": 2022,
            "is_wenli": 2,
            "score": 608,
            "ranking": 11637,
            "num": 435
        },

        {
            "id": 15231,
            "year": 2022,
            "is_wenli": 2,
            "score": 607,
            "ranking": 12067,
            "num": 430
        },

        {
            "id": 15232,
            "year": 2022,
            "is_wenli": 2,
            "score": 606,
            "ranking": 12461,
            "num": 394
        },

        {
            "id": 15233,
            "year": 2022,
            "is_wenli": 2,
            "score": 605,
            "ranking": 12898,
            "num": 437
        },

        {
            "id": 15234,
            "year": 2022,
            "is_wenli": 2,
            "score": 604,
            "ranking": 13355,
            "num": 457
        },

        {
            "id": 15235,
            "year": 2022,
            "is_wenli": 2,
            "score": 603,
            "ranking": 13797,
            "num": 442
        },

        {
            "id": 15236,
            "year": 2022,
            "is_wenli": 2,
            "score": 602,
            "ranking": 14255,
            "num": 458
        },

        {
            "id": 15237,
            "year": 2022,
            "is_wenli": 2,
            "score": 601,
            "ranking": 14755,
            "num": 500
        },

        {
            "id": 15238,
            "year": 2022,
            "is_wenli": 2,
            "score": 600,
            "ranking": 15216,
            "num": 461
        },

        {
            "id": 15239,
            "year": 2022,
            "is_wenli": 2,
            "score": 599,
            "ranking": 15751,
            "num": 535
        },

        {
            "id": 15240,
            "year": 2022,
            "is_wenli": 2,
            "score": 598,
            "ranking": 16307,
            "num": 556
        },

        {
            "id": 15241,
            "year": 2022,
            "is_wenli": 2,
            "score": 597,
            "ranking": 16878,
            "num": 571
        },

        {
            "id": 15242,
            "year": 2022,
            "is_wenli": 2,
            "score": 596,
            "ranking": 17463,
            "num": 585
        },

        {
            "id": 15243,
            "year": 2022,
            "is_wenli": 2,
            "score": 595,
            "ranking": 18060,
            "num": 597
        },

        {
            "id": 15244,
            "year": 2022,
            "is_wenli": 2,
            "score": 594,
            "ranking": 18630,
            "num": 570
        },

        {
            "id": 15245,
            "year": 2022,
            "is_wenli": 2,
            "score": 593,
            "ranking": 19260,
            "num": 630
        },

        {
            "id": 15246,
            "year": 2022,
            "is_wenli": 2,
            "score": 592,
            "ranking": 19875,
            "num": 615
        },

        {
            "id": 15247,
            "year": 2022,
            "is_wenli": 2,
            "score": 591,
            "ranking": 20499,
            "num": 624
        },

        {
            "id": 15248,
            "year": 2022,
            "is_wenli": 2,
            "score": 590,
            "ranking": 21142,
            "num": 643
        },

        {
            "id": 15249,
            "year": 2022,
            "is_wenli": 2,
            "score": 589,
            "ranking": 21800,
            "num": 658
        },

        {
            "id": 15250,
            "year": 2022,
            "is_wenli": 2,
            "score": 588,
            "ranking": 22462,
            "num": 662
        },

        {
            "id": 15251,
            "year": 2022,
            "is_wenli": 2,
            "score": 587,
            "ranking": 23098,
            "num": 636
        },

        {
            "id": 15252,
            "year": 2022,
            "is_wenli": 2,
            "score": 586,
            "ranking": 23793,
            "num": 695
        },

        {
            "id": 15253,
            "year": 2022,
            "is_wenli": 2,
            "score": 585,
            "ranking": 24528,
            "num": 735
        },

        {
            "id": 15254,
            "year": 2022,
            "is_wenli": 2,
            "score": 584,
            "ranking": 25296,
            "num": 768
        },

        {
            "id": 15255,
            "year": 2022,
            "is_wenli": 2,
            "score": 583,
            "ranking": 26058,
            "num": 762
        },

        {
            "id": 15256,
            "year": 2022,
            "is_wenli": 2,
            "score": 582,
            "ranking": 26826,
            "num": 768
        },

        {
            "id": 15257,
            "year": 2022,
            "is_wenli": 2,
            "score": 581,
            "ranking": 27613,
            "num": 787
        },

        {
            "id": 15258,
            "year": 2022,
            "is_wenli": 2,
            "score": 580,
            "ranking": 28410,
            "num": 797
        },

        {
            "id": 15259,
            "year": 2022,
            "is_wenli": 2,
            "score": 579,
            "ranking": 29255,
            "num": 845
        },

        {
            "id": 15260,
            "year": 2022,
            "is_wenli": 2,
            "score": 578,
            "ranking": 30098,
            "num": 843
        },

        {
            "id": 15261,
            "year": 2022,
            "is_wenli": 2,
            "score": 577,
            "ranking": 30905,
            "num": 807
        },

        {
            "id": 15262,
            "year": 2022,
            "is_wenli": 2,
            "score": 576,
            "ranking": 31813,
            "num": 908
        },

        {
            "id": 15263,
            "year": 2022,
            "is_wenli": 2,
            "score": 575,
            "ranking": 32661,
            "num": 848
        },

        {
            "id": 15264,
            "year": 2022,
            "is_wenli": 2,
            "score": 574,
            "ranking": 33525,
            "num": 864
        },

        {
            "id": 15265,
            "year": 2022,
            "is_wenli": 2,
            "score": 573,
            "ranking": 34386,
            "num": 861
        },

        {
            "id": 15266,
            "year": 2022,
            "is_wenli": 2,
            "score": 572,
            "ranking": 35312,
            "num": 926
        },

        {
            "id": 15267,
            "year": 2022,
            "is_wenli": 2,
            "score": 571,
            "ranking": 36261,
            "num": 949
        },

        {
            "id": 15268,
            "year": 2022,
            "is_wenli": 2,
            "score": 570,
            "ranking": 37209,
            "num": 948
        },

        {
            "id": 15269,
            "year": 2022,
            "is_wenli": 2,
            "score": 569,
            "ranking": 38099,
            "num": 890
        },

        {
            "id": 15270,
            "year": 2022,
            "is_wenli": 2,
            "score": 568,
            "ranking": 39068,
            "num": 969
        },

        {
            "id": 15271,
            "year": 2022,
            "is_wenli": 2,
            "score": 567,
            "ranking": 40090,
            "num": 1022
        },

        {
            "id": 15272,
            "year": 2022,
            "is_wenli": 2,
            "score": 566,
            "ranking": 41164,
            "num": 1074
        },

        {
            "id": 15273,
            "year": 2022,
            "is_wenli": 2,
            "score": 565,
            "ranking": 42195,
            "num": 1031
        },

        {
            "id": 15274,
            "year": 2022,
            "is_wenli": 2,
            "score": 564,
            "ranking": 43252,
            "num": 1057
        },

        {
            "id": 15275,
            "year": 2022,
            "is_wenli": 2,
            "score": 563,
            "ranking": 44297,
            "num": 1045
        },

        {
            "id": 15276,
            "year": 2022,
            "is_wenli": 2,
            "score": 562,
            "ranking": 45332,
            "num": 1035
        },

        {
            "id": 15277,
            "year": 2022,
            "is_wenli": 2,
            "score": 561,
            "ranking": 46342,
            "num": 1010
        },

        {
            "id": 15278,
            "year": 2022,
            "is_wenli": 2,
            "score": 560,
            "ranking": 47459,
            "num": 1117
        },

        {
            "id": 15279,
            "year": 2022,
            "is_wenli": 2,
            "score": 559,
            "ranking": 48530,
            "num": 1071
        },

        {
            "id": 15280,
            "year": 2022,
            "is_wenli": 2,
            "score": 558,
            "ranking": 49754,
            "num": 1224
        },

        {
            "id": 15281,
            "year": 2022,
            "is_wenli": 2,
            "score": 557,
            "ranking": 50915,
            "num": 1161
        },

        {
            "id": 15282,
            "year": 2022,
            "is_wenli": 2,
            "score": 556,
            "ranking": 52020,
            "num": 1105
        },

        {
            "id": 15283,
            "year": 2022,
            "is_wenli": 2,
            "score": 555,
            "ranking": 53255,
            "num": 1235
        },

        {
            "id": 15284,
            "year": 2022,
            "is_wenli": 2,
            "score": 554,
            "ranking": 54405,
            "num": 1150
        },

        {
            "id": 15285,
            "year": 2022,
            "is_wenli": 2,
            "score": 553,
            "ranking": 55587,
            "num": 1182
        },

        {
            "id": 15286,
            "year": 2022,
            "is_wenli": 2,
            "score": 552,
            "ranking": 56758,
            "num": 1171
        },

        {
            "id": 15287,
            "year": 2022,
            "is_wenli": 2,
            "score": 551,
            "ranking": 58004,
            "num": 1246
        },

        {
            "id": 15288,
            "year": 2022,
            "is_wenli": 2,
            "score": 550,
            "ranking": 59236,
            "num": 1232
        },

        {
            "id": 15289,
            "year": 2022,
            "is_wenli": 2,
            "score": 549,
            "ranking": 60499,
            "num": 1263
        },

        {
            "id": 15290,
            "year": 2022,
            "is_wenli": 2,
            "score": 548,
            "ranking": 61756,
            "num": 1257
        },

        {
            "id": 15291,
            "year": 2022,
            "is_wenli": 2,
            "score": 547,
            "ranking": 63022,
            "num": 1266
        },

        {
            "id": 15292,
            "year": 2022,
            "is_wenli": 2,
            "score": 546,
            "ranking": 64280,
            "num": 1258
        },

        {
            "id": 15293,
            "year": 2022,
            "is_wenli": 2,
            "score": 545,
            "ranking": 65632,
            "num": 1352
        },

        {
            "id": 15294,
            "year": 2022,
            "is_wenli": 2,
            "score": 544,
            "ranking": 66918,
            "num": 1286
        },

        {
            "id": 15295,
            "year": 2022,
            "is_wenli": 2,
            "score": 543,
            "ranking": 68292,
            "num": 1374
        },

        {
            "id": 15296,
            "year": 2022,
            "is_wenli": 2,
            "score": 542,
            "ranking": 69619,
            "num": 1327
        },

        {
            "id": 15297,
            "year": 2022,
            "is_wenli": 2,
            "score": 541,
            "ranking": 70931,
            "num": 1312
        },

        {
            "id": 15298,
            "year": 2022,
            "is_wenli": 2,
            "score": 540,
            "ranking": 72351,
            "num": 1420
        },

        {
            "id": 15299,
            "year": 2022,
            "is_wenli": 2,
            "score": 539,
            "ranking": 73712,
            "num": 1361
        },

        {
            "id": 15300,
            "year": 2022,
            "is_wenli": 2,
            "score": 538,
            "ranking": 75105,
            "num": 1393
        },

        {
            "id": 15301,
            "year": 2022,
            "is_wenli": 2,
            "score": 537,
            "ranking": 76524,
            "num": 1419
        },

        {
            "id": 15302,
            "year": 2022,
            "is_wenli": 2,
            "score": 536,
            "ranking": 78004,
            "num": 1480
        },

        {
            "id": 15303,
            "year": 2022,
            "is_wenli": 2,
            "score": 535,
            "ranking": 79411,
            "num": 1407
        },

        {
            "id": 15304,
            "year": 2022,
            "is_wenli": 2,
            "score": 534,
            "ranking": 80842,
            "num": 1431
        },

        {
            "id": 15305,
            "year": 2022,
            "is_wenli": 2,
            "score": 533,
            "ranking": 82265,
            "num": 1423
        },

        {
            "id": 15306,
            "year": 2022,
            "is_wenli": 2,
            "score": 532,
            "ranking": 83691,
            "num": 1426
        },

        {
            "id": 15307,
            "year": 2022,
            "is_wenli": 2,
            "score": 531,
            "ranking": 85142,
            "num": 1451
        },

        {
            "id": 15308,
            "year": 2022,
            "is_wenli": 2,
            "score": 530,
            "ranking": 86614,
            "num": 1472
        },

        {
            "id": 15309,
            "year": 2022,
            "is_wenli": 2,
            "score": 529,
            "ranking": 88126,
            "num": 1512
        },

        {
            "id": 15310,
            "year": 2022,
            "is_wenli": 2,
            "score": 528,
            "ranking": 89626,
            "num": 1500
        },

        {
            "id": 15311,
            "year": 2022,
            "is_wenli": 2,
            "score": 527,
            "ranking": 91117,
            "num": 1491
        },

        {
            "id": 15312,
            "year": 2022,
            "is_wenli": 2,
            "score": 526,
            "ranking": 92680,
            "num": 1563
        },

        {
            "id": 15313,
            "year": 2022,
            "is_wenli": 2,
            "score": 525,
            "ranking": 94214,
            "num": 1534
        },

        {
            "id": 15314,
            "year": 2022,
            "is_wenli": 2,
            "score": 524,
            "ranking": 95771,
            "num": 1557
        },

        {
            "id": 15315,
            "year": 2022,
            "is_wenli": 2,
            "score": 523,
            "ranking": 97348,
            "num": 1577
        },

        {
            "id": 15316,
            "year": 2022,
            "is_wenli": 2,
            "score": 522,
            "ranking": 98888,
            "num": 1540
        },

        {
            "id": 15317,
            "year": 2022,
            "is_wenli": 2,
            "score": 521,
            "ranking": 100394,
            "num": 1506
        },

        {
            "id": 15318,
            "year": 2022,
            "is_wenli": 2,
            "score": 520,
            "ranking": 101946,
            "num": 1552
        },

        {
            "id": 15319,
            "year": 2022,
            "is_wenli": 2,
            "score": 519,
            "ranking": 103576,
            "num": 1630
        },

        {
            "id": 15320,
            "year": 2022,
            "is_wenli": 2,
            "score": 518,
            "ranking": 105128,
            "num": 1552
        },

        {
            "id": 15321,
            "year": 2022,
            "is_wenli": 2,
            "score": 517,
            "ranking": 106694,
            "num": 1566
        },

        {
            "id": 15322,
            "year": 2022,
            "is_wenli": 2,
            "score": 516,
            "ranking": 108302,
            "num": 1608
        },

        {
            "id": 15323,
            "year": 2022,
            "is_wenli": 2,
            "score": 515,
            "ranking": 109967,
            "num": 1665
        },

        {
            "id": 15324,
            "year": 2022,
            "is_wenli": 2,
            "score": 514,
            "ranking": 111579,
            "num": 1612
        },

        {
            "id": 15325,
            "year": 2022,
            "is_wenli": 2,
            "score": 513,
            "ranking": 113165,
            "num": 1586
        },

        {
            "id": 15326,
            "year": 2022,
            "is_wenli": 2,
            "score": 512,
            "ranking": 114789,
            "num": 1624
        },

        {
            "id": 15327,
            "year": 2022,
            "is_wenli": 2,
            "score": 511,
            "ranking": 116434,
            "num": 1645
        },

        {
            "id": 15328,
            "year": 2022,
            "is_wenli": 2,
            "score": 510,
            "ranking": 118120,
            "num": 1686
        },

        {
            "id": 15329,
            "year": 2022,
            "is_wenli": 2,
            "score": 509,
            "ranking": 119754,
            "num": 1634
        },

        {
            "id": 15330,
            "year": 2022,
            "is_wenli": 2,
            "score": 508,
            "ranking": 121353,
            "num": 1599
        },

        {
            "id": 15331,
            "year": 2022,
            "is_wenli": 2,
            "score": 507,
            "ranking": 123094,
            "num": 1741
        },

        {
            "id": 15332,
            "year": 2022,
            "is_wenli": 2,
            "score": 506,
            "ranking": 124830,
            "num": 1736
        },

        {
            "id": 15333,
            "year": 2022,
            "is_wenli": 2,
            "score": 505,
            "ranking": 126499,
            "num": 1669
        },

        {
            "id": 15334,
            "year": 2022,
            "is_wenli": 2,
            "score": 504,
            "ranking": 128203,
            "num": 1704
        },

        {
            "id": 15335,
            "year": 2022,
            "is_wenli": 2,
            "score": 503,
            "ranking": 129863,
            "num": 1660
        },

        {
            "id": 15336,
            "year": 2022,
            "is_wenli": 2,
            "score": 502,
            "ranking": 131529,
            "num": 1666
        },

        {
            "id": 15337,
            "year": 2022,
            "is_wenli": 2,
            "score": 501,
            "ranking": 133288,
            "num": 1759
        },

        {
            "id": 15338,
            "year": 2022,
            "is_wenli": 2,
            "score": 500,
            "ranking": 135000,
            "num": 1712
        },

        {
            "id": 15339,
            "year": 2022,
            "is_wenli": 2,
            "score": 499,
            "ranking": 136824,
            "num": 1824
        },

        {
            "id": 15340,
            "year": 2022,
            "is_wenli": 2,
            "score": 498,
            "ranking": 138531,
            "num": 1707
        },

        {
            "id": 15341,
            "year": 2022,
            "is_wenli": 2,
            "score": 497,
            "ranking": 140270,
            "num": 1739
        },

        {
            "id": 15342,
            "year": 2022,
            "is_wenli": 2,
            "score": 496,
            "ranking": 142023,
            "num": 1753
        },

        {
            "id": 15343,
            "year": 2022,
            "is_wenli": 2,
            "score": 495,
            "ranking": 143788,
            "num": 1765
        },

        {
            "id": 15344,
            "year": 2022,
            "is_wenli": 2,
            "score": 494,
            "ranking": 145574,
            "num": 1786
        },

        {
            "id": 15345,
            "year": 2022,
            "is_wenli": 2,
            "score": 493,
            "ranking": 147371,
            "num": 1797
        },

        {
            "id": 15346,
            "year": 2022,
            "is_wenli": 2,
            "score": 492,
            "ranking": 149109,
            "num": 1738
        },

        {
            "id": 15347,
            "year": 2022,
            "is_wenli": 2,
            "score": 491,
            "ranking": 150900,
            "num": 1791
        },

        {
            "id": 15348,
            "year": 2022,
            "is_wenli": 2,
            "score": 490,
            "ranking": 152694,
            "num": 1794
        },

        {
            "id": 15349,
            "year": 2022,
            "is_wenli": 2,
            "score": 489,
            "ranking": 154495,
            "num": 1801
        },

        {
            "id": 15350,
            "year": 2022,
            "is_wenli": 2,
            "score": 488,
            "ranking": 156364,
            "num": 1869
        },

        {
            "id": 15351,
            "year": 2022,
            "is_wenli": 2,
            "score": 487,
            "ranking": 158176,
            "num": 1812
        },

        {
            "id": 15352,
            "year": 2022,
            "is_wenli": 2,
            "score": 486,
            "ranking": 159996,
            "num": 1820
        },

        {
            "id": 15353,
            "year": 2022,
            "is_wenli": 2,
            "score": 485,
            "ranking": 161752,
            "num": 1756
        },

        {
            "id": 15354,
            "year": 2022,
            "is_wenli": 2,
            "score": 484,
            "ranking": 163606,
            "num": 1854
        },

        {
            "id": 15355,
            "year": 2022,
            "is_wenli": 2,
            "score": 483,
            "ranking": 165467,
            "num": 1861
        },

        {
            "id": 15356,
            "year": 2022,
            "is_wenli": 2,
            "score": 482,
            "ranking": 167270,
            "num": 1803
        },

        {
            "id": 15357,
            "year": 2022,
            "is_wenli": 2,
            "score": 481,
            "ranking": 169125,
            "num": 1855
        },

        {
            "id": 15358,
            "year": 2022,
            "is_wenli": 2,
            "score": 480,
            "ranking": 170904,
            "num": 1779
        },

        {
            "id": 15359,
            "year": 2022,
            "is_wenli": 2,
            "score": 479,
            "ranking": 172819,
            "num": 1915
        },

        {
            "id": 15360,
            "year": 2022,
            "is_wenli": 2,
            "score": 478,
            "ranking": 174690,
            "num": 1871
        },

        {
            "id": 15361,
            "year": 2022,
            "is_wenli": 2,
            "score": 477,
            "ranking": 176553,
            "num": 1863
        },

        {
            "id": 15362,
            "year": 2022,
            "is_wenli": 2,
            "score": 476,
            "ranking": 178470,
            "num": 1917
        },

        {
            "id": 15363,
            "year": 2022,
            "is_wenli": 2,
            "score": 475,
            "ranking": 180296,
            "num": 1826
        },

        {
            "id": 15364,
            "year": 2022,
            "is_wenli": 2,
            "score": 474,
            "ranking": 182223,
            "num": 1927
        },

        {
            "id": 15365,
            "year": 2022,
            "is_wenli": 2,
            "score": 473,
            "ranking": 184122,
            "num": 1899
        },

        {
            "id": 15366,
            "year": 2022,
            "is_wenli": 2,
            "score": 472,
            "ranking": 185944,
            "num": 1822
        },

        {
            "id": 15367,
            "year": 2022,
            "is_wenli": 2,
            "score": 471,
            "ranking": 187789,
            "num": 1845
        },

        {
            "id": 15368,
            "year": 2022,
            "is_wenli": 2,
            "score": 470,
            "ranking": 189615,
            "num": 1826
        },

        {
            "id": 15369,
            "year": 2022,
            "is_wenli": 2,
            "score": 469,
            "ranking": 191481,
            "num": 1866
        },

        {
            "id": 15370,
            "year": 2022,
            "is_wenli": 2,
            "score": 468,
            "ranking": 193391,
            "num": 1910
        },

        {
            "id": 15371,
            "year": 2022,
            "is_wenli": 2,
            "score": 467,
            "ranking": 195268,
            "num": 1877
        },

        {
            "id": 15372,
            "year": 2022,
            "is_wenli": 2,
            "score": 466,
            "ranking": 197206,
            "num": 1938
        },

        {
            "id": 15373,
            "year": 2022,
            "is_wenli": 2,
            "score": 465,
            "ranking": 199130,
            "num": 1924
        },

        {
            "id": 15374,
            "year": 2022,
            "is_wenli": 2,
            "score": 464,
            "ranking": 201077,
            "num": 1947
        },

        {
            "id": 15375,
            "year": 2022,
            "is_wenli": 2,
            "score": 463,
            "ranking": 202992,
            "num": 1915
        },

        {
            "id": 15376,
            "year": 2022,
            "is_wenli": 2,
            "score": 462,
            "ranking": 205021,
            "num": 2029
        },

        {
            "id": 15377,
            "year": 2022,
            "is_wenli": 2,
            "score": 461,
            "ranking": 206955,
            "num": 1934
        },

        {
            "id": 15378,
            "year": 2022,
            "is_wenli": 2,
            "score": 460,
            "ranking": 208851,
            "num": 1896
        },

        {
            "id": 15379,
            "year": 2022,
            "is_wenli": 2,
            "score": 459,
            "ranking": 210875,
            "num": 2024
        },

        {
            "id": 15380,
            "year": 2022,
            "is_wenli": 2,
            "score": 458,
            "ranking": 212825,
            "num": 1950
        },

        {
            "id": 15381,
            "year": 2022,
            "is_wenli": 2,
            "score": 457,
            "ranking": 214799,
            "num": 1974
        },

        {
            "id": 15382,
            "year": 2022,
            "is_wenli": 2,
            "score": 456,
            "ranking": 216733,
            "num": 1934
        },

        {
            "id": 15383,
            "year": 2022,
            "is_wenli": 2,
            "score": 455,
            "ranking": 218632,
            "num": 1899
        },

        {
            "id": 15384,
            "year": 2022,
            "is_wenli": 2,
            "score": 454,
            "ranking": 220603,
            "num": 1971
        },

        {
            "id": 15385,
            "year": 2022,
            "is_wenli": 2,
            "score": 453,
            "ranking": 222608,
            "num": 2005
        },

        {
            "id": 15386,
            "year": 2022,
            "is_wenli": 2,
            "score": 452,
            "ranking": 224604,
            "num": 1996
        },

        {
            "id": 15387,
            "year": 2022,
            "is_wenli": 2,
            "score": 451,
            "ranking": 226591,
            "num": 1987
        },

        {
            "id": 15388,
            "year": 2022,
            "is_wenli": 2,
            "score": 450,
            "ranking": 228597,
            "num": 2006
        },

        {
            "id": 15389,
            "year": 2022,
            "is_wenli": 2,
            "score": 449,
            "ranking": 230549,
            "num": 1952
        },

        {
            "id": 15390,
            "year": 2022,
            "is_wenli": 2,
            "score": 448,
            "ranking": 232453,
            "num": 1904
        },

        {
            "id": 15391,
            "year": 2022,
            "is_wenli": 2,
            "score": 447,
            "ranking": 234449,
            "num": 1996
        },

        {
            "id": 15392,
            "year": 2022,
            "is_wenli": 2,
            "score": 446,
            "ranking": 236478,
            "num": 2029
        },

        {
            "id": 15393,
            "year": 2022,
            "is_wenli": 2,
            "score": 445,
            "ranking": 238493,
            "num": 2015
        },

        {
            "id": 15394,
            "year": 2022,
            "is_wenli": 2,
            "score": 444,
            "ranking": 240478,
            "num": 1985
        },

        {
            "id": 15395,
            "year": 2022,
            "is_wenli": 2,
            "score": 443,
            "ranking": 242380,
            "num": 1902
        },

        {
            "id": 15396,
            "year": 2022,
            "is_wenli": 2,
            "score": 442,
            "ranking": 244367,
            "num": 1987
        },

        {
            "id": 15397,
            "year": 2022,
            "is_wenli": 2,
            "score": 441,
            "ranking": 246348,
            "num": 1981
        },

        {
            "id": 15398,
            "year": 2022,
            "is_wenli": 2,
            "score": 440,
            "ranking": 248312,
            "num": 1964
        },

        {
            "id": 15399,
            "year": 2022,
            "is_wenli": 2,
            "score": 439,
            "ranking": 250298,
            "num": 1986
        },

        {
            "id": 15400,
            "year": 2022,
            "is_wenli": 2,
            "score": 438,
            "ranking": 252264,
            "num": 1966
        },

        {
            "id": 15401,
            "year": 2022,
            "is_wenli": 2,
            "score": 437,
            "ranking": 254266,
            "num": 2002
        },

        {
            "id": 15402,
            "year": 2022,
            "is_wenli": 2,
            "score": 436,
            "ranking": 256194,
            "num": 1928
        },

        {
            "id": 15403,
            "year": 2022,
            "is_wenli": 2,
            "score": 435,
            "ranking": 258144,
            "num": 1950
        },

        {
            "id": 15404,
            "year": 2022,
            "is_wenli": 2,
            "score": 434,
            "ranking": 260151,
            "num": 2007
        },

        {
            "id": 15405,
            "year": 2022,
            "is_wenli": 2,
            "score": 433,
            "ranking": 262086,
            "num": 1935
        },

        {
            "id": 15406,
            "year": 2022,
            "is_wenli": 2,
            "score": 432,
            "ranking": 263993,
            "num": 1907
        },

        {
            "id": 15407,
            "year": 2022,
            "is_wenli": 2,
            "score": 431,
            "ranking": 265962,
            "num": 1969
        },

        {
            "id": 15408,
            "year": 2022,
            "is_wenli": 2,
            "score": 430,
            "ranking": 267903,
            "num": 1941
        },

        {
            "id": 15409,
            "year": 2022,
            "is_wenli": 2,
            "score": 429,
            "ranking": 269806,
            "num": 1903
        },

        {
            "id": 15410,
            "year": 2022,
            "is_wenli": 2,
            "score": 428,
            "ranking": 271716,
            "num": 1910
        },

        {
            "id": 15411,
            "year": 2022,
            "is_wenli": 2,
            "score": 427,
            "ranking": 273612,
            "num": 1896
        },

        {
            "id": 15412,
            "year": 2022,
            "is_wenli": 2,
            "score": 426,
            "ranking": 275482,
            "num": 1870
        },

        {
            "id": 15413,
            "year": 2022,
            "is_wenli": 2,
            "score": 425,
            "ranking": 277403,
            "num": 1921
        },

        {
            "id": 15414,
            "year": 2022,
            "is_wenli": 2,
            "score": 424,
            "ranking": 279381,
            "num": 1978
        },

        {
            "id": 15415,
            "year": 2022,
            "is_wenli": 2,
            "score": 423,
            "ranking": 281322,
            "num": 1941
        },

        {
            "id": 15416,
            "year": 2022,
            "is_wenli": 2,
            "score": 422,
            "ranking": 283237,
            "num": 1915
        },

        {
            "id": 15417,
            "year": 2022,
            "is_wenli": 2,
            "score": 421,
            "ranking": 285152,
            "num": 1915
        },

        {
            "id": 15418,
            "year": 2022,
            "is_wenli": 2,
            "score": 420,
            "ranking": 287021,
            "num": 1869
        },

        {
            "id": 15419,
            "year": 2022,
            "is_wenli": 2,
            "score": 419,
            "ranking": 288892,
            "num": 1871
        },

        {
            "id": 15420,
            "year": 2022,
            "is_wenli": 2,
            "score": 418,
            "ranking": 290759,
            "num": 1867
        },

        {
            "id": 15421,
            "year": 2022,
            "is_wenli": 2,
            "score": 417,
            "ranking": 292646,
            "num": 1887
        },

        {
            "id": 15422,
            "year": 2022,
            "is_wenli": 2,
            "score": 416,
            "ranking": 294463,
            "num": 1817
        },

        {
            "id": 15423,
            "year": 2022,
            "is_wenli": 2,
            "score": 415,
            "ranking": 296338,
            "num": 1875
        },

        {
            "id": 15424,
            "year": 2022,
            "is_wenli": 2,
            "score": 414,
            "ranking": 298177,
            "num": 1839
        },

        {
            "id": 15425,
            "year": 2022,
            "is_wenli": 2,
            "score": 413,
            "ranking": 300059,
            "num": 1882
        },

        {
            "id": 15426,
            "year": 2022,
            "is_wenli": 2,
            "score": 412,
            "ranking": 301870,
            "num": 1811
        },

        {
            "id": 15427,
            "year": 2022,
            "is_wenli": 2,
            "score": 411,
            "ranking": 303736,
            "num": 1866
        },

        {
            "id": 15428,
            "year": 2022,
            "is_wenli": 2,
            "score": 410,
            "ranking": 305497,
            "num": 1761
        },

        {
            "id": 15429,
            "year": 2022,
            "is_wenli": 2,
            "score": 409,
            "ranking": 307335,
            "num": 1838
        },

        {
            "id": 15430,
            "year": 2022,
            "is_wenli": 2,
            "score": 408,
            "ranking": 309180,
            "num": 1845
        },

        {
            "id": 15431,
            "year": 2022,
            "is_wenli": 2,
            "score": 407,
            "ranking": 310959,
            "num": 1779
        },

        {
            "id": 15432,
            "year": 2022,
            "is_wenli": 2,
            "score": 406,
            "ranking": 312751,
            "num": 1792
        },

        {
            "id": 15433,
            "year": 2022,
            "is_wenli": 2,
            "score": 405,
            "ranking": 314509,
            "num": 1758
        },

        {
            "id": 15434,
            "year": 2022,
            "is_wenli": 2,
            "score": 404,
            "ranking": 316269,
            "num": 1760
        },

        {
            "id": 15435,
            "year": 2022,
            "is_wenli": 2,
            "score": 403,
            "ranking": 318007,
            "num": 1738
        },

        {
            "id": 15436,
            "year": 2022,
            "is_wenli": 2,
            "score": 402,
            "ranking": 319753,
            "num": 1746
        },

        {
            "id": 15437,
            "year": 2022,
            "is_wenli": 2,
            "score": 401,
            "ranking": 321577,
            "num": 1824
        },

        {
            "id": 15438,
            "year": 2022,
            "is_wenli": 2,
            "score": 400,
            "ranking": 323388,
            "num": 1811
        },

        {
            "id": 15439,
            "year": 2022,
            "is_wenli": 2,
            "score": 399,
            "ranking": 325140,
            "num": 1752
        },

        {
            "id": 15440,
            "year": 2022,
            "is_wenli": 2,
            "score": 398,
            "ranking": 326828,
            "num": 1688
        },

        {
            "id": 15441,
            "year": 2022,
            "is_wenli": 2,
            "score": 397,
            "ranking": 328508,
            "num": 1680
        },

        {
            "id": 15442,
            "year": 2022,
            "is_wenli": 2,
            "score": 396,
            "ranking": 330301,
            "num": 1793
        },

        {
            "id": 15443,
            "year": 2022,
            "is_wenli": 2,
            "score": 395,
            "ranking": 331994,
            "num": 1693
        },

        {
            "id": 15444,
            "year": 2022,
            "is_wenli": 2,
            "score": 394,
            "ranking": 333631,
            "num": 1637
        },

        {
            "id": 15445,
            "year": 2022,
            "is_wenli": 2,
            "score": 393,
            "ranking": 335333,
            "num": 1702
        },

        {
            "id": 15446,
            "year": 2022,
            "is_wenli": 2,
            "score": 392,
            "ranking": 337031,
            "num": 1698
        },

        {
            "id": 15447,
            "year": 2022,
            "is_wenli": 2,
            "score": 391,
            "ranking": 338741,
            "num": 1710
        },

        {
            "id": 15448,
            "year": 2022,
            "is_wenli": 2,
            "score": 390,
            "ranking": 340369,
            "num": 1628
        },

        {
            "id": 15449,
            "year": 2022,
            "is_wenli": 2,
            "score": 389,
            "ranking": 341992,
            "num": 1623
        },

        {
            "id": 15450,
            "year": 2022,
            "is_wenli": 2,
            "score": 388,
            "ranking": 343631,
            "num": 1639
        },

        {
            "id": 15451,
            "year": 2022,
            "is_wenli": 2,
            "score": 387,
            "ranking": 345253,
            "num": 1622
        },

        {
            "id": 15452,
            "year": 2022,
            "is_wenli": 2,
            "score": 386,
            "ranking": 346832,
            "num": 1579
        },

        {
            "id": 15453,
            "year": 2022,
            "is_wenli": 2,
            "score": 385,
            "ranking": 348461,
            "num": 1629
        },

        {
            "id": 15454,
            "year": 2022,
            "is_wenli": 2,
            "score": 384,
            "ranking": 349987,
            "num": 1526
        },

        {
            "id": 15455,
            "year": 2022,
            "is_wenli": 2,
            "score": 383,
            "ranking": 351518,
            "num": 1531
        },

        {
            "id": 15456,
            "year": 2022,
            "is_wenli": 2,
            "score": 382,
            "ranking": 353072,
            "num": 1554
        },

        {
            "id": 15457,
            "year": 2022,
            "is_wenli": 2,
            "score": 381,
            "ranking": 354629,
            "num": 1557
        },

        {
            "id": 15458,
            "year": 2022,
            "is_wenli": 2,
            "score": 380,
            "ranking": 356157,
            "num": 1528
        },

        {
            "id": 15459,
            "year": 2022,
            "is_wenli": 2,
            "score": 379,
            "ranking": 357664,
            "num": 1507
        },

        {
            "id": 15460,
            "year": 2022,
            "is_wenli": 2,
            "score": 378,
            "ranking": 359173,
            "num": 1509
        },

        {
            "id": 15461,
            "year": 2022,
            "is_wenli": 2,
            "score": 377,
            "ranking": 360683,
            "num": 1510
        },

        {
            "id": 15462,
            "year": 2022,
            "is_wenli": 2,
            "score": 376,
            "ranking": 362196,
            "num": 1513
        },

        {
            "id": 15463,
            "year": 2022,
            "is_wenli": 2,
            "score": 375,
            "ranking": 363684,
            "num": 1488
        },

        {
            "id": 15464,
            "year": 2022,
            "is_wenli": 2,
            "score": 374,
            "ranking": 365196,
            "num": 1512
        },

        {
            "id": 15465,
            "year": 2022,
            "is_wenli": 2,
            "score": 373,
            "ranking": 366658,
            "num": 1462
        },

        {
            "id": 15466,
            "year": 2022,
            "is_wenli": 2,
            "score": 372,
            "ranking": 368153,
            "num": 1495
        },

        {
            "id": 15467,
            "year": 2022,
            "is_wenli": 2,
            "score": 371,
            "ranking": 369640,
            "num": 1487
        },

        {
            "id": 15468,
            "year": 2022,
            "is_wenli": 2,
            "score": 370,
            "ranking": 371092,
            "num": 1452
        },

        {
            "id": 15469,
            "year": 2022,
            "is_wenli": 2,
            "score": 369,
            "ranking": 372530,
            "num": 1438
        },

        {
            "id": 15470,
            "year": 2022,
            "is_wenli": 2,
            "score": 368,
            "ranking": 373946,
            "num": 1416
        },

        {
            "id": 15471,
            "year": 2022,
            "is_wenli": 2,
            "score": 367,
            "ranking": 375329,
            "num": 1383
        },

        {
            "id": 15472,
            "year": 2022,
            "is_wenli": 2,
            "score": 366,
            "ranking": 376701,
            "num": 1372
        },

        {
            "id": 15473,
            "year": 2022,
            "is_wenli": 2,
            "score": 365,
            "ranking": 378123,
            "num": 1422
        },

        {
            "id": 15474,
            "year": 2022,
            "is_wenli": 2,
            "score": 364,
            "ranking": 379498,
            "num": 1375
        },

        {
            "id": 15475,
            "year": 2022,
            "is_wenli": 2,
            "score": 363,
            "ranking": 380889,
            "num": 1391
        },

        {
            "id": 15476,
            "year": 2022,
            "is_wenli": 2,
            "score": 362,
            "ranking": 382217,
            "num": 1328
        },

        {
            "id": 15477,
            "year": 2022,
            "is_wenli": 2,
            "score": 361,
            "ranking": 383490,
            "num": 1273
        },

        {
            "id": 15478,
            "year": 2022,
            "is_wenli": 2,
            "score": 360,
            "ranking": 384742,
            "num": 1252
        },

        {
            "id": 15479,
            "year": 2022,
            "is_wenli": 2,
            "score": 359,
            "ranking": 386000,
            "num": 1258
        },

        {
            "id": 15480,
            "year": 2022,
            "is_wenli": 2,
            "score": 358,
            "ranking": 387326,
            "num": 1326
        },

        {
            "id": 15481,
            "year": 2022,
            "is_wenli": 2,
            "score": 357,
            "ranking": 388602,
            "num": 1276
        },

        {
            "id": 15482,
            "year": 2022,
            "is_wenli": 2,
            "score": 356,
            "ranking": 389899,
            "num": 1297
        },

        {
            "id": 15483,
            "year": 2022,
            "is_wenli": 2,
            "score": 355,
            "ranking": 391123,
            "num": 1224
        },

        {
            "id": 15484,
            "year": 2022,
            "is_wenli": 2,
            "score": 354,
            "ranking": 392436,
            "num": 1313
        },

        {
            "id": 15485,
            "year": 2022,
            "is_wenli": 2,
            "score": 353,
            "ranking": 393697,
            "num": 1261
        },

        {
            "id": 15486,
            "year": 2022,
            "is_wenli": 2,
            "score": 352,
            "ranking": 394939,
            "num": 1242
        },

        {
            "id": 15487,
            "year": 2022,
            "is_wenli": 2,
            "score": 351,
            "ranking": 396225,
            "num": 1286
        },

        {
            "id": 15488,
            "year": 2022,
            "is_wenli": 2,
            "score": 350,
            "ranking": 397469,
            "num": 1244
        },

        {
            "id": 15489,
            "year": 2022,
            "is_wenli": 2,
            "score": 349,
            "ranking": 398720,
            "num": 1251
        },

        {
            "id": 15490,
            "year": 2022,
            "is_wenli": 2,
            "score": 348,
            "ranking": 399931,
            "num": 1211
        },

        {
            "id": 15491,
            "year": 2022,
            "is_wenli": 2,
            "score": 347,
            "ranking": 401175,
            "num": 1244
        },

        {
            "id": 15492,
            "year": 2022,
            "is_wenli": 2,
            "score": 346,
            "ranking": 402376,
            "num": 1201
        },

        {
            "id": 15493,
            "year": 2022,
            "is_wenli": 2,
            "score": 345,
            "ranking": 403601,
            "num": 1225
        },

        {
            "id": 15494,
            "year": 2022,
            "is_wenli": 2,
            "score": 344,
            "ranking": 404862,
            "num": 1261
        },

        {
            "id": 15495,
            "year": 2022,
            "is_wenli": 2,
            "score": 343,
            "ranking": 406062,
            "num": 1200
        },

        {
            "id": 15496,
            "year": 2022,
            "is_wenli": 2,
            "score": 342,
            "ranking": 407270,
            "num": 1208
        },

        {
            "id": 15497,
            "year": 2022,
            "is_wenli": 2,
            "score": 341,
            "ranking": 408438,
            "num": 1168
        },

        {
            "id": 15498,
            "year": 2022,
            "is_wenli": 2,
            "score": 340,
            "ranking": 409601,
            "num": 1163
        },

        {
            "id": 15499,
            "year": 2022,
            "is_wenli": 2,
            "score": 339,
            "ranking": 410717,
            "num": 1116
        },

        {
            "id": 15500,
            "year": 2022,
            "is_wenli": 2,
            "score": 338,
            "ranking": 411779,
            "num": 1062
        },

        {
            "id": 15501,
            "year": 2022,
            "is_wenli": 2,
            "score": 337,
            "ranking": 412879,
            "num": 1100
        },

        {
            "id": 15502,
            "year": 2022,
            "is_wenli": 2,
            "score": 336,
            "ranking": 413996,
            "num": 1117
        },

        {
            "id": 15503,
            "year": 2022,
            "is_wenli": 2,
            "score": 335,
            "ranking": 415130,
            "num": 1134
        },

        {
            "id": 15504,
            "year": 2022,
            "is_wenli": 2,
            "score": 334,
            "ranking": 416252,
            "num": 1122
        },

        {
            "id": 15505,
            "year": 2022,
            "is_wenli": 2,
            "score": 333,
            "ranking": 417376,
            "num": 1124
        },

        {
            "id": 15506,
            "year": 2022,
            "is_wenli": 2,
            "score": 332,
            "ranking": 418498,
            "num": 1122
        },

        {
            "id": 15507,
            "year": 2022,
            "is_wenli": 2,
            "score": 331,
            "ranking": 419612,
            "num": 1114
        },

        {
            "id": 15508,
            "year": 2022,
            "is_wenli": 2,
            "score": 330,
            "ranking": 420739,
            "num": 1127
        },

        {
            "id": 15509,
            "year": 2022,
            "is_wenli": 2,
            "score": 329,
            "ranking": 421793,
            "num": 1054
        },

        {
            "id": 15510,
            "year": 2022,
            "is_wenli": 2,
            "score": 328,
            "ranking": 422853,
            "num": 1060
        },

        {
            "id": 15511,
            "year": 2022,
            "is_wenli": 2,
            "score": 327,
            "ranking": 423925,
            "num": 1072
        },

        {
            "id": 15512,
            "year": 2022,
            "is_wenli": 2,
            "score": 326,
            "ranking": 424972,
            "num": 1047
        },

        {
            "id": 15513,
            "year": 2022,
            "is_wenli": 2,
            "score": 325,
            "ranking": 426019,
            "num": 1047
        },

        {
            "id": 15514,
            "year": 2022,
            "is_wenli": 2,
            "score": 324,
            "ranking": 427101,
            "num": 1082
        },

        {
            "id": 15515,
            "year": 2022,
            "is_wenli": 2,
            "score": 323,
            "ranking": 428144,
            "num": 1043
        },

        {
            "id": 15516,
            "year": 2022,
            "is_wenli": 2,
            "score": 322,
            "ranking": 429182,
            "num": 1038
        },

        {
            "id": 15517,
            "year": 2022,
            "is_wenli": 2,
            "score": 321,
            "ranking": 430221,
            "num": 1039
        },

        {
            "id": 15518,
            "year": 2022,
            "is_wenli": 2,
            "score": 320,
            "ranking": 431242,
            "num": 1021
        },

        {
            "id": 15519,
            "year": 2022,
            "is_wenli": 2,
            "score": 319,
            "ranking": 432261,
            "num": 1019
        },

        {
            "id": 15520,
            "year": 2022,
            "is_wenli": 2,
            "score": 318,
            "ranking": 433266,
            "num": 1005
        },

        {
            "id": 15521,
            "year": 2022,
            "is_wenli": 2,
            "score": 317,
            "ranking": 434234,
            "num": 968
        },

        {
            "id": 15522,
            "year": 2022,
            "is_wenli": 2,
            "score": 316,
            "ranking": 435220,
            "num": 986
        },

        {
            "id": 15523,
            "year": 2022,
            "is_wenli": 2,
            "score": 315,
            "ranking": 436171,
            "num": 951
        },

        {
            "id": 15524,
            "year": 2022,
            "is_wenli": 2,
            "score": 314,
            "ranking": 437045,
            "num": 874
        },

        {
            "id": 15525,
            "year": 2022,
            "is_wenli": 2,
            "score": 313,
            "ranking": 437931,
            "num": 886
        },

        {
            "id": 15526,
            "year": 2022,
            "is_wenli": 2,
            "score": 312,
            "ranking": 438833,
            "num": 902
        },

        {
            "id": 15527,
            "year": 2022,
            "is_wenli": 2,
            "score": 311,
            "ranking": 439701,
            "num": 868
        },

        {
            "id": 15528,
            "year": 2022,
            "is_wenli": 2,
            "score": 310,
            "ranking": 440655,
            "num": 954
        },

        {
            "id": 15529,
            "year": 2022,
            "is_wenli": 2,
            "score": 309,
            "ranking": 441545,
            "num": 890
        },

        {
            "id": 15530,
            "year": 2022,
            "is_wenli": 2,
            "score": 308,
            "ranking": 442448,
            "num": 903
        },

        {
            "id": 15531,
            "year": 2022,
            "is_wenli": 2,
            "score": 307,
            "ranking": 443384,
            "num": 936
        },

        {
            "id": 15532,
            "year": 2022,
            "is_wenli": 2,
            "score": 306,
            "ranking": 444296,
            "num": 912
        },

        {
            "id": 15533,
            "year": 2022,
            "is_wenli": 2,
            "score": 305,
            "ranking": 445187,
            "num": 891
        },

        {
            "id": 15534,
            "year": 2022,
            "is_wenli": 2,
            "score": 304,
            "ranking": 446039,
            "num": 852
        },

        {
            "id": 15535,
            "year": 2022,
            "is_wenli": 2,
            "score": 303,
            "ranking": 446895,
            "num": 856
        },

        {
            "id": 15536,
            "year": 2022,
            "is_wenli": 2,
            "score": 302,
            "ranking": 447734,
            "num": 839
        },

        {
            "id": 15537,
            "year": 2022,
            "is_wenli": 2,
            "score": 301,
            "ranking": 448594,
            "num": 860
        },

        {
            "id": 15538,
            "year": 2022,
            "is_wenli": 2,
            "score": 300,
            "ranking": 449455,
            "num": 861
        },

        {
            "id": 15539,
            "year": 2022,
            "is_wenli": 2,
            "score": 299,
            "ranking": 450256,
            "num": 801
        },

        {
            "id": 15540,
            "year": 2022,
            "is_wenli": 2,
            "score": 298,
            "ranking": 451054,
            "num": 798
        },

        {
            "id": 15541,
            "year": 2022,
            "is_wenli": 2,
            "score": 297,
            "ranking": 451869,
            "num": 815
        },

        {
            "id": 15542,
            "year": 2022,
            "is_wenli": 2,
            "score": 296,
            "ranking": 452616,
            "num": 747
        },

        {
            "id": 15543,
            "year": 2022,
            "is_wenli": 2,
            "score": 295,
            "ranking": 453447,
            "num": 831
        },

        {
            "id": 15544,
            "year": 2022,
            "is_wenli": 2,
            "score": 294,
            "ranking": 454219,
            "num": 772
        },

        {
            "id": 15545,
            "year": 2022,
            "is_wenli": 2,
            "score": 293,
            "ranking": 454971,
            "num": 752
        },

        {
            "id": 15546,
            "year": 2022,
            "is_wenli": 2,
            "score": 292,
            "ranking": 455770,
            "num": 799
        },

        {
            "id": 15547,
            "year": 2022,
            "is_wenli": 2,
            "score": 291,
            "ranking": 456569,
            "num": 799
        },

        {
            "id": 15548,
            "year": 2022,
            "is_wenli": 2,
            "score": 290,
            "ranking": 457370,
            "num": 801
        },

        {
            "id": 15549,
            "year": 2022,
            "is_wenli": 2,
            "score": 289,
            "ranking": 458163,
            "num": 793
        },

        {
            "id": 15550,
            "year": 2022,
            "is_wenli": 2,
            "score": 288,
            "ranking": 458891,
            "num": 728
        },

        {
            "id": 15551,
            "year": 2022,
            "is_wenli": 2,
            "score": 287,
            "ranking": 459657,
            "num": 766
        },

        {
            "id": 15552,
            "year": 2022,
            "is_wenli": 2,
            "score": 286,
            "ranking": 460407,
            "num": 750
        },

        {
            "id": 15553,
            "year": 2022,
            "is_wenli": 2,
            "score": 285,
            "ranking": 461136,
            "num": 729
        },

        {
            "id": 15554,
            "year": 2022,
            "is_wenli": 2,
            "score": 284,
            "ranking": 461892,
            "num": 756
        },

        {
            "id": 15555,
            "year": 2022,
            "is_wenli": 2,
            "score": 283,
            "ranking": 462566,
            "num": 674
        },

        {
            "id": 15556,
            "year": 2022,
            "is_wenli": 2,
            "score": 282,
            "ranking": 463257,
            "num": 691
        },

        {
            "id": 15557,
            "year": 2022,
            "is_wenli": 2,
            "score": 281,
            "ranking": 463916,
            "num": 659
        },

        {
            "id": 15558,
            "year": 2022,
            "is_wenli": 2,
            "score": 280,
            "ranking": 464556,
            "num": 640
        },

        {
            "id": 15559,
            "year": 2022,
            "is_wenli": 2,
            "score": 279,
            "ranking": 465249,
            "num": 693
        },

        {
            "id": 15560,
            "year": 2022,
            "is_wenli": 2,
            "score": 278,
            "ranking": 465910,
            "num": 661
        },

        {
            "id": 15561,
            "year": 2022,
            "is_wenli": 2,
            "score": 277,
            "ranking": 466546,
            "num": 636
        },

        {
            "id": 15562,
            "year": 2022,
            "is_wenli": 2,
            "score": 276,
            "ranking": 467171,
            "num": 625
        },

        {
            "id": 15563,
            "year": 2022,
            "is_wenli": 2,
            "score": 275,
            "ranking": 467814,
            "num": 643
        },

        {
            "id": 15564,
            "year": 2022,
            "is_wenli": 2,
            "score": 274,
            "ranking": 468464,
            "num": 650
        },

        {
            "id": 15565,
            "year": 2022,
            "is_wenli": 2,
            "score": 273,
            "ranking": 469108,
            "num": 644
        },

        {
            "id": 15566,
            "year": 2022,
            "is_wenli": 2,
            "score": 272,
            "ranking": 469785,
            "num": 677
        },

        {
            "id": 15567,
            "year": 2022,
            "is_wenli": 2,
            "score": 271,
            "ranking": 470388,
            "num": 603
        },

        {
            "id": 15568,
            "year": 2022,
            "is_wenli": 2,
            "score": 270,
            "ranking": 471000,
            "num": 612
        },

        {
            "id": 15569,
            "year": 2022,
            "is_wenli": 2,
            "score": 269,
            "ranking": 471629,
            "num": 629
        },

        {
            "id": 15570,
            "year": 2022,
            "is_wenli": 2,
            "score": 268,
            "ranking": 472245,
            "num": 616
        },

        {
            "id": 15571,
            "year": 2022,
            "is_wenli": 2,
            "score": 267,
            "ranking": 472873,
            "num": 628
        },

        {
            "id": 15572,
            "year": 2022,
            "is_wenli": 2,
            "score": 266,
            "ranking": 473522,
            "num": 649
        },

        {
            "id": 15573,
            "year": 2022,
            "is_wenli": 2,
            "score": 265,
            "ranking": 474136,
            "num": 614
        },

        {
            "id": 15574,
            "year": 2022,
            "is_wenli": 2,
            "score": 264,
            "ranking": 474725,
            "num": 589
        },

        {
            "id": 15575,
            "year": 2022,
            "is_wenli": 2,
            "score": 263,
            "ranking": 475310,
            "num": 585
        },

        {
            "id": 15576,
            "year": 2022,
            "is_wenli": 2,
            "score": 262,
            "ranking": 475867,
            "num": 557
        },

        {
            "id": 15577,
            "year": 2022,
            "is_wenli": 2,
            "score": 261,
            "ranking": 476448,
            "num": 581
        },

        {
            "id": 15578,
            "year": 2022,
            "is_wenli": 2,
            "score": 260,
            "ranking": 476958,
            "num": 510
        },

        {
            "id": 15579,
            "year": 2022,
            "is_wenli": 2,
            "score": 259,
            "ranking": 477542,
            "num": 584
        },

        {
            "id": 15580,
            "year": 2022,
            "is_wenli": 2,
            "score": 258,
            "ranking": 478091,
            "num": 549
        },

        {
            "id": 15581,
            "year": 2022,
            "is_wenli": 2,
            "score": 257,
            "ranking": 478612,
            "num": 521
        },

        {
            "id": 15582,
            "year": 2022,
            "is_wenli": 2,
            "score": 256,
            "ranking": 479124,
            "num": 512
        },

        {
            "id": 15583,
            "year": 2022,
            "is_wenli": 2,
            "score": 255,
            "ranking": 479660,
            "num": 536
        },

        {
            "id": 15584,
            "year": 2022,
            "is_wenli": 2,
            "score": 254,
            "ranking": 480147,
            "num": 487
        },

        {
            "id": 15585,
            "year": 2022,
            "is_wenli": 2,
            "score": 253,
            "ranking": 480682,
            "num": 535
        },

        {
            "id": 15586,
            "year": 2022,
            "is_wenli": 2,
            "score": 252,
            "ranking": 481185,
            "num": 503
        },

        {
            "id": 15587,
            "year": 2022,
            "is_wenli": 2,
            "score": 251,
            "ranking": 481702,
            "num": 517
        },

        {
            "id": 15588,
            "year": 2022,
            "is_wenli": 2,
            "score": 250,
            "ranking": 482256,
            "num": 554
        },

        {
            "id": 15589,
            "year": 2022,
            "is_wenli": 2,
            "score": 249,
            "ranking": 482713,
            "num": 457
        },

        {
            "id": 15590,
            "year": 2022,
            "is_wenli": 2,
            "score": 248,
            "ranking": 483209,
            "num": 496
        },

        {
            "id": 15591,
            "year": 2022,
            "is_wenli": 2,
            "score": 247,
            "ranking": 483690,
            "num": 481
        },

        {
            "id": 15592,
            "year": 2022,
            "is_wenli": 2,
            "score": 246,
            "ranking": 484159,
            "num": 469
        },

        {
            "id": 15593,
            "year": 2022,
            "is_wenli": 2,
            "score": 245,
            "ranking": 484635,
            "num": 476
        },

        {
            "id": 15594,
            "year": 2022,
            "is_wenli": 2,
            "score": 244,
            "ranking": 485106,
            "num": 471
        },

        {
            "id": 15595,
            "year": 2022,
            "is_wenli": 2,
            "score": 243,
            "ranking": 485560,
            "num": 454
        },

        {
            "id": 15596,
            "year": 2022,
            "is_wenli": 2,
            "score": 242,
            "ranking": 486016,
            "num": 456
        },

        {
            "id": 15597,
            "year": 2022,
            "is_wenli": 2,
            "score": 241,
            "ranking": 486492,
            "num": 476
        },

        {
            "id": 15598,
            "year": 2022,
            "is_wenli": 2,
            "score": 240,
            "ranking": 486913,
            "num": 421
        },

        {
            "id": 15599,
            "year": 2022,
            "is_wenli": 2,
            "score": 239,
            "ranking": 487347,
            "num": 434
        },

        {
            "id": 15600,
            "year": 2022,
            "is_wenli": 2,
            "score": 238,
            "ranking": 487781,
            "num": 434
        },

        {
            "id": 15601,
            "year": 2022,
            "is_wenli": 2,
            "score": 237,
            "ranking": 488192,
            "num": 411
        },

        {
            "id": 15602,
            "year": 2022,
            "is_wenli": 2,
            "score": 236,
            "ranking": 488647,
            "num": 455
        },

        {
            "id": 15603,
            "year": 2022,
            "is_wenli": 2,
            "score": 235,
            "ranking": 489095,
            "num": 448
        },

        {
            "id": 15604,
            "year": 2022,
            "is_wenli": 2,
            "score": 234,
            "ranking": 489525,
            "num": 430
        },

        {
            "id": 15605,
            "year": 2022,
            "is_wenli": 2,
            "score": 233,
            "ranking": 489933,
            "num": 408
        },

        {
            "id": 15606,
            "year": 2022,
            "is_wenli": 2,
            "score": 232,
            "ranking": 490368,
            "num": 435
        },

        {
            "id": 15607,
            "year": 2022,
            "is_wenli": 2,
            "score": 231,
            "ranking": 490751,
            "num": 383
        },

        {
            "id": 15608,
            "year": 2022,
            "is_wenli": 2,
            "score": 230,
            "ranking": 491129,
            "num": 378
        },

        {
            "id": 15609,
            "year": 2022,
            "is_wenli": 2,
            "score": 229,
            "ranking": 491511,
            "num": 382
        },

        {
            "id": 15610,
            "year": 2022,
            "is_wenli": 2,
            "score": 228,
            "ranking": 491877,
            "num": 366
        },

        {
            "id": 15611,
            "year": 2022,
            "is_wenli": 2,
            "score": 227,
            "ranking": 492241,
            "num": 364
        },

        {
            "id": 15612,
            "year": 2022,
            "is_wenli": 2,
            "score": 226,
            "ranking": 492581,
            "num": 340
        },

        {
            "id": 15613,
            "year": 2022,
            "is_wenli": 2,
            "score": 225,
            "ranking": 492949,
            "num": 368
        },

        {
            "id": 15614,
            "year": 2022,
            "is_wenli": 2,
            "score": 224,
            "ranking": 493287,
            "num": 338
        },

        {
            "id": 15615,
            "year": 2022,
            "is_wenli": 2,
            "score": 223,
            "ranking": 493635,
            "num": 348
        },

        {
            "id": 15616,
            "year": 2022,
            "is_wenli": 2,
            "score": 222,
            "ranking": 494016,
            "num": 381
        },

        {
            "id": 15617,
            "year": 2022,
            "is_wenli": 2,
            "score": 221,
            "ranking": 494367,
            "num": 351
        },

        {
            "id": 15618,
            "year": 2022,
            "is_wenli": 2,
            "score": 220,
            "ranking": 494708,
            "num": 341
        },

        {
            "id": 15619,
            "year": 2022,
            "is_wenli": 2,
            "score": 219,
            "ranking": 494994,
            "num": 286
        },

        {
            "id": 15620,
            "year": 2022,
            "is_wenli": 2,
            "score": 218,
            "ranking": 495325,
            "num": 331
        },

        {
            "id": 15621,
            "year": 2022,
            "is_wenli": 2,
            "score": 217,
            "ranking": 495628,
            "num": 303
        },

        {
            "id": 15622,
            "year": 2022,
            "is_wenli": 2,
            "score": 216,
            "ranking": 495929,
            "num": 301
        },

        {
            "id": 15623,
            "year": 2022,
            "is_wenli": 2,
            "score": 215,
            "ranking": 496252,
            "num": 323
        },

        {
            "id": 15624,
            "year": 2022,
            "is_wenli": 2,
            "score": 214,
            "ranking": 496571,
            "num": 319
        },

        {
            "id": 15625,
            "year": 2022,
            "is_wenli": 2,
            "score": 213,
            "ranking": 496867,
            "num": 296
        },

        {
            "id": 15626,
            "year": 2022,
            "is_wenli": 2,
            "score": 212,
            "ranking": 497190,
            "num": 323
        },

        {
            "id": 15627,
            "year": 2022,
            "is_wenli": 2,
            "score": 211,
            "ranking": 497490,
            "num": 300
        },

        {
            "id": 15628,
            "year": 2022,
            "is_wenli": 2,
            "score": 210,
            "ranking": 497746,
            "num": 256
        },

        {
            "id": 15629,
            "year": 2022,
            "is_wenli": 2,
            "score": 209,
            "ranking": 498046,
            "num": 300
        },

        {
            "id": 15630,
            "year": 2022,
            "is_wenli": 2,
            "score": 208,
            "ranking": 498322,
            "num": 276
        },

        {
            "id": 15631,
            "year": 2022,
            "is_wenli": 2,
            "score": 207,
            "ranking": 498599,
            "num": 277
        },

        {
            "id": 15632,
            "year": 2022,
            "is_wenli": 2,
            "score": 206,
            "ranking": 498881,
            "num": 282
        },

        {
            "id": 15633,
            "year": 2022,
            "is_wenli": 2,
            "score": 205,
            "ranking": 499150,
            "num": 269
        },

        {
            "id": 15634,
            "year": 2022,
            "is_wenli": 2,
            "score": 204,
            "ranking": 499415,
            "num": 265
        },

        {
            "id": 15635,
            "year": 2022,
            "is_wenli": 2,
            "score": 203,
            "ranking": 499660,
            "num": 245
        },

        {
            "id": 15636,
            "year": 2022,
            "is_wenli": 2,
            "score": 202,
            "ranking": 499902,
            "num": 242
        },

        {
            "id": 15637,
            "year": 2022,
            "is_wenli": 2,
            "score": 201,
            "ranking": 500133,
            "num": 231
        },

        {
            "id": 15638,
            "year": 2022,
            "is_wenli": 2,
            "score": 200,
            "ranking": 500384,
            "num": 251
        },

        {
            "id": 15639,
            "year": 2022,
            "is_wenli": 2,
            "score": 199,
            "ranking": 500608,
            "num": 224
        },

        {
            "id": 15640,
            "year": 2022,
            "is_wenli": 2,
            "score": 198,
            "ranking": 500857,
            "num": 249
        },

        {
            "id": 15641,
            "year": 2022,
            "is_wenli": 2,
            "score": 197,
            "ranking": 501079,
            "num": 222
        },

        {
            "id": 15642,
            "year": 2022,
            "is_wenli": 2,
            "score": 196,
            "ranking": 501295,
            "num": 216
        },

        {
            "id": 15643,
            "year": 2022,
            "is_wenli": 2,
            "score": 195,
            "ranking": 501516,
            "num": 221
        },

        {
            "id": 15644,
            "year": 2022,
            "is_wenli": 2,
            "score": 194,
            "ranking": 501742,
            "num": 226
        },

        {
            "id": 15645,
            "year": 2022,
            "is_wenli": 2,
            "score": 193,
            "ranking": 501943,
            "num": 201
        },

        {
            "id": 15646,
            "year": 2022,
            "is_wenli": 2,
            "score": 192,
            "ranking": 502167,
            "num": 224
        },

        {
            "id": 15647,
            "year": 2022,
            "is_wenli": 2,
            "score": 191,
            "ranking": 502380,
            "num": 213
        },

        {
            "id": 15648,
            "year": 2022,
            "is_wenli": 2,
            "score": 190,
            "ranking": 502581,
            "num": 201
        },

        {
            "id": 15649,
            "year": 2022,
            "is_wenli": 2,
            "score": 189,
            "ranking": 502773,
            "num": 192
        },

        {
            "id": 15650,
            "year": 2022,
            "is_wenli": 2,
            "score": 188,
            "ranking": 502976,
            "num": 203
        },

        {
            "id": 15651,
            "year": 2022,
            "is_wenli": 2,
            "score": 187,
            "ranking": 503143,
            "num": 167
        },

        {
            "id": 15652,
            "year": 2022,
            "is_wenli": 2,
            "score": 186,
            "ranking": 503336,
            "num": 193
        },

        {
            "id": 15653,
            "year": 2022,
            "is_wenli": 2,
            "score": 185,
            "ranking": 503498,
            "num": 162
        },

        {
            "id": 15654,
            "year": 2022,
            "is_wenli": 2,
            "score": 184,
            "ranking": 503672,
            "num": 174
        },

        {
            "id": 15655,
            "year": 2022,
            "is_wenli": 2,
            "score": 183,
            "ranking": 503848,
            "num": 176
        },

        {
            "id": 15656,
            "year": 2022,
            "is_wenli": 2,
            "score": 182,
            "ranking": 504030,
            "num": 182
        },

        {
            "id": 15657,
            "year": 2022,
            "is_wenli": 2,
            "score": 181,
            "ranking": 504222,
            "num": 192
        },

        {
            "id": 15658,
            "year": 2022,
            "is_wenli": 2,
            "score": 180,
            "ranking": 504396,
            "num": 174
        },

        {
            "id": 15659,
            "year": 2022,
            "is_wenli": 2,
            "score": 179,
            "ranking": 504576,
            "num": 180
        },

        {
            "id": 15660,
            "year": 2022,
            "is_wenli": 2,
            "score": 178,
            "ranking": 504709,
            "num": 133
        },

        {
            "id": 15661,
            "year": 2022,
            "is_wenli": 2,
            "score": 177,
            "ranking": 504868,
            "num": 159
        },

        {
            "id": 15662,
            "year": 2022,
            "is_wenli": 2,
            "score": 176,
            "ranking": 505010,
            "num": 142
        },

        {
            "id": 15663,
            "year": 2022,
            "is_wenli": 2,
            "score": 175,
            "ranking": 505145,
            "num": 135
        },

        {
            "id": 15664,
            "year": 2022,
            "is_wenli": 2,
            "score": 174,
            "ranking": 505277,
            "num": 132
        },

        {
            "id": 15665,
            "year": 2022,
            "is_wenli": 2,
            "score": 173,
            "ranking": 505408,
            "num": 131
        },

        {
            "id": 15666,
            "year": 2022,
            "is_wenli": 2,
            "score": 172,
            "ranking": 505546,
            "num": 138
        },

        {
            "id": 15667,
            "year": 2022,
            "is_wenli": 2,
            "score": 171,
            "ranking": 505679,
            "num": 133
        },

        {
            "id": 15668,
            "year": 2022,
            "is_wenli": 2,
            "score": 170,
            "ranking": 505813,
            "num": 134
        },

        {
            "id": 15669,
            "year": 2022,
            "is_wenli": 2,
            "score": 169,
            "ranking": 505936,
            "num": 123
        },

        {
            "id": 15670,
            "year": 2022,
            "is_wenli": 2,
            "score": 168,
            "ranking": 506064,
            "num": 128
        },

        {
            "id": 15671,
            "year": 2022,
            "is_wenli": 2,
            "score": 167,
            "ranking": 506175,
            "num": 111
        },

        {
            "id": 15672,
            "year": 2022,
            "is_wenli": 2,
            "score": 166,
            "ranking": 506318,
            "num": 143
        },

        {
            "id": 15673,
            "year": 2022,
            "is_wenli": 2,
            "score": 165,
            "ranking": 506424,
            "num": 106
        },

        {
            "id": 15674,
            "year": 2022,
            "is_wenli": 2,
            "score": 164,
            "ranking": 506532,
            "num": 108
        },

        {
            "id": 15675,
            "year": 2022,
            "is_wenli": 2,
            "score": 163,
            "ranking": 506656,
            "num": 124
        },

        {
            "id": 15676,
            "year": 2022,
            "is_wenli": 2,
            "score": 162,
            "ranking": 506769,
            "num": 113
        },

        {
            "id": 15677,
            "year": 2022,
            "is_wenli": 2,
            "score": 161,
            "ranking": 506881,
            "num": 112
        },

        {
            "id": 15678,
            "year": 2022,
            "is_wenli": 2,
            "score": 160,
            "ranking": 506990,
            "num": 109
        },

        {
            "id": 15679,
            "year": 2022,
            "is_wenli": 2,
            "score": 159,
            "ranking": 507104,
            "num": 114
        },

        {
            "id": 15680,
            "year": 2022,
            "is_wenli": 2,
            "score": 158,
            "ranking": 507205,
            "num": 101
        },

        {
            "id": 15681,
            "year": 2022,
            "is_wenli": 2,
            "score": 157,
            "ranking": 507308,
            "num": 103
        },

        {
            "id": 15682,
            "year": 2022,
            "is_wenli": 2,
            "score": 156,
            "ranking": 507392,
            "num": 84
        },

        {
            "id": 15683,
            "year": 2022,
            "is_wenli": 2,
            "score": 155,
            "ranking": 507477,
            "num": 85
        },

        {
            "id": 15684,
            "year": 2022,
            "is_wenli": 2,
            "score": 154,
            "ranking": 507571,
            "num": 94
        },

        {
            "id": 15685,
            "year": 2022,
            "is_wenli": 2,
            "score": 153,
            "ranking": 507659,
            "num": 88
        },

        {
            "id": 15686,
            "year": 2022,
            "is_wenli": 2,
            "score": 152,
            "ranking": 507751,
            "num": 92
        },

        {
            "id": 15687,
            "year": 2022,
            "is_wenli": 2,
            "score": 151,
            "ranking": 507824,
            "num": 73
        },

        {
            "id": 15688,
            "year": 2022,
            "is_wenli": 2,
            "score": 150,
            "ranking": 507915,
            "num": 91
        },

        {
            "id": 15689,
            "year": 2022,
            "is_wenli": 2,
            "score": 149,
            "ranking": 507995,
            "num": 80
        },

        {
            "id": 15690,
            "year": 2022,
            "is_wenli": 2,
            "score": 148,
            "ranking": 508072,
            "num": 77
        },

        {
            "id": 15691,
            "year": 2022,
            "is_wenli": 2,
            "score": 147,
            "ranking": 508139,
            "num": 67
        },

        {
            "id": 15692,
            "year": 2022,
            "is_wenli": 2,
            "score": 146,
            "ranking": 508210,
            "num": 71
        },

        {
            "id": 15693,
            "year": 2022,
            "is_wenli": 2,
            "score": 145,
            "ranking": 508270,
            "num": 60
        },

        {
            "id": 15694,
            "year": 2022,
            "is_wenli": 2,
            "score": 144,
            "ranking": 508331,
            "num": 61
        },

        {
            "id": 15695,
            "year": 2022,
            "is_wenli": 2,
            "score": 143,
            "ranking": 508400,
            "num": 69
        },

        {
            "id": 15696,
            "year": 2022,
            "is_wenli": 2,
            "score": 142,
            "ranking": 508471,
            "num": 71
        },

        {
            "id": 15697,
            "year": 2022,
            "is_wenli": 2,
            "score": 141,
            "ranking": 508530,
            "num": 59
        },

        {
            "id": 15698,
            "year": 2022,
            "is_wenli": 2,
            "score": 140,
            "ranking": 508581,
            "num": 51
        },

        {
            "id": 15699,
            "year": 2022,
            "is_wenli": 2,
            "score": 139,
            "ranking": 508638,
            "num": 57
        },

        {
            "id": 15700,
            "year": 2022,
            "is_wenli": 2,
            "score": 138,
            "ranking": 508696,
            "num": 58
        },

        {
            "id": 15701,
            "year": 2022,
            "is_wenli": 2,
            "score": 137,
            "ranking": 508745,
            "num": 49
        },

        {
            "id": 15702,
            "year": 2022,
            "is_wenli": 2,
            "score": 136,
            "ranking": 508792,
            "num": 47
        },

        {
            "id": 15703,
            "year": 2022,
            "is_wenli": 2,
            "score": 135,
            "ranking": 508826,
            "num": 34
        },

        {
            "id": 15704,
            "year": 2022,
            "is_wenli": 2,
            "score": 134,
            "ranking": 508866,
            "num": 40
        },

        {
            "id": 15705,
            "year": 2022,
            "is_wenli": 2,
            "score": 133,
            "ranking": 508903,
            "num": 37
        },

        {
            "id": 15706,
            "year": 2022,
            "is_wenli": 2,
            "score": 132,
            "ranking": 508949,
            "num": 46
        },

        {
            "id": 15707,
            "year": 2022,
            "is_wenli": 2,
            "score": 131,
            "ranking": 508989,
            "num": 40
        },

        {
            "id": 15708,
            "year": 2022,
            "is_wenli": 2,
            "score": 130,
            "ranking": 509040,
            "num": 51
        },

        {
            "id": 15709,
            "year": 2022,
            "is_wenli": 2,
            "score": 129,
            "ranking": 509082,
            "num": 42
        },

        {
            "id": 15710,
            "year": 2022,
            "is_wenli": 2,
            "score": 128,
            "ranking": 509123,
            "num": 41
        },

        {
            "id": 15711,
            "year": 2022,
            "is_wenli": 2,
            "score": 127,
            "ranking": 509147,
            "num": 24
        },

        {
            "id": 15712,
            "year": 2022,
            "is_wenli": 2,
            "score": 126,
            "ranking": 509186,
            "num": 39
        },

        {
            "id": 15713,
            "year": 2022,
            "is_wenli": 2,
            "score": 125,
            "ranking": 509210,
            "num": 24
        },

        {
            "id": 15714,
            "year": 2022,
            "is_wenli": 2,
            "score": 124,
            "ranking": 509245,
            "num": 35
        },

        {
            "id": 15715,
            "year": 2022,
            "is_wenli": 2,
            "score": 123,
            "ranking": 509268,
            "num": 23
        },

        {
            "id": 15716,
            "year": 2022,
            "is_wenli": 2,
            "score": 122,
            "ranking": 509301,
            "num": 33
        },

        {
            "id": 15717,
            "year": 2022,
            "is_wenli": 2,
            "score": 121,
            "ranking": 509345,
            "num": 44
        },

        {
            "id": 15718,
            "year": 2022,
            "is_wenli": 2,
            "score": 120,
            "ranking": 509380,
            "num": 35
        },

        {
            "id": 15719,
            "year": 2022,
            "is_wenli": 2,
            "score": 119,
            "ranking": 509412,
            "num": 32
        },

        {
            "id": 15720,
            "year": 2022,
            "is_wenli": 2,
            "score": 118,
            "ranking": 509433,
            "num": 21
        },

        {
            "id": 15721,
            "year": 2022,
            "is_wenli": 2,
            "score": 117,
            "ranking": 509462,
            "num": 29
        },

        {
            "id": 15722,
            "year": 2022,
            "is_wenli": 2,
            "score": 116,
            "ranking": 509484,
            "num": 22
        },

        {
            "id": 15723,
            "year": 2022,
            "is_wenli": 2,
            "score": 115,
            "ranking": 509509,
            "num": 25
        },

        {
            "id": 15724,
            "year": 2022,
            "is_wenli": 2,
            "score": 114,
            "ranking": 509533,
            "num": 24
        },

        {
            "id": 15725,
            "year": 2022,
            "is_wenli": 2,
            "score": 113,
            "ranking": 509550,
            "num": 17
        },

        {
            "id": 15726,
            "year": 2022,
            "is_wenli": 2,
            "score": 112,
            "ranking": 509572,
            "num": 22
        },

        {
            "id": 15727,
            "year": 2022,
            "is_wenli": 2,
            "score": 111,
            "ranking": 509586,
            "num": 14
        },

        {
            "id": 15728,
            "year": 2022,
            "is_wenli": 2,
            "score": 110,
            "ranking": 509602,
            "num": 16
        },

        {
            "id": 15729,
            "year": 2022,
            "is_wenli": 2,
            "score": 109,
            "ranking": 509628,
            "num": 26
        },

        {
            "id": 15730,
            "year": 2022,
            "is_wenli": 2,
            "score": 108,
            "ranking": 509647,
            "num": 19
        },

        {
            "id": 15731,
            "year": 2022,
            "is_wenli": 2,
            "score": 107,
            "ranking": 509657,
            "num": 10
        },

        {
            "id": 15732,
            "year": 2022,
            "is_wenli": 2,
            "score": 106,
            "ranking": 509680,
            "num": 23
        },

        {
            "id": 15733,
            "year": 2022,
            "is_wenli": 2,
            "score": 105,
            "ranking": 509692,
            "num": 12
        },

        {
            "id": 15734,
            "year": 2022,
            "is_wenli": 2,
            "score": 104,
            "ranking": 509711,
            "num": 19
        },

        {
            "id": 15735,
            "year": 2022,
            "is_wenli": 2,
            "score": 103,
            "ranking": 509731,
            "num": 20
        },

        {
            "id": 15736,
            "year": 2022,
            "is_wenli": 2,
            "score": 102,
            "ranking": 509739,
            "num": 8
        },

        {
            "id": 15737,
            "year": 2022,
            "is_wenli": 2,
            "score": 101,
            "ranking": 509746,
            "num": 7
        },

        {
            "id": 15738,
            "year": 2022,
            "is_wenli": 2,
            "score": 100,
            "ranking": 509762,
            "num": 16
        }
    ],
    2021: [
        {
            "id": 5115,
            "score": 708,
            "ranking": 15,
            "is_wenli": 2,
            "year": 2021,
            "num": 15
        },

        {
            "id": 5116,
            "score": 707,
            "ranking": 18,
            "is_wenli": 2,
            "year": 2021,
            "num": 3
        },

        {
            "id": 5117,
            "score": 706,
            "ranking": 20,
            "is_wenli": 2,
            "year": 2021,
            "num": 2
        },

        {
            "id": 5118,
            "score": 705,
            "ranking": 26,
            "is_wenli": 2,
            "year": 2021,
            "num": 6
        },

        {
            "id": 5119,
            "score": 704,
            "ranking": 33,
            "is_wenli": 2,
            "year": 2021,
            "num": 7
        },

        {
            "id": 5120,
            "score": 703,
            "ranking": 39,
            "is_wenli": 2,
            "year": 2021,
            "num": 6
        },

        {
            "id": 5121,
            "score": 702,
            "ranking": 49,
            "is_wenli": 2,
            "year": 2021,
            "num": 10
        },

        {
            "id": 5122,
            "score": 701,
            "ranking": 59,
            "is_wenli": 2,
            "year": 2021,
            "num": 10
        },

        {
            "id": 5123,
            "score": 700,
            "ranking": 68,
            "is_wenli": 2,
            "year": 2021,
            "num": 9
        },

        {
            "id": 5124,
            "score": 699,
            "ranking": 83,
            "is_wenli": 2,
            "year": 2021,
            "num": 15
        },

        {
            "id": 5125,
            "score": 698,
            "ranking": 97,
            "is_wenli": 2,
            "year": 2021,
            "num": 14
        },

        {
            "id": 5126,
            "score": 697,
            "ranking": 111,
            "is_wenli": 2,
            "year": 2021,
            "num": 14
        },

        {
            "id": 5127,
            "score": 696,
            "ranking": 122,
            "is_wenli": 2,
            "year": 2021,
            "num": 11
        },

        {
            "id": 5128,
            "score": 695,
            "ranking": 143,
            "is_wenli": 2,
            "year": 2021,
            "num": 21
        },

        {
            "id": 5129,
            "score": 694,
            "ranking": 159,
            "is_wenli": 2,
            "year": 2021,
            "num": 16
        },

        {
            "id": 5130,
            "score": 693,
            "ranking": 179,
            "is_wenli": 2,
            "year": 2021,
            "num": 20
        },

        {
            "id": 5131,
            "score": 692,
            "ranking": 203,
            "is_wenli": 2,
            "year": 2021,
            "num": 24
        },

        {
            "id": 5132,
            "score": 691,
            "ranking": 227,
            "is_wenli": 2,
            "year": 2021,
            "num": 24
        },

        {
            "id": 5133,
            "score": 690,
            "ranking": 255,
            "is_wenli": 2,
            "year": 2021,
            "num": 28
        },

        {
            "id": 5134,
            "score": 689,
            "ranking": 286,
            "is_wenli": 2,
            "year": 2021,
            "num": 31
        },

        {
            "id": 5135,
            "score": 688,
            "ranking": 315,
            "is_wenli": 2,
            "year": 2021,
            "num": 29
        },

        {
            "id": 5136,
            "score": 687,
            "ranking": 348,
            "is_wenli": 2,
            "year": 2021,
            "num": 33
        },

        {
            "id": 5137,
            "score": 686,
            "ranking": 383,
            "is_wenli": 2,
            "year": 2021,
            "num": 35
        },

        {
            "id": 5138,
            "score": 685,
            "ranking": 426,
            "is_wenli": 2,
            "year": 2021,
            "num": 43
        },

        {
            "id": 5139,
            "score": 684,
            "ranking": 472,
            "is_wenli": 2,
            "year": 2021,
            "num": 46
        },

        {
            "id": 5140,
            "score": 683,
            "ranking": 513,
            "is_wenli": 2,
            "year": 2021,
            "num": 41
        },

        {
            "id": 5141,
            "score": 682,
            "ranking": 551,
            "is_wenli": 2,
            "year": 2021,
            "num": 38
        },

        {
            "id": 5142,
            "score": 681,
            "ranking": 604,
            "is_wenli": 2,
            "year": 2021,
            "num": 53
        },

        {
            "id": 5143,
            "score": 680,
            "ranking": 659,
            "is_wenli": 2,
            "year": 2021,
            "num": 55
        },

        {
            "id": 5144,
            "score": 679,
            "ranking": 716,
            "is_wenli": 2,
            "year": 2021,
            "num": 57
        },

        {
            "id": 5145,
            "score": 678,
            "ranking": 774,
            "is_wenli": 2,
            "year": 2021,
            "num": 58
        },

        {
            "id": 5146,
            "score": 677,
            "ranking": 836,
            "is_wenli": 2,
            "year": 2021,
            "num": 62
        },

        {
            "id": 5147,
            "score": 676,
            "ranking": 902,
            "is_wenli": 2,
            "year": 2021,
            "num": 66
        },

        {
            "id": 5148,
            "score": 675,
            "ranking": 982,
            "is_wenli": 2,
            "year": 2021,
            "num": 80
        },

        {
            "id": 5149,
            "score": 674,
            "ranking": 1046,
            "is_wenli": 2,
            "year": 2021,
            "num": 64
        },

        {
            "id": 5150,
            "score": 673,
            "ranking": 1115,
            "is_wenli": 2,
            "year": 2021,
            "num": 69
        },

        {
            "id": 5151,
            "score": 672,
            "ranking": 1184,
            "is_wenli": 2,
            "year": 2021,
            "num": 69
        },

        {
            "id": 5152,
            "score": 671,
            "ranking": 1290,
            "is_wenli": 2,
            "year": 2021,
            "num": 106
        },

        {
            "id": 5153,
            "score": 670,
            "ranking": 1390,
            "is_wenli": 2,
            "year": 2021,
            "num": 100
        },

        {
            "id": 5154,
            "score": 669,
            "ranking": 1500,
            "is_wenli": 2,
            "year": 2021,
            "num": 110
        },

        {
            "id": 5155,
            "score": 668,
            "ranking": 1606,
            "is_wenli": 2,
            "year": 2021,
            "num": 106
        },

        {
            "id": 5156,
            "score": 667,
            "ranking": 1730,
            "is_wenli": 2,
            "year": 2021,
            "num": 124
        },

        {
            "id": 5157,
            "score": 666,
            "ranking": 1839,
            "is_wenli": 2,
            "year": 2021,
            "num": 109
        },

        {
            "id": 5158,
            "score": 665,
            "ranking": 1945,
            "is_wenli": 2,
            "year": 2021,
            "num": 106
        },

        {
            "id": 5159,
            "score": 664,
            "ranking": 2055,
            "is_wenli": 2,
            "year": 2021,
            "num": 110
        },

        {
            "id": 5160,
            "score": 663,
            "ranking": 2171,
            "is_wenli": 2,
            "year": 2021,
            "num": 116
        },

        {
            "id": 5161,
            "score": 662,
            "ranking": 2315,
            "is_wenli": 2,
            "year": 2021,
            "num": 144
        },

        {
            "id": 5162,
            "score": 661,
            "ranking": 2447,
            "is_wenli": 2,
            "year": 2021,
            "num": 132
        },

        {
            "id": 5163,
            "score": 660,
            "ranking": 2582,
            "is_wenli": 2,
            "year": 2021,
            "num": 135
        },

        {
            "id": 5164,
            "score": 659,
            "ranking": 2750,
            "is_wenli": 2,
            "year": 2021,
            "num": 168
        },

        {
            "id": 5165,
            "score": 658,
            "ranking": 2928,
            "is_wenli": 2,
            "year": 2021,
            "num": 178
        },

        {
            "id": 5166,
            "score": 657,
            "ranking": 3071,
            "is_wenli": 2,
            "year": 2021,
            "num": 143
        },

        {
            "id": 5167,
            "score": 656,
            "ranking": 3232,
            "is_wenli": 2,
            "year": 2021,
            "num": 161
        },

        {
            "id": 5168,
            "score": 655,
            "ranking": 3427,
            "is_wenli": 2,
            "year": 2021,
            "num": 195
        },

        {
            "id": 5169,
            "score": 654,
            "ranking": 3618,
            "is_wenli": 2,
            "year": 2021,
            "num": 191
        },

        {
            "id": 5170,
            "score": 653,
            "ranking": 3815,
            "is_wenli": 2,
            "year": 2021,
            "num": 197
        },

        {
            "id": 5171,
            "score": 652,
            "ranking": 4022,
            "is_wenli": 2,
            "year": 2021,
            "num": 207
        },

        {
            "id": 5172,
            "score": 651,
            "ranking": 4219,
            "is_wenli": 2,
            "year": 2021,
            "num": 197
        },

        {
            "id": 5173,
            "score": 650,
            "ranking": 4428,
            "is_wenli": 2,
            "year": 2021,
            "num": 209
        },

        {
            "id": 5174,
            "score": 649,
            "ranking": 4632,
            "is_wenli": 2,
            "year": 2021,
            "num": 204
        },

        {
            "id": 5175,
            "score": 648,
            "ranking": 4866,
            "is_wenli": 2,
            "year": 2021,
            "num": 234
        },

        {
            "id": 5176,
            "score": 647,
            "ranking": 5113,
            "is_wenli": 2,
            "year": 2021,
            "num": 247
        },

        {
            "id": 5177,
            "score": 646,
            "ranking": 5337,
            "is_wenli": 2,
            "year": 2021,
            "num": 224
        },

        {
            "id": 5178,
            "score": 645,
            "ranking": 5586,
            "is_wenli": 2,
            "year": 2021,
            "num": 249
        },

        {
            "id": 5179,
            "score": 644,
            "ranking": 5865,
            "is_wenli": 2,
            "year": 2021,
            "num": 279
        },

        {
            "id": 5180,
            "score": 643,
            "ranking": 6115,
            "is_wenli": 2,
            "year": 2021,
            "num": 250
        },

        {
            "id": 5181,
            "score": 642,
            "ranking": 6374,
            "is_wenli": 2,
            "year": 2021,
            "num": 259
        },

        {
            "id": 5182,
            "score": 641,
            "ranking": 6621,
            "is_wenli": 2,
            "year": 2021,
            "num": 247
        },

        {
            "id": 5183,
            "score": 640,
            "ranking": 6896,
            "is_wenli": 2,
            "year": 2021,
            "num": 275
        },

        {
            "id": 5184,
            "score": 639,
            "ranking": 7225,
            "is_wenli": 2,
            "year": 2021,
            "num": 329
        },

        {
            "id": 5185,
            "score": 638,
            "ranking": 7501,
            "is_wenli": 2,
            "year": 2021,
            "num": 276
        },

        {
            "id": 5186,
            "score": 637,
            "ranking": 7791,
            "is_wenli": 2,
            "year": 2021,
            "num": 290
        },

        {
            "id": 5187,
            "score": 636,
            "ranking": 8107,
            "is_wenli": 2,
            "year": 2021,
            "num": 316
        },

        {
            "id": 5188,
            "score": 635,
            "ranking": 8421,
            "is_wenli": 2,
            "year": 2021,
            "num": 314
        },

        {
            "id": 5189,
            "score": 634,
            "ranking": 8730,
            "is_wenli": 2,
            "year": 2021,
            "num": 309
        },

        {
            "id": 5190,
            "score": 633,
            "ranking": 9067,
            "is_wenli": 2,
            "year": 2021,
            "num": 337
        },

        {
            "id": 5191,
            "score": 632,
            "ranking": 9454,
            "is_wenli": 2,
            "year": 2021,
            "num": 387
        },

        {
            "id": 5192,
            "score": 631,
            "ranking": 9815,
            "is_wenli": 2,
            "year": 2021,
            "num": 361
        },

        {
            "id": 5193,
            "score": 630,
            "ranking": 10181,
            "is_wenli": 2,
            "year": 2021,
            "num": 366
        },

        {
            "id": 5194,
            "score": 629,
            "ranking": 10535,
            "is_wenli": 2,
            "year": 2021,
            "num": 354
        },

        {
            "id": 5195,
            "score": 628,
            "ranking": 10919,
            "is_wenli": 2,
            "year": 2021,
            "num": 384
        },

        {
            "id": 5196,
            "score": 627,
            "ranking": 11294,
            "is_wenli": 2,
            "year": 2021,
            "num": 375
        },

        {
            "id": 5197,
            "score": 626,
            "ranking": 11699,
            "is_wenli": 2,
            "year": 2021,
            "num": 405
        },

        {
            "id": 5198,
            "score": 625,
            "ranking": 12135,
            "is_wenli": 2,
            "year": 2021,
            "num": 436
        },

        {
            "id": 5199,
            "score": 624,
            "ranking": 12534,
            "is_wenli": 2,
            "year": 2021,
            "num": 399
        },

        {
            "id": 5200,
            "score": 623,
            "ranking": 12952,
            "is_wenli": 2,
            "year": 2021,
            "num": 418
        },

        {
            "id": 5201,
            "score": 622,
            "ranking": 13376,
            "is_wenli": 2,
            "year": 2021,
            "num": 424
        },

        {
            "id": 5202,
            "score": 621,
            "ranking": 13845,
            "is_wenli": 2,
            "year": 2021,
            "num": 469
        },

        {
            "id": 5203,
            "score": 620,
            "ranking": 14309,
            "is_wenli": 2,
            "year": 2021,
            "num": 464
        },

        {
            "id": 5204,
            "score": 619,
            "ranking": 14767,
            "is_wenli": 2,
            "year": 2021,
            "num": 458
        },

        {
            "id": 5205,
            "score": 618,
            "ranking": 15229,
            "is_wenli": 2,
            "year": 2021,
            "num": 462
        },

        {
            "id": 5206,
            "score": 617,
            "ranking": 15697,
            "is_wenli": 2,
            "year": 2021,
            "num": 468
        },

        {
            "id": 5207,
            "score": 616,
            "ranking": 16166,
            "is_wenli": 2,
            "year": 2021,
            "num": 469
        },

        {
            "id": 5208,
            "score": 615,
            "ranking": 16706,
            "is_wenli": 2,
            "year": 2021,
            "num": 540
        },

        {
            "id": 5209,
            "score": 614,
            "ranking": 17248,
            "is_wenli": 2,
            "year": 2021,
            "num": 542
        },

        {
            "id": 5210,
            "score": 613,
            "ranking": 17797,
            "is_wenli": 2,
            "year": 2021,
            "num": 549
        },

        {
            "id": 5211,
            "score": 612,
            "ranking": 18358,
            "is_wenli": 2,
            "year": 2021,
            "num": 561
        },

        {
            "id": 5212,
            "score": 611,
            "ranking": 18927,
            "is_wenli": 2,
            "year": 2021,
            "num": 569
        },

        {
            "id": 5213,
            "score": 610,
            "ranking": 19481,
            "is_wenli": 2,
            "year": 2021,
            "num": 554
        },

        {
            "id": 5214,
            "score": 609,
            "ranking": 20081,
            "is_wenli": 2,
            "year": 2021,
            "num": 600
        },

        {
            "id": 5215,
            "score": 608,
            "ranking": 20660,
            "is_wenli": 2,
            "year": 2021,
            "num": 579
        },

        {
            "id": 5216,
            "score": 607,
            "ranking": 21254,
            "is_wenli": 2,
            "year": 2021,
            "num": 594
        },

        {
            "id": 5217,
            "score": 606,
            "ranking": 21866,
            "is_wenli": 2,
            "year": 2021,
            "num": 612
        },

        {
            "id": 5218,
            "score": 605,
            "ranking": 22560,
            "is_wenli": 2,
            "year": 2021,
            "num": 694
        },

        {
            "id": 5219,
            "score": 604,
            "ranking": 23232,
            "is_wenli": 2,
            "year": 2021,
            "num": 672
        },

        {
            "id": 5220,
            "score": 603,
            "ranking": 23896,
            "is_wenli": 2,
            "year": 2021,
            "num": 664
        },

        {
            "id": 5221,
            "score": 602,
            "ranking": 24547,
            "is_wenli": 2,
            "year": 2021,
            "num": 651
        },

        {
            "id": 5222,
            "score": 601,
            "ranking": 25226,
            "is_wenli": 2,
            "year": 2021,
            "num": 679
        },

        {
            "id": 5223,
            "score": 600,
            "ranking": 25941,
            "is_wenli": 2,
            "year": 2021,
            "num": 715
        },

        {
            "id": 5224,
            "score": 599,
            "ranking": 26645,
            "is_wenli": 2,
            "year": 2021,
            "num": 704
        },

        {
            "id": 5225,
            "score": 598,
            "ranking": 27341,
            "is_wenli": 2,
            "year": 2021,
            "num": 696
        },

        {
            "id": 5226,
            "score": 597,
            "ranking": 28109,
            "is_wenli": 2,
            "year": 2021,
            "num": 768
        },

        {
            "id": 5227,
            "score": 596,
            "ranking": 28854,
            "is_wenli": 2,
            "year": 2021,
            "num": 745
        },

        {
            "id": 5228,
            "score": 595,
            "ranking": 29573,
            "is_wenli": 2,
            "year": 2021,
            "num": 719
        },

        {
            "id": 5229,
            "score": 594,
            "ranking": 30319,
            "is_wenli": 2,
            "year": 2021,
            "num": 746
        },

        {
            "id": 5230,
            "score": 593,
            "ranking": 31136,
            "is_wenli": 2,
            "year": 2021,
            "num": 817
        },

        {
            "id": 5231,
            "score": 592,
            "ranking": 31893,
            "is_wenli": 2,
            "year": 2021,
            "num": 757
        },

        {
            "id": 5232,
            "score": 591,
            "ranking": 32664,
            "is_wenli": 2,
            "year": 2021,
            "num": 771
        },

        {
            "id": 5233,
            "score": 590,
            "ranking": 33462,
            "is_wenli": 2,
            "year": 2021,
            "num": 798
        },

        {
            "id": 5234,
            "score": 589,
            "ranking": 34265,
            "is_wenli": 2,
            "year": 2021,
            "num": 803
        },

        {
            "id": 5235,
            "score": 588,
            "ranking": 35077,
            "is_wenli": 2,
            "year": 2021,
            "num": 812
        },

        {
            "id": 5236,
            "score": 587,
            "ranking": 35958,
            "is_wenli": 2,
            "year": 2021,
            "num": 881
        },

        {
            "id": 5237,
            "score": 586,
            "ranking": 36819,
            "is_wenli": 2,
            "year": 2021,
            "num": 861
        },

        {
            "id": 5238,
            "score": 585,
            "ranking": 37676,
            "is_wenli": 2,
            "year": 2021,
            "num": 857
        },

        {
            "id": 5239,
            "score": 584,
            "ranking": 38526,
            "is_wenli": 2,
            "year": 2021,
            "num": 850
        },

        {
            "id": 5240,
            "score": 583,
            "ranking": 39420,
            "is_wenli": 2,
            "year": 2021,
            "num": 894
        },

        {
            "id": 5241,
            "score": 582,
            "ranking": 40304,
            "is_wenli": 2,
            "year": 2021,
            "num": 884
        },

        {
            "id": 5242,
            "score": 581,
            "ranking": 41207,
            "is_wenli": 2,
            "year": 2021,
            "num": 903
        },

        {
            "id": 5243,
            "score": 580,
            "ranking": 42114,
            "is_wenli": 2,
            "year": 2021,
            "num": 907
        },

        {
            "id": 5244,
            "score": 579,
            "ranking": 43027,
            "is_wenli": 2,
            "year": 2021,
            "num": 913
        },

        {
            "id": 5245,
            "score": 578,
            "ranking": 43977,
            "is_wenli": 2,
            "year": 2021,
            "num": 950
        },

        {
            "id": 5246,
            "score": 577,
            "ranking": 44925,
            "is_wenli": 2,
            "year": 2021,
            "num": 948
        },

        {
            "id": 5247,
            "score": 576,
            "ranking": 45897,
            "is_wenli": 2,
            "year": 2021,
            "num": 972
        },

        {
            "id": 5248,
            "score": 575,
            "ranking": 46947,
            "is_wenli": 2,
            "year": 2021,
            "num": 1050
        },

        {
            "id": 5249,
            "score": 574,
            "ranking": 47907,
            "is_wenli": 2,
            "year": 2021,
            "num": 960
        },

        {
            "id": 5250,
            "score": 573,
            "ranking": 48861,
            "is_wenli": 2,
            "year": 2021,
            "num": 954
        },

        {
            "id": 5251,
            "score": 572,
            "ranking": 49827,
            "is_wenli": 2,
            "year": 2021,
            "num": 966
        },

        {
            "id": 5252,
            "score": 571,
            "ranking": 50842,
            "is_wenli": 2,
            "year": 2021,
            "num": 1015
        },

        {
            "id": 5253,
            "score": 570,
            "ranking": 51895,
            "is_wenli": 2,
            "year": 2021,
            "num": 1053
        },

        {
            "id": 5254,
            "score": 569,
            "ranking": 52925,
            "is_wenli": 2,
            "year": 2021,
            "num": 1030
        },

        {
            "id": 5255,
            "score": 568,
            "ranking": 53926,
            "is_wenli": 2,
            "year": 2021,
            "num": 1001
        },

        {
            "id": 5256,
            "score": 567,
            "ranking": 54949,
            "is_wenli": 2,
            "year": 2021,
            "num": 1023
        },

        {
            "id": 5257,
            "score": 566,
            "ranking": 55959,
            "is_wenli": 2,
            "year": 2021,
            "num": 1010
        },

        {
            "id": 5258,
            "score": 565,
            "ranking": 57047,
            "is_wenli": 2,
            "year": 2021,
            "num": 1088
        },

        {
            "id": 5259,
            "score": 564,
            "ranking": 58092,
            "is_wenli": 2,
            "year": 2021,
            "num": 1045
        },

        {
            "id": 5260,
            "score": 563,
            "ranking": 59195,
            "is_wenli": 2,
            "year": 2021,
            "num": 1103
        },

        {
            "id": 5261,
            "score": 562,
            "ranking": 60300,
            "is_wenli": 2,
            "year": 2021,
            "num": 1105
        },

        {
            "id": 5262,
            "score": 561,
            "ranking": 61408,
            "is_wenli": 2,
            "year": 2021,
            "num": 1108
        },

        {
            "id": 5263,
            "score": 560,
            "ranking": 62527,
            "is_wenli": 2,
            "year": 2021,
            "num": 1119
        },

        {
            "id": 5264,
            "score": 559,
            "ranking": 63644,
            "is_wenli": 2,
            "year": 2021,
            "num": 1117
        },

        {
            "id": 5265,
            "score": 558,
            "ranking": 64821,
            "is_wenli": 2,
            "year": 2021,
            "num": 1177
        },

        {
            "id": 5266,
            "score": 557,
            "ranking": 66016,
            "is_wenli": 2,
            "year": 2021,
            "num": 1195
        },

        {
            "id": 5267,
            "score": 556,
            "ranking": 67119,
            "is_wenli": 2,
            "year": 2021,
            "num": 1103
        },

        {
            "id": 5268,
            "score": 555,
            "ranking": 68314,
            "is_wenli": 2,
            "year": 2021,
            "num": 1195
        },

        {
            "id": 5269,
            "score": 554,
            "ranking": 69571,
            "is_wenli": 2,
            "year": 2021,
            "num": 1257
        },

        {
            "id": 5270,
            "score": 553,
            "ranking": 70771,
            "is_wenli": 2,
            "year": 2021,
            "num": 1200
        },

        {
            "id": 5271,
            "score": 552,
            "ranking": 71998,
            "is_wenli": 2,
            "year": 2021,
            "num": 1227
        },

        {
            "id": 5272,
            "score": 551,
            "ranking": 73198,
            "is_wenli": 2,
            "year": 2021,
            "num": 1200
        },

        {
            "id": 5273,
            "score": 550,
            "ranking": 74466,
            "is_wenli": 2,
            "year": 2021,
            "num": 1268
        },

        {
            "id": 5274,
            "score": 549,
            "ranking": 75663,
            "is_wenli": 2,
            "year": 2021,
            "num": 1197
        },

        {
            "id": 5275,
            "score": 548,
            "ranking": 76893,
            "is_wenli": 2,
            "year": 2021,
            "num": 1230
        },

        {
            "id": 5276,
            "score": 547,
            "ranking": 78166,
            "is_wenli": 2,
            "year": 2021,
            "num": 1273
        },

        {
            "id": 5277,
            "score": 546,
            "ranking": 79430,
            "is_wenli": 2,
            "year": 2021,
            "num": 1264
        },

        {
            "id": 5278,
            "score": 545,
            "ranking": 80734,
            "is_wenli": 2,
            "year": 2021,
            "num": 1304
        },

        {
            "id": 5279,
            "score": 544,
            "ranking": 81978,
            "is_wenli": 2,
            "year": 2021,
            "num": 1244
        },

        {
            "id": 5280,
            "score": 543,
            "ranking": 83173,
            "is_wenli": 2,
            "year": 2021,
            "num": 1195
        },

        {
            "id": 5281,
            "score": 542,
            "ranking": 84384,
            "is_wenli": 2,
            "year": 2021,
            "num": 1211
        },

        {
            "id": 5282,
            "score": 541,
            "ranking": 85633,
            "is_wenli": 2,
            "year": 2021,
            "num": 1249
        },

        {
            "id": 5283,
            "score": 540,
            "ranking": 86942,
            "is_wenli": 2,
            "year": 2021,
            "num": 1309
        },

        {
            "id": 5284,
            "score": 539,
            "ranking": 88238,
            "is_wenli": 2,
            "year": 2021,
            "num": 1296
        },

        {
            "id": 5285,
            "score": 538,
            "ranking": 89520,
            "is_wenli": 2,
            "year": 2021,
            "num": 1282
        },

        {
            "id": 5286,
            "score": 537,
            "ranking": 90783,
            "is_wenli": 2,
            "year": 2021,
            "num": 1263
        },

        {
            "id": 5287,
            "score": 536,
            "ranking": 92075,
            "is_wenli": 2,
            "year": 2021,
            "num": 1292
        },

        {
            "id": 5288,
            "score": 535,
            "ranking": 93448,
            "is_wenli": 2,
            "year": 2021,
            "num": 1373
        },

        {
            "id": 5289,
            "score": 534,
            "ranking": 94763,
            "is_wenli": 2,
            "year": 2021,
            "num": 1315
        },

        {
            "id": 5290,
            "score": 533,
            "ranking": 96108,
            "is_wenli": 2,
            "year": 2021,
            "num": 1345
        },

        {
            "id": 5291,
            "score": 532,
            "ranking": 97392,
            "is_wenli": 2,
            "year": 2021,
            "num": 1284
        },

        {
            "id": 5292,
            "score": 531,
            "ranking": 98686,
            "is_wenli": 2,
            "year": 2021,
            "num": 1294
        },

        {
            "id": 5293,
            "score": 530,
            "ranking": 99984,
            "is_wenli": 2,
            "year": 2021,
            "num": 1298
        },

        {
            "id": 5294,
            "score": 529,
            "ranking": 101319,
            "is_wenli": 2,
            "year": 2021,
            "num": 1335
        },

        {
            "id": 5295,
            "score": 528,
            "ranking": 102673,
            "is_wenli": 2,
            "year": 2021,
            "num": 1354
        },

        {
            "id": 5296,
            "score": 527,
            "ranking": 104040,
            "is_wenli": 2,
            "year": 2021,
            "num": 1367
        },

        {
            "id": 5297,
            "score": 526,
            "ranking": 105431,
            "is_wenli": 2,
            "year": 2021,
            "num": 1391
        },

        {
            "id": 5298,
            "score": 525,
            "ranking": 106846,
            "is_wenli": 2,
            "year": 2021,
            "num": 1415
        },

        {
            "id": 5299,
            "score": 524,
            "ranking": 108202,
            "is_wenli": 2,
            "year": 2021,
            "num": 1356
        },

        {
            "id": 5300,
            "score": 523,
            "ranking": 109592,
            "is_wenli": 2,
            "year": 2021,
            "num": 1390
        },

        {
            "id": 5301,
            "score": 522,
            "ranking": 111038,
            "is_wenli": 2,
            "year": 2021,
            "num": 1446
        },

        {
            "id": 5302,
            "score": 521,
            "ranking": 112446,
            "is_wenli": 2,
            "year": 2021,
            "num": 1408
        },

        {
            "id": 5303,
            "score": 520,
            "ranking": 113880,
            "is_wenli": 2,
            "year": 2021,
            "num": 1434
        },

        {
            "id": 5304,
            "score": 519,
            "ranking": 115307,
            "is_wenli": 2,
            "year": 2021,
            "num": 1427
        },

        {
            "id": 5305,
            "score": 518,
            "ranking": 116712,
            "is_wenli": 2,
            "year": 2021,
            "num": 1405
        },

        {
            "id": 5306,
            "score": 517,
            "ranking": 118136,
            "is_wenli": 2,
            "year": 2021,
            "num": 1424
        },

        {
            "id": 5307,
            "score": 516,
            "ranking": 119572,
            "is_wenli": 2,
            "year": 2021,
            "num": 1436
        },

        {
            "id": 5308,
            "score": 515,
            "ranking": 121053,
            "is_wenli": 2,
            "year": 2021,
            "num": 1481
        },

        {
            "id": 5309,
            "score": 514,
            "ranking": 122496,
            "is_wenli": 2,
            "year": 2021,
            "num": 1443
        },

        {
            "id": 5310,
            "score": 513,
            "ranking": 123956,
            "is_wenli": 2,
            "year": 2021,
            "num": 1460
        },

        {
            "id": 5311,
            "score": 512,
            "ranking": 125339,
            "is_wenli": 2,
            "year": 2021,
            "num": 1383
        },

        {
            "id": 5312,
            "score": 511,
            "ranking": 126766,
            "is_wenli": 2,
            "year": 2021,
            "num": 1427
        },

        {
            "id": 5313,
            "score": 510,
            "ranking": 128279,
            "is_wenli": 2,
            "year": 2021,
            "num": 1513
        },

        {
            "id": 5314,
            "score": 509,
            "ranking": 129750,
            "is_wenli": 2,
            "year": 2021,
            "num": 1471
        },

        {
            "id": 5315,
            "score": 508,
            "ranking": 131200,
            "is_wenli": 2,
            "year": 2021,
            "num": 1450
        },

        {
            "id": 5316,
            "score": 507,
            "ranking": 132697,
            "is_wenli": 2,
            "year": 2021,
            "num": 1497
        },

        {
            "id": 5317,
            "score": 506,
            "ranking": 134151,
            "is_wenli": 2,
            "year": 2021,
            "num": 1454
        },

        {
            "id": 5318,
            "score": 505,
            "ranking": 135597,
            "is_wenli": 2,
            "year": 2021,
            "num": 1446
        },

        {
            "id": 5319,
            "score": 504,
            "ranking": 137053,
            "is_wenli": 2,
            "year": 2021,
            "num": 1456
        },

        {
            "id": 5320,
            "score": 503,
            "ranking": 138510,
            "is_wenli": 2,
            "year": 2021,
            "num": 1457
        },

        {
            "id": 5321,
            "score": 502,
            "ranking": 139904,
            "is_wenli": 2,
            "year": 2021,
            "num": 1394
        },

        {
            "id": 5322,
            "score": 501,
            "ranking": 141361,
            "is_wenli": 2,
            "year": 2021,
            "num": 1457
        },

        {
            "id": 5323,
            "score": 500,
            "ranking": 142881,
            "is_wenli": 2,
            "year": 2021,
            "num": 1520
        },

        {
            "id": 5324,
            "score": 499,
            "ranking": 144391,
            "is_wenli": 2,
            "year": 2021,
            "num": 1510
        },

        {
            "id": 5325,
            "score": 498,
            "ranking": 145875,
            "is_wenli": 2,
            "year": 2021,
            "num": 1484
        },

        {
            "id": 5326,
            "score": 497,
            "ranking": 147350,
            "is_wenli": 2,
            "year": 2021,
            "num": 1475
        },

        {
            "id": 5327,
            "score": 496,
            "ranking": 148869,
            "is_wenli": 2,
            "year": 2021,
            "num": 1519
        },

        {
            "id": 5328,
            "score": 495,
            "ranking": 150381,
            "is_wenli": 2,
            "year": 2021,
            "num": 1512
        },

        {
            "id": 5329,
            "score": 494,
            "ranking": 151865,
            "is_wenli": 2,
            "year": 2021,
            "num": 1484
        },

        {
            "id": 5330,
            "score": 493,
            "ranking": 153381,
            "is_wenli": 2,
            "year": 2021,
            "num": 1516
        },

        {
            "id": 5331,
            "score": 492,
            "ranking": 154848,
            "is_wenli": 2,
            "year": 2021,
            "num": 1467
        },

        {
            "id": 5332,
            "score": 491,
            "ranking": 156390,
            "is_wenli": 2,
            "year": 2021,
            "num": 1542
        },

        {
            "id": 5333,
            "score": 490,
            "ranking": 157920,
            "is_wenli": 2,
            "year": 2021,
            "num": 1530
        },

        {
            "id": 5334,
            "score": 489,
            "ranking": 159463,
            "is_wenli": 2,
            "year": 2021,
            "num": 1543
        },

        {
            "id": 5335,
            "score": 488,
            "ranking": 160983,
            "is_wenli": 2,
            "year": 2021,
            "num": 1520
        },

        {
            "id": 5336,
            "score": 487,
            "ranking": 162483,
            "is_wenli": 2,
            "year": 2021,
            "num": 1500
        },

        {
            "id": 5337,
            "score": 486,
            "ranking": 164055,
            "is_wenli": 2,
            "year": 2021,
            "num": 1572
        },

        {
            "id": 5338,
            "score": 485,
            "ranking": 165585,
            "is_wenli": 2,
            "year": 2021,
            "num": 1530
        },

        {
            "id": 5339,
            "score": 484,
            "ranking": 167136,
            "is_wenli": 2,
            "year": 2021,
            "num": 1551
        },

        {
            "id": 5340,
            "score": 483,
            "ranking": 168671,
            "is_wenli": 2,
            "year": 2021,
            "num": 1535
        },

        {
            "id": 5341,
            "score": 482,
            "ranking": 170142,
            "is_wenli": 2,
            "year": 2021,
            "num": 1471
        },

        {
            "id": 5342,
            "score": 481,
            "ranking": 171656,
            "is_wenli": 2,
            "year": 2021,
            "num": 1514
        },

        {
            "id": 5343,
            "score": 480,
            "ranking": 173219,
            "is_wenli": 2,
            "year": 2021,
            "num": 1563
        },

        {
            "id": 5344,
            "score": 479,
            "ranking": 174842,
            "is_wenli": 2,
            "year": 2021,
            "num": 1623
        },

        {
            "id": 5345,
            "score": 478,
            "ranking": 176475,
            "is_wenli": 2,
            "year": 2021,
            "num": 1633
        },

        {
            "id": 5346,
            "score": 477,
            "ranking": 178120,
            "is_wenli": 2,
            "year": 2021,
            "num": 1645
        },

        {
            "id": 5347,
            "score": 476,
            "ranking": 179665,
            "is_wenli": 2,
            "year": 2021,
            "num": 1545
        },

        {
            "id": 5348,
            "score": 475,
            "ranking": 181262,
            "is_wenli": 2,
            "year": 2021,
            "num": 1597
        },

        {
            "id": 5349,
            "score": 474,
            "ranking": 182785,
            "is_wenli": 2,
            "year": 2021,
            "num": 1523
        },

        {
            "id": 5350,
            "score": 473,
            "ranking": 184349,
            "is_wenli": 2,
            "year": 2021,
            "num": 1564
        },

        {
            "id": 5351,
            "score": 472,
            "ranking": 185975,
            "is_wenli": 2,
            "year": 2021,
            "num": 1626
        },

        {
            "id": 5352,
            "score": 471,
            "ranking": 187565,
            "is_wenli": 2,
            "year": 2021,
            "num": 1590
        },

        {
            "id": 5353,
            "score": 470,
            "ranking": 189083,
            "is_wenli": 2,
            "year": 2021,
            "num": 1518
        },

        {
            "id": 5354,
            "score": 469,
            "ranking": 190631,
            "is_wenli": 2,
            "year": 2021,
            "num": 1548
        },

        {
            "id": 5355,
            "score": 468,
            "ranking": 192193,
            "is_wenli": 2,
            "year": 2021,
            "num": 1562
        },

        {
            "id": 5356,
            "score": 467,
            "ranking": 193798,
            "is_wenli": 2,
            "year": 2021,
            "num": 1605
        },

        {
            "id": 5357,
            "score": 466,
            "ranking": 195410,
            "is_wenli": 2,
            "year": 2021,
            "num": 1612
        },

        {
            "id": 5358,
            "score": 465,
            "ranking": 197054,
            "is_wenli": 2,
            "year": 2021,
            "num": 1644
        },

        {
            "id": 5359,
            "score": 464,
            "ranking": 198637,
            "is_wenli": 2,
            "year": 2021,
            "num": 1583
        },

        {
            "id": 5360,
            "score": 463,
            "ranking": 200256,
            "is_wenli": 2,
            "year": 2021,
            "num": 1619
        },

        {
            "id": 5361,
            "score": 462,
            "ranking": 201854,
            "is_wenli": 2,
            "year": 2021,
            "num": 1598
        },

        {
            "id": 5362,
            "score": 461,
            "ranking": 203404,
            "is_wenli": 2,
            "year": 2021,
            "num": 1550
        },

        {
            "id": 5363,
            "score": 460,
            "ranking": 205000,
            "is_wenli": 2,
            "year": 2021,
            "num": 1596
        },

        {
            "id": 5364,
            "score": 459,
            "ranking": 206643,
            "is_wenli": 2,
            "year": 2021,
            "num": 1643
        },

        {
            "id": 5365,
            "score": 458,
            "ranking": 208283,
            "is_wenli": 2,
            "year": 2021,
            "num": 1640
        },

        {
            "id": 5366,
            "score": 457,
            "ranking": 209890,
            "is_wenli": 2,
            "year": 2021,
            "num": 1607
        },

        {
            "id": 5367,
            "score": 456,
            "ranking": 211482,
            "is_wenli": 2,
            "year": 2021,
            "num": 1592
        },

        {
            "id": 5368,
            "score": 455,
            "ranking": 213085,
            "is_wenli": 2,
            "year": 2021,
            "num": 1603
        },

        {
            "id": 5369,
            "score": 454,
            "ranking": 214734,
            "is_wenli": 2,
            "year": 2021,
            "num": 1649
        },

        {
            "id": 5370,
            "score": 453,
            "ranking": 216337,
            "is_wenli": 2,
            "year": 2021,
            "num": 1603
        },

        {
            "id": 5371,
            "score": 452,
            "ranking": 217907,
            "is_wenli": 2,
            "year": 2021,
            "num": 1570
        },

        {
            "id": 5372,
            "score": 451,
            "ranking": 219532,
            "is_wenli": 2,
            "year": 2021,
            "num": 1625
        },

        {
            "id": 5373,
            "score": 450,
            "ranking": 221117,
            "is_wenli": 2,
            "year": 2021,
            "num": 1585
        },

        {
            "id": 5374,
            "score": 449,
            "ranking": 222771,
            "is_wenli": 2,
            "year": 2021,
            "num": 1654
        },

        {
            "id": 5375,
            "score": 448,
            "ranking": 224338,
            "is_wenli": 2,
            "year": 2021,
            "num": 1567
        },

        {
            "id": 5376,
            "score": 447,
            "ranking": 225988,
            "is_wenli": 2,
            "year": 2021,
            "num": 1650
        },

        {
            "id": 5377,
            "score": 446,
            "ranking": 227590,
            "is_wenli": 2,
            "year": 2021,
            "num": 1602
        },

        {
            "id": 5378,
            "score": 445,
            "ranking": 229192,
            "is_wenli": 2,
            "year": 2021,
            "num": 1602
        },

        {
            "id": 5379,
            "score": 444,
            "ranking": 230786,
            "is_wenli": 2,
            "year": 2021,
            "num": 1594
        },

        {
            "id": 5380,
            "score": 443,
            "ranking": 232325,
            "is_wenli": 2,
            "year": 2021,
            "num": 1539
        },

        {
            "id": 5381,
            "score": 442,
            "ranking": 233927,
            "is_wenli": 2,
            "year": 2021,
            "num": 1602
        },

        {
            "id": 5382,
            "score": 441,
            "ranking": 235515,
            "is_wenli": 2,
            "year": 2021,
            "num": 1588
        },

        {
            "id": 5383,
            "score": 440,
            "ranking": 237132,
            "is_wenli": 2,
            "year": 2021,
            "num": 1617
        },

        {
            "id": 5384,
            "score": 439,
            "ranking": 238693,
            "is_wenli": 2,
            "year": 2021,
            "num": 1561
        },

        {
            "id": 5385,
            "score": 438,
            "ranking": 240321,
            "is_wenli": 2,
            "year": 2021,
            "num": 1628
        },

        {
            "id": 5386,
            "score": 437,
            "ranking": 241940,
            "is_wenli": 2,
            "year": 2021,
            "num": 1619
        },

        {
            "id": 5387,
            "score": 436,
            "ranking": 243532,
            "is_wenli": 2,
            "year": 2021,
            "num": 1592
        },

        {
            "id": 5388,
            "score": 435,
            "ranking": 245065,
            "is_wenli": 2,
            "year": 2021,
            "num": 1533
        },

        {
            "id": 5389,
            "score": 434,
            "ranking": 246717,
            "is_wenli": 2,
            "year": 2021,
            "num": 1652
        },

        {
            "id": 5390,
            "score": 433,
            "ranking": 248295,
            "is_wenli": 2,
            "year": 2021,
            "num": 1578
        },

        {
            "id": 5391,
            "score": 432,
            "ranking": 249868,
            "is_wenli": 2,
            "year": 2021,
            "num": 1573
        },

        {
            "id": 5392,
            "score": 431,
            "ranking": 251493,
            "is_wenli": 2,
            "year": 2021,
            "num": 1625
        },

        {
            "id": 5393,
            "score": 430,
            "ranking": 253042,
            "is_wenli": 2,
            "year": 2021,
            "num": 1549
        },

        {
            "id": 5394,
            "score": 429,
            "ranking": 254608,
            "is_wenli": 2,
            "year": 2021,
            "num": 1566
        },

        {
            "id": 5395,
            "score": 428,
            "ranking": 256159,
            "is_wenli": 2,
            "year": 2021,
            "num": 1551
        },

        {
            "id": 5396,
            "score": 427,
            "ranking": 257747,
            "is_wenli": 2,
            "year": 2021,
            "num": 1588
        },

        {
            "id": 5397,
            "score": 426,
            "ranking": 259330,
            "is_wenli": 2,
            "year": 2021,
            "num": 1583
        },

        {
            "id": 5398,
            "score": 425,
            "ranking": 260851,
            "is_wenli": 2,
            "year": 2021,
            "num": 1521
        },

        {
            "id": 5399,
            "score": 424,
            "ranking": 262361,
            "is_wenli": 2,
            "year": 2021,
            "num": 1510
        },

        {
            "id": 5400,
            "score": 423,
            "ranking": 263892,
            "is_wenli": 2,
            "year": 2021,
            "num": 1531
        },

        {
            "id": 5401,
            "score": 422,
            "ranking": 265432,
            "is_wenli": 2,
            "year": 2021,
            "num": 1540
        },

        {
            "id": 5402,
            "score": 421,
            "ranking": 266965,
            "is_wenli": 2,
            "year": 2021,
            "num": 1533
        },

        {
            "id": 5403,
            "score": 420,
            "ranking": 268493,
            "is_wenli": 2,
            "year": 2021,
            "num": 1528
        },

        {
            "id": 5404,
            "score": 419,
            "ranking": 269968,
            "is_wenli": 2,
            "year": 2021,
            "num": 1475
        },

        {
            "id": 5405,
            "score": 418,
            "ranking": 271535,
            "is_wenli": 2,
            "year": 2021,
            "num": 1567
        },

        {
            "id": 5406,
            "score": 417,
            "ranking": 273082,
            "is_wenli": 2,
            "year": 2021,
            "num": 1547
        },

        {
            "id": 5407,
            "score": 416,
            "ranking": 274530,
            "is_wenli": 2,
            "year": 2021,
            "num": 1448
        },

        {
            "id": 5408,
            "score": 415,
            "ranking": 276009,
            "is_wenli": 2,
            "year": 2021,
            "num": 1479
        },

        {
            "id": 5409,
            "score": 414,
            "ranking": 277505,
            "is_wenli": 2,
            "year": 2021,
            "num": 1496
        },

        {
            "id": 5410,
            "score": 413,
            "ranking": 279013,
            "is_wenli": 2,
            "year": 2021,
            "num": 1508
        },

        {
            "id": 5411,
            "score": 412,
            "ranking": 280640,
            "is_wenli": 2,
            "year": 2021,
            "num": 1627
        },

        {
            "id": 5412,
            "score": 411,
            "ranking": 282125,
            "is_wenli": 2,
            "year": 2021,
            "num": 1485
        },

        {
            "id": 5413,
            "score": 410,
            "ranking": 283600,
            "is_wenli": 2,
            "year": 2021,
            "num": 1475
        },

        {
            "id": 5414,
            "score": 409,
            "ranking": 284988,
            "is_wenli": 2,
            "year": 2021,
            "num": 1388
        },

        {
            "id": 5415,
            "score": 408,
            "ranking": 286455,
            "is_wenli": 2,
            "year": 2021,
            "num": 1467
        },

        {
            "id": 5416,
            "score": 407,
            "ranking": 287920,
            "is_wenli": 2,
            "year": 2021,
            "num": 1465
        },

        {
            "id": 5417,
            "score": 406,
            "ranking": 289382,
            "is_wenli": 2,
            "year": 2021,
            "num": 1462
        },

        {
            "id": 5418,
            "score": 405,
            "ranking": 290800,
            "is_wenli": 2,
            "year": 2021,
            "num": 1418
        },

        {
            "id": 5419,
            "score": 404,
            "ranking": 292189,
            "is_wenli": 2,
            "year": 2021,
            "num": 1389
        },

        {
            "id": 5420,
            "score": 403,
            "ranking": 293683,
            "is_wenli": 2,
            "year": 2021,
            "num": 1494
        },

        {
            "id": 5421,
            "score": 402,
            "ranking": 295123,
            "is_wenli": 2,
            "year": 2021,
            "num": 1440
        },

        {
            "id": 5422,
            "score": 401,
            "ranking": 296564,
            "is_wenli": 2,
            "year": 2021,
            "num": 1441
        },

        {
            "id": 5423,
            "score": 400,
            "ranking": 297990,
            "is_wenli": 2,
            "year": 2021,
            "num": 1426
        },

        {
            "id": 5424,
            "score": 399,
            "ranking": 299464,
            "is_wenli": 2,
            "year": 2021,
            "num": 1474
        },

        {
            "id": 5425,
            "score": 398,
            "ranking": 300860,
            "is_wenli": 2,
            "year": 2021,
            "num": 1396
        },

        {
            "id": 5426,
            "score": 397,
            "ranking": 302239,
            "is_wenli": 2,
            "year": 2021,
            "num": 1379
        },

        {
            "id": 5427,
            "score": 396,
            "ranking": 303678,
            "is_wenli": 2,
            "year": 2021,
            "num": 1439
        },

        {
            "id": 5428,
            "score": 395,
            "ranking": 305066,
            "is_wenli": 2,
            "year": 2021,
            "num": 1388
        },

        {
            "id": 5429,
            "score": 394,
            "ranking": 306512,
            "is_wenli": 2,
            "year": 2021,
            "num": 1446
        },

        {
            "id": 5430,
            "score": 393,
            "ranking": 307958,
            "is_wenli": 2,
            "year": 2021,
            "num": 1446
        },

        {
            "id": 5431,
            "score": 392,
            "ranking": 309359,
            "is_wenli": 2,
            "year": 2021,
            "num": 1401
        },

        {
            "id": 5432,
            "score": 391,
            "ranking": 310754,
            "is_wenli": 2,
            "year": 2021,
            "num": 1395
        },

        {
            "id": 5433,
            "score": 390,
            "ranking": 312127,
            "is_wenli": 2,
            "year": 2021,
            "num": 1373
        },

        {
            "id": 5434,
            "score": 389,
            "ranking": 313390,
            "is_wenli": 2,
            "year": 2021,
            "num": 1263
        },

        {
            "id": 5435,
            "score": 388,
            "ranking": 314712,
            "is_wenli": 2,
            "year": 2021,
            "num": 1322
        },

        {
            "id": 5436,
            "score": 387,
            "ranking": 316017,
            "is_wenli": 2,
            "year": 2021,
            "num": 1305
        },

        {
            "id": 5437,
            "score": 386,
            "ranking": 317337,
            "is_wenli": 2,
            "year": 2021,
            "num": 1320
        },

        {
            "id": 5438,
            "score": 385,
            "ranking": 318688,
            "is_wenli": 2,
            "year": 2021,
            "num": 1351
        },

        {
            "id": 5439,
            "score": 384,
            "ranking": 319936,
            "is_wenli": 2,
            "year": 2021,
            "num": 1248
        },

        {
            "id": 5440,
            "score": 383,
            "ranking": 321298,
            "is_wenli": 2,
            "year": 2021,
            "num": 1362
        },

        {
            "id": 5441,
            "score": 382,
            "ranking": 322619,
            "is_wenli": 2,
            "year": 2021,
            "num": 1321
        },

        {
            "id": 5442,
            "score": 381,
            "ranking": 323916,
            "is_wenli": 2,
            "year": 2021,
            "num": 1297
        },

        {
            "id": 5443,
            "score": 380,
            "ranking": 325201,
            "is_wenli": 2,
            "year": 2021,
            "num": 1285
        },

        {
            "id": 5444,
            "score": 379,
            "ranking": 326501,
            "is_wenli": 2,
            "year": 2021,
            "num": 1300
        },

        {
            "id": 5445,
            "score": 378,
            "ranking": 327739,
            "is_wenli": 2,
            "year": 2021,
            "num": 1238
        },

        {
            "id": 5446,
            "score": 377,
            "ranking": 328956,
            "is_wenli": 2,
            "year": 2021,
            "num": 1217
        },

        {
            "id": 5447,
            "score": 376,
            "ranking": 330152,
            "is_wenli": 2,
            "year": 2021,
            "num": 1196
        },

        {
            "id": 5448,
            "score": 375,
            "ranking": 331449,
            "is_wenli": 2,
            "year": 2021,
            "num": 1297
        },

        {
            "id": 5449,
            "score": 374,
            "ranking": 332635,
            "is_wenli": 2,
            "year": 2021,
            "num": 1186
        },

        {
            "id": 5450,
            "score": 373,
            "ranking": 333837,
            "is_wenli": 2,
            "year": 2021,
            "num": 1202
        },

        {
            "id": 5451,
            "score": 372,
            "ranking": 335103,
            "is_wenli": 2,
            "year": 2021,
            "num": 1266
        },

        {
            "id": 5452,
            "score": 371,
            "ranking": 336342,
            "is_wenli": 2,
            "year": 2021,
            "num": 1239
        },

        {
            "id": 5453,
            "score": 370,
            "ranking": 337562,
            "is_wenli": 2,
            "year": 2021,
            "num": 1220
        },

        {
            "id": 5454,
            "score": 369,
            "ranking": 338774,
            "is_wenli": 2,
            "year": 2021,
            "num": 1212
        },

        {
            "id": 5455,
            "score": 368,
            "ranking": 339984,
            "is_wenli": 2,
            "year": 2021,
            "num": 1210
        },

        {
            "id": 5456,
            "score": 367,
            "ranking": 341260,
            "is_wenli": 2,
            "year": 2021,
            "num": 1276
        },

        {
            "id": 5457,
            "score": 366,
            "ranking": 342443,
            "is_wenli": 2,
            "year": 2021,
            "num": 1183
        },

        {
            "id": 5458,
            "score": 365,
            "ranking": 343595,
            "is_wenli": 2,
            "year": 2021,
            "num": 1152
        },

        {
            "id": 5459,
            "score": 364,
            "ranking": 344792,
            "is_wenli": 2,
            "year": 2021,
            "num": 1197
        },

        {
            "id": 5460,
            "score": 363,
            "ranking": 345910,
            "is_wenli": 2,
            "year": 2021,
            "num": 1118
        },

        {
            "id": 5461,
            "score": 362,
            "ranking": 347076,
            "is_wenli": 2,
            "year": 2021,
            "num": 1166
        },

        {
            "id": 5462,
            "score": 361,
            "ranking": 348237,
            "is_wenli": 2,
            "year": 2021,
            "num": 1161
        },

        {
            "id": 5463,
            "score": 360,
            "ranking": 349363,
            "is_wenli": 2,
            "year": 2021,
            "num": 1126
        },

        {
            "id": 5464,
            "score": 359,
            "ranking": 350512,
            "is_wenli": 2,
            "year": 2021,
            "num": 1149
        },

        {
            "id": 5465,
            "score": 358,
            "ranking": 351616,
            "is_wenli": 2,
            "year": 2021,
            "num": 1104
        },

        {
            "id": 5466,
            "score": 357,
            "ranking": 352759,
            "is_wenli": 2,
            "year": 2021,
            "num": 1143
        },

        {
            "id": 5467,
            "score": 356,
            "ranking": 353925,
            "is_wenli": 2,
            "year": 2021,
            "num": 1166
        },

        {
            "id": 5468,
            "score": 355,
            "ranking": 355056,
            "is_wenli": 2,
            "year": 2021,
            "num": 1131
        },

        {
            "id": 5469,
            "score": 354,
            "ranking": 356200,
            "is_wenli": 2,
            "year": 2021,
            "num": 1144
        },

        {
            "id": 5470,
            "score": 353,
            "ranking": 357342,
            "is_wenli": 2,
            "year": 2021,
            "num": 1142
        },

        {
            "id": 5471,
            "score": 352,
            "ranking": 358450,
            "is_wenli": 2,
            "year": 2021,
            "num": 1108
        },

        {
            "id": 5472,
            "score": 351,
            "ranking": 359516,
            "is_wenli": 2,
            "year": 2021,
            "num": 1066
        },

        {
            "id": 5473,
            "score": 350,
            "ranking": 360652,
            "is_wenli": 2,
            "year": 2021,
            "num": 1136
        },

        {
            "id": 5474,
            "score": 349,
            "ranking": 361705,
            "is_wenli": 2,
            "year": 2021,
            "num": 1053
        },

        {
            "id": 5475,
            "score": 348,
            "ranking": 362820,
            "is_wenli": 2,
            "year": 2021,
            "num": 1115
        },

        {
            "id": 5476,
            "score": 347,
            "ranking": 363896,
            "is_wenli": 2,
            "year": 2021,
            "num": 1076
        },

        {
            "id": 5477,
            "score": 346,
            "ranking": 364977,
            "is_wenli": 2,
            "year": 2021,
            "num": 1081
        },

        {
            "id": 5478,
            "score": 345,
            "ranking": 366020,
            "is_wenli": 2,
            "year": 2021,
            "num": 1043
        },

        {
            "id": 5479,
            "score": 344,
            "ranking": 367121,
            "is_wenli": 2,
            "year": 2021,
            "num": 1101
        },

        {
            "id": 5480,
            "score": 343,
            "ranking": 368119,
            "is_wenli": 2,
            "year": 2021,
            "num": 998
        },

        {
            "id": 5481,
            "score": 342,
            "ranking": 369106,
            "is_wenli": 2,
            "year": 2021,
            "num": 987
        },

        {
            "id": 5482,
            "score": 341,
            "ranking": 370148,
            "is_wenli": 2,
            "year": 2021,
            "num": 1042
        },

        {
            "id": 5483,
            "score": 340,
            "ranking": 371134,
            "is_wenli": 2,
            "year": 2021,
            "num": 986
        },

        {
            "id": 5484,
            "score": 339,
            "ranking": 372139,
            "is_wenli": 2,
            "year": 2021,
            "num": 1005
        },

        {
            "id": 5485,
            "score": 338,
            "ranking": 373202,
            "is_wenli": 2,
            "year": 2021,
            "num": 1063
        },

        {
            "id": 5486,
            "score": 337,
            "ranking": 374211,
            "is_wenli": 2,
            "year": 2021,
            "num": 1009
        },

        {
            "id": 5487,
            "score": 336,
            "ranking": 375206,
            "is_wenli": 2,
            "year": 2021,
            "num": 995
        },

        {
            "id": 5488,
            "score": 335,
            "ranking": 376195,
            "is_wenli": 2,
            "year": 2021,
            "num": 989
        },

        {
            "id": 5489,
            "score": 334,
            "ranking": 377182,
            "is_wenli": 2,
            "year": 2021,
            "num": 987
        },

        {
            "id": 5490,
            "score": 333,
            "ranking": 378146,
            "is_wenli": 2,
            "year": 2021,
            "num": 964
        },

        {
            "id": 5491,
            "score": 332,
            "ranking": 379179,
            "is_wenli": 2,
            "year": 2021,
            "num": 1033
        },

        {
            "id": 5492,
            "score": 331,
            "ranking": 380279,
            "is_wenli": 2,
            "year": 2021,
            "num": 1100
        },

        {
            "id": 5493,
            "score": 330,
            "ranking": 381264,
            "is_wenli": 2,
            "year": 2021,
            "num": 985
        },

        {
            "id": 5494,
            "score": 329,
            "ranking": 382293,
            "is_wenli": 2,
            "year": 2021,
            "num": 1029
        },

        {
            "id": 5495,
            "score": 328,
            "ranking": 383281,
            "is_wenli": 2,
            "year": 2021,
            "num": 988
        },

        {
            "id": 5496,
            "score": 327,
            "ranking": 384210,
            "is_wenli": 2,
            "year": 2021,
            "num": 929
        },

        {
            "id": 5497,
            "score": 326,
            "ranking": 385153,
            "is_wenli": 2,
            "year": 2021,
            "num": 943
        },

        {
            "id": 5498,
            "score": 325,
            "ranking": 386069,
            "is_wenli": 2,
            "year": 2021,
            "num": 916
        },

        {
            "id": 5499,
            "score": 324,
            "ranking": 386979,
            "is_wenli": 2,
            "year": 2021,
            "num": 910
        },

        {
            "id": 5500,
            "score": 323,
            "ranking": 387897,
            "is_wenli": 2,
            "year": 2021,
            "num": 918
        },

        {
            "id": 5501,
            "score": 322,
            "ranking": 388828,
            "is_wenli": 2,
            "year": 2021,
            "num": 931
        },

        {
            "id": 5502,
            "score": 321,
            "ranking": 389729,
            "is_wenli": 2,
            "year": 2021,
            "num": 901
        },

        {
            "id": 5503,
            "score": 320,
            "ranking": 390620,
            "is_wenli": 2,
            "year": 2021,
            "num": 891
        },

        {
            "id": 5504,
            "score": 319,
            "ranking": 391524,
            "is_wenli": 2,
            "year": 2021,
            "num": 904
        },

        {
            "id": 5505,
            "score": 318,
            "ranking": 392430,
            "is_wenli": 2,
            "year": 2021,
            "num": 906
        },

        {
            "id": 5506,
            "score": 317,
            "ranking": 393342,
            "is_wenli": 2,
            "year": 2021,
            "num": 912
        },

        {
            "id": 5507,
            "score": 316,
            "ranking": 394239,
            "is_wenli": 2,
            "year": 2021,
            "num": 897
        },

        {
            "id": 5508,
            "score": 315,
            "ranking": 395179,
            "is_wenli": 2,
            "year": 2021,
            "num": 940
        },

        {
            "id": 5509,
            "score": 314,
            "ranking": 396105,
            "is_wenli": 2,
            "year": 2021,
            "num": 926
        },

        {
            "id": 5510,
            "score": 313,
            "ranking": 397005,
            "is_wenli": 2,
            "year": 2021,
            "num": 900
        },

        {
            "id": 5511,
            "score": 312,
            "ranking": 397807,
            "is_wenli": 2,
            "year": 2021,
            "num": 802
        },

        {
            "id": 5512,
            "score": 311,
            "ranking": 398638,
            "is_wenli": 2,
            "year": 2021,
            "num": 831
        },

        {
            "id": 5513,
            "score": 310,
            "ranking": 399514,
            "is_wenli": 2,
            "year": 2021,
            "num": 876
        },

        {
            "id": 5514,
            "score": 309,
            "ranking": 400374,
            "is_wenli": 2,
            "year": 2021,
            "num": 860
        },

        {
            "id": 5515,
            "score": 308,
            "ranking": 401229,
            "is_wenli": 2,
            "year": 2021,
            "num": 855
        },

        {
            "id": 5516,
            "score": 307,
            "ranking": 402043,
            "is_wenli": 2,
            "year": 2021,
            "num": 814
        },

        {
            "id": 5517,
            "score": 306,
            "ranking": 402848,
            "is_wenli": 2,
            "year": 2021,
            "num": 805
        },

        {
            "id": 5518,
            "score": 305,
            "ranking": 403678,
            "is_wenli": 2,
            "year": 2021,
            "num": 830
        },

        {
            "id": 5519,
            "score": 304,
            "ranking": 404499,
            "is_wenli": 2,
            "year": 2021,
            "num": 821
        },

        {
            "id": 5520,
            "score": 303,
            "ranking": 405312,
            "is_wenli": 2,
            "year": 2021,
            "num": 813
        },

        {
            "id": 5521,
            "score": 302,
            "ranking": 406113,
            "is_wenli": 2,
            "year": 2021,
            "num": 801
        },

        {
            "id": 5522,
            "score": 301,
            "ranking": 406940,
            "is_wenli": 2,
            "year": 2021,
            "num": 827
        },

        {
            "id": 5523,
            "score": 300,
            "ranking": 407732,
            "is_wenli": 2,
            "year": 2021,
            "num": 792
        },

        {
            "id": 5524,
            "score": 299,
            "ranking": 408563,
            "is_wenli": 2,
            "year": 2021,
            "num": 831
        },

        {
            "id": 5525,
            "score": 298,
            "ranking": 409340,
            "is_wenli": 2,
            "year": 2021,
            "num": 777
        },

        {
            "id": 5526,
            "score": 297,
            "ranking": 410094,
            "is_wenli": 2,
            "year": 2021,
            "num": 754
        },

        {
            "id": 5527,
            "score": 296,
            "ranking": 410866,
            "is_wenli": 2,
            "year": 2021,
            "num": 772
        },

        {
            "id": 5528,
            "score": 295,
            "ranking": 411653,
            "is_wenli": 2,
            "year": 2021,
            "num": 787
        },

        {
            "id": 5529,
            "score": 294,
            "ranking": 412416,
            "is_wenli": 2,
            "year": 2021,
            "num": 763
        },

        {
            "id": 5530,
            "score": 293,
            "ranking": 413163,
            "is_wenli": 2,
            "year": 2021,
            "num": 747
        },

        {
            "id": 5531,
            "score": 292,
            "ranking": 413902,
            "is_wenli": 2,
            "year": 2021,
            "num": 739
        },

        {
            "id": 5532,
            "score": 291,
            "ranking": 414635,
            "is_wenli": 2,
            "year": 2021,
            "num": 733
        },

        {
            "id": 5533,
            "score": 290,
            "ranking": 415412,
            "is_wenli": 2,
            "year": 2021,
            "num": 777
        },

        {
            "id": 5534,
            "score": 289,
            "ranking": 416144,
            "is_wenli": 2,
            "year": 2021,
            "num": 732
        },

        {
            "id": 5535,
            "score": 288,
            "ranking": 416885,
            "is_wenli": 2,
            "year": 2021,
            "num": 741
        },

        {
            "id": 5536,
            "score": 287,
            "ranking": 417605,
            "is_wenli": 2,
            "year": 2021,
            "num": 720
        },

        {
            "id": 5537,
            "score": 286,
            "ranking": 418301,
            "is_wenli": 2,
            "year": 2021,
            "num": 696
        },

        {
            "id": 5538,
            "score": 285,
            "ranking": 419012,
            "is_wenli": 2,
            "year": 2021,
            "num": 711
        },

        {
            "id": 5539,
            "score": 284,
            "ranking": 419727,
            "is_wenli": 2,
            "year": 2021,
            "num": 715
        },

        {
            "id": 5540,
            "score": 283,
            "ranking": 420453,
            "is_wenli": 2,
            "year": 2021,
            "num": 726
        },

        {
            "id": 5541,
            "score": 282,
            "ranking": 421149,
            "is_wenli": 2,
            "year": 2021,
            "num": 696
        },

        {
            "id": 5542,
            "score": 281,
            "ranking": 421796,
            "is_wenli": 2,
            "year": 2021,
            "num": 647
        },

        {
            "id": 5543,
            "score": 280,
            "ranking": 422454,
            "is_wenli": 2,
            "year": 2021,
            "num": 658
        },

        {
            "id": 5544,
            "score": 279,
            "ranking": 423123,
            "is_wenli": 2,
            "year": 2021,
            "num": 669
        },

        {
            "id": 5545,
            "score": 278,
            "ranking": 423765,
            "is_wenli": 2,
            "year": 2021,
            "num": 642
        },

        {
            "id": 5546,
            "score": 277,
            "ranking": 424438,
            "is_wenli": 2,
            "year": 2021,
            "num": 673
        },

        {
            "id": 5547,
            "score": 276,
            "ranking": 425090,
            "is_wenli": 2,
            "year": 2021,
            "num": 652
        },

        {
            "id": 5548,
            "score": 275,
            "ranking": 425697,
            "is_wenli": 2,
            "year": 2021,
            "num": 607
        },

        {
            "id": 5549,
            "score": 274,
            "ranking": 426369,
            "is_wenli": 2,
            "year": 2021,
            "num": 672
        },

        {
            "id": 5550,
            "score": 273,
            "ranking": 427049,
            "is_wenli": 2,
            "year": 2021,
            "num": 680
        },

        {
            "id": 5551,
            "score": 272,
            "ranking": 427653,
            "is_wenli": 2,
            "year": 2021,
            "num": 604
        },

        {
            "id": 5552,
            "score": 271,
            "ranking": 428302,
            "is_wenli": 2,
            "year": 2021,
            "num": 649
        },

        {
            "id": 5553,
            "score": 270,
            "ranking": 428892,
            "is_wenli": 2,
            "year": 2021,
            "num": 590
        },

        {
            "id": 5554,
            "score": 269,
            "ranking": 429517,
            "is_wenli": 2,
            "year": 2021,
            "num": 625
        },

        {
            "id": 5555,
            "score": 268,
            "ranking": 430120,
            "is_wenli": 2,
            "year": 2021,
            "num": 603
        },

        {
            "id": 5556,
            "score": 267,
            "ranking": 430749,
            "is_wenli": 2,
            "year": 2021,
            "num": 629
        },

        {
            "id": 5557,
            "score": 266,
            "ranking": 431380,
            "is_wenli": 2,
            "year": 2021,
            "num": 631
        },

        {
            "id": 5558,
            "score": 265,
            "ranking": 431962,
            "is_wenli": 2,
            "year": 2021,
            "num": 582
        },

        {
            "id": 5559,
            "score": 264,
            "ranking": 432550,
            "is_wenli": 2,
            "year": 2021,
            "num": 588
        },

        {
            "id": 5560,
            "score": 263,
            "ranking": 433155,
            "is_wenli": 2,
            "year": 2021,
            "num": 605
        },

        {
            "id": 5561,
            "score": 262,
            "ranking": 433732,
            "is_wenli": 2,
            "year": 2021,
            "num": 577
        },

        {
            "id": 5562,
            "score": 261,
            "ranking": 434307,
            "is_wenli": 2,
            "year": 2021,
            "num": 575
        },

        {
            "id": 5563,
            "score": 260,
            "ranking": 434859,
            "is_wenli": 2,
            "year": 2021,
            "num": 552
        },

        {
            "id": 5564,
            "score": 259,
            "ranking": 435417,
            "is_wenli": 2,
            "year": 2021,
            "num": 558
        },

        {
            "id": 5565,
            "score": 258,
            "ranking": 435998,
            "is_wenli": 2,
            "year": 2021,
            "num": 581
        },

        {
            "id": 5566,
            "score": 257,
            "ranking": 436499,
            "is_wenli": 2,
            "year": 2021,
            "num": 501
        },

        {
            "id": 5567,
            "score": 256,
            "ranking": 437059,
            "is_wenli": 2,
            "year": 2021,
            "num": 560
        },

        {
            "id": 5568,
            "score": 255,
            "ranking": 437595,
            "is_wenli": 2,
            "year": 2021,
            "num": 536
        },

        {
            "id": 5569,
            "score": 254,
            "ranking": 438140,
            "is_wenli": 2,
            "year": 2021,
            "num": 545
        },

        {
            "id": 5570,
            "score": 253,
            "ranking": 438705,
            "is_wenli": 2,
            "year": 2021,
            "num": 565
        },

        {
            "id": 5571,
            "score": 252,
            "ranking": 439233,
            "is_wenli": 2,
            "year": 2021,
            "num": 528
        },

        {
            "id": 5572,
            "score": 251,
            "ranking": 439728,
            "is_wenli": 2,
            "year": 2021,
            "num": 495
        },

        {
            "id": 5573,
            "score": 250,
            "ranking": 440238,
            "is_wenli": 2,
            "year": 2021,
            "num": 510
        },

        {
            "id": 5574,
            "score": 249,
            "ranking": 440763,
            "is_wenli": 2,
            "year": 2021,
            "num": 525
        },

        {
            "id": 5575,
            "score": 248,
            "ranking": 441245,
            "is_wenli": 2,
            "year": 2021,
            "num": 482
        },

        {
            "id": 5576,
            "score": 247,
            "ranking": 441747,
            "is_wenli": 2,
            "year": 2021,
            "num": 502
        },

        {
            "id": 5577,
            "score": 246,
            "ranking": 442215,
            "is_wenli": 2,
            "year": 2021,
            "num": 468
        },

        {
            "id": 5578,
            "score": 245,
            "ranking": 442647,
            "is_wenli": 2,
            "year": 2021,
            "num": 432
        },

        {
            "id": 5579,
            "score": 244,
            "ranking": 443114,
            "is_wenli": 2,
            "year": 2021,
            "num": 467
        },

        {
            "id": 5580,
            "score": 243,
            "ranking": 443595,
            "is_wenli": 2,
            "year": 2021,
            "num": 481
        },

        {
            "id": 5581,
            "score": 242,
            "ranking": 444060,
            "is_wenli": 2,
            "year": 2021,
            "num": 465
        },

        {
            "id": 5582,
            "score": 241,
            "ranking": 444547,
            "is_wenli": 2,
            "year": 2021,
            "num": 487
        },

        {
            "id": 5583,
            "score": 240,
            "ranking": 445014,
            "is_wenli": 2,
            "year": 2021,
            "num": 467
        },

        {
            "id": 5584,
            "score": 239,
            "ranking": 445438,
            "is_wenli": 2,
            "year": 2021,
            "num": 424
        },

        {
            "id": 5585,
            "score": 238,
            "ranking": 445896,
            "is_wenli": 2,
            "year": 2021,
            "num": 458
        },

        {
            "id": 5586,
            "score": 237,
            "ranking": 446311,
            "is_wenli": 2,
            "year": 2021,
            "num": 415
        },

        {
            "id": 5587,
            "score": 236,
            "ranking": 446728,
            "is_wenli": 2,
            "year": 2021,
            "num": 417
        },

        {
            "id": 5588,
            "score": 235,
            "ranking": 447179,
            "is_wenli": 2,
            "year": 2021,
            "num": 451
        },

        {
            "id": 5589,
            "score": 234,
            "ranking": 447618,
            "is_wenli": 2,
            "year": 2021,
            "num": 439
        },

        {
            "id": 5590,
            "score": 233,
            "ranking": 448064,
            "is_wenli": 2,
            "year": 2021,
            "num": 446
        },

        {
            "id": 5591,
            "score": 232,
            "ranking": 448501,
            "is_wenli": 2,
            "year": 2021,
            "num": 437
        },

        {
            "id": 5592,
            "score": 231,
            "ranking": 448918,
            "is_wenli": 2,
            "year": 2021,
            "num": 417
        },

        {
            "id": 5593,
            "score": 230,
            "ranking": 449315,
            "is_wenli": 2,
            "year": 2021,
            "num": 397
        },

        {
            "id": 5594,
            "score": 229,
            "ranking": 449726,
            "is_wenli": 2,
            "year": 2021,
            "num": 411
        },

        {
            "id": 5595,
            "score": 228,
            "ranking": 450128,
            "is_wenli": 2,
            "year": 2021,
            "num": 402
        },

        {
            "id": 5596,
            "score": 227,
            "ranking": 450521,
            "is_wenli": 2,
            "year": 2021,
            "num": 393
        },

        {
            "id": 5597,
            "score": 226,
            "ranking": 450903,
            "is_wenli": 2,
            "year": 2021,
            "num": 382
        },

        {
            "id": 5598,
            "score": 225,
            "ranking": 451285,
            "is_wenli": 2,
            "year": 2021,
            "num": 382
        },

        {
            "id": 5599,
            "score": 224,
            "ranking": 451633,
            "is_wenli": 2,
            "year": 2021,
            "num": 348
        },

        {
            "id": 5600,
            "score": 223,
            "ranking": 451974,
            "is_wenli": 2,
            "year": 2021,
            "num": 341
        },

        {
            "id": 5601,
            "score": 222,
            "ranking": 452325,
            "is_wenli": 2,
            "year": 2021,
            "num": 351
        },

        {
            "id": 5602,
            "score": 221,
            "ranking": 452677,
            "is_wenli": 2,
            "year": 2021,
            "num": 352
        },

        {
            "id": 5603,
            "score": 220,
            "ranking": 453026,
            "is_wenli": 2,
            "year": 2021,
            "num": 349
        },

        {
            "id": 5604,
            "score": 219,
            "ranking": 453382,
            "is_wenli": 2,
            "year": 2021,
            "num": 356
        },

        {
            "id": 5605,
            "score": 218,
            "ranking": 453704,
            "is_wenli": 2,
            "year": 2021,
            "num": 322
        },

        {
            "id": 5606,
            "score": 217,
            "ranking": 454032,
            "is_wenli": 2,
            "year": 2021,
            "num": 328
        },

        {
            "id": 5607,
            "score": 216,
            "ranking": 454376,
            "is_wenli": 2,
            "year": 2021,
            "num": 344
        },

        {
            "id": 5608,
            "score": 215,
            "ranking": 454702,
            "is_wenli": 2,
            "year": 2021,
            "num": 326
        },

        {
            "id": 5609,
            "score": 214,
            "ranking": 455017,
            "is_wenli": 2,
            "year": 2021,
            "num": 315
        },

        {
            "id": 5610,
            "score": 213,
            "ranking": 455308,
            "is_wenli": 2,
            "year": 2021,
            "num": 291
        },

        {
            "id": 5611,
            "score": 212,
            "ranking": 455597,
            "is_wenli": 2,
            "year": 2021,
            "num": 289
        },

        {
            "id": 5612,
            "score": 211,
            "ranking": 455911,
            "is_wenli": 2,
            "year": 2021,
            "num": 314
        },

        {
            "id": 5613,
            "score": 210,
            "ranking": 456186,
            "is_wenli": 2,
            "year": 2021,
            "num": 275
        },

        {
            "id": 5614,
            "score": 209,
            "ranking": 456476,
            "is_wenli": 2,
            "year": 2021,
            "num": 290
        },

        {
            "id": 5615,
            "score": 208,
            "ranking": 456752,
            "is_wenli": 2,
            "year": 2021,
            "num": 276
        },

        {
            "id": 5616,
            "score": 207,
            "ranking": 457006,
            "is_wenli": 2,
            "year": 2021,
            "num": 254
        },

        {
            "id": 5617,
            "score": 206,
            "ranking": 457281,
            "is_wenli": 2,
            "year": 2021,
            "num": 275
        },

        {
            "id": 5618,
            "score": 205,
            "ranking": 457553,
            "is_wenli": 2,
            "year": 2021,
            "num": 272
        },

        {
            "id": 5619,
            "score": 204,
            "ranking": 457845,
            "is_wenli": 2,
            "year": 2021,
            "num": 292
        },

        {
            "id": 5620,
            "score": 203,
            "ranking": 458113,
            "is_wenli": 2,
            "year": 2021,
            "num": 268
        },

        {
            "id": 5621,
            "score": 202,
            "ranking": 458390,
            "is_wenli": 2,
            "year": 2021,
            "num": 277
        },

        {
            "id": 5622,
            "score": 201,
            "ranking": 458630,
            "is_wenli": 2,
            "year": 2021,
            "num": 240
        },

        {
            "id": 5623,
            "score": 200,
            "ranking": 458864,
            "is_wenli": 2,
            "year": 2021,
            "num": 234
        },

        {
            "id": 5624,
            "score": 199,
            "ranking": 459117,
            "is_wenli": 2,
            "year": 2021,
            "num": 253
        },

        {
            "id": 5625,
            "score": 198,
            "ranking": 459356,
            "is_wenli": 2,
            "year": 2021,
            "num": 239
        },

        {
            "id": 5626,
            "score": 197,
            "ranking": 459596,
            "is_wenli": 2,
            "year": 2021,
            "num": 240
        },

        {
            "id": 5627,
            "score": 196,
            "ranking": 459792,
            "is_wenli": 2,
            "year": 2021,
            "num": 196
        },

        {
            "id": 5628,
            "score": 195,
            "ranking": 459997,
            "is_wenli": 2,
            "year": 2021,
            "num": 205
        },

        {
            "id": 5629,
            "score": 194,
            "ranking": 460221,
            "is_wenli": 2,
            "year": 2021,
            "num": 224
        },

        {
            "id": 5630,
            "score": 193,
            "ranking": 460400,
            "is_wenli": 2,
            "year": 2021,
            "num": 179
        },

        {
            "id": 5631,
            "score": 192,
            "ranking": 460593,
            "is_wenli": 2,
            "year": 2021,
            "num": 193
        },

        {
            "id": 5632,
            "score": 191,
            "ranking": 460774,
            "is_wenli": 2,
            "year": 2021,
            "num": 181
        },

        {
            "id": 5633,
            "score": 190,
            "ranking": 460973,
            "is_wenli": 2,
            "year": 2021,
            "num": 199
        },

        {
            "id": 5634,
            "score": 189,
            "ranking": 461158,
            "is_wenli": 2,
            "year": 2021,
            "num": 185
        },

        {
            "id": 5635,
            "score": 188,
            "ranking": 461360,
            "is_wenli": 2,
            "year": 2021,
            "num": 202
        },

        {
            "id": 5636,
            "score": 187,
            "ranking": 461527,
            "is_wenli": 2,
            "year": 2021,
            "num": 167
        },

        {
            "id": 5637,
            "score": 186,
            "ranking": 461722,
            "is_wenli": 2,
            "year": 2021,
            "num": 195
        },

        {
            "id": 5638,
            "score": 185,
            "ranking": 461893,
            "is_wenli": 2,
            "year": 2021,
            "num": 171
        },

        {
            "id": 5639,
            "score": 184,
            "ranking": 462049,
            "is_wenli": 2,
            "year": 2021,
            "num": 156
        },

        {
            "id": 5640,
            "score": 183,
            "ranking": 462202,
            "is_wenli": 2,
            "year": 2021,
            "num": 153
        },

        {
            "id": 5641,
            "score": 182,
            "ranking": 462368,
            "is_wenli": 2,
            "year": 2021,
            "num": 166
        },

        {
            "id": 5642,
            "score": 181,
            "ranking": 462526,
            "is_wenli": 2,
            "year": 2021,
            "num": 158
        },

        {
            "id": 5643,
            "score": 180,
            "ranking": 462670,
            "is_wenli": 2,
            "year": 2021,
            "num": 144
        },

        {
            "id": 5644,
            "score": 179,
            "ranking": 462822,
            "is_wenli": 2,
            "year": 2021,
            "num": 152
        },

        {
            "id": 5645,
            "score": 178,
            "ranking": 462962,
            "is_wenli": 2,
            "year": 2021,
            "num": 140
        },

        {
            "id": 5646,
            "score": 177,
            "ranking": 463097,
            "is_wenli": 2,
            "year": 2021,
            "num": 135
        },

        {
            "id": 5647,
            "score": 176,
            "ranking": 463240,
            "is_wenli": 2,
            "year": 2021,
            "num": 143
        },

        {
            "id": 5648,
            "score": 175,
            "ranking": 463368,
            "is_wenli": 2,
            "year": 2021,
            "num": 128
        },

        {
            "id": 5649,
            "score": 174,
            "ranking": 463495,
            "is_wenli": 2,
            "year": 2021,
            "num": 127
        },

        {
            "id": 5650,
            "score": 173,
            "ranking": 463602,
            "is_wenli": 2,
            "year": 2021,
            "num": 107
        },

        {
            "id": 5651,
            "score": 172,
            "ranking": 463714,
            "is_wenli": 2,
            "year": 2021,
            "num": 112
        },

        {
            "id": 5652,
            "score": 171,
            "ranking": 463831,
            "is_wenli": 2,
            "year": 2021,
            "num": 117
        },

        {
            "id": 5653,
            "score": 170,
            "ranking": 463930,
            "is_wenli": 2,
            "year": 2021,
            "num": 99
        },

        {
            "id": 5654,
            "score": 169,
            "ranking": 464029,
            "is_wenli": 2,
            "year": 2021,
            "num": 99
        },

        {
            "id": 5655,
            "score": 168,
            "ranking": 464140,
            "is_wenli": 2,
            "year": 2021,
            "num": 111
        },

        {
            "id": 5656,
            "score": 167,
            "ranking": 464242,
            "is_wenli": 2,
            "year": 2021,
            "num": 102
        },

        {
            "id": 5657,
            "score": 166,
            "ranking": 464342,
            "is_wenli": 2,
            "year": 2021,
            "num": 100
        },

        {
            "id": 5658,
            "score": 165,
            "ranking": 464444,
            "is_wenli": 2,
            "year": 2021,
            "num": 102
        },

        {
            "id": 5659,
            "score": 164,
            "ranking": 464526,
            "is_wenli": 2,
            "year": 2021,
            "num": 82
        },

        {
            "id": 5660,
            "score": 163,
            "ranking": 464595,
            "is_wenli": 2,
            "year": 2021,
            "num": 69
        },

        {
            "id": 5661,
            "score": 162,
            "ranking": 464679,
            "is_wenli": 2,
            "year": 2021,
            "num": 84
        },

        {
            "id": 5662,
            "score": 161,
            "ranking": 464756,
            "is_wenli": 2,
            "year": 2021,
            "num": 77
        },

        {
            "id": 5663,
            "score": 160,
            "ranking": 464826,
            "is_wenli": 2,
            "year": 2021,
            "num": 70
        },

        {
            "id": 5664,
            "score": 159,
            "ranking": 464907,
            "is_wenli": 2,
            "year": 2021,
            "num": 81
        },

        {
            "id": 5665,
            "score": 158,
            "ranking": 464973,
            "is_wenli": 2,
            "year": 2021,
            "num": 66
        },

        {
            "id": 5666,
            "score": 157,
            "ranking": 465042,
            "is_wenli": 2,
            "year": 2021,
            "num": 69
        },

        {
            "id": 5667,
            "score": 156,
            "ranking": 465111,
            "is_wenli": 2,
            "year": 2021,
            "num": 69
        },

        {
            "id": 5668,
            "score": 155,
            "ranking": 465179,
            "is_wenli": 2,
            "year": 2021,
            "num": 68
        },

        {
            "id": 5669,
            "score": 154,
            "ranking": 465242,
            "is_wenli": 2,
            "year": 2021,
            "num": 63
        },

        {
            "id": 5670,
            "score": 153,
            "ranking": 465301,
            "is_wenli": 2,
            "year": 2021,
            "num": 59
        },

        {
            "id": 5671,
            "score": 152,
            "ranking": 465355,
            "is_wenli": 2,
            "year": 2021,
            "num": 54
        },

        {
            "id": 5672,
            "score": 151,
            "ranking": 465422,
            "is_wenli": 2,
            "year": 2021,
            "num": 67
        },

        {
            "id": 5673,
            "score": 150,
            "ranking": 465469,
            "is_wenli": 2,
            "year": 2021,
            "num": 47
        },

        {
            "id": 5674,
            "score": 149,
            "ranking": 465506,
            "is_wenli": 2,
            "year": 2021,
            "num": 37
        },

        {
            "id": 5675,
            "score": 148,
            "ranking": 465544,
            "is_wenli": 2,
            "year": 2021,
            "num": 38
        },

        {
            "id": 5676,
            "score": 147,
            "ranking": 465602,
            "is_wenli": 2,
            "year": 2021,
            "num": 58
        },

        {
            "id": 5677,
            "score": 146,
            "ranking": 465637,
            "is_wenli": 2,
            "year": 2021,
            "num": 35
        },

        {
            "id": 5678,
            "score": 145,
            "ranking": 465680,
            "is_wenli": 2,
            "year": 2021,
            "num": 43
        },

        {
            "id": 5679,
            "score": 144,
            "ranking": 465725,
            "is_wenli": 2,
            "year": 2021,
            "num": 45
        },

        {
            "id": 5680,
            "score": 143,
            "ranking": 465753,
            "is_wenli": 2,
            "year": 2021,
            "num": 28
        },

        {
            "id": 5681,
            "score": 142,
            "ranking": 465790,
            "is_wenli": 2,
            "year": 2021,
            "num": 37
        },

        {
            "id": 5682,
            "score": 141,
            "ranking": 465814,
            "is_wenli": 2,
            "year": 2021,
            "num": 24
        },

        {
            "id": 5683,
            "score": 140,
            "ranking": 465855,
            "is_wenli": 2,
            "year": 2021,
            "num": 41
        },

        {
            "id": 5684,
            "score": 139,
            "ranking": 465885,
            "is_wenli": 2,
            "year": 2021,
            "num": 30
        },

        {
            "id": 5685,
            "score": 138,
            "ranking": 465915,
            "is_wenli": 2,
            "year": 2021,
            "num": 30
        },

        {
            "id": 5686,
            "score": 137,
            "ranking": 465945,
            "is_wenli": 2,
            "year": 2021,
            "num": 30
        },

        {
            "id": 5687,
            "score": 136,
            "ranking": 465973,
            "is_wenli": 2,
            "year": 2021,
            "num": 28
        },

        {
            "id": 5688,
            "score": 135,
            "ranking": 466000,
            "is_wenli": 2,
            "year": 2021,
            "num": 27
        },

        {
            "id": 5689,
            "score": 134,
            "ranking": 466020,
            "is_wenli": 2,
            "year": 2021,
            "num": 20
        },

        {
            "id": 5690,
            "score": 133,
            "ranking": 466032,
            "is_wenli": 2,
            "year": 2021,
            "num": 12
        },

        {
            "id": 5691,
            "score": 132,
            "ranking": 466058,
            "is_wenli": 2,
            "year": 2021,
            "num": 26
        },

        {
            "id": 5692,
            "score": 131,
            "ranking": 466080,
            "is_wenli": 2,
            "year": 2021,
            "num": 22
        },

        {
            "id": 5693,
            "score": 130,
            "ranking": 466099,
            "is_wenli": 2,
            "year": 2021,
            "num": 19
        },

        {
            "id": 5694,
            "score": 129,
            "ranking": 466121,
            "is_wenli": 2,
            "year": 2021,
            "num": 22
        },

        {
            "id": 5695,
            "score": 128,
            "ranking": 466142,
            "is_wenli": 2,
            "year": 2021,
            "num": 21
        },

        {
            "id": 5696,
            "score": 127,
            "ranking": 466164,
            "is_wenli": 2,
            "year": 2021,
            "num": 22
        },

        {
            "id": 5697,
            "score": 126,
            "ranking": 466183,
            "is_wenli": 2,
            "year": 2021,
            "num": 19
        },

        {
            "id": 5698,
            "score": 125,
            "ranking": 466195,
            "is_wenli": 2,
            "year": 2021,
            "num": 12
        },

        {
            "id": 5699,
            "score": 124,
            "ranking": 466210,
            "is_wenli": 2,
            "year": 2021,
            "num": 15
        },

        {
            "id": 5700,
            "score": 123,
            "ranking": 466233,
            "is_wenli": 2,
            "year": 2021,
            "num": 23
        },

        {
            "id": 5701,
            "score": 122,
            "ranking": 466252,
            "is_wenli": 2,
            "year": 2021,
            "num": 19
        },

        {
            "id": 5702,
            "score": 121,
            "ranking": 466265,
            "is_wenli": 2,
            "year": 2021,
            "num": 13
        },

        {
            "id": 5703,
            "score": 120,
            "ranking": 466281,
            "is_wenli": 2,
            "year": 2021,
            "num": 16
        },

        {
            "id": 5704,
            "score": 119,
            "ranking": 466293,
            "is_wenli": 2,
            "year": 2021,
            "num": 12
        },

        {
            "id": 5705,
            "score": 118,
            "ranking": 466307,
            "is_wenli": 2,
            "year": 2021,
            "num": 14
        },

        {
            "id": 5706,
            "score": 117,
            "ranking": 466320,
            "is_wenli": 2,
            "year": 2021,
            "num": 13
        },

        {
            "id": 5707,
            "score": 116,
            "ranking": 466330,
            "is_wenli": 2,
            "year": 2021,
            "num": 10
        },

        {
            "id": 5708,
            "score": 115,
            "ranking": 466338,
            "is_wenli": 2,
            "year": 2021,
            "num": 8
        },

        {
            "id": 5709,
            "score": 114,
            "ranking": 466349,
            "is_wenli": 2,
            "year": 2021,
            "num": 11
        },

        {
            "id": 5710,
            "score": 113,
            "ranking": 466356,
            "is_wenli": 2,
            "year": 2021,
            "num": 7
        },

        {
            "id": 5711,
            "score": 112,
            "ranking": 466369,
            "is_wenli": 2,
            "year": 2021,
            "num": 13
        },

        {
            "id": 5712,
            "score": 111,
            "ranking": 466380,
            "is_wenli": 2,
            "year": 2021,
            "num": 11
        },

        {
            "id": 5713,
            "score": 110,
            "ranking": 466389,
            "is_wenli": 2,
            "year": 2021,
            "num": 9
        },

        {
            "id": 5714,
            "score": 109,
            "ranking": 466402,
            "is_wenli": 2,
            "year": 2021,
            "num": 13
        },

        {
            "id": 5715,
            "score": 108,
            "ranking": 466411,
            "is_wenli": 2,
            "year": 2021,
            "num": 9
        },

        {
            "id": 5716,
            "score": 107,
            "ranking": 466420,
            "is_wenli": 2,
            "year": 2021,
            "num": 9
        },

        {
            "id": 5717,
            "score": 106,
            "ranking": 466429,
            "is_wenli": 2,
            "year": 2021,
            "num": 9
        },

        {
            "id": 5718,
            "score": 105,
            "ranking": 466439,
            "is_wenli": 2,
            "year": 2021,
            "num": 10
        },

        {
            "id": 5719,
            "score": 104,
            "ranking": 466448,
            "is_wenli": 2,
            "year": 2021,
            "num": 9
        },

        {
            "id": 5720,
            "score": 103,
            "ranking": 466460,
            "is_wenli": 2,
            "year": 2021,
            "num": 12
        },

        {
            "id": 5721,
            "score": 102,
            "ranking": 466470,
            "is_wenli": 2,
            "year": 2021,
            "num": 10
        },

        {
            "id": 5722,
            "score": 101,
            "ranking": 466478,
            "is_wenli": 2,
            "year": 2021,
            "num": 8
        },

        {
            "id": 5723,
            "score": 100,
            "ranking": 466487,
            "is_wenli": 2,
            "year": 2021,
            "num": 9
        }
    ],
    2020: [
        {
            "score": 715,
            "ranking": 11,
            "num": 11
        },

        {
            "score": 714,
            "ranking": 16,
            "num": 5
        },

        {
            "score": 713,
            "ranking": 18,
            "num": 2
        },

        {
            "score": 712,
            "ranking": 20,
            "num": 2
        },

        {
            "score": 711,
            "ranking": 22,
            "num": 2
        },

        {
            "score": 710,
            "ranking": 27,
            "num": 5
        },

        {
            "score": 709,
            "ranking": 37,
            "num": 10
        },

        {
            "score": 708,
            "ranking": 45,
            "num": 8
        },

        {
            "score": 707,
            "ranking": 54,
            "num": 9
        },

        {
            "score": 706,
            "ranking": 65,
            "num": 11
        },

        {
            "score": 705,
            "ranking": 79,
            "num": 14
        },

        {
            "score": 704,
            "ranking": 87,
            "num": 8
        },

        {
            "score": 703,
            "ranking": 107,
            "num": 20
        },

        {
            "score": 702,
            "ranking": 126,
            "num": 19
        },

        {
            "score": 701,
            "ranking": 151,
            "num": 25
        },

        {
            "score": 700,
            "ranking": 169,
            "num": 18
        },

        {
            "score": 699,
            "ranking": 197,
            "num": 28
        },

        {
            "score": 698,
            "ranking": 235,
            "num": 38
        },

        {
            "score": 697,
            "ranking": 268,
            "num": 33
        },

        {
            "score": 696,
            "ranking": 298,
            "num": 30
        },

        {
            "score": 695,
            "ranking": 335,
            "num": 37
        },

        {
            "score": 694,
            "ranking": 376,
            "num": 41
        },

        {
            "score": 693,
            "ranking": 443,
            "num": 67
        },

        {
            "score": 692,
            "ranking": 491,
            "num": 48
        },

        {
            "score": 691,
            "ranking": 556,
            "num": 65
        },

        {
            "score": 690,
            "ranking": 627,
            "num": 71
        },

        {
            "score": 689,
            "ranking": 705,
            "num": 78
        },

        {
            "score": 688,
            "ranking": 774,
            "num": 69
        },

        {
            "score": 687,
            "ranking": 848,
            "num": 74
        },

        {
            "score": 686,
            "ranking": 953,
            "num": 105
        },

        {
            "score": 685,
            "ranking": 1036,
            "num": 83
        },

        {
            "score": 684,
            "ranking": 1159,
            "num": 123
        },

        {
            "score": 683,
            "ranking": 1272,
            "num": 113
        },

        {
            "score": 682,
            "ranking": 1377,
            "num": 105
        },

        {
            "score": 681,
            "ranking": 1521,
            "num": 144
        },

        {
            "score": 680,
            "ranking": 1660,
            "num": 139
        },

        {
            "score": 679,
            "ranking": 1784,
            "num": 124
        },

        {
            "score": 678,
            "ranking": 1919,
            "num": 135
        },

        {
            "score": 677,
            "ranking": 2065,
            "num": 146
        },

        {
            "score": 676,
            "ranking": 2213,
            "num": 148
        },

        {
            "score": 675,
            "ranking": 2370,
            "num": 157
        },

        {
            "score": 674,
            "ranking": 2546,
            "num": 176
        },

        {
            "score": 673,
            "ranking": 2742,
            "num": 196
        },

        {
            "score": 672,
            "ranking": 2936,
            "num": 194
        },

        {
            "score": 671,
            "ranking": 3152,
            "num": 216
        },

        {
            "score": 670,
            "ranking": 3375,
            "num": 223
        },

        {
            "score": 669,
            "ranking": 3612,
            "num": 237
        },

        {
            "score": 668,
            "ranking": 3845,
            "num": 233
        },

        {
            "score": 667,
            "ranking": 4082,
            "num": 237
        },

        {
            "score": 666,
            "ranking": 4347,
            "num": 265
        },

        {
            "score": 665,
            "ranking": 4594,
            "num": 247
        },

        {
            "score": 664,
            "ranking": 4878,
            "num": 284
        },

        {
            "score": 663,
            "ranking": 5152,
            "num": 274
        },

        {
            "score": 662,
            "ranking": 5463,
            "num": 311
        },

        {
            "score": 661,
            "ranking": 5753,
            "num": 290
        },

        {
            "score": 660,
            "ranking": 6046,
            "num": 293
        },

        {
            "score": 659,
            "ranking": 6356,
            "num": 310
        },

        {
            "score": 658,
            "ranking": 6676,
            "num": 320
        },

        {
            "score": 657,
            "ranking": 7026,
            "num": 350
        },

        {
            "score": 656,
            "ranking": 7373,
            "num": 347
        },

        {
            "score": 655,
            "ranking": 7724,
            "num": 351
        },

        {
            "score": 654,
            "ranking": 8089,
            "num": 365
        },

        {
            "score": 653,
            "ranking": 8491,
            "num": 402
        },

        {
            "score": 652,
            "ranking": 8900,
            "num": 409
        },

        {
            "score": 651,
            "ranking": 9274,
            "num": 374
        },

        {
            "score": 650,
            "ranking": 9653,
            "num": 379
        },

        {
            "score": 649,
            "ranking": 10081,
            "num": 428
        },

        {
            "score": 648,
            "ranking": 10506,
            "num": 425
        },

        {
            "score": 647,
            "ranking": 10957,
            "num": 451
        },

        {
            "score": 646,
            "ranking": 11437,
            "num": 480
        },

        {
            "score": 645,
            "ranking": 11903,
            "num": 466
        },

        {
            "score": 644,
            "ranking": 12396,
            "num": 493
        },

        {
            "score": 643,
            "ranking": 12897,
            "num": 501
        },

        {
            "score": 642,
            "ranking": 13368,
            "num": 471
        },

        {
            "score": 641,
            "ranking": 13884,
            "num": 516
        },

        {
            "score": 640,
            "ranking": 14443,
            "num": 559
        },

        {
            "score": 639,
            "ranking": 14936,
            "num": 493
        },

        {
            "score": 638,
            "ranking": 15517,
            "num": 581
        },

        {
            "score": 637,
            "ranking": 16139,
            "num": 622
        },

        {
            "score": 636,
            "ranking": 16698,
            "num": 559
        },

        {
            "score": 635,
            "ranking": 17277,
            "num": 579
        },

        {
            "score": 634,
            "ranking": 17857,
            "num": 580
        },

        {
            "score": 633,
            "ranking": 18475,
            "num": 618
        },

        {
            "score": 632,
            "ranking": 19083,
            "num": 608
        },

        {
            "score": 631,
            "ranking": 19649,
            "num": 566
        },

        {
            "score": 630,
            "ranking": 20308,
            "num": 659
        },

        {
            "score": 629,
            "ranking": 20922,
            "num": 614
        },

        {
            "score": 628,
            "ranking": 21581,
            "num": 659
        },

        {
            "score": 627,
            "ranking": 22276,
            "num": 695
        },

        {
            "score": 626,
            "ranking": 22973,
            "num": 697
        },

        {
            "score": 625,
            "ranking": 23684,
            "num": 711
        },

        {
            "score": 624,
            "ranking": 24312,
            "num": 628
        },

        {
            "score": 623,
            "ranking": 25056,
            "num": 744
        },

        {
            "score": 622,
            "ranking": 25751,
            "num": 695
        },

        {
            "score": 621,
            "ranking": 26493,
            "num": 742
        },

        {
            "score": 620,
            "ranking": 27221,
            "num": 728
        },

        {
            "score": 619,
            "ranking": 27959,
            "num": 738
        },

        {
            "score": 618,
            "ranking": 28686,
            "num": 727
        },

        {
            "score": 617,
            "ranking": 29485,
            "num": 799
        },

        {
            "score": 616,
            "ranking": 30260,
            "num": 775
        },

        {
            "score": 615,
            "ranking": 31039,
            "num": 779
        },

        {
            "score": 614,
            "ranking": 31866,
            "num": 827
        },

        {
            "score": 613,
            "ranking": 32658,
            "num": 792
        },

        {
            "score": 612,
            "ranking": 33477,
            "num": 819
        },

        {
            "score": 611,
            "ranking": 34290,
            "num": 813
        },

        {
            "score": 610,
            "ranking": 35130,
            "num": 840
        },

        {
            "score": 609,
            "ranking": 35994,
            "num": 864
        },

        {
            "score": 608,
            "ranking": 36876,
            "num": 882
        },

        {
            "score": 607,
            "ranking": 37744,
            "num": 868
        },

        {
            "score": 606,
            "ranking": 38611,
            "num": 867
        },

        {
            "score": 605,
            "ranking": 39525,
            "num": 914
        },

        {
            "score": 604,
            "ranking": 40431,
            "num": 906
        },

        {
            "score": 603,
            "ranking": 41377,
            "num": 946
        },

        {
            "score": 602,
            "ranking": 42274,
            "num": 897
        },

        {
            "score": 601,
            "ranking": 43222,
            "num": 948
        },

        {
            "score": 600,
            "ranking": 44162,
            "num": 940
        },

        {
            "score": 599,
            "ranking": 45122,
            "num": 960
        },

        {
            "score": 598,
            "ranking": 46111,
            "num": 989
        },

        {
            "score": 597,
            "ranking": 47088,
            "num": 977
        },

        {
            "score": 596,
            "ranking": 48117,
            "num": 1029
        },

        {
            "score": 595,
            "ranking": 49113,
            "num": 996
        },

        {
            "score": 594,
            "ranking": 50132,
            "num": 1019
        },

        {
            "score": 593,
            "ranking": 51170,
            "num": 1038
        },

        {
            "score": 592,
            "ranking": 52176,
            "num": 1006
        },

        {
            "score": 591,
            "ranking": 53210,
            "num": 1034
        },

        {
            "score": 590,
            "ranking": 54281,
            "num": 1071
        },

        {
            "score": 589,
            "ranking": 55355,
            "num": 1074
        },

        {
            "score": 588,
            "ranking": 56402,
            "num": 1047
        },

        {
            "score": 587,
            "ranking": 57472,
            "num": 1070
        },

        {
            "score": 586,
            "ranking": 58573,
            "num": 1101
        },

        {
            "score": 585,
            "ranking": 59698,
            "num": 1125
        },

        {
            "score": 584,
            "ranking": 60827,
            "num": 1129
        },

        {
            "score": 583,
            "ranking": 61893,
            "num": 1066
        },

        {
            "score": 582,
            "ranking": 63035,
            "num": 1142
        },

        {
            "score": 581,
            "ranking": 64188,
            "num": 1153
        },

        {
            "score": 580,
            "ranking": 65365,
            "num": 1177
        },

        {
            "score": 579,
            "ranking": 66467,
            "num": 1102
        },

        {
            "score": 578,
            "ranking": 67627,
            "num": 1160
        },

        {
            "score": 577,
            "ranking": 68843,
            "num": 1216
        },

        {
            "score": 576,
            "ranking": 69982,
            "num": 1139
        },

        {
            "score": 575,
            "ranking": 71135,
            "num": 1153
        },

        {
            "score": 574,
            "ranking": 72367,
            "num": 1232
        },

        {
            "score": 573,
            "ranking": 73543,
            "num": 1176
        },

        {
            "score": 572,
            "ranking": 74766,
            "num": 1223
        },

        {
            "score": 571,
            "ranking": 75906,
            "num": 1140
        },

        {
            "score": 570,
            "ranking": 77140,
            "num": 1234
        },

        {
            "score": 569,
            "ranking": 78357,
            "num": 1217
        },

        {
            "score": 568,
            "ranking": 79540,
            "num": 1183
        },

        {
            "score": 567,
            "ranking": 80773,
            "num": 1233
        },

        {
            "score": 566,
            "ranking": 82003,
            "num": 1230
        },

        {
            "score": 565,
            "ranking": 83217,
            "num": 1214
        },

        {
            "score": 564,
            "ranking": 84489,
            "num": 1272
        },

        {
            "score": 563,
            "ranking": 85729,
            "num": 1240
        },

        {
            "score": 562,
            "ranking": 87025,
            "num": 1296
        },

        {
            "score": 561,
            "ranking": 88293,
            "num": 1268
        },

        {
            "score": 560,
            "ranking": 89567,
            "num": 1274
        },

        {
            "score": 559,
            "ranking": 90901,
            "num": 1334
        },

        {
            "score": 558,
            "ranking": 92191,
            "num": 1290
        },

        {
            "score": 557,
            "ranking": 93476,
            "num": 1285
        },

        {
            "score": 556,
            "ranking": 94834,
            "num": 1358
        },

        {
            "score": 555,
            "ranking": 96089,
            "num": 1255
        },

        {
            "score": 554,
            "ranking": 97420,
            "num": 1331
        },

        {
            "score": 553,
            "ranking": 98716,
            "num": 1296
        },

        {
            "score": 552,
            "ranking": 100103,
            "num": 1387
        },

        {
            "score": 551,
            "ranking": 101503,
            "num": 1400
        },

        {
            "score": 550,
            "ranking": 102795,
            "num": 1292
        },

        {
            "score": 549,
            "ranking": 104116,
            "num": 1321
        },

        {
            "score": 548,
            "ranking": 105494,
            "num": 1378
        },

        {
            "score": 547,
            "ranking": 106820,
            "num": 1326
        },

        {
            "score": 546,
            "ranking": 108151,
            "num": 1331
        },

        {
            "score": 545,
            "ranking": 109540,
            "num": 1389
        },

        {
            "score": 544,
            "ranking": 110870,
            "num": 1330
        },

        {
            "score": 543,
            "ranking": 112214,
            "num": 1344
        },

        {
            "score": 542,
            "ranking": 113569,
            "num": 1355
        },

        {
            "score": 541,
            "ranking": 114968,
            "num": 1399
        },

        {
            "score": 540,
            "ranking": 116385,
            "num": 1417
        },

        {
            "score": 539,
            "ranking": 117811,
            "num": 1426
        },

        {
            "score": 538,
            "ranking": 119222,
            "num": 1411
        },

        {
            "score": 537,
            "ranking": 120651,
            "num": 1429
        },

        {
            "score": 536,
            "ranking": 122058,
            "num": 1407
        },

        {
            "score": 535,
            "ranking": 123435,
            "num": 1377
        },

        {
            "score": 534,
            "ranking": 124788,
            "num": 1353
        },

        {
            "score": 533,
            "ranking": 126208,
            "num": 1420
        },

        {
            "score": 532,
            "ranking": 127600,
            "num": 1392
        },

        {
            "score": 531,
            "ranking": 128942,
            "num": 1342
        },

        {
            "score": 530,
            "ranking": 130372,
            "num": 1430
        },

        {
            "score": 529,
            "ranking": 131782,
            "num": 1410
        },

        {
            "score": 528,
            "ranking": 133199,
            "num": 1417
        },

        {
            "score": 527,
            "ranking": 134593,
            "num": 1394
        },

        {
            "score": 526,
            "ranking": 135998,
            "num": 1405
        },

        {
            "score": 525,
            "ranking": 137488,
            "num": 1490
        },

        {
            "score": 524,
            "ranking": 138907,
            "num": 1419
        },

        {
            "score": 523,
            "ranking": 140403,
            "num": 1496
        },

        {
            "score": 522,
            "ranking": 141799,
            "num": 1396
        },

        {
            "score": 521,
            "ranking": 143264,
            "num": 1465
        },

        {
            "score": 520,
            "ranking": 144698,
            "num": 1434
        },

        {
            "score": 519,
            "ranking": 146141,
            "num": 1443
        },

        {
            "score": 518,
            "ranking": 147501,
            "num": 1360
        },

        {
            "score": 517,
            "ranking": 148936,
            "num": 1435
        },

        {
            "score": 516,
            "ranking": 150331,
            "num": 1395
        },

        {
            "score": 515,
            "ranking": 151757,
            "num": 1426
        },

        {
            "score": 514,
            "ranking": 153171,
            "num": 1414
        },

        {
            "score": 513,
            "ranking": 154550,
            "num": 1379
        },

        {
            "score": 512,
            "ranking": 155958,
            "num": 1408
        },

        {
            "score": 511,
            "ranking": 157359,
            "num": 1401
        },

        {
            "score": 510,
            "ranking": 158828,
            "num": 1469
        },

        {
            "score": 509,
            "ranking": 160203,
            "num": 1375
        },

        {
            "score": 508,
            "ranking": 161609,
            "num": 1406
        },

        {
            "score": 507,
            "ranking": 163015,
            "num": 1406
        },

        {
            "score": 506,
            "ranking": 164447,
            "num": 1432
        },

        {
            "score": 505,
            "ranking": 165842,
            "num": 1395
        },

        {
            "score": 504,
            "ranking": 167247,
            "num": 1405
        },

        {
            "score": 503,
            "ranking": 168670,
            "num": 1423
        },

        {
            "score": 502,
            "ranking": 170132,
            "num": 1462
        },

        {
            "score": 501,
            "ranking": 171454,
            "num": 1322
        },

        {
            "score": 500,
            "ranking": 172921,
            "num": 1467
        },

        {
            "score": 499,
            "ranking": 174394,
            "num": 1473
        },

        {
            "score": 498,
            "ranking": 175789,
            "num": 1395
        },

        {
            "score": 497,
            "ranking": 177201,
            "num": 1412
        },

        {
            "score": 496,
            "ranking": 178596,
            "num": 1395
        },

        {
            "score": 495,
            "ranking": 179984,
            "num": 1388
        },

        {
            "score": 494,
            "ranking": 181490,
            "num": 1506
        },

        {
            "score": 493,
            "ranking": 182908,
            "num": 1418
        },

        {
            "score": 492,
            "ranking": 184345,
            "num": 1437
        },

        {
            "score": 491,
            "ranking": 185784,
            "num": 1439
        },

        {
            "score": 490,
            "ranking": 187213,
            "num": 1429
        },

        {
            "score": 489,
            "ranking": 188599,
            "num": 1386
        },

        {
            "score": 488,
            "ranking": 190039,
            "num": 1440
        },

        {
            "score": 487,
            "ranking": 191461,
            "num": 1422
        },

        {
            "score": 486,
            "ranking": 192920,
            "num": 1459
        },

        {
            "score": 485,
            "ranking": 194389,
            "num": 1469
        },

        {
            "score": 484,
            "ranking": 195845,
            "num": 1456
        },

        {
            "score": 483,
            "ranking": 197169,
            "num": 1324
        },

        {
            "score": 482,
            "ranking": 198608,
            "num": 1439
        },

        {
            "score": 481,
            "ranking": 200016,
            "num": 1408
        },

        {
            "score": 480,
            "ranking": 201440,
            "num": 1424
        },

        {
            "score": 479,
            "ranking": 202887,
            "num": 1447
        },

        {
            "score": 478,
            "ranking": 204297,
            "num": 1410
        },

        {
            "score": 477,
            "ranking": 205778,
            "num": 1481
        },

        {
            "score": 476,
            "ranking": 207250,
            "num": 1472
        },

        {
            "score": 475,
            "ranking": 208687,
            "num": 1437
        },

        {
            "score": 474,
            "ranking": 210109,
            "num": 1422
        },

        {
            "score": 473,
            "ranking": 211459,
            "num": 1350
        },

        {
            "score": 472,
            "ranking": 212907,
            "num": 1448
        },

        {
            "score": 471,
            "ranking": 214321,
            "num": 1414
        },

        {
            "score": 470,
            "ranking": 215801,
            "num": 1480
        },

        {
            "score": 469,
            "ranking": 217220,
            "num": 1419
        },

        {
            "score": 468,
            "ranking": 218640,
            "num": 1420
        },

        {
            "score": 467,
            "ranking": 220020,
            "num": 1380
        },

        {
            "score": 466,
            "ranking": 221408,
            "num": 1388
        },

        {
            "score": 465,
            "ranking": 222839,
            "num": 1431
        },

        {
            "score": 464,
            "ranking": 224244,
            "num": 1405
        },

        {
            "score": 463,
            "ranking": 225637,
            "num": 1393
        },

        {
            "score": 462,
            "ranking": 227021,
            "num": 1384
        },

        {
            "score": 461,
            "ranking": 228392,
            "num": 1371
        },

        {
            "score": 460,
            "ranking": 229756,
            "num": 1364
        },

        {
            "score": 459,
            "ranking": 231205,
            "num": 1449
        },

        {
            "score": 458,
            "ranking": 232685,
            "num": 1480
        },

        {
            "score": 457,
            "ranking": 234014,
            "num": 1329
        },

        {
            "score": 456,
            "ranking": 235408,
            "num": 1394
        },

        {
            "score": 455,
            "ranking": 236806,
            "num": 1398
        },

        {
            "score": 454,
            "ranking": 238237,
            "num": 1431
        },

        {
            "score": 453,
            "ranking": 239641,
            "num": 1404
        },

        {
            "score": 452,
            "ranking": 241022,
            "num": 1381
        },

        {
            "score": 451,
            "ranking": 242386,
            "num": 1364
        },

        {
            "score": 450,
            "ranking": 243730,
            "num": 1344
        },

        {
            "score": 449,
            "ranking": 245038,
            "num": 1308
        },

        {
            "score": 448,
            "ranking": 246379,
            "num": 1341
        },

        {
            "score": 447,
            "ranking": 247757,
            "num": 1378
        },

        {
            "score": 446,
            "ranking": 249117,
            "num": 1360
        },

        {
            "score": 445,
            "ranking": 250424,
            "num": 1307
        },

        {
            "score": 444,
            "ranking": 251828,
            "num": 1404
        },

        {
            "score": 443,
            "ranking": 253224,
            "num": 1396
        },

        {
            "score": 442,
            "ranking": 254580,
            "num": 1356
        },

        {
            "score": 441,
            "ranking": 255937,
            "num": 1357
        },

        {
            "score": 440,
            "ranking": 257231,
            "num": 1294
        },

        {
            "score": 439,
            "ranking": 258623,
            "num": 1392
        },

        {
            "score": 438,
            "ranking": 259953,
            "num": 1330
        },

        {
            "score": 437,
            "ranking": 261238,
            "num": 1285
        },

        {
            "score": 436,
            "ranking": 262570,
            "num": 1332
        },

        {
            "score": 435,
            "ranking": 263849,
            "num": 1279
        },

        {
            "score": 434,
            "ranking": 265198,
            "num": 1349
        },

        {
            "score": 433,
            "ranking": 266534,
            "num": 1336
        },

        {
            "score": 432,
            "ranking": 267893,
            "num": 1359
        },

        {
            "score": 431,
            "ranking": 269150,
            "num": 1257
        },

        {
            "score": 430,
            "ranking": 270424,
            "num": 1274
        },

        {
            "score": 429,
            "ranking": 271775,
            "num": 1351
        },

        {
            "score": 428,
            "ranking": 273118,
            "num": 1343
        },

        {
            "score": 427,
            "ranking": 274383,
            "num": 1265
        },

        {
            "score": 426,
            "ranking": 275609,
            "num": 1226
        },

        {
            "score": 425,
            "ranking": 276885,
            "num": 1276
        },

        {
            "score": 424,
            "ranking": 278111,
            "num": 1226
        },

        {
            "score": 423,
            "ranking": 279339,
            "num": 1228
        },

        {
            "score": 422,
            "ranking": 280614,
            "num": 1275
        },

        {
            "score": 421,
            "ranking": 281879,
            "num": 1265
        },

        {
            "score": 420,
            "ranking": 283127,
            "num": 1248
        },

        {
            "score": 419,
            "ranking": 284340,
            "num": 1213
        },

        {
            "score": 418,
            "ranking": 285539,
            "num": 1199
        },

        {
            "score": 417,
            "ranking": 286788,
            "num": 1249
        },

        {
            "score": 416,
            "ranking": 288004,
            "num": 1216
        },

        {
            "score": 415,
            "ranking": 289156,
            "num": 1152
        },

        {
            "score": 414,
            "ranking": 290319,
            "num": 1163
        },

        {
            "score": 413,
            "ranking": 291515,
            "num": 1196
        },

        {
            "score": 412,
            "ranking": 292721,
            "num": 1206
        },

        {
            "score": 411,
            "ranking": 293890,
            "num": 1169
        },

        {
            "score": 410,
            "ranking": 295095,
            "num": 1205
        },

        {
            "score": 409,
            "ranking": 296276,
            "num": 1181
        },

        {
            "score": 408,
            "ranking": 297446,
            "num": 1170
        },

        {
            "score": 407,
            "ranking": 298628,
            "num": 1182
        },

        {
            "score": 406,
            "ranking": 299822,
            "num": 1194
        },

        {
            "score": 405,
            "ranking": 300980,
            "num": 1158
        },

        {
            "score": 404,
            "ranking": 302145,
            "num": 1165
        },

        {
            "score": 403,
            "ranking": 303342,
            "num": 1197
        },

        {
            "score": 402,
            "ranking": 304554,
            "num": 1212
        },

        {
            "score": 401,
            "ranking": 305684,
            "num": 1130
        },

        {
            "score": 400,
            "ranking": 306756,
            "num": 1072
        },

        {
            "score": 399,
            "ranking": 307862,
            "num": 1106
        },

        {
            "score": 398,
            "ranking": 308943,
            "num": 1081
        },

        {
            "score": 397,
            "ranking": 310060,
            "num": 1117
        },

        {
            "score": 396,
            "ranking": 311189,
            "num": 1129
        },

        {
            "score": 395,
            "ranking": 312240,
            "num": 1051
        },

        {
            "score": 394,
            "ranking": 313381,
            "num": 1141
        },

        {
            "score": 393,
            "ranking": 314483,
            "num": 1102
        },

        {
            "score": 392,
            "ranking": 315606,
            "num": 1123
        },

        {
            "score": 391,
            "ranking": 316676,
            "num": 1070
        },

        {
            "score": 390,
            "ranking": 317769,
            "num": 1093
        },

        {
            "score": 389,
            "ranking": 318845,
            "num": 1076
        },

        {
            "score": 388,
            "ranking": 319966,
            "num": 1121
        },

        {
            "score": 387,
            "ranking": 321046,
            "num": 1080
        },

        {
            "score": 386,
            "ranking": 322130,
            "num": 1084
        },

        {
            "score": 385,
            "ranking": 323233,
            "num": 1103
        },

        {
            "score": 384,
            "ranking": 324305,
            "num": 1072
        },

        {
            "score": 383,
            "ranking": 325347,
            "num": 1042
        },

        {
            "score": 382,
            "ranking": 326354,
            "num": 1007
        },

        {
            "score": 381,
            "ranking": 327432,
            "num": 1078
        },

        {
            "score": 380,
            "ranking": 328522,
            "num": 1090
        },

        {
            "score": 379,
            "ranking": 329507,
            "num": 985
        },

        {
            "score": 378,
            "ranking": 330483,
            "num": 976
        },

        {
            "score": 377,
            "ranking": 331481,
            "num": 998
        },

        {
            "score": 376,
            "ranking": 332556,
            "num": 1075
        },

        {
            "score": 375,
            "ranking": 333566,
            "num": 1010
        },

        {
            "score": 374,
            "ranking": 334598,
            "num": 1032
        },

        {
            "score": 373,
            "ranking": 335607,
            "num": 1009
        },

        {
            "score": 372,
            "ranking": 336590,
            "num": 983
        },

        {
            "score": 371,
            "ranking": 337467,
            "num": 877
        },

        {
            "score": 370,
            "ranking": 338443,
            "num": 976
        },

        {
            "score": 369,
            "ranking": 339363,
            "num": 920
        },

        {
            "score": 368,
            "ranking": 340374,
            "num": 1011
        },

        {
            "score": 367,
            "ranking": 341362,
            "num": 988
        },

        {
            "score": 366,
            "ranking": 342287,
            "num": 925
        },

        {
            "score": 365,
            "ranking": 343284,
            "num": 997
        },

        {
            "score": 364,
            "ranking": 344195,
            "num": 911
        },

        {
            "score": 363,
            "ranking": 345124,
            "num": 929
        },

        {
            "score": 362,
            "ranking": 346093,
            "num": 969
        },

        {
            "score": 361,
            "ranking": 347054,
            "num": 961
        },

        {
            "score": 360,
            "ranking": 348047,
            "num": 993
        },

        {
            "score": 359,
            "ranking": 348951,
            "num": 904
        },

        {
            "score": 358,
            "ranking": 349844,
            "num": 893
        },

        {
            "score": 357,
            "ranking": 350773,
            "num": 929
        },

        {
            "score": 356,
            "ranking": 351680,
            "num": 907
        },

        {
            "score": 355,
            "ranking": 352584,
            "num": 904
        },

        {
            "score": 354,
            "ranking": 353488,
            "num": 904
        },

        {
            "score": 353,
            "ranking": 354373,
            "num": 885
        },

        {
            "score": 352,
            "ranking": 355317,
            "num": 944
        },

        {
            "score": 351,
            "ranking": 356216,
            "num": 899
        },

        {
            "score": 350,
            "ranking": 357092,
            "num": 876
        },

        {
            "score": 349,
            "ranking": 357968,
            "num": 876
        },

        {
            "score": 348,
            "ranking": 358905,
            "num": 937
        },

        {
            "score": 347,
            "ranking": 359761,
            "num": 856
        },

        {
            "score": 346,
            "ranking": 360667,
            "num": 906
        },

        {
            "score": 345,
            "ranking": 361541,
            "num": 874
        },

        {
            "score": 344,
            "ranking": 362358,
            "num": 817
        },

        {
            "score": 343,
            "ranking": 363272,
            "num": 914
        },

        {
            "score": 342,
            "ranking": 364119,
            "num": 847
        },

        {
            "score": 341,
            "ranking": 364980,
            "num": 861
        },

        {
            "score": 340,
            "ranking": 365881,
            "num": 901
        },

        {
            "score": 339,
            "ranking": 366728,
            "num": 847
        },

        {
            "score": 338,
            "ranking": 367587,
            "num": 859
        },

        {
            "score": 337,
            "ranking": 368399,
            "num": 812
        },

        {
            "score": 336,
            "ranking": 369237,
            "num": 838
        },

        {
            "score": 335,
            "ranking": 370014,
            "num": 777
        },

        {
            "score": 334,
            "ranking": 370822,
            "num": 808
        },

        {
            "score": 333,
            "ranking": 371656,
            "num": 834
        },

        {
            "score": 332,
            "ranking": 372447,
            "num": 791
        },

        {
            "score": 331,
            "ranking": 373266,
            "num": 819
        },

        {
            "score": 330,
            "ranking": 374107,
            "num": 841
        },

        {
            "score": 329,
            "ranking": 374862,
            "num": 755
        },

        {
            "score": 328,
            "ranking": 375675,
            "num": 813
        },

        {
            "score": 327,
            "ranking": 376510,
            "num": 835
        },

        {
            "score": 326,
            "ranking": 377330,
            "num": 820
        },

        {
            "score": 325,
            "ranking": 378124,
            "num": 794
        },

        {
            "score": 324,
            "ranking": 378890,
            "num": 766
        },

        {
            "score": 323,
            "ranking": 379664,
            "num": 774
        },

        {
            "score": 322,
            "ranking": 380446,
            "num": 782
        },

        {
            "score": 321,
            "ranking": 381259,
            "num": 813
        },

        {
            "score": 320,
            "ranking": 382059,
            "num": 800
        },

        {
            "score": 319,
            "ranking": 382852,
            "num": 793
        },

        {
            "score": 318,
            "ranking": 383618,
            "num": 766
        },

        {
            "score": 317,
            "ranking": 384391,
            "num": 773
        },

        {
            "score": 316,
            "ranking": 385137,
            "num": 746
        },

        {
            "score": 315,
            "ranking": 385845,
            "num": 708
        },

        {
            "score": 314,
            "ranking": 386613,
            "num": 768
        },

        {
            "score": 313,
            "ranking": 387364,
            "num": 751
        },

        {
            "score": 312,
            "ranking": 388069,
            "num": 705
        },

        {
            "score": 311,
            "ranking": 388801,
            "num": 732
        },

        {
            "score": 310,
            "ranking": 389527,
            "num": 726
        },

        {
            "score": 309,
            "ranking": 390263,
            "num": 736
        },

        {
            "score": 308,
            "ranking": 391008,
            "num": 745
        },

        {
            "score": 307,
            "ranking": 391763,
            "num": 755
        },

        {
            "score": 306,
            "ranking": 392493,
            "num": 730
        },

        {
            "score": 305,
            "ranking": 393189,
            "num": 696
        },

        {
            "score": 304,
            "ranking": 393919,
            "num": 730
        },

        {
            "score": 303,
            "ranking": 394668,
            "num": 749
        },

        {
            "score": 302,
            "ranking": 395401,
            "num": 733
        },

        {
            "score": 301,
            "ranking": 396138,
            "num": 737
        },

        {
            "score": 300,
            "ranking": 396822,
            "num": 684
        },

        {
            "score": 299,
            "ranking": 397511,
            "num": 689
        },

        {
            "score": 298,
            "ranking": 398229,
            "num": 718
        },

        {
            "score": 297,
            "ranking": 398938,
            "num": 709
        },

        {
            "score": 296,
            "ranking": 399630,
            "num": 692
        },

        {
            "score": 295,
            "ranking": 400314,
            "num": 684
        },

        {
            "score": 294,
            "ranking": 400947,
            "num": 633
        },

        {
            "score": 293,
            "ranking": 401615,
            "num": 668
        },

        {
            "score": 292,
            "ranking": 402307,
            "num": 692
        },

        {
            "score": 291,
            "ranking": 403015,
            "num": 708
        },

        {
            "score": 290,
            "ranking": 403692,
            "num": 677
        },

        {
            "score": 289,
            "ranking": 404385,
            "num": 693
        },

        {
            "score": 288,
            "ranking": 405063,
            "num": 678
        },

        {
            "score": 287,
            "ranking": 405742,
            "num": 679
        },

        {
            "score": 286,
            "ranking": 406423,
            "num": 681
        },

        {
            "score": 285,
            "ranking": 407091,
            "num": 668
        },

        {
            "score": 284,
            "ranking": 407733,
            "num": 642
        },

        {
            "score": 283,
            "ranking": 408411,
            "num": 678
        },

        {
            "score": 282,
            "ranking": 409058,
            "num": 647
        },

        {
            "score": 281,
            "ranking": 409716,
            "num": 658
        },

        {
            "score": 280,
            "ranking": 410375,
            "num": 659
        },

        {
            "score": 279,
            "ranking": 410996,
            "num": 621
        },

        {
            "score": 278,
            "ranking": 411657,
            "num": 661
        },

        {
            "score": 277,
            "ranking": 412326,
            "num": 669
        },

        {
            "score": 276,
            "ranking": 412987,
            "num": 661
        },

        {
            "score": 275,
            "ranking": 413599,
            "num": 612
        },

        {
            "score": 274,
            "ranking": 414194,
            "num": 595
        },

        {
            "score": 273,
            "ranking": 414845,
            "num": 651
        },

        {
            "score": 272,
            "ranking": 415436,
            "num": 591
        },

        {
            "score": 271,
            "ranking": 416089,
            "num": 653
        },

        {
            "score": 270,
            "ranking": 416675,
            "num": 586
        },

        {
            "score": 269,
            "ranking": 417301,
            "num": 626
        },

        {
            "score": 268,
            "ranking": 417967,
            "num": 666
        },

        {
            "score": 267,
            "ranking": 418534,
            "num": 567
        },

        {
            "score": 266,
            "ranking": 419160,
            "num": 626
        },

        {
            "score": 265,
            "ranking": 419800,
            "num": 640
        },

        {
            "score": 264,
            "ranking": 420425,
            "num": 625
        },

        {
            "score": 263,
            "ranking": 421047,
            "num": 622
        },

        {
            "score": 262,
            "ranking": 421653,
            "num": 606
        },

        {
            "score": 261,
            "ranking": 422252,
            "num": 599
        },

        {
            "score": 260,
            "ranking": 422837,
            "num": 585
        },

        {
            "score": 259,
            "ranking": 423399,
            "num": 562
        },

        {
            "score": 258,
            "ranking": 423982,
            "num": 583
        },

        {
            "score": 257,
            "ranking": 424551,
            "num": 569
        },

        {
            "score": 256,
            "ranking": 425150,
            "num": 599
        },

        {
            "score": 255,
            "ranking": 425718,
            "num": 568
        },

        {
            "score": 254,
            "ranking": 426344,
            "num": 626
        },

        {
            "score": 253,
            "ranking": 426855,
            "num": 511
        },

        {
            "score": 252,
            "ranking": 427467,
            "num": 612
        },

        {
            "score": 251,
            "ranking": 428032,
            "num": 565
        },

        {
            "score": 250,
            "ranking": 428542,
            "num": 510
        },

        {
            "score": 249,
            "ranking": 429091,
            "num": 549
        },

        {
            "score": 248,
            "ranking": 429651,
            "num": 560
        },

        {
            "score": 247,
            "ranking": 430178,
            "num": 527
        },

        {
            "score": 246,
            "ranking": 430769,
            "num": 591
        },

        {
            "score": 245,
            "ranking": 431325,
            "num": 556
        },

        {
            "score": 244,
            "ranking": 431853,
            "num": 528
        },

        {
            "score": 243,
            "ranking": 432381,
            "num": 528
        },

        {
            "score": 242,
            "ranking": 432911,
            "num": 530
        },

        {
            "score": 241,
            "ranking": 433423,
            "num": 512
        },

        {
            "score": 240,
            "ranking": 433991,
            "num": 568
        },

        {
            "score": 239,
            "ranking": 434494,
            "num": 503
        },

        {
            "score": 238,
            "ranking": 435049,
            "num": 555
        },

        {
            "score": 237,
            "ranking": 435584,
            "num": 535
        },

        {
            "score": 236,
            "ranking": 436104,
            "num": 520
        },

        {
            "score": 235,
            "ranking": 436617,
            "num": 513
        },

        {
            "score": 234,
            "ranking": 437131,
            "num": 514
        },

        {
            "score": 233,
            "ranking": 437656,
            "num": 525
        },

        {
            "score": 232,
            "ranking": 438203,
            "num": 547
        },

        {
            "score": 231,
            "ranking": 438746,
            "num": 543
        },

        {
            "score": 230,
            "ranking": 439267,
            "num": 521
        },

        {
            "score": 229,
            "ranking": 439768,
            "num": 501
        },

        {
            "score": 228,
            "ranking": 440250,
            "num": 482
        },

        {
            "score": 227,
            "ranking": 440743,
            "num": 493
        },

        {
            "score": 226,
            "ranking": 441249,
            "num": 506
        },

        {
            "score": 225,
            "ranking": 441760,
            "num": 511
        },

        {
            "score": 224,
            "ranking": 442315,
            "num": 555
        },

        {
            "score": 223,
            "ranking": 442810,
            "num": 495
        },

        {
            "score": 222,
            "ranking": 443281,
            "num": 471
        },

        {
            "score": 221,
            "ranking": 443779,
            "num": 498
        },

        {
            "score": 220,
            "ranking": 444277,
            "num": 498
        },

        {
            "score": 219,
            "ranking": 444795,
            "num": 518
        },

        {
            "score": 218,
            "ranking": 445259,
            "num": 464
        },

        {
            "score": 217,
            "ranking": 445751,
            "num": 492
        },

        {
            "score": 216,
            "ranking": 446199,
            "num": 448
        },

        {
            "score": 215,
            "ranking": 446694,
            "num": 495
        },

        {
            "score": 214,
            "ranking": 447174,
            "num": 480
        },

        {
            "score": 213,
            "ranking": 447612,
            "num": 438
        },

        {
            "score": 212,
            "ranking": 448065,
            "num": 453
        },

        {
            "score": 211,
            "ranking": 448486,
            "num": 421
        },

        {
            "score": 210,
            "ranking": 448936,
            "num": 450
        },

        {
            "score": 209,
            "ranking": 449393,
            "num": 457
        },

        {
            "score": 208,
            "ranking": 449800,
            "num": 407
        },

        {
            "score": 207,
            "ranking": 450210,
            "num": 410
        },

        {
            "score": 206,
            "ranking": 450666,
            "num": 456
        },

        {
            "score": 205,
            "ranking": 451088,
            "num": 422
        },

        {
            "score": 204,
            "ranking": 451504,
            "num": 416
        },

        {
            "score": 203,
            "ranking": 451962,
            "num": 458
        },

        {
            "score": 202,
            "ranking": 452394,
            "num": 432
        },

        {
            "score": 201,
            "ranking": 452805,
            "num": 411
        },

        {
            "score": 200,
            "ranking": 453190,
            "num": 385
        },

        {
            "score": 199,
            "ranking": 453604,
            "num": 414
        },

        {
            "score": 198,
            "ranking": 453983,
            "num": 379
        },

        {
            "score": 197,
            "ranking": 454358,
            "num": 375
        },

        {
            "score": 196,
            "ranking": 454776,
            "num": 418
        },

        {
            "score": 195,
            "ranking": 455158,
            "num": 382
        },

        {
            "score": 194,
            "ranking": 455548,
            "num": 390
        },

        {
            "score": 193,
            "ranking": 455919,
            "num": 371
        },

        {
            "score": 192,
            "ranking": 456317,
            "num": 398
        },

        {
            "score": 191,
            "ranking": 456681,
            "num": 364
        },

        {
            "score": 190,
            "ranking": 457092,
            "num": 411
        },

        {
            "score": 189,
            "ranking": 457506,
            "num": 414
        },

        {
            "score": 188,
            "ranking": 457817,
            "num": 311
        },

        {
            "score": 187,
            "ranking": 458170,
            "num": 353
        },

        {
            "score": 186,
            "ranking": 458525,
            "num": 355
        },

        {
            "score": 185,
            "ranking": 458886,
            "num": 361
        },

        {
            "score": 184,
            "ranking": 459239,
            "num": 353
        },

        {
            "score": 183,
            "ranking": 459583,
            "num": 344
        },

        {
            "score": 182,
            "ranking": 459924,
            "num": 341
        },

        {
            "score": 181,
            "ranking": 460216,
            "num": 292
        },

        {
            "score": 180,
            "ranking": 460554,
            "num": 338
        },

        {
            "score": 179,
            "ranking": 460857,
            "num": 303
        },

        {
            "score": 178,
            "ranking": 461152,
            "num": 295
        },

        {
            "score": 177,
            "ranking": 461433,
            "num": 281
        },

        {
            "score": 176,
            "ranking": 461726,
            "num": 293
        },

        {
            "score": 175,
            "ranking": 462004,
            "num": 278
        },

        {
            "score": 174,
            "ranking": 462267,
            "num": 263
        },

        {
            "score": 173,
            "ranking": 462530,
            "num": 263
        },

        {
            "score": 172,
            "ranking": 462794,
            "num": 264
        },

        {
            "score": 171,
            "ranking": 463032,
            "num": 238
        },

        {
            "score": 170,
            "ranking": 463291,
            "num": 259
        },

        {
            "score": 169,
            "ranking": 463539,
            "num": 248
        },

        {
            "score": 168,
            "ranking": 463790,
            "num": 251
        },

        {
            "score": 167,
            "ranking": 464044,
            "num": 254
        },

        {
            "score": 166,
            "ranking": 464260,
            "num": 216
        },

        {
            "score": 165,
            "ranking": 464477,
            "num": 217
        },

        {
            "score": 164,
            "ranking": 464706,
            "num": 229
        },

        {
            "score": 163,
            "ranking": 464926,
            "num": 220
        },

        {
            "score": 162,
            "ranking": 465113,
            "num": 187
        },

        {
            "score": 161,
            "ranking": 465352,
            "num": 239
        },

        {
            "score": 160,
            "ranking": 465519,
            "num": 167
        },

        {
            "score": 159,
            "ranking": 465729,
            "num": 210
        },

        {
            "score": 158,
            "ranking": 465933,
            "num": 204
        },

        {
            "score": 157,
            "ranking": 466091,
            "num": 158
        },

        {
            "score": 156,
            "ranking": 466239,
            "num": 148
        },

        {
            "score": 155,
            "ranking": 466416,
            "num": 177
        },

        {
            "score": 154,
            "ranking": 466586,
            "num": 170
        },

        {
            "score": 153,
            "ranking": 466750,
            "num": 164
        },

        {
            "score": 152,
            "ranking": 466922,
            "num": 172
        },

        {
            "score": 151,
            "ranking": 467074,
            "num": 152
        },

        {
            "score": 150,
            "ranking": 467233,
            "num": 159
        },

        {
            "score": 149,
            "ranking": 467380,
            "num": 147
        },

        {
            "score": 148,
            "ranking": 467515,
            "num": 135
        },

        {
            "score": 147,
            "ranking": 467650,
            "num": 135
        },

        {
            "score": 146,
            "ranking": 467777,
            "num": 127
        },

        {
            "score": 145,
            "ranking": 467893,
            "num": 116
        },

        {
            "score": 144,
            "ranking": 468001,
            "num": 108
        },

        {
            "score": 143,
            "ranking": 468109,
            "num": 108
        },

        {
            "score": 142,
            "ranking": 468207,
            "num": 98
        },

        {
            "score": 141,
            "ranking": 468301,
            "num": 94
        },

        {
            "score": 140,
            "ranking": 468378,
            "num": 77
        },

        {
            "score": 139,
            "ranking": 468458,
            "num": 80
        },

        {
            "score": 138,
            "ranking": 468534,
            "num": 76
        },

        {
            "score": 137,
            "ranking": 468613,
            "num": 79
        },

        {
            "score": 136,
            "ranking": 468684,
            "num": 71
        },

        {
            "score": 135,
            "ranking": 468766,
            "num": 82
        },

        {
            "score": 134,
            "ranking": 468851,
            "num": 85
        },

        {
            "score": 133,
            "ranking": 468933,
            "num": 82
        },

        {
            "score": 132,
            "ranking": 469006,
            "num": 73
        },

        {
            "score": 131,
            "ranking": 469086,
            "num": 80
        },

        {
            "score": 130,
            "ranking": 469155,
            "num": 69
        },

        {
            "score": 129,
            "ranking": 469225,
            "num": 70
        },

        {
            "score": 128,
            "ranking": 469278,
            "num": 53
        },

        {
            "score": 127,
            "ranking": 469338,
            "num": 60
        },

        {
            "score": 126,
            "ranking": 469403,
            "num": 65
        },

        {
            "score": 125,
            "ranking": 469463,
            "num": 60
        },

        {
            "score": 124,
            "ranking": 469520,
            "num": 57
        },

        {
            "score": 123,
            "ranking": 469558,
            "num": 38
        },

        {
            "score": 122,
            "ranking": 469605,
            "num": 47
        },

        {
            "score": 121,
            "ranking": 469651,
            "num": 46
        },

        {
            "score": 120,
            "ranking": 469706,
            "num": 55
        },

        {
            "score": 119,
            "ranking": 469752,
            "num": 46
        },

        {
            "score": 118,
            "ranking": 469808,
            "num": 56
        },

        {
            "score": 117,
            "ranking": 469845,
            "num": 37
        },

        {
            "score": 116,
            "ranking": 469883,
            "num": 38
        },

        {
            "score": 115,
            "ranking": 469928,
            "num": 45
        },

        {
            "score": 114,
            "ranking": 469968,
            "num": 40
        },

        {
            "score": 113,
            "ranking": 470003,
            "num": 35
        },

        {
            "score": 112,
            "ranking": 470038,
            "num": 35
        },

        {
            "score": 111,
            "ranking": 470073,
            "num": 35
        },

        {
            "score": 110,
            "ranking": 470100,
            "num": 27
        },

        {
            "score": 109,
            "ranking": 470125,
            "num": 25
        },

        {
            "score": 108,
            "ranking": 470155,
            "num": 30
        },

        {
            "score": 107,
            "ranking": 470179,
            "num": 24
        },

        {
            "score": 106,
            "ranking": 470213,
            "num": 34
        },

        {
            "score": 105,
            "ranking": 470243,
            "num": 30
        },

        {
            "score": 104,
            "ranking": 470269,
            "num": 26
        },

        {
            "score": 103,
            "ranking": 470304,
            "num": 35
        },

        {
            "score": 102,
            "ranking": 470332,
            "num": 28
        },

        {
            "score": 101,
            "ranking": 470351,
            "num": 19
        },

        {
            "score": 100,
            "ranking": 470378,
            "num": 27
        }
    ],
    2019: [
        {
            "score": 697,
            "ranking": 11,
            "num": 11
        },

        {
            "score": 696,
            "ranking": 13,
            "num": 2
        },

        {
            "score": 695,
            "ranking": 16,
            "num": 3
        },

        {
            "score": 694,
            "ranking": 21,
            "num": 5
        },

        {
            "score": 693,
            "ranking": 26,
            "num": 5
        },

        {
            "score": 692,
            "ranking": 30,
            "num": 4
        },

        {
            "score": 691,
            "ranking": 32,
            "num": 2
        },

        {
            "score": 690,
            "ranking": 37,
            "num": 5
        },

        {
            "score": 689,
            "ranking": 45,
            "num": 8
        },

        {
            "score": 688,
            "ranking": 48,
            "num": 3
        },

        {
            "score": 687,
            "ranking": 53,
            "num": 5
        },

        {
            "score": 686,
            "ranking": 66,
            "num": 13
        },

        {
            "score": 685,
            "ranking": 83,
            "num": 17
        },

        {
            "score": 684,
            "ranking": 96,
            "num": 13
        },

        {
            "score": 683,
            "ranking": 112,
            "num": 16
        },

        {
            "score": 682,
            "ranking": 121,
            "num": 9
        },

        {
            "score": 681,
            "ranking": 142,
            "num": 21
        },

        {
            "score": 680,
            "ranking": 157,
            "num": 15
        },

        {
            "score": 679,
            "ranking": 173,
            "num": 16
        },

        {
            "score": 678,
            "ranking": 194,
            "num": 21
        },

        {
            "score": 677,
            "ranking": 220,
            "num": 26
        },

        {
            "score": 676,
            "ranking": 248,
            "num": 28
        },

        {
            "score": 675,
            "ranking": 271,
            "num": 23
        },

        {
            "score": 674,
            "ranking": 296,
            "num": 25
        },

        {
            "score": 673,
            "ranking": 331,
            "num": 35
        },

        {
            "score": 672,
            "ranking": 364,
            "num": 33
        },

        {
            "score": 671,
            "ranking": 414,
            "num": 50
        },

        {
            "score": 670,
            "ranking": 455,
            "num": 41
        },

        {
            "score": 669,
            "ranking": 496,
            "num": 41
        },

        {
            "score": 668,
            "ranking": 527,
            "num": 31
        },

        {
            "score": 667,
            "ranking": 574,
            "num": 47
        },

        {
            "score": 666,
            "ranking": 612,
            "num": 38
        },

        {
            "score": 665,
            "ranking": 660,
            "num": 48
        },

        {
            "score": 664,
            "ranking": 723,
            "num": 63
        },

        {
            "score": 663,
            "ranking": 781,
            "num": 58
        },

        {
            "score": 662,
            "ranking": 839,
            "num": 58
        },

        {
            "score": 661,
            "ranking": 893,
            "num": 54
        },

        {
            "score": 660,
            "ranking": 970,
            "num": 77
        },

        {
            "score": 659,
            "ranking": 1032,
            "num": 62
        },

        {
            "score": 658,
            "ranking": 1115,
            "num": 83
        },

        {
            "score": 657,
            "ranking": 1186,
            "num": 71
        },

        {
            "score": 656,
            "ranking": 1275,
            "num": 89
        },

        {
            "score": 655,
            "ranking": 1372,
            "num": 97
        },

        {
            "score": 654,
            "ranking": 1465,
            "num": 93
        },

        {
            "score": 653,
            "ranking": 1584,
            "num": 119
        },

        {
            "score": 652,
            "ranking": 1689,
            "num": 105
        },

        {
            "score": 651,
            "ranking": 1801,
            "num": 112
        },

        {
            "score": 650,
            "ranking": 1899,
            "num": 98
        },

        {
            "score": 649,
            "ranking": 2012,
            "num": 113
        },

        {
            "score": 648,
            "ranking": 2113,
            "num": 101
        },

        {
            "score": 647,
            "ranking": 2230,
            "num": 117
        },

        {
            "score": 646,
            "ranking": 2358,
            "num": 128
        },

        {
            "score": 645,
            "ranking": 2497,
            "num": 139
        },

        {
            "score": 644,
            "ranking": 2638,
            "num": 141
        },

        {
            "score": 643,
            "ranking": 2783,
            "num": 145
        },

        {
            "score": 642,
            "ranking": 2921,
            "num": 138
        },

        {
            "score": 641,
            "ranking": 3085,
            "num": 164
        },

        {
            "score": 640,
            "ranking": 3242,
            "num": 157
        },

        {
            "score": 639,
            "ranking": 3434,
            "num": 192
        },

        {
            "score": 638,
            "ranking": 3641,
            "num": 207
        },

        {
            "score": 637,
            "ranking": 3812,
            "num": 171
        },

        {
            "score": 636,
            "ranking": 4028,
            "num": 216
        },

        {
            "score": 635,
            "ranking": 4241,
            "num": 213
        },

        {
            "score": 634,
            "ranking": 4436,
            "num": 195
        },

        {
            "score": 633,
            "ranking": 4651,
            "num": 215
        },

        {
            "score": 632,
            "ranking": 4877,
            "num": 226
        },

        {
            "score": 631,
            "ranking": 5104,
            "num": 227
        },

        {
            "score": 630,
            "ranking": 5342,
            "num": 238
        },

        {
            "score": 629,
            "ranking": 5572,
            "num": 230
        },

        {
            "score": 628,
            "ranking": 5793,
            "num": 221
        },

        {
            "score": 627,
            "ranking": 6047,
            "num": 254
        },

        {
            "score": 626,
            "ranking": 6306,
            "num": 259
        },

        {
            "score": 625,
            "ranking": 6574,
            "num": 268
        },

        {
            "score": 624,
            "ranking": 6877,
            "num": 303
        },

        {
            "score": 623,
            "ranking": 7166,
            "num": 289
        },

        {
            "score": 622,
            "ranking": 7457,
            "num": 291
        },

        {
            "score": 621,
            "ranking": 7757,
            "num": 300
        },

        {
            "score": 620,
            "ranking": 8056,
            "num": 299
        },

        {
            "score": 619,
            "ranking": 8371,
            "num": 315
        },

        {
            "score": 618,
            "ranking": 8715,
            "num": 344
        },

        {
            "score": 617,
            "ranking": 9020,
            "num": 305
        },

        {
            "score": 616,
            "ranking": 9395,
            "num": 375
        },

        {
            "score": 615,
            "ranking": 9736,
            "num": 341
        },

        {
            "score": 614,
            "ranking": 10078,
            "num": 342
        },

        {
            "score": 613,
            "ranking": 10464,
            "num": 386
        },

        {
            "score": 612,
            "ranking": 10848,
            "num": 384
        },

        {
            "score": 611,
            "ranking": 11219,
            "num": 371
        },

        {
            "score": 610,
            "ranking": 11615,
            "num": 396
        },

        {
            "score": 609,
            "ranking": 12015,
            "num": 400
        },

        {
            "score": 608,
            "ranking": 12435,
            "num": 420
        },

        {
            "score": 607,
            "ranking": 12858,
            "num": 423
        },

        {
            "score": 606,
            "ranking": 13279,
            "num": 421
        },

        {
            "score": 605,
            "ranking": 13725,
            "num": 446
        },

        {
            "score": 604,
            "ranking": 14189,
            "num": 464
        },

        {
            "score": 603,
            "ranking": 14629,
            "num": 440
        },

        {
            "score": 602,
            "ranking": 15084,
            "num": 455
        },

        {
            "score": 601,
            "ranking": 15554,
            "num": 470
        },

        {
            "score": 600,
            "ranking": 16048,
            "num": 494
        },

        {
            "score": 599,
            "ranking": 16510,
            "num": 462
        },

        {
            "score": 598,
            "ranking": 17020,
            "num": 510
        },

        {
            "score": 597,
            "ranking": 17549,
            "num": 529
        },

        {
            "score": 596,
            "ranking": 18059,
            "num": 510
        },

        {
            "score": 595,
            "ranking": 18563,
            "num": 504
        },

        {
            "score": 594,
            "ranking": 19118,
            "num": 555
        },

        {
            "score": 593,
            "ranking": 19684,
            "num": 566
        },

        {
            "score": 592,
            "ranking": 20281,
            "num": 597
        },

        {
            "score": 591,
            "ranking": 20850,
            "num": 569
        },

        {
            "score": 590,
            "ranking": 21457,
            "num": 607
        },

        {
            "score": 589,
            "ranking": 22024,
            "num": 567
        },

        {
            "score": 588,
            "ranking": 22618,
            "num": 594
        },

        {
            "score": 587,
            "ranking": 23239,
            "num": 621
        },

        {
            "score": 586,
            "ranking": 23893,
            "num": 654
        },

        {
            "score": 585,
            "ranking": 24522,
            "num": 629
        },

        {
            "score": 584,
            "ranking": 25153,
            "num": 631
        },

        {
            "score": 583,
            "ranking": 25787,
            "num": 634
        },

        {
            "score": 582,
            "ranking": 26424,
            "num": 637
        },

        {
            "score": 581,
            "ranking": 27095,
            "num": 671
        },

        {
            "score": 580,
            "ranking": 27764,
            "num": 669
        },

        {
            "score": 579,
            "ranking": 28476,
            "num": 712
        },

        {
            "score": 578,
            "ranking": 29151,
            "num": 675
        },

        {
            "score": 577,
            "ranking": 29841,
            "num": 690
        },

        {
            "score": 576,
            "ranking": 30538,
            "num": 697
        },

        {
            "score": 575,
            "ranking": 31251,
            "num": 713
        },

        {
            "score": 574,
            "ranking": 31945,
            "num": 694
        },

        {
            "score": 573,
            "ranking": 32636,
            "num": 691
        },

        {
            "score": 572,
            "ranking": 33407,
            "num": 771
        },

        {
            "score": 571,
            "ranking": 34124,
            "num": 717
        },

        {
            "score": 570,
            "ranking": 34852,
            "num": 728
        },

        {
            "score": 569,
            "ranking": 35574,
            "num": 722
        },

        {
            "score": 568,
            "ranking": 36336,
            "num": 762
        },

        {
            "score": 567,
            "ranking": 37129,
            "num": 793
        },

        {
            "score": 566,
            "ranking": 37938,
            "num": 809
        },

        {
            "score": 565,
            "ranking": 38753,
            "num": 815
        },

        {
            "score": 564,
            "ranking": 39606,
            "num": 853
        },

        {
            "score": 563,
            "ranking": 40404,
            "num": 798
        },

        {
            "score": 562,
            "ranking": 41266,
            "num": 862
        },

        {
            "score": 561,
            "ranking": 42168,
            "num": 902
        },

        {
            "score": 560,
            "ranking": 43018,
            "num": 850
        },

        {
            "score": 559,
            "ranking": 43868,
            "num": 850
        },

        {
            "score": 558,
            "ranking": 44724,
            "num": 856
        },

        {
            "score": 557,
            "ranking": 45612,
            "num": 888
        },

        {
            "score": 556,
            "ranking": 46572,
            "num": 960
        },

        {
            "score": 555,
            "ranking": 47516,
            "num": 944
        },

        {
            "score": 554,
            "ranking": 48470,
            "num": 954
        },

        {
            "score": 553,
            "ranking": 49387,
            "num": 917
        },

        {
            "score": 552,
            "ranking": 50338,
            "num": 951
        },

        {
            "score": 551,
            "ranking": 51294,
            "num": 956
        },

        {
            "score": 550,
            "ranking": 52220,
            "num": 926
        },

        {
            "score": 549,
            "ranking": 53206,
            "num": 986
        },

        {
            "score": 548,
            "ranking": 54135,
            "num": 929
        },

        {
            "score": 547,
            "ranking": 55105,
            "num": 970
        },

        {
            "score": 546,
            "ranking": 56118,
            "num": 1013
        },

        {
            "score": 545,
            "ranking": 57178,
            "num": 1060
        },

        {
            "score": 544,
            "ranking": 58177,
            "num": 999
        },

        {
            "score": 543,
            "ranking": 59191,
            "num": 1014
        },

        {
            "score": 542,
            "ranking": 60165,
            "num": 974
        },

        {
            "score": 541,
            "ranking": 61214,
            "num": 1049
        },

        {
            "score": 540,
            "ranking": 62311,
            "num": 1097
        },

        {
            "score": 539,
            "ranking": 63318,
            "num": 1007
        },

        {
            "score": 538,
            "ranking": 64379,
            "num": 1061
        },

        {
            "score": 537,
            "ranking": 65427,
            "num": 1048
        },

        {
            "score": 536,
            "ranking": 66504,
            "num": 1077
        },

        {
            "score": 535,
            "ranking": 67572,
            "num": 1068
        },

        {
            "score": 534,
            "ranking": 68627,
            "num": 1055
        },

        {
            "score": 533,
            "ranking": 69714,
            "num": 1087
        },

        {
            "score": 532,
            "ranking": 70806,
            "num": 1092
        },

        {
            "score": 531,
            "ranking": 71851,
            "num": 1045
        },

        {
            "score": 530,
            "ranking": 73020,
            "num": 1169
        },

        {
            "score": 529,
            "ranking": 74158,
            "num": 1138
        },

        {
            "score": 528,
            "ranking": 75279,
            "num": 1121
        },

        {
            "score": 527,
            "ranking": 76393,
            "num": 1114
        },

        {
            "score": 526,
            "ranking": 77523,
            "num": 1130
        },

        {
            "score": 525,
            "ranking": 78652,
            "num": 1129
        },

        {
            "score": 524,
            "ranking": 79803,
            "num": 1151
        },

        {
            "score": 523,
            "ranking": 81012,
            "num": 1209
        },

        {
            "score": 522,
            "ranking": 82193,
            "num": 1181
        },

        {
            "score": 521,
            "ranking": 83314,
            "num": 1121
        },

        {
            "score": 520,
            "ranking": 84432,
            "num": 1118
        },

        {
            "score": 519,
            "ranking": 85649,
            "num": 1217
        },

        {
            "score": 518,
            "ranking": 86875,
            "num": 1226
        },

        {
            "score": 517,
            "ranking": 88095,
            "num": 1220
        },

        {
            "score": 516,
            "ranking": 89282,
            "num": 1187
        },

        {
            "score": 515,
            "ranking": 90542,
            "num": 1260
        },

        {
            "score": 514,
            "ranking": 91816,
            "num": 1274
        },

        {
            "score": 513,
            "ranking": 93105,
            "num": 1289
        },

        {
            "score": 512,
            "ranking": 94355,
            "num": 1250
        },

        {
            "score": 511,
            "ranking": 95599,
            "num": 1244
        },

        {
            "score": 510,
            "ranking": 96807,
            "num": 1208
        },

        {
            "score": 509,
            "ranking": 98103,
            "num": 1296
        },

        {
            "score": 508,
            "ranking": 99361,
            "num": 1258
        },

        {
            "score": 507,
            "ranking": 100680,
            "num": 1319
        },

        {
            "score": 506,
            "ranking": 101963,
            "num": 1283
        },

        {
            "score": 505,
            "ranking": 103209,
            "num": 1246
        },

        {
            "score": 504,
            "ranking": 104489,
            "num": 1280
        },

        {
            "score": 503,
            "ranking": 105793,
            "num": 1304
        },

        {
            "score": 502,
            "ranking": 107111,
            "num": 1318
        },

        {
            "score": 501,
            "ranking": 108397,
            "num": 1286
        },

        {
            "score": 500,
            "ranking": 109722,
            "num": 1325
        },

        {
            "score": 499,
            "ranking": 111061,
            "num": 1339
        },

        {
            "score": 498,
            "ranking": 112391,
            "num": 1330
        },

        {
            "score": 497,
            "ranking": 113728,
            "num": 1337
        },

        {
            "score": 496,
            "ranking": 115107,
            "num": 1379
        },

        {
            "score": 495,
            "ranking": 116429,
            "num": 1322
        },

        {
            "score": 494,
            "ranking": 117785,
            "num": 1356
        },

        {
            "score": 493,
            "ranking": 119172,
            "num": 1387
        },

        {
            "score": 492,
            "ranking": 120507,
            "num": 1335
        },

        {
            "score": 491,
            "ranking": 121907,
            "num": 1400
        },

        {
            "score": 490,
            "ranking": 123275,
            "num": 1368
        },

        {
            "score": 489,
            "ranking": 124682,
            "num": 1407
        },

        {
            "score": 488,
            "ranking": 126087,
            "num": 1405
        },

        {
            "score": 487,
            "ranking": 127545,
            "num": 1458
        },

        {
            "score": 486,
            "ranking": 129013,
            "num": 1468
        },

        {
            "score": 485,
            "ranking": 130391,
            "num": 1378
        },

        {
            "score": 484,
            "ranking": 131781,
            "num": 1390
        },

        {
            "score": 483,
            "ranking": 133227,
            "num": 1446
        },

        {
            "score": 482,
            "ranking": 134658,
            "num": 1431
        },

        {
            "score": 481,
            "ranking": 136160,
            "num": 1502
        },

        {
            "score": 480,
            "ranking": 137646,
            "num": 1486
        },

        {
            "score": 479,
            "ranking": 139124,
            "num": 1478
        },

        {
            "score": 478,
            "ranking": 140526,
            "num": 1402
        },

        {
            "score": 477,
            "ranking": 141960,
            "num": 1434
        },

        {
            "score": 476,
            "ranking": 143428,
            "num": 1468
        },

        {
            "score": 475,
            "ranking": 144952,
            "num": 1524
        },

        {
            "score": 474,
            "ranking": 146428,
            "num": 1476
        },

        {
            "score": 473,
            "ranking": 147855,
            "num": 1427
        },

        {
            "score": 472,
            "ranking": 149279,
            "num": 1424
        },

        {
            "score": 471,
            "ranking": 150749,
            "num": 1470
        },

        {
            "score": 470,
            "ranking": 152213,
            "num": 1464
        },

        {
            "score": 469,
            "ranking": 153726,
            "num": 1513
        },

        {
            "score": 468,
            "ranking": 155299,
            "num": 1573
        },

        {
            "score": 467,
            "ranking": 156834,
            "num": 1535
        },

        {
            "score": 466,
            "ranking": 158333,
            "num": 1499
        },

        {
            "score": 465,
            "ranking": 159888,
            "num": 1555
        },

        {
            "score": 464,
            "ranking": 161404,
            "num": 1516
        },

        {
            "score": 463,
            "ranking": 162953,
            "num": 1549
        },

        {
            "score": 462,
            "ranking": 164407,
            "num": 1454
        },

        {
            "score": 461,
            "ranking": 165929,
            "num": 1522
        },

        {
            "score": 460,
            "ranking": 167432,
            "num": 1503
        },

        {
            "score": 459,
            "ranking": 168910,
            "num": 1478
        },

        {
            "score": 458,
            "ranking": 170400,
            "num": 1490
        },

        {
            "score": 457,
            "ranking": 171994,
            "num": 1594
        },

        {
            "score": 456,
            "ranking": 173485,
            "num": 1491
        },

        {
            "score": 455,
            "ranking": 175024,
            "num": 1539
        },

        {
            "score": 454,
            "ranking": 176534,
            "num": 1510
        },

        {
            "score": 453,
            "ranking": 178112,
            "num": 1578
        },

        {
            "score": 452,
            "ranking": 179660,
            "num": 1548
        },

        {
            "score": 451,
            "ranking": 181267,
            "num": 1607
        },

        {
            "score": 450,
            "ranking": 182812,
            "num": 1545
        },

        {
            "score": 449,
            "ranking": 184336,
            "num": 1524
        },

        {
            "score": 448,
            "ranking": 185877,
            "num": 1541
        },

        {
            "score": 447,
            "ranking": 187430,
            "num": 1553
        },

        {
            "score": 446,
            "ranking": 189057,
            "num": 1627
        },

        {
            "score": 445,
            "ranking": 190661,
            "num": 1604
        },

        {
            "score": 444,
            "ranking": 192243,
            "num": 1582
        },

        {
            "score": 443,
            "ranking": 193825,
            "num": 1582
        },

        {
            "score": 442,
            "ranking": 195442,
            "num": 1617
        },

        {
            "score": 441,
            "ranking": 197053,
            "num": 1611
        },

        {
            "score": 440,
            "ranking": 198658,
            "num": 1605
        },

        {
            "score": 439,
            "ranking": 200217,
            "num": 1559
        },

        {
            "score": 438,
            "ranking": 201696,
            "num": 1479
        },

        {
            "score": 437,
            "ranking": 203316,
            "num": 1620
        },

        {
            "score": 436,
            "ranking": 204917,
            "num": 1601
        },

        {
            "score": 435,
            "ranking": 206509,
            "num": 1592
        },

        {
            "score": 434,
            "ranking": 208112,
            "num": 1603
        },

        {
            "score": 433,
            "ranking": 209699,
            "num": 1587
        },

        {
            "score": 432,
            "ranking": 211300,
            "num": 1601
        },

        {
            "score": 431,
            "ranking": 212792,
            "num": 1492
        },

        {
            "score": 430,
            "ranking": 214312,
            "num": 1520
        },

        {
            "score": 429,
            "ranking": 215808,
            "num": 1496
        },

        {
            "score": 428,
            "ranking": 217384,
            "num": 1576
        },

        {
            "score": 427,
            "ranking": 218977,
            "num": 1593
        },

        {
            "score": 426,
            "ranking": 220514,
            "num": 1537
        },

        {
            "score": 425,
            "ranking": 222067,
            "num": 1553
        },

        {
            "score": 424,
            "ranking": 223648,
            "num": 1581
        },

        {
            "score": 423,
            "ranking": 225127,
            "num": 1479
        },

        {
            "score": 422,
            "ranking": 226764,
            "num": 1637
        },

        {
            "score": 421,
            "ranking": 228295,
            "num": 1531
        },

        {
            "score": 420,
            "ranking": 229909,
            "num": 1614
        },

        {
            "score": 419,
            "ranking": 231433,
            "num": 1524
        },

        {
            "score": 418,
            "ranking": 232966,
            "num": 1533
        },

        {
            "score": 417,
            "ranking": 234488,
            "num": 1522
        },

        {
            "score": 416,
            "ranking": 235936,
            "num": 1448
        },

        {
            "score": 415,
            "ranking": 237441,
            "num": 1505
        },

        {
            "score": 414,
            "ranking": 238977,
            "num": 1536
        },

        {
            "score": 413,
            "ranking": 240565,
            "num": 1588
        },

        {
            "score": 412,
            "ranking": 242062,
            "num": 1497
        },

        {
            "score": 411,
            "ranking": 243516,
            "num": 1454
        },

        {
            "score": 410,
            "ranking": 244999,
            "num": 1483
        },

        {
            "score": 409,
            "ranking": 246460,
            "num": 1461
        },

        {
            "score": 408,
            "ranking": 247892,
            "num": 1432
        },

        {
            "score": 407,
            "ranking": 249416,
            "num": 1524
        },

        {
            "score": 406,
            "ranking": 250790,
            "num": 1374
        },

        {
            "score": 405,
            "ranking": 252264,
            "num": 1474
        },

        {
            "score": 404,
            "ranking": 253798,
            "num": 1534
        },

        {
            "score": 403,
            "ranking": 255219,
            "num": 1421
        },

        {
            "score": 402,
            "ranking": 256652,
            "num": 1433
        },

        {
            "score": 401,
            "ranking": 258045,
            "num": 1393
        },

        {
            "score": 400,
            "ranking": 259513,
            "num": 1468
        },

        {
            "score": 399,
            "ranking": 260916,
            "num": 1403
        },

        {
            "score": 398,
            "ranking": 262381,
            "num": 1465
        },

        {
            "score": 397,
            "ranking": 263856,
            "num": 1475
        },

        {
            "score": 396,
            "ranking": 265263,
            "num": 1407
        },

        {
            "score": 395,
            "ranking": 266754,
            "num": 1491
        },

        {
            "score": 394,
            "ranking": 268221,
            "num": 1467
        },

        {
            "score": 393,
            "ranking": 269668,
            "num": 1447
        },

        {
            "score": 392,
            "ranking": 271093,
            "num": 1425
        },

        {
            "score": 391,
            "ranking": 272463,
            "num": 1370
        },

        {
            "score": 390,
            "ranking": 273805,
            "num": 1342
        },

        {
            "score": 389,
            "ranking": 275178,
            "num": 1373
        },

        {
            "score": 388,
            "ranking": 276546,
            "num": 1368
        },

        {
            "score": 387,
            "ranking": 277885,
            "num": 1339
        },

        {
            "score": 386,
            "ranking": 279199,
            "num": 1314
        },

        {
            "score": 385,
            "ranking": 280520,
            "num": 1321
        },

        {
            "score": 384,
            "ranking": 281872,
            "num": 1352
        },

        {
            "score": 383,
            "ranking": 283159,
            "num": 1287
        },

        {
            "score": 382,
            "ranking": 284500,
            "num": 1341
        },

        {
            "score": 381,
            "ranking": 285813,
            "num": 1313
        },

        {
            "score": 380,
            "ranking": 287121,
            "num": 1308
        },

        {
            "score": 379,
            "ranking": 288314,
            "num": 1193
        },

        {
            "score": 378,
            "ranking": 289541,
            "num": 1227
        },

        {
            "score": 377,
            "ranking": 290804,
            "num": 1263
        },

        {
            "score": 376,
            "ranking": 292144,
            "num": 1340
        },

        {
            "score": 375,
            "ranking": 293411,
            "num": 1267
        },

        {
            "score": 374,
            "ranking": 294694,
            "num": 1283
        },

        {
            "score": 373,
            "ranking": 295910,
            "num": 1216
        },

        {
            "score": 372,
            "ranking": 297098,
            "num": 1188
        },

        {
            "score": 371,
            "ranking": 298324,
            "num": 1226
        },

        {
            "score": 370,
            "ranking": 299513,
            "num": 1189
        },

        {
            "score": 369,
            "ranking": 300716,
            "num": 1203
        },

        {
            "score": 368,
            "ranking": 301945,
            "num": 1229
        },

        {
            "score": 367,
            "ranking": 303116,
            "num": 1171
        },

        {
            "score": 366,
            "ranking": 304270,
            "num": 1154
        },

        {
            "score": 365,
            "ranking": 305452,
            "num": 1182
        },

        {
            "score": 364,
            "ranking": 306643,
            "num": 1191
        },

        {
            "score": 363,
            "ranking": 307790,
            "num": 1147
        },

        {
            "score": 362,
            "ranking": 308904,
            "num": 1114
        },

        {
            "score": 361,
            "ranking": 310036,
            "num": 1132
        },

        {
            "score": 360,
            "ranking": 311169,
            "num": 1133
        },

        {
            "score": 359,
            "ranking": 312238,
            "num": 1069
        },

        {
            "score": 358,
            "ranking": 313379,
            "num": 1141
        },

        {
            "score": 357,
            "ranking": 314528,
            "num": 1149
        },

        {
            "score": 356,
            "ranking": 315698,
            "num": 1170
        },

        {
            "score": 355,
            "ranking": 316823,
            "num": 1125
        },

        {
            "score": 354,
            "ranking": 317880,
            "num": 1057
        },

        {
            "score": 353,
            "ranking": 318932,
            "num": 1052
        },

        {
            "score": 352,
            "ranking": 319985,
            "num": 1053
        },

        {
            "score": 351,
            "ranking": 321021,
            "num": 1036
        },

        {
            "score": 350,
            "ranking": 322076,
            "num": 1055
        },

        {
            "score": 349,
            "ranking": 323147,
            "num": 1071
        },

        {
            "score": 348,
            "ranking": 324214,
            "num": 1067
        },

        {
            "score": 347,
            "ranking": 325199,
            "num": 985
        },

        {
            "score": 346,
            "ranking": 326204,
            "num": 1005
        },

        {
            "score": 345,
            "ranking": 327228,
            "num": 1024
        },

        {
            "score": 344,
            "ranking": 328189,
            "num": 961
        },

        {
            "score": 343,
            "ranking": 329205,
            "num": 1016
        },

        {
            "score": 342,
            "ranking": 330199,
            "num": 994
        },

        {
            "score": 341,
            "ranking": 331208,
            "num": 1009
        },

        {
            "score": 340,
            "ranking": 332187,
            "num": 979
        },

        {
            "score": 339,
            "ranking": 333108,
            "num": 921
        },

        {
            "score": 338,
            "ranking": 334091,
            "num": 983
        },

        {
            "score": 337,
            "ranking": 335039,
            "num": 948
        },

        {
            "score": 336,
            "ranking": 336003,
            "num": 964
        },

        {
            "score": 335,
            "ranking": 336961,
            "num": 958
        },

        {
            "score": 334,
            "ranking": 337853,
            "num": 892
        },

        {
            "score": 333,
            "ranking": 338791,
            "num": 938
        },

        {
            "score": 332,
            "ranking": 339721,
            "num": 930
        },

        {
            "score": 331,
            "ranking": 340626,
            "num": 905
        },

        {
            "score": 330,
            "ranking": 341514,
            "num": 888
        },

        {
            "score": 329,
            "ranking": 342441,
            "num": 927
        },

        {
            "score": 328,
            "ranking": 343323,
            "num": 882
        },

        {
            "score": 327,
            "ranking": 344254,
            "num": 931
        },

        {
            "score": 326,
            "ranking": 345103,
            "num": 849
        },

        {
            "score": 325,
            "ranking": 345975,
            "num": 872
        },

        {
            "score": 324,
            "ranking": 346849,
            "num": 874
        },

        {
            "score": 323,
            "ranking": 347709,
            "num": 860
        },

        {
            "score": 322,
            "ranking": 348525,
            "num": 816
        },

        {
            "score": 321,
            "ranking": 349343,
            "num": 818
        },

        {
            "score": 320,
            "ranking": 350172,
            "num": 829
        },

        {
            "score": 319,
            "ranking": 351014,
            "num": 842
        },

        {
            "score": 318,
            "ranking": 351805,
            "num": 791
        },

        {
            "score": 317,
            "ranking": 352639,
            "num": 834
        },

        {
            "score": 316,
            "ranking": 353399,
            "num": 760
        },

        {
            "score": 315,
            "ranking": 354162,
            "num": 763
        },

        {
            "score": 314,
            "ranking": 354926,
            "num": 764
        },

        {
            "score": 313,
            "ranking": 355658,
            "num": 732
        },

        {
            "score": 312,
            "ranking": 356456,
            "num": 798
        },

        {
            "score": 311,
            "ranking": 357193,
            "num": 737
        },

        {
            "score": 310,
            "ranking": 357953,
            "num": 760
        },

        {
            "score": 309,
            "ranking": 358677,
            "num": 724
        },

        {
            "score": 308,
            "ranking": 359459,
            "num": 782
        },

        {
            "score": 307,
            "ranking": 360176,
            "num": 717
        },

        {
            "score": 306,
            "ranking": 360920,
            "num": 744
        },

        {
            "score": 305,
            "ranking": 361674,
            "num": 754
        },

        {
            "score": 304,
            "ranking": 362358,
            "num": 684
        },

        {
            "score": 303,
            "ranking": 363054,
            "num": 696
        },

        {
            "score": 302,
            "ranking": 363748,
            "num": 694
        },

        {
            "score": 301,
            "ranking": 364411,
            "num": 663
        },

        {
            "score": 300,
            "ranking": 365066,
            "num": 655
        },

        {
            "score": 299,
            "ranking": 365757,
            "num": 691
        },

        {
            "score": 298,
            "ranking": 366418,
            "num": 661
        },

        {
            "score": 297,
            "ranking": 367049,
            "num": 631
        },

        {
            "score": 296,
            "ranking": 367698,
            "num": 649
        },

        {
            "score": 295,
            "ranking": 368316,
            "num": 618
        },

        {
            "score": 294,
            "ranking": 368971,
            "num": 655
        },

        {
            "score": 293,
            "ranking": 369553,
            "num": 582
        },

        {
            "score": 292,
            "ranking": 370175,
            "num": 622
        },

        {
            "score": 291,
            "ranking": 370803,
            "num": 628
        },

        {
            "score": 290,
            "ranking": 371396,
            "num": 593
        },

        {
            "score": 289,
            "ranking": 372016,
            "num": 620
        },

        {
            "score": 288,
            "ranking": 372589,
            "num": 573
        },

        {
            "score": 287,
            "ranking": 373170,
            "num": 581
        },

        {
            "score": 286,
            "ranking": 373741,
            "num": 571
        },

        {
            "score": 285,
            "ranking": 374314,
            "num": 573
        },

        {
            "score": 284,
            "ranking": 374874,
            "num": 560
        },

        {
            "score": 283,
            "ranking": 375438,
            "num": 564
        },

        {
            "score": 282,
            "ranking": 376042,
            "num": 604
        },

        {
            "score": 281,
            "ranking": 376608,
            "num": 566
        },

        {
            "score": 280,
            "ranking": 377151,
            "num": 543
        },

        {
            "score": 279,
            "ranking": 377698,
            "num": 547
        },

        {
            "score": 278,
            "ranking": 378213,
            "num": 515
        },

        {
            "score": 277,
            "ranking": 378754,
            "num": 541
        },

        {
            "score": 276,
            "ranking": 379243,
            "num": 489
        },

        {
            "score": 275,
            "ranking": 379752,
            "num": 509
        },

        {
            "score": 274,
            "ranking": 380241,
            "num": 489
        },

        {
            "score": 273,
            "ranking": 380742,
            "num": 501
        },

        {
            "score": 272,
            "ranking": 381223,
            "num": 481
        },

        {
            "score": 271,
            "ranking": 381711,
            "num": 488
        },

        {
            "score": 270,
            "ranking": 382220,
            "num": 509
        },

        {
            "score": 269,
            "ranking": 382707,
            "num": 487
        },

        {
            "score": 268,
            "ranking": 383144,
            "num": 437
        },

        {
            "score": 267,
            "ranking": 383609,
            "num": 465
        },

        {
            "score": 266,
            "ranking": 384041,
            "num": 432
        },

        {
            "score": 265,
            "ranking": 384475,
            "num": 434
        },

        {
            "score": 264,
            "ranking": 384893,
            "num": 418
        },

        {
            "score": 263,
            "ranking": 385319,
            "num": 426
        },

        {
            "score": 262,
            "ranking": 385748,
            "num": 429
        },

        {
            "score": 261,
            "ranking": 386186,
            "num": 438
        },

        {
            "score": 260,
            "ranking": 386595,
            "num": 409
        },

        {
            "score": 259,
            "ranking": 387023,
            "num": 428
        },

        {
            "score": 258,
            "ranking": 387416,
            "num": 393
        },

        {
            "score": 257,
            "ranking": 387837,
            "num": 421
        },

        {
            "score": 256,
            "ranking": 388197,
            "num": 360
        },

        {
            "score": 255,
            "ranking": 388606,
            "num": 409
        },

        {
            "score": 254,
            "ranking": 389008,
            "num": 402
        },

        {
            "score": 253,
            "ranking": 389350,
            "num": 342
        },

        {
            "score": 252,
            "ranking": 389742,
            "num": 392
        },

        {
            "score": 251,
            "ranking": 390094,
            "num": 352
        },

        {
            "score": 250,
            "ranking": 390490,
            "num": 396
        },

        {
            "score": 249,
            "ranking": 390850,
            "num": 360
        },

        {
            "score": 248,
            "ranking": 391215,
            "num": 365
        },

        {
            "score": 247,
            "ranking": 391555,
            "num": 340
        },

        {
            "score": 246,
            "ranking": 391914,
            "num": 359
        },

        {
            "score": 245,
            "ranking": 392276,
            "num": 362
        },

        {
            "score": 244,
            "ranking": 392618,
            "num": 342
        },

        {
            "score": 243,
            "ranking": 392959,
            "num": 341
        },

        {
            "score": 242,
            "ranking": 393296,
            "num": 337
        },

        {
            "score": 241,
            "ranking": 393616,
            "num": 320
        },

        {
            "score": 240,
            "ranking": 393964,
            "num": 348
        },

        {
            "score": 239,
            "ranking": 394286,
            "num": 322
        },

        {
            "score": 238,
            "ranking": 394591,
            "num": 305
        },

        {
            "score": 237,
            "ranking": 394854,
            "num": 263
        },

        {
            "score": 236,
            "ranking": 395128,
            "num": 274
        },

        {
            "score": 235,
            "ranking": 395409,
            "num": 281
        },

        {
            "score": 234,
            "ranking": 395687,
            "num": 278
        },

        {
            "score": 233,
            "ranking": 395957,
            "num": 270
        },

        {
            "score": 232,
            "ranking": 396268,
            "num": 311
        },

        {
            "score": 231,
            "ranking": 396549,
            "num": 281
        },

        {
            "score": 230,
            "ranking": 396828,
            "num": 279
        },

        {
            "score": 229,
            "ranking": 397104,
            "num": 276
        },

        {
            "score": 228,
            "ranking": 397353,
            "num": 249
        },

        {
            "score": 227,
            "ranking": 397624,
            "num": 271
        },

        {
            "score": 226,
            "ranking": 397840,
            "num": 216
        },

        {
            "score": 225,
            "ranking": 398118,
            "num": 278
        },

        {
            "score": 224,
            "ranking": 398375,
            "num": 257
        },

        {
            "score": 223,
            "ranking": 398594,
            "num": 219
        },

        {
            "score": 222,
            "ranking": 398845,
            "num": 251
        },

        {
            "score": 221,
            "ranking": 399096,
            "num": 251
        },

        {
            "score": 220,
            "ranking": 399318,
            "num": 222
        },

        {
            "score": 219,
            "ranking": 399547,
            "num": 229
        },

        {
            "score": 218,
            "ranking": 399758,
            "num": 211
        },

        {
            "score": 217,
            "ranking": 400000,
            "num": 242
        },

        {
            "score": 216,
            "ranking": 400207,
            "num": 207
        },

        {
            "score": 215,
            "ranking": 400438,
            "num": 231
        },

        {
            "score": 214,
            "ranking": 400676,
            "num": 238
        },

        {
            "score": 213,
            "ranking": 400876,
            "num": 200
        },

        {
            "score": 212,
            "ranking": 401100,
            "num": 224
        },

        {
            "score": 211,
            "ranking": 401306,
            "num": 206
        },

        {
            "score": 210,
            "ranking": 401483,
            "num": 177
        },

        {
            "score": 209,
            "ranking": 401654,
            "num": 171
        },

        {
            "score": 208,
            "ranking": 401839,
            "num": 185
        },

        {
            "score": 207,
            "ranking": 402008,
            "num": 169
        },

        {
            "score": 206,
            "ranking": 402195,
            "num": 187
        },

        {
            "score": 205,
            "ranking": 402381,
            "num": 186
        },

        {
            "score": 204,
            "ranking": 402550,
            "num": 169
        },

        {
            "score": 203,
            "ranking": 402720,
            "num": 170
        },

        {
            "score": 202,
            "ranking": 402877,
            "num": 157
        },

        {
            "score": 201,
            "ranking": 403058,
            "num": 181
        },

        {
            "score": 200,
            "ranking": 403223,
            "num": 165
        },

        {
            "score": 199,
            "ranking": 403376,
            "num": 153
        },

        {
            "score": 198,
            "ranking": 403517,
            "num": 141
        },

        {
            "score": 197,
            "ranking": 403669,
            "num": 152
        },

        {
            "score": 196,
            "ranking": 403800,
            "num": 131
        },

        {
            "score": 195,
            "ranking": 403958,
            "num": 158
        },

        {
            "score": 194,
            "ranking": 404116,
            "num": 158
        },

        {
            "score": 193,
            "ranking": 404280,
            "num": 164
        },

        {
            "score": 192,
            "ranking": 404399,
            "num": 119
        },

        {
            "score": 191,
            "ranking": 404523,
            "num": 124
        },

        {
            "score": 190,
            "ranking": 404668,
            "num": 145
        },

        {
            "score": 189,
            "ranking": 404809,
            "num": 141
        },

        {
            "score": 188,
            "ranking": 404915,
            "num": 106
        },

        {
            "score": 187,
            "ranking": 405019,
            "num": 104
        },

        {
            "score": 186,
            "ranking": 405138,
            "num": 119
        },

        {
            "score": 185,
            "ranking": 405251,
            "num": 113
        },

        {
            "score": 184,
            "ranking": 405350,
            "num": 99
        },

        {
            "score": 183,
            "ranking": 405460,
            "num": 110
        },

        {
            "score": 182,
            "ranking": 405558,
            "num": 98
        },

        {
            "score": 181,
            "ranking": 405657,
            "num": 99
        },

        {
            "score": 180,
            "ranking": 405762,
            "num": 105
        },

        {
            "score": 179,
            "ranking": 405864,
            "num": 102
        },

        {
            "score": 178,
            "ranking": 405959,
            "num": 95
        },

        {
            "score": 177,
            "ranking": 406064,
            "num": 105
        },

        {
            "score": 176,
            "ranking": 406159,
            "num": 95
        },

        {
            "score": 175,
            "ranking": 406244,
            "num": 85
        },

        {
            "score": 174,
            "ranking": 406309,
            "num": 65
        },

        {
            "score": 173,
            "ranking": 406411,
            "num": 102
        },

        {
            "score": 172,
            "ranking": 406491,
            "num": 80
        },

        {
            "score": 171,
            "ranking": 406555,
            "num": 64
        },

        {
            "score": 170,
            "ranking": 406625,
            "num": 70
        },

        {
            "score": 169,
            "ranking": 406709,
            "num": 84
        },

        {
            "score": 168,
            "ranking": 406787,
            "num": 78
        },

        {
            "score": 167,
            "ranking": 406865,
            "num": 78
        },

        {
            "score": 166,
            "ranking": 406925,
            "num": 60
        },

        {
            "score": 165,
            "ranking": 407006,
            "num": 81
        },

        {
            "score": 164,
            "ranking": 407068,
            "num": 62
        },

        {
            "score": 163,
            "ranking": 407115,
            "num": 47
        },

        {
            "score": 162,
            "ranking": 407166,
            "num": 51
        },

        {
            "score": 161,
            "ranking": 407230,
            "num": 64
        },

        {
            "score": 160,
            "ranking": 407280,
            "num": 50
        },

        {
            "score": 159,
            "ranking": 407355,
            "num": 75
        },

        {
            "score": 158,
            "ranking": 407410,
            "num": 55
        },

        {
            "score": 157,
            "ranking": 407468,
            "num": 58
        },

        {
            "score": 156,
            "ranking": 407497,
            "num": 29
        },

        {
            "score": 155,
            "ranking": 407538,
            "num": 41
        },

        {
            "score": 154,
            "ranking": 407578,
            "num": 40
        },

        {
            "score": 153,
            "ranking": 407618,
            "num": 40
        },

        {
            "score": 152,
            "ranking": 407645,
            "num": 27
        },

        {
            "score": 151,
            "ranking": 407686,
            "num": 41
        },

        {
            "score": 150,
            "ranking": 407727,
            "num": 41
        },

        {
            "score": 149,
            "ranking": 407769,
            "num": 42
        },

        {
            "score": 148,
            "ranking": 407810,
            "num": 41
        },

        {
            "score": 147,
            "ranking": 407856,
            "num": 46
        },

        {
            "score": 146,
            "ranking": 407885,
            "num": 29
        },

        {
            "score": 145,
            "ranking": 407910,
            "num": 25
        },

        {
            "score": 144,
            "ranking": 407949,
            "num": 39
        },

        {
            "score": 143,
            "ranking": 407986,
            "num": 37
        },

        {
            "score": 142,
            "ranking": 408013,
            "num": 27
        },

        {
            "score": 141,
            "ranking": 408037,
            "num": 24
        },

        {
            "score": 140,
            "ranking": 408059,
            "num": 22
        },

        {
            "score": 139,
            "ranking": 408083,
            "num": 24
        },

        {
            "score": 138,
            "ranking": 408103,
            "num": 20
        },

        {
            "score": 137,
            "ranking": 408126,
            "num": 23
        },

        {
            "score": 136,
            "ranking": 408148,
            "num": 22
        },

        {
            "score": 135,
            "ranking": 408173,
            "num": 25
        },

        {
            "score": 134,
            "ranking": 408190,
            "num": 17
        },

        {
            "score": 133,
            "ranking": 408221,
            "num": 31
        },

        {
            "score": 132,
            "ranking": 408244,
            "num": 23
        },

        {
            "score": 131,
            "ranking": 408257,
            "num": 13
        }
    ],
    2018: [
        {
            "score": 706,
            "ranking": 3,
            "num": 3
        },

        {
            "score": 704,
            "ranking": 4,
            "num": 1
        },

        {
            "score": 703,
            "ranking": 5,
            "num": 1
        },

        {
            "score": 702,
            "ranking": 7,
            "num": 2
        },

        {
            "score": 701,
            "ranking": 9,
            "num": 2
        },

        {
            "score": 700,
            "ranking": 12,
            "num": 3
        },

        {
            "score": 699,
            "ranking": 14,
            "num": 2
        },

        {
            "score": 698,
            "ranking": 15,
            "num": 1
        },

        {
            "score": 697,
            "ranking": 20,
            "num": 5
        },

        {
            "score": 696,
            "ranking": 30,
            "num": 10
        },

        {
            "score": 695,
            "ranking": 32,
            "num": 2
        },

        {
            "score": 694,
            "ranking": 37,
            "num": 5
        },

        {
            "score": 693,
            "ranking": 46,
            "num": 9
        },

        {
            "score": 692,
            "ranking": 53,
            "num": 7
        },

        {
            "score": 691,
            "ranking": 59,
            "num": 6
        },

        {
            "score": 690,
            "ranking": 67,
            "num": 8
        },

        {
            "score": 689,
            "ranking": 76,
            "num": 9
        },

        {
            "score": 688,
            "ranking": 88,
            "num": 12
        },

        {
            "score": 687,
            "ranking": 95,
            "num": 7
        },

        {
            "score": 686,
            "ranking": 109,
            "num": 14
        },

        {
            "score": 685,
            "ranking": 123,
            "num": 14
        },

        {
            "score": 684,
            "ranking": 140,
            "num": 17
        },

        {
            "score": 683,
            "ranking": 160,
            "num": 20
        },

        {
            "score": 682,
            "ranking": 182,
            "num": 22
        },

        {
            "score": 681,
            "ranking": 207,
            "num": 25
        },

        {
            "score": 680,
            "ranking": 230,
            "num": 23
        },

        {
            "score": 679,
            "ranking": 259,
            "num": 29
        },

        {
            "score": 678,
            "ranking": 284,
            "num": 25
        },

        {
            "score": 677,
            "ranking": 319,
            "num": 35
        },

        {
            "score": 676,
            "ranking": 354,
            "num": 35
        },

        {
            "score": 675,
            "ranking": 389,
            "num": 35
        },

        {
            "score": 674,
            "ranking": 431,
            "num": 42
        },

        {
            "score": 673,
            "ranking": 470,
            "num": 39
        },

        {
            "score": 672,
            "ranking": 517,
            "num": 47
        },

        {
            "score": 671,
            "ranking": 564,
            "num": 47
        },

        {
            "score": 670,
            "ranking": 610,
            "num": 46
        },

        {
            "score": 669,
            "ranking": 664,
            "num": 54
        },

        {
            "score": 668,
            "ranking": 728,
            "num": 64
        },

        {
            "score": 667,
            "ranking": 794,
            "num": 66
        },

        {
            "score": 666,
            "ranking": 854,
            "num": 60
        },

        {
            "score": 665,
            "ranking": 933,
            "num": 79
        },

        {
            "score": 664,
            "ranking": 1006,
            "num": 73
        },

        {
            "score": 663,
            "ranking": 1080,
            "num": 74
        },

        {
            "score": 662,
            "ranking": 1146,
            "num": 66
        },

        {
            "score": 661,
            "ranking": 1220,
            "num": 74
        },

        {
            "score": 660,
            "ranking": 1302,
            "num": 82
        },

        {
            "score": 659,
            "ranking": 1386,
            "num": 84
        },

        {
            "score": 658,
            "ranking": 1466,
            "num": 80
        },

        {
            "score": 657,
            "ranking": 1570,
            "num": 104
        },

        {
            "score": 656,
            "ranking": 1655,
            "num": 85
        },

        {
            "score": 655,
            "ranking": 1760,
            "num": 105
        },

        {
            "score": 654,
            "ranking": 1863,
            "num": 103
        },

        {
            "score": 653,
            "ranking": 2000,
            "num": 137
        },

        {
            "score": 652,
            "ranking": 2130,
            "num": 130
        },

        {
            "score": 651,
            "ranking": 2245,
            "num": 115
        },

        {
            "score": 650,
            "ranking": 2377,
            "num": 132
        },

        {
            "score": 649,
            "ranking": 2503,
            "num": 126
        },

        {
            "score": 648,
            "ranking": 2652,
            "num": 149
        },

        {
            "score": 647,
            "ranking": 2800,
            "num": 148
        },

        {
            "score": 646,
            "ranking": 2928,
            "num": 128
        },

        {
            "score": 645,
            "ranking": 3092,
            "num": 164
        },

        {
            "score": 644,
            "ranking": 3246,
            "num": 154
        },

        {
            "score": 643,
            "ranking": 3421,
            "num": 175
        },

        {
            "score": 642,
            "ranking": 3598,
            "num": 177
        },

        {
            "score": 641,
            "ranking": 3782,
            "num": 184
        },

        {
            "score": 640,
            "ranking": 3960,
            "num": 178
        },

        {
            "score": 639,
            "ranking": 4143,
            "num": 183
        },

        {
            "score": 638,
            "ranking": 4329,
            "num": 186
        },

        {
            "score": 637,
            "ranking": 4531,
            "num": 202
        },

        {
            "score": 636,
            "ranking": 4718,
            "num": 187
        },

        {
            "score": 635,
            "ranking": 4926,
            "num": 208
        },

        {
            "score": 634,
            "ranking": 5125,
            "num": 199
        },

        {
            "score": 633,
            "ranking": 5348,
            "num": 223
        },

        {
            "score": 632,
            "ranking": 5559,
            "num": 211
        },

        {
            "score": 631,
            "ranking": 5779,
            "num": 220
        },

        {
            "score": 630,
            "ranking": 6000,
            "num": 221
        },

        {
            "score": 629,
            "ranking": 6252,
            "num": 252
        },

        {
            "score": 628,
            "ranking": 6498,
            "num": 246
        },

        {
            "score": 627,
            "ranking": 6759,
            "num": 261
        },

        {
            "score": 626,
            "ranking": 6996,
            "num": 237
        },

        {
            "score": 625,
            "ranking": 7286,
            "num": 290
        },

        {
            "score": 624,
            "ranking": 7555,
            "num": 269
        },

        {
            "score": 623,
            "ranking": 7828,
            "num": 273
        },

        {
            "score": 622,
            "ranking": 8141,
            "num": 313
        },

        {
            "score": 621,
            "ranking": 8451,
            "num": 310
        },

        {
            "score": 620,
            "ranking": 8748,
            "num": 297
        },

        {
            "score": 619,
            "ranking": 9037,
            "num": 289
        },

        {
            "score": 618,
            "ranking": 9354,
            "num": 317
        },

        {
            "score": 617,
            "ranking": 9681,
            "num": 327
        },

        {
            "score": 616,
            "ranking": 10013,
            "num": 332
        },

        {
            "score": 615,
            "ranking": 10370,
            "num": 357
        },

        {
            "score": 614,
            "ranking": 10714,
            "num": 344
        },

        {
            "score": 613,
            "ranking": 11056,
            "num": 342
        },

        {
            "score": 612,
            "ranking": 11400,
            "num": 344
        },

        {
            "score": 611,
            "ranking": 11712,
            "num": 312
        },

        {
            "score": 610,
            "ranking": 12100,
            "num": 388
        },

        {
            "score": 609,
            "ranking": 12496,
            "num": 396
        },

        {
            "score": 608,
            "ranking": 12912,
            "num": 416
        },

        {
            "score": 607,
            "ranking": 13303,
            "num": 391
        },

        {
            "score": 606,
            "ranking": 13715,
            "num": 412
        },

        {
            "score": 605,
            "ranking": 14133,
            "num": 418
        },

        {
            "score": 604,
            "ranking": 14591,
            "num": 458
        },

        {
            "score": 603,
            "ranking": 15057,
            "num": 466
        },

        {
            "score": 602,
            "ranking": 15444,
            "num": 387
        },

        {
            "score": 601,
            "ranking": 15862,
            "num": 418
        },

        {
            "score": 600,
            "ranking": 16314,
            "num": 452
        },

        {
            "score": 599,
            "ranking": 16721,
            "num": 407
        },

        {
            "score": 598,
            "ranking": 17190,
            "num": 469
        },

        {
            "score": 597,
            "ranking": 17669,
            "num": 479
        },

        {
            "score": 596,
            "ranking": 18167,
            "num": 498
        },

        {
            "score": 595,
            "ranking": 18611,
            "num": 444
        },

        {
            "score": 594,
            "ranking": 19097,
            "num": 486
        },

        {
            "score": 593,
            "ranking": 19586,
            "num": 489
        },

        {
            "score": 592,
            "ranking": 20067,
            "num": 481
        },

        {
            "score": 591,
            "ranking": 20612,
            "num": 545
        },

        {
            "score": 590,
            "ranking": 21133,
            "num": 521
        },

        {
            "score": 589,
            "ranking": 21709,
            "num": 576
        },

        {
            "score": 588,
            "ranking": 22262,
            "num": 553
        },

        {
            "score": 587,
            "ranking": 22847,
            "num": 585
        },

        {
            "score": 586,
            "ranking": 23432,
            "num": 585
        },

        {
            "score": 585,
            "ranking": 24015,
            "num": 583
        },

        {
            "score": 584,
            "ranking": 24624,
            "num": 609
        },

        {
            "score": 583,
            "ranking": 25200,
            "num": 576
        },

        {
            "score": 582,
            "ranking": 25779,
            "num": 579
        },

        {
            "score": 581,
            "ranking": 26389,
            "num": 610
        },

        {
            "score": 580,
            "ranking": 27041,
            "num": 652
        },

        {
            "score": 579,
            "ranking": 27642,
            "num": 601
        },

        {
            "score": 578,
            "ranking": 28227,
            "num": 585
        },

        {
            "score": 577,
            "ranking": 28843,
            "num": 616
        },

        {
            "score": 576,
            "ranking": 29486,
            "num": 643
        },

        {
            "score": 575,
            "ranking": 30122,
            "num": 636
        },

        {
            "score": 574,
            "ranking": 30752,
            "num": 630
        },

        {
            "score": 573,
            "ranking": 31384,
            "num": 632
        },

        {
            "score": 572,
            "ranking": 32011,
            "num": 627
        },

        {
            "score": 571,
            "ranking": 32759,
            "num": 748
        },

        {
            "score": 570,
            "ranking": 33449,
            "num": 690
        },

        {
            "score": 569,
            "ranking": 34113,
            "num": 664
        },

        {
            "score": 568,
            "ranking": 34859,
            "num": 746
        },

        {
            "score": 567,
            "ranking": 35578,
            "num": 719
        },

        {
            "score": 566,
            "ranking": 36312,
            "num": 734
        },

        {
            "score": 565,
            "ranking": 37053,
            "num": 741
        },

        {
            "score": 564,
            "ranking": 37772,
            "num": 719
        },

        {
            "score": 563,
            "ranking": 38484,
            "num": 712
        },

        {
            "score": 562,
            "ranking": 39257,
            "num": 773
        },

        {
            "score": 561,
            "ranking": 39974,
            "num": 717
        },

        {
            "score": 560,
            "ranking": 40745,
            "num": 771
        },

        {
            "score": 559,
            "ranking": 41539,
            "num": 794
        },

        {
            "score": 558,
            "ranking": 42341,
            "num": 802
        },

        {
            "score": 557,
            "ranking": 43166,
            "num": 825
        },

        {
            "score": 556,
            "ranking": 43915,
            "num": 749
        },

        {
            "score": 555,
            "ranking": 44734,
            "num": 819
        },

        {
            "score": 554,
            "ranking": 45525,
            "num": 791
        },

        {
            "score": 553,
            "ranking": 46358,
            "num": 833
        },

        {
            "score": 552,
            "ranking": 47211,
            "num": 853
        },

        {
            "score": 551,
            "ranking": 48043,
            "num": 832
        },

        {
            "score": 550,
            "ranking": 48886,
            "num": 843
        },

        {
            "score": 549,
            "ranking": 49758,
            "num": 872
        },

        {
            "score": 548,
            "ranking": 50647,
            "num": 889
        },

        {
            "score": 547,
            "ranking": 51463,
            "num": 816
        },

        {
            "score": 546,
            "ranking": 52387,
            "num": 924
        },

        {
            "score": 545,
            "ranking": 53254,
            "num": 867
        },

        {
            "score": 544,
            "ranking": 54123,
            "num": 869
        },

        {
            "score": 543,
            "ranking": 55062,
            "num": 939
        },

        {
            "score": 542,
            "ranking": 55962,
            "num": 900
        },

        {
            "score": 541,
            "ranking": 56901,
            "num": 939
        },

        {
            "score": 540,
            "ranking": 57808,
            "num": 907
        },

        {
            "score": 539,
            "ranking": 58817,
            "num": 1009
        },

        {
            "score": 538,
            "ranking": 59764,
            "num": 947
        },

        {
            "score": 537,
            "ranking": 60743,
            "num": 979
        },

        {
            "score": 536,
            "ranking": 61702,
            "num": 959
        },

        {
            "score": 535,
            "ranking": 62665,
            "num": 963
        },

        {
            "score": 534,
            "ranking": 63646,
            "num": 981
        },

        {
            "score": 533,
            "ranking": 64596,
            "num": 950
        },

        {
            "score": 532,
            "ranking": 65570,
            "num": 974
        },

        {
            "score": 531,
            "ranking": 66544,
            "num": 974
        },

        {
            "score": 530,
            "ranking": 67520,
            "num": 976
        },

        {
            "score": 529,
            "ranking": 68522,
            "num": 1002
        },

        {
            "score": 528,
            "ranking": 69535,
            "num": 1013
        },

        {
            "score": 527,
            "ranking": 70573,
            "num": 1038
        },

        {
            "score": 526,
            "ranking": 71565,
            "num": 992
        },

        {
            "score": 525,
            "ranking": 72572,
            "num": 1007
        },

        {
            "score": 524,
            "ranking": 73631,
            "num": 1059
        },

        {
            "score": 523,
            "ranking": 74566,
            "num": 935
        },

        {
            "score": 522,
            "ranking": 75582,
            "num": 1016
        },

        {
            "score": 521,
            "ranking": 76578,
            "num": 996
        },

        {
            "score": 520,
            "ranking": 77679,
            "num": 1101
        },

        {
            "score": 519,
            "ranking": 78689,
            "num": 1010
        },

        {
            "score": 518,
            "ranking": 79734,
            "num": 1045
        },

        {
            "score": 517,
            "ranking": 80757,
            "num": 1023
        },

        {
            "score": 516,
            "ranking": 81781,
            "num": 1024
        },

        {
            "score": 515,
            "ranking": 82846,
            "num": 1065
        },

        {
            "score": 514,
            "ranking": 83888,
            "num": 1042
        },

        {
            "score": 513,
            "ranking": 85035,
            "num": 1147
        },

        {
            "score": 512,
            "ranking": 86110,
            "num": 1075
        },

        {
            "score": 511,
            "ranking": 87208,
            "num": 1098
        },

        {
            "score": 510,
            "ranking": 88287,
            "num": 1079
        },

        {
            "score": 509,
            "ranking": 89407,
            "num": 1120
        },

        {
            "score": 508,
            "ranking": 90484,
            "num": 1077
        },

        {
            "score": 507,
            "ranking": 91562,
            "num": 1078
        },

        {
            "score": 506,
            "ranking": 92631,
            "num": 1069
        },

        {
            "score": 505,
            "ranking": 93772,
            "num": 1141
        },

        {
            "score": 504,
            "ranking": 94885,
            "num": 1113
        },

        {
            "score": 503,
            "ranking": 96023,
            "num": 1138
        },

        {
            "score": 502,
            "ranking": 97168,
            "num": 1145
        },

        {
            "score": 501,
            "ranking": 98319,
            "num": 1151
        },

        {
            "score": 500,
            "ranking": 99507,
            "num": 1188
        },

        {
            "score": 499,
            "ranking": 100709,
            "num": 1202
        },

        {
            "score": 498,
            "ranking": 101908,
            "num": 1199
        },

        {
            "score": 497,
            "ranking": 103118,
            "num": 1210
        },

        {
            "score": 496,
            "ranking": 104362,
            "num": 1244
        },

        {
            "score": 495,
            "ranking": 105524,
            "num": 1162
        },

        {
            "score": 494,
            "ranking": 106733,
            "num": 1209
        },

        {
            "score": 493,
            "ranking": 107979,
            "num": 1246
        },

        {
            "score": 492,
            "ranking": 109212,
            "num": 1233
        },

        {
            "score": 491,
            "ranking": 110417,
            "num": 1205
        },

        {
            "score": 490,
            "ranking": 111672,
            "num": 1255
        },

        {
            "score": 489,
            "ranking": 112929,
            "num": 1257
        },

        {
            "score": 488,
            "ranking": 114177,
            "num": 1248
        },

        {
            "score": 487,
            "ranking": 115409,
            "num": 1232
        },

        {
            "score": 486,
            "ranking": 116652,
            "num": 1243
        },

        {
            "score": 485,
            "ranking": 117903,
            "num": 1251
        },

        {
            "score": 484,
            "ranking": 119108,
            "num": 1205
        },

        {
            "score": 483,
            "ranking": 120408,
            "num": 1300
        },

        {
            "score": 482,
            "ranking": 121682,
            "num": 1274
        },

        {
            "score": 481,
            "ranking": 122901,
            "num": 1219
        },

        {
            "score": 480,
            "ranking": 124214,
            "num": 1313
        },

        {
            "score": 479,
            "ranking": 125497,
            "num": 1283
        },

        {
            "score": 478,
            "ranking": 126800,
            "num": 1303
        },

        {
            "score": 477,
            "ranking": 128060,
            "num": 1260
        },

        {
            "score": 476,
            "ranking": 129399,
            "num": 1339
        },

        {
            "score": 475,
            "ranking": 130659,
            "num": 1260
        },

        {
            "score": 474,
            "ranking": 131966,
            "num": 1307
        },

        {
            "score": 473,
            "ranking": 133310,
            "num": 1344
        },

        {
            "score": 472,
            "ranking": 134604,
            "num": 1294
        },

        {
            "score": 471,
            "ranking": 135954,
            "num": 1350
        },

        {
            "score": 470,
            "ranking": 137269,
            "num": 1315
        },

        {
            "score": 469,
            "ranking": 138568,
            "num": 1299
        },

        {
            "score": 468,
            "ranking": 139883,
            "num": 1315
        },

        {
            "score": 467,
            "ranking": 141173,
            "num": 1290
        },

        {
            "score": 466,
            "ranking": 142492,
            "num": 1319
        },

        {
            "score": 465,
            "ranking": 143825,
            "num": 1333
        },

        {
            "score": 464,
            "ranking": 145144,
            "num": 1319
        },

        {
            "score": 463,
            "ranking": 146450,
            "num": 1306
        },

        {
            "score": 462,
            "ranking": 147736,
            "num": 1286
        },

        {
            "score": 461,
            "ranking": 149103,
            "num": 1367
        },

        {
            "score": 460,
            "ranking": 150408,
            "num": 1305
        },

        {
            "score": 459,
            "ranking": 151756,
            "num": 1348
        },

        {
            "score": 458,
            "ranking": 153104,
            "num": 1348
        },

        {
            "score": 457,
            "ranking": 154476,
            "num": 1372
        },

        {
            "score": 456,
            "ranking": 155853,
            "num": 1377
        },

        {
            "score": 455,
            "ranking": 157199,
            "num": 1346
        },

        {
            "score": 454,
            "ranking": 158555,
            "num": 1356
        },

        {
            "score": 453,
            "ranking": 159838,
            "num": 1283
        },

        {
            "score": 452,
            "ranking": 161238,
            "num": 1400
        },

        {
            "score": 451,
            "ranking": 162553,
            "num": 1315
        },

        {
            "score": 450,
            "ranking": 163888,
            "num": 1335
        },

        {
            "score": 449,
            "ranking": 165288,
            "num": 1400
        },

        {
            "score": 448,
            "ranking": 166668,
            "num": 1380
        },

        {
            "score": 447,
            "ranking": 168099,
            "num": 1431
        },

        {
            "score": 446,
            "ranking": 169476,
            "num": 1377
        },

        {
            "score": 445,
            "ranking": 170826,
            "num": 1350
        },

        {
            "score": 444,
            "ranking": 172231,
            "num": 1405
        },

        {
            "score": 443,
            "ranking": 173642,
            "num": 1411
        },

        {
            "score": 442,
            "ranking": 175046,
            "num": 1404
        },

        {
            "score": 441,
            "ranking": 176425,
            "num": 1379
        },

        {
            "score": 440,
            "ranking": 177786,
            "num": 1361
        },

        {
            "score": 439,
            "ranking": 179170,
            "num": 1384
        },

        {
            "score": 438,
            "ranking": 180543,
            "num": 1373
        },

        {
            "score": 437,
            "ranking": 181968,
            "num": 1425
        },

        {
            "score": 436,
            "ranking": 183409,
            "num": 1441
        },

        {
            "score": 435,
            "ranking": 184787,
            "num": 1378
        },

        {
            "score": 434,
            "ranking": 186172,
            "num": 1385
        },

        {
            "score": 433,
            "ranking": 187538,
            "num": 1366
        },

        {
            "score": 432,
            "ranking": 188928,
            "num": 1390
        },

        {
            "score": 431,
            "ranking": 190262,
            "num": 1334
        },

        {
            "score": 430,
            "ranking": 191652,
            "num": 1390
        },

        {
            "score": 429,
            "ranking": 193026,
            "num": 1374
        },

        {
            "score": 428,
            "ranking": 194502,
            "num": 1476
        },

        {
            "score": 427,
            "ranking": 195850,
            "num": 1348
        },

        {
            "score": 426,
            "ranking": 197157,
            "num": 1307
        },

        {
            "score": 425,
            "ranking": 198558,
            "num": 1401
        },

        {
            "score": 424,
            "ranking": 199851,
            "num": 1293
        },

        {
            "score": 423,
            "ranking": 201281,
            "num": 1430
        },

        {
            "score": 422,
            "ranking": 202671,
            "num": 1390
        },

        {
            "score": 421,
            "ranking": 204059,
            "num": 1388
        },

        {
            "score": 420,
            "ranking": 205421,
            "num": 1362
        },

        {
            "score": 419,
            "ranking": 206814,
            "num": 1393
        },

        {
            "score": 418,
            "ranking": 208167,
            "num": 1353
        },

        {
            "score": 417,
            "ranking": 209576,
            "num": 1409
        },

        {
            "score": 416,
            "ranking": 210923,
            "num": 1347
        },

        {
            "score": 415,
            "ranking": 212276,
            "num": 1353
        },

        {
            "score": 414,
            "ranking": 213704,
            "num": 1428
        },

        {
            "score": 413,
            "ranking": 215061,
            "num": 1357
        },

        {
            "score": 412,
            "ranking": 216449,
            "num": 1388
        },

        {
            "score": 411,
            "ranking": 217868,
            "num": 1419
        },

        {
            "score": 410,
            "ranking": 219285,
            "num": 1417
        },

        {
            "score": 409,
            "ranking": 220635,
            "num": 1350
        },

        {
            "score": 408,
            "ranking": 222040,
            "num": 1405
        },

        {
            "score": 407,
            "ranking": 223403,
            "num": 1363
        },

        {
            "score": 406,
            "ranking": 224743,
            "num": 1340
        },

        {
            "score": 405,
            "ranking": 226120,
            "num": 1377
        },

        {
            "score": 404,
            "ranking": 227438,
            "num": 1318
        },

        {
            "score": 403,
            "ranking": 228766,
            "num": 1328
        },

        {
            "score": 402,
            "ranking": 230105,
            "num": 1339
        },

        {
            "score": 401,
            "ranking": 231510,
            "num": 1405
        },

        {
            "score": 400,
            "ranking": 232837,
            "num": 1327
        },

        {
            "score": 399,
            "ranking": 234204,
            "num": 1367
        },

        {
            "score": 398,
            "ranking": 235582,
            "num": 1378
        },

        {
            "score": 397,
            "ranking": 236908,
            "num": 1326
        },

        {
            "score": 396,
            "ranking": 238242,
            "num": 1334
        },

        {
            "score": 395,
            "ranking": 239549,
            "num": 1307
        },

        {
            "score": 394,
            "ranking": 240874,
            "num": 1325
        },

        {
            "score": 393,
            "ranking": 242153,
            "num": 1279
        },

        {
            "score": 392,
            "ranking": 243429,
            "num": 1276
        },

        {
            "score": 391,
            "ranking": 244748,
            "num": 1319
        },

        {
            "score": 390,
            "ranking": 246011,
            "num": 1263
        },

        {
            "score": 389,
            "ranking": 247294,
            "num": 1283
        },

        {
            "score": 388,
            "ranking": 248595,
            "num": 1301
        },

        {
            "score": 387,
            "ranking": 249880,
            "num": 1285
        },

        {
            "score": 386,
            "ranking": 251170,
            "num": 1290
        },

        {
            "score": 385,
            "ranking": 252414,
            "num": 1244
        },

        {
            "score": 384,
            "ranking": 253689,
            "num": 1275
        },

        {
            "score": 383,
            "ranking": 254917,
            "num": 1228
        },

        {
            "score": 382,
            "ranking": 256196,
            "num": 1279
        },

        {
            "score": 381,
            "ranking": 257477,
            "num": 1281
        },

        {
            "score": 380,
            "ranking": 258797,
            "num": 1320
        },

        {
            "score": 379,
            "ranking": 260091,
            "num": 1294
        },

        {
            "score": 378,
            "ranking": 261356,
            "num": 1265
        },

        {
            "score": 377,
            "ranking": 262622,
            "num": 1266
        },

        {
            "score": 376,
            "ranking": 263895,
            "num": 1273
        },

        {
            "score": 375,
            "ranking": 265175,
            "num": 1280
        },

        {
            "score": 374,
            "ranking": 266423,
            "num": 1248
        },

        {
            "score": 373,
            "ranking": 267716,
            "num": 1293
        },

        {
            "score": 372,
            "ranking": 268995,
            "num": 1279
        },

        {
            "score": 371,
            "ranking": 270203,
            "num": 1208
        },

        {
            "score": 370,
            "ranking": 271515,
            "num": 1312
        },

        {
            "score": 369,
            "ranking": 272747,
            "num": 1232
        },

        {
            "score": 368,
            "ranking": 273949,
            "num": 1202
        },

        {
            "score": 367,
            "ranking": 275155,
            "num": 1206
        },

        {
            "score": 366,
            "ranking": 276403,
            "num": 1248
        },

        {
            "score": 365,
            "ranking": 277658,
            "num": 1255
        },

        {
            "score": 364,
            "ranking": 278868,
            "num": 1210
        },

        {
            "score": 363,
            "ranking": 280018,
            "num": 1150
        },

        {
            "score": 362,
            "ranking": 281215,
            "num": 1197
        },

        {
            "score": 361,
            "ranking": 282389,
            "num": 1174
        },

        {
            "score": 360,
            "ranking": 283531,
            "num": 1142
        },

        {
            "score": 359,
            "ranking": 284755,
            "num": 1224
        },

        {
            "score": 358,
            "ranking": 285942,
            "num": 1187
        },

        {
            "score": 357,
            "ranking": 287098,
            "num": 1156
        },

        {
            "score": 356,
            "ranking": 288190,
            "num": 1092
        },

        {
            "score": 355,
            "ranking": 289306,
            "num": 1116
        },

        {
            "score": 354,
            "ranking": 290400,
            "num": 1094
        },

        {
            "score": 353,
            "ranking": 291538,
            "num": 1138
        },

        {
            "score": 352,
            "ranking": 292683,
            "num": 1145
        },

        {
            "score": 351,
            "ranking": 293837,
            "num": 1154
        },

        {
            "score": 350,
            "ranking": 295001,
            "num": 1164
        },

        {
            "score": 349,
            "ranking": 296117,
            "num": 1116
        },

        {
            "score": 348,
            "ranking": 297282,
            "num": 1165
        },

        {
            "score": 347,
            "ranking": 298382,
            "num": 1100
        },

        {
            "score": 346,
            "ranking": 299450,
            "num": 1068
        },

        {
            "score": 345,
            "ranking": 300504,
            "num": 1054
        },

        {
            "score": 344,
            "ranking": 301594,
            "num": 1090
        },

        {
            "score": 343,
            "ranking": 302686,
            "num": 1092
        },

        {
            "score": 342,
            "ranking": 303765,
            "num": 1079
        },

        {
            "score": 341,
            "ranking": 304807,
            "num": 1042
        },

        {
            "score": 340,
            "ranking": 305866,
            "num": 1059
        },

        {
            "score": 339,
            "ranking": 306926,
            "num": 1060
        },

        {
            "score": 338,
            "ranking": 308028,
            "num": 1102
        },

        {
            "score": 337,
            "ranking": 309072,
            "num": 1044
        },

        {
            "score": 336,
            "ranking": 310140,
            "num": 1068
        },

        {
            "score": 335,
            "ranking": 311158,
            "num": 1018
        },

        {
            "score": 334,
            "ranking": 312261,
            "num": 1103
        },

        {
            "score": 333,
            "ranking": 313297,
            "num": 1036
        },

        {
            "score": 332,
            "ranking": 314282,
            "num": 985
        },

        {
            "score": 331,
            "ranking": 315286,
            "num": 1004
        },

        {
            "score": 330,
            "ranking": 316288,
            "num": 1002
        },

        {
            "score": 329,
            "ranking": 317292,
            "num": 1004
        },

        {
            "score": 328,
            "ranking": 318265,
            "num": 973
        },

        {
            "score": 327,
            "ranking": 319239,
            "num": 974
        },

        {
            "score": 326,
            "ranking": 320249,
            "num": 1010
        },

        {
            "score": 325,
            "ranking": 321231,
            "num": 982
        },

        {
            "score": 324,
            "ranking": 322208,
            "num": 977
        },

        {
            "score": 323,
            "ranking": 323169,
            "num": 961
        },

        {
            "score": 322,
            "ranking": 324154,
            "num": 985
        },

        {
            "score": 321,
            "ranking": 325141,
            "num": 987
        },

        {
            "score": 320,
            "ranking": 326121,
            "num": 980
        },

        {
            "score": 319,
            "ranking": 327062,
            "num": 941
        },

        {
            "score": 318,
            "ranking": 328010,
            "num": 948
        },

        {
            "score": 317,
            "ranking": 328910,
            "num": 900
        },

        {
            "score": 316,
            "ranking": 329864,
            "num": 954
        },

        {
            "score": 315,
            "ranking": 330783,
            "num": 919
        },

        {
            "score": 314,
            "ranking": 331730,
            "num": 947
        },

        {
            "score": 313,
            "ranking": 332639,
            "num": 909
        },

        {
            "score": 312,
            "ranking": 333531,
            "num": 892
        },

        {
            "score": 311,
            "ranking": 334349,
            "num": 818
        },

        {
            "score": 310,
            "ranking": 335243,
            "num": 894
        },

        {
            "score": 309,
            "ranking": 336185,
            "num": 942
        },

        {
            "score": 308,
            "ranking": 337081,
            "num": 896
        },

        {
            "score": 307,
            "ranking": 337953,
            "num": 872
        },

        {
            "score": 306,
            "ranking": 338796,
            "num": 843
        },

        {
            "score": 305,
            "ranking": 339666,
            "num": 870
        },

        {
            "score": 304,
            "ranking": 340570,
            "num": 904
        },

        {
            "score": 303,
            "ranking": 341381,
            "num": 811
        },

        {
            "score": 302,
            "ranking": 342188,
            "num": 807
        },

        {
            "score": 301,
            "ranking": 343077,
            "num": 889
        },

        {
            "score": 300,
            "ranking": 343940,
            "num": 863
        },

        {
            "score": 299,
            "ranking": 344747,
            "num": 807
        },

        {
            "score": 298,
            "ranking": 345565,
            "num": 818
        },

        {
            "score": 297,
            "ranking": 346372,
            "num": 807
        },

        {
            "score": 296,
            "ranking": 347113,
            "num": 741
        },

        {
            "score": 295,
            "ranking": 347887,
            "num": 774
        },

        {
            "score": 294,
            "ranking": 348678,
            "num": 791
        },

        {
            "score": 293,
            "ranking": 349476,
            "num": 798
        },

        {
            "score": 292,
            "ranking": 350241,
            "num": 765
        },

        {
            "score": 291,
            "ranking": 350992,
            "num": 751
        },

        {
            "score": 290,
            "ranking": 351741,
            "num": 749
        },

        {
            "score": 289,
            "ranking": 352522,
            "num": 781
        },

        {
            "score": 288,
            "ranking": 353265,
            "num": 743
        },

        {
            "score": 287,
            "ranking": 354012,
            "num": 747
        },

        {
            "score": 286,
            "ranking": 354759,
            "num": 747
        },

        {
            "score": 285,
            "ranking": 355501,
            "num": 742
        },

        {
            "score": 284,
            "ranking": 356225,
            "num": 724
        },

        {
            "score": 283,
            "ranking": 356935,
            "num": 710
        },

        {
            "score": 282,
            "ranking": 357618,
            "num": 683
        },

        {
            "score": 281,
            "ranking": 358276,
            "num": 658
        },

        {
            "score": 280,
            "ranking": 358929,
            "num": 653
        },

        {
            "score": 279,
            "ranking": 359639,
            "num": 710
        },

        {
            "score": 278,
            "ranking": 360298,
            "num": 659
        },

        {
            "score": 277,
            "ranking": 360963,
            "num": 665
        },

        {
            "score": 276,
            "ranking": 361580,
            "num": 617
        },

        {
            "score": 275,
            "ranking": 362239,
            "num": 659
        },

        {
            "score": 274,
            "ranking": 362920,
            "num": 681
        },

        {
            "score": 273,
            "ranking": 363574,
            "num": 654
        },

        {
            "score": 272,
            "ranking": 364250,
            "num": 676
        },

        {
            "score": 271,
            "ranking": 364886,
            "num": 636
        },

        {
            "score": 270,
            "ranking": 365457,
            "num": 571
        },

        {
            "score": 269,
            "ranking": 366084,
            "num": 627
        },

        {
            "score": 268,
            "ranking": 366677,
            "num": 593
        },

        {
            "score": 267,
            "ranking": 367339,
            "num": 662
        },

        {
            "score": 266,
            "ranking": 367967,
            "num": 628
        },

        {
            "score": 265,
            "ranking": 368574,
            "num": 607
        },

        {
            "score": 264,
            "ranking": 369114,
            "num": 540
        },

        {
            "score": 263,
            "ranking": 369732,
            "num": 618
        },

        {
            "score": 262,
            "ranking": 370323,
            "num": 591
        },

        {
            "score": 261,
            "ranking": 370903,
            "num": 580
        },

        {
            "score": 260,
            "ranking": 371489,
            "num": 586
        },

        {
            "score": 259,
            "ranking": 372075,
            "num": 586
        },

        {
            "score": 258,
            "ranking": 372645,
            "num": 570
        },

        {
            "score": 257,
            "ranking": 373192,
            "num": 547
        },

        {
            "score": 256,
            "ranking": 373710,
            "num": 518
        },

        {
            "score": 255,
            "ranking": 374268,
            "num": 558
        },

        {
            "score": 254,
            "ranking": 374791,
            "num": 523
        },

        {
            "score": 253,
            "ranking": 375327,
            "num": 536
        },

        {
            "score": 252,
            "ranking": 375879,
            "num": 552
        },

        {
            "score": 251,
            "ranking": 376417,
            "num": 538
        },

        {
            "score": 250,
            "ranking": 376892,
            "num": 475
        },

        {
            "score": 249,
            "ranking": 377424,
            "num": 532
        },

        {
            "score": 248,
            "ranking": 377937,
            "num": 513
        },

        {
            "score": 247,
            "ranking": 378428,
            "num": 491
        },

        {
            "score": 246,
            "ranking": 378906,
            "num": 478
        },

        {
            "score": 245,
            "ranking": 379384,
            "num": 478
        },

        {
            "score": 244,
            "ranking": 379835,
            "num": 451
        },

        {
            "score": 243,
            "ranking": 380253,
            "num": 418
        },

        {
            "score": 242,
            "ranking": 380731,
            "num": 478
        },

        {
            "score": 241,
            "ranking": 381206,
            "num": 475
        },

        {
            "score": 240,
            "ranking": 381674,
            "num": 468
        },

        {
            "score": 239,
            "ranking": 382099,
            "num": 425
        },

        {
            "score": 238,
            "ranking": 382495,
            "num": 396
        },

        {
            "score": 237,
            "ranking": 382891,
            "num": 396
        },

        {
            "score": 236,
            "ranking": 383314,
            "num": 423
        },

        {
            "score": 235,
            "ranking": 383730,
            "num": 416
        },

        {
            "score": 234,
            "ranking": 384126,
            "num": 396
        },

        {
            "score": 233,
            "ranking": 384549,
            "num": 423
        },

        {
            "score": 232,
            "ranking": 384921,
            "num": 372
        },

        {
            "score": 231,
            "ranking": 385302,
            "num": 381
        },

        {
            "score": 230,
            "ranking": 385661,
            "num": 359
        },

        {
            "score": 229,
            "ranking": 386018,
            "num": 357
        },

        {
            "score": 228,
            "ranking": 386365,
            "num": 347
        },

        {
            "score": 227,
            "ranking": 386726,
            "num": 361
        },

        {
            "score": 226,
            "ranking": 387084,
            "num": 358
        },

        {
            "score": 225,
            "ranking": 387438,
            "num": 354
        },

        {
            "score": 224,
            "ranking": 387769,
            "num": 331
        },

        {
            "score": 223,
            "ranking": 388119,
            "num": 350
        },

        {
            "score": 222,
            "ranking": 388445,
            "num": 326
        },

        {
            "score": 221,
            "ranking": 388777,
            "num": 332
        },

        {
            "score": 220,
            "ranking": 389093,
            "num": 316
        },

        {
            "score": 219,
            "ranking": 389398,
            "num": 305
        },

        {
            "score": 218,
            "ranking": 389710,
            "num": 312
        },

        {
            "score": 217,
            "ranking": 390015,
            "num": 305
        },

        {
            "score": 216,
            "ranking": 390302,
            "num": 287
        },

        {
            "score": 215,
            "ranking": 390585,
            "num": 283
        },

        {
            "score": 214,
            "ranking": 390868,
            "num": 283
        },

        {
            "score": 213,
            "ranking": 391150,
            "num": 282
        },

        {
            "score": 212,
            "ranking": 391460,
            "num": 310
        },

        {
            "score": 211,
            "ranking": 391715,
            "num": 255
        },

        {
            "score": 210,
            "ranking": 391968,
            "num": 253
        },

        {
            "score": 209,
            "ranking": 392247,
            "num": 279
        },

        {
            "score": 208,
            "ranking": 392511,
            "num": 264
        },

        {
            "score": 207,
            "ranking": 392769,
            "num": 258
        },

        {
            "score": 206,
            "ranking": 392993,
            "num": 224
        },

        {
            "score": 205,
            "ranking": 393217,
            "num": 224
        },

        {
            "score": 204,
            "ranking": 393432,
            "num": 215
        },

        {
            "score": 203,
            "ranking": 393678,
            "num": 246
        },

        {
            "score": 202,
            "ranking": 393924,
            "num": 246
        },

        {
            "score": 201,
            "ranking": 394137,
            "num": 213
        },

        {
            "score": 200,
            "ranking": 394350,
            "num": 213
        },

        {
            "score": 199,
            "ranking": 394560,
            "num": 210
        },

        {
            "score": 198,
            "ranking": 394762,
            "num": 202
        },

        {
            "score": 197,
            "ranking": 394984,
            "num": 222
        },

        {
            "score": 196,
            "ranking": 395187,
            "num": 203
        },

        {
            "score": 195,
            "ranking": 395379,
            "num": 192
        },

        {
            "score": 194,
            "ranking": 395581,
            "num": 202
        },

        {
            "score": 193,
            "ranking": 395757,
            "num": 176
        },

        {
            "score": 192,
            "ranking": 395927,
            "num": 170
        },

        {
            "score": 191,
            "ranking": 396109,
            "num": 182
        },

        {
            "score": 190,
            "ranking": 396279,
            "num": 170
        },

        {
            "score": 189,
            "ranking": 396447,
            "num": 168
        },

        {
            "score": 188,
            "ranking": 396639,
            "num": 192
        },

        {
            "score": 187,
            "ranking": 396781,
            "num": 142
        },

        {
            "score": 186,
            "ranking": 396945,
            "num": 164
        },

        {
            "score": 185,
            "ranking": 397094,
            "num": 149
        },

        {
            "score": 184,
            "ranking": 397239,
            "num": 145
        },

        {
            "score": 183,
            "ranking": 397387,
            "num": 148
        },

        {
            "score": 182,
            "ranking": 397499,
            "num": 112
        },

        {
            "score": 181,
            "ranking": 397621,
            "num": 122
        },

        {
            "score": 180,
            "ranking": 397747,
            "num": 126
        },

        {
            "score": 179,
            "ranking": 397851,
            "num": 104
        },

        {
            "score": 178,
            "ranking": 397980,
            "num": 129
        },

        {
            "score": 177,
            "ranking": 398085,
            "num": 105
        },

        {
            "score": 176,
            "ranking": 398211,
            "num": 126
        },

        {
            "score": 175,
            "ranking": 398311,
            "num": 100
        },

        {
            "score": 174,
            "ranking": 398415,
            "num": 104
        },

        {
            "score": 173,
            "ranking": 398513,
            "num": 98
        },

        {
            "score": 172,
            "ranking": 398608,
            "num": 95
        },

        {
            "score": 171,
            "ranking": 398703,
            "num": 95
        },

        {
            "score": 170,
            "ranking": 398786,
            "num": 83
        },

        {
            "score": 169,
            "ranking": 398876,
            "num": 90
        },

        {
            "score": 168,
            "ranking": 398980,
            "num": 104
        },

        {
            "score": 167,
            "ranking": 399075,
            "num": 95
        },

        {
            "score": 166,
            "ranking": 399163,
            "num": 88
        },

        {
            "score": 165,
            "ranking": 399241,
            "num": 78
        },

        {
            "score": 164,
            "ranking": 399308,
            "num": 67
        },

        {
            "score": 163,
            "ranking": 399382,
            "num": 74
        },

        {
            "score": 162,
            "ranking": 399436,
            "num": 54
        },

        {
            "score": 161,
            "ranking": 399517,
            "num": 81
        },

        {
            "score": 160,
            "ranking": 399584,
            "num": 67
        },

        {
            "score": 159,
            "ranking": 399644,
            "num": 60
        },

        {
            "score": 158,
            "ranking": 399706,
            "num": 62
        },

        {
            "score": 157,
            "ranking": 399766,
            "num": 60
        },

        {
            "score": 156,
            "ranking": 399832,
            "num": 66
        },

        {
            "score": 155,
            "ranking": 399901,
            "num": 69
        },

        {
            "score": 154,
            "ranking": 399956,
            "num": 55
        },

        {
            "score": 153,
            "ranking": 400010,
            "num": 54
        },

        {
            "score": 152,
            "ranking": 400067,
            "num": 57
        },

        {
            "score": 151,
            "ranking": 400117,
            "num": 50
        },

        {
            "score": 150,
            "ranking": 400174,
            "num": 57
        },

        {
            "score": 149,
            "ranking": 400211,
            "num": 37
        },

        {
            "score": 148,
            "ranking": 400258,
            "num": 47
        },

        {
            "score": 147,
            "ranking": 400298,
            "num": 40
        },

        {
            "score": 146,
            "ranking": 400343,
            "num": 45
        },

        {
            "score": 145,
            "ranking": 400377,
            "num": 34
        },

        {
            "score": 144,
            "ranking": 400407,
            "num": 30
        },

        {
            "score": 143,
            "ranking": 400436,
            "num": 29
        },

        {
            "score": 142,
            "ranking": 400463,
            "num": 27
        },

        {
            "score": 141,
            "ranking": 400495,
            "num": 32
        },

        {
            "score": 140,
            "ranking": 400537,
            "num": 42
        },

        {
            "score": 139,
            "ranking": 400565,
            "num": 28
        },

        {
            "score": 138,
            "ranking": 400596,
            "num": 31
        },

        {
            "score": 137,
            "ranking": 400618,
            "num": 22
        },

        {
            "score": 136,
            "ranking": 400644,
            "num": 26
        },

        {
            "score": 135,
            "ranking": 400665,
            "num": 21
        },

        {
            "score": 134,
            "ranking": 400698,
            "num": 33
        },

        {
            "score": 133,
            "ranking": 400719,
            "num": 21
        },

        {
            "score": 132,
            "ranking": 400748,
            "num": 29
        },

        {
            "score": 131,
            "ranking": 400767,
            "num": 19
        },

        {
            "score": 130,
            "ranking": 400788,
            "num": 21
        },

        {
            "score": 129,
            "ranking": 400808,
            "num": 20
        },

        {
            "score": 128,
            "ranking": 400824,
            "num": 16
        },

        {
            "score": 127,
            "ranking": 400845,
            "num": 21
        },

        {
            "score": 126,
            "ranking": 400870,
            "num": 25
        },

        {
            "score": 125,
            "ranking": 400888,
            "num": 18
        },

        {
            "score": 124,
            "ranking": 400900,
            "num": 12
        },

        {
            "score": 123,
            "ranking": 400911,
            "num": 11
        },

        {
            "score": 122,
            "ranking": 400932,
            "num": 21
        },

        {
            "score": 121,
            "ranking": 400949,
            "num": 17
        },

        {
            "score": 120,
            "ranking": 400970,
            "num": 21
        },

        {
            "score": 119,
            "ranking": 400983,
            "num": 13
        },

        {
            "score": 118,
            "ranking": 400988,
            "num": 5
        },

        {
            "score": 117,
            "ranking": 401003,
            "num": 15
        },

        {
            "score": 116,
            "ranking": 401010,
            "num": 7
        },

        {
            "score": 115,
            "ranking": 401018,
            "num": 8
        },

        {
            "score": 114,
            "ranking": 401026,
            "num": 8
        },

        {
            "score": 113,
            "ranking": 401037,
            "num": 11
        },

        {
            "score": 112,
            "ranking": 401045,
            "num": 8
        },

        {
            "score": 111,
            "ranking": 401053,
            "num": 8
        },

        {
            "score": 110,
            "ranking": 401063,
            "num": 10
        },

        {
            "score": 109,
            "ranking": 401071,
            "num": 8
        },

        {
            "score": 108,
            "ranking": 401081,
            "num": 10
        },

        {
            "score": 107,
            "ranking": 401089,
            "num": 8
        },

        {
            "score": 106,
            "ranking": 401098,
            "num": 9
        },

        {
            "score": 105,
            "ranking": 401107,
            "num": 9
        },

        {
            "score": 104,
            "ranking": 401112,
            "num": 5
        },

        {
            "score": 103,
            "ranking": 401120,
            "num": 8
        },

        {
            "score": 102,
            "ranking": 401125,
            "num": 5
        },

        {
            "score": 101,
            "ranking": 401135,
            "num": 10
        },

        {
            "score": 100,
            "ranking": 401141,
            "num": 6
        }
    ],
    2017: [
        {
            "score": 695,
            "ranking": 3,
            "num": 3
        },

        {
            "score": 694,
            "ranking": 4,
            "num": 1
        },

        {
            "score": 692,
            "ranking": 5,
            "num": 1
        },

        {
            "score": 691,
            "ranking": 6,
            "num": 1
        },

        {
            "score": 690,
            "ranking": 7,
            "num": 1
        },

        {
            "score": 689,
            "ranking": 8,
            "num": 1
        },

        {
            "score": 688,
            "ranking": 10,
            "num": 2
        },

        {
            "score": 686,
            "ranking": 11,
            "num": 1
        },

        {
            "score": 685,
            "ranking": 14,
            "num": 3
        },

        {
            "score": 683,
            "ranking": 15,
            "num": 1
        },

        {
            "score": 682,
            "ranking": 20,
            "num": 5
        },

        {
            "score": 681,
            "ranking": 22,
            "num": 2
        },

        {
            "score": 680,
            "ranking": 28,
            "num": 6
        },

        {
            "score": 679,
            "ranking": 37,
            "num": 9
        },

        {
            "score": 678,
            "ranking": 44,
            "num": 7
        },

        {
            "score": 677,
            "ranking": 52,
            "num": 8
        },

        {
            "score": 676,
            "ranking": 60,
            "num": 8
        },

        {
            "score": 675,
            "ranking": 71,
            "num": 11
        },

        {
            "score": 674,
            "ranking": 79,
            "num": 8
        },

        {
            "score": 673,
            "ranking": 89,
            "num": 10
        },

        {
            "score": 672,
            "ranking": 103,
            "num": 14
        },

        {
            "score": 671,
            "ranking": 112,
            "num": 9
        },

        {
            "score": 670,
            "ranking": 125,
            "num": 13
        },

        {
            "score": 669,
            "ranking": 138,
            "num": 13
        },

        {
            "score": 668,
            "ranking": 149,
            "num": 11
        },

        {
            "score": 667,
            "ranking": 164,
            "num": 15
        },

        {
            "score": 666,
            "ranking": 181,
            "num": 17
        },

        {
            "score": 665,
            "ranking": 206,
            "num": 25
        },

        {
            "score": 664,
            "ranking": 220,
            "num": 14
        },

        {
            "score": 663,
            "ranking": 234,
            "num": 14
        },

        {
            "score": 662,
            "ranking": 252,
            "num": 18
        },

        {
            "score": 661,
            "ranking": 277,
            "num": 25
        },

        {
            "score": 660,
            "ranking": 298,
            "num": 21
        },

        {
            "score": 659,
            "ranking": 313,
            "num": 15
        },

        {
            "score": 658,
            "ranking": 336,
            "num": 23
        },

        {
            "score": 657,
            "ranking": 377,
            "num": 41
        },

        {
            "score": 656,
            "ranking": 417,
            "num": 40
        },

        {
            "score": 655,
            "ranking": 447,
            "num": 30
        },

        {
            "score": 654,
            "ranking": 485,
            "num": 38
        },

        {
            "score": 653,
            "ranking": 526,
            "num": 41
        },

        {
            "score": 652,
            "ranking": 561,
            "num": 35
        },

        {
            "score": 651,
            "ranking": 599,
            "num": 38
        },

        {
            "score": 650,
            "ranking": 641,
            "num": 42
        },

        {
            "score": 649,
            "ranking": 687,
            "num": 46
        },

        {
            "score": 648,
            "ranking": 730,
            "num": 43
        },

        {
            "score": 647,
            "ranking": 776,
            "num": 46
        },

        {
            "score": 646,
            "ranking": 834,
            "num": 58
        },

        {
            "score": 645,
            "ranking": 889,
            "num": 55
        },

        {
            "score": 644,
            "ranking": 947,
            "num": 58
        },

        {
            "score": 643,
            "ranking": 1004,
            "num": 57
        },

        {
            "score": 642,
            "ranking": 1052,
            "num": 48
        },

        {
            "score": 641,
            "ranking": 1118,
            "num": 66
        },

        {
            "score": 640,
            "ranking": 1190,
            "num": 72
        },

        {
            "score": 639,
            "ranking": 1263,
            "num": 73
        },

        {
            "score": 638,
            "ranking": 1336,
            "num": 73
        },

        {
            "score": 637,
            "ranking": 1417,
            "num": 81
        },

        {
            "score": 636,
            "ranking": 1497,
            "num": 80
        },

        {
            "score": 635,
            "ranking": 1581,
            "num": 84
        },

        {
            "score": 634,
            "ranking": 1684,
            "num": 103
        },

        {
            "score": 633,
            "ranking": 1754,
            "num": 70
        },

        {
            "score": 632,
            "ranking": 1837,
            "num": 83
        },

        {
            "score": 631,
            "ranking": 1932,
            "num": 95
        },

        {
            "score": 630,
            "ranking": 2030,
            "num": 98
        },

        {
            "score": 629,
            "ranking": 2139,
            "num": 109
        },

        {
            "score": 628,
            "ranking": 2237,
            "num": 98
        },

        {
            "score": 627,
            "ranking": 2358,
            "num": 121
        },

        {
            "score": 626,
            "ranking": 2491,
            "num": 133
        },

        {
            "score": 625,
            "ranking": 2627,
            "num": 136
        },

        {
            "score": 624,
            "ranking": 2767,
            "num": 140
        },

        {
            "score": 623,
            "ranking": 2886,
            "num": 119
        },

        {
            "score": 622,
            "ranking": 3028,
            "num": 142
        },

        {
            "score": 621,
            "ranking": 3150,
            "num": 122
        },

        {
            "score": 620,
            "ranking": 3272,
            "num": 122
        },

        {
            "score": 619,
            "ranking": 3420,
            "num": 148
        },

        {
            "score": 618,
            "ranking": 3561,
            "num": 141
        },

        {
            "score": 617,
            "ranking": 3720,
            "num": 159
        },

        {
            "score": 616,
            "ranking": 3873,
            "num": 153
        },

        {
            "score": 615,
            "ranking": 4032,
            "num": 159
        },

        {
            "score": 614,
            "ranking": 4187,
            "num": 155
        },

        {
            "score": 613,
            "ranking": 4346,
            "num": 159
        },

        {
            "score": 612,
            "ranking": 4523,
            "num": 177
        },

        {
            "score": 611,
            "ranking": 4722,
            "num": 199
        },

        {
            "score": 610,
            "ranking": 4917,
            "num": 195
        },

        {
            "score": 609,
            "ranking": 5119,
            "num": 202
        },

        {
            "score": 608,
            "ranking": 5299,
            "num": 180
        },

        {
            "score": 607,
            "ranking": 5489,
            "num": 190
        },

        {
            "score": 606,
            "ranking": 5717,
            "num": 228
        },

        {
            "score": 605,
            "ranking": 5925,
            "num": 208
        },

        {
            "score": 604,
            "ranking": 6157,
            "num": 232
        },

        {
            "score": 603,
            "ranking": 6409,
            "num": 252
        },

        {
            "score": 602,
            "ranking": 6655,
            "num": 246
        },

        {
            "score": 601,
            "ranking": 6906,
            "num": 251
        },

        {
            "score": 600,
            "ranking": 7147,
            "num": 241
        },

        {
            "score": 599,
            "ranking": 7408,
            "num": 261
        },

        {
            "score": 598,
            "ranking": 7688,
            "num": 280
        },

        {
            "score": 597,
            "ranking": 7970,
            "num": 282
        },

        {
            "score": 596,
            "ranking": 8250,
            "num": 280
        },

        {
            "score": 595,
            "ranking": 8526,
            "num": 276
        },

        {
            "score": 594,
            "ranking": 8813,
            "num": 287
        },

        {
            "score": 593,
            "ranking": 9098,
            "num": 285
        },

        {
            "score": 592,
            "ranking": 9372,
            "num": 274
        },

        {
            "score": 591,
            "ranking": 9687,
            "num": 315
        },

        {
            "score": 590,
            "ranking": 9994,
            "num": 307
        },

        {
            "score": 589,
            "ranking": 10306,
            "num": 312
        },

        {
            "score": 588,
            "ranking": 10654,
            "num": 348
        },

        {
            "score": 587,
            "ranking": 10979,
            "num": 325
        },

        {
            "score": 586,
            "ranking": 11306,
            "num": 327
        },

        {
            "score": 585,
            "ranking": 11681,
            "num": 375
        },

        {
            "score": 584,
            "ranking": 12032,
            "num": 351
        },

        {
            "score": 583,
            "ranking": 12392,
            "num": 360
        },

        {
            "score": 582,
            "ranking": 12774,
            "num": 382
        },

        {
            "score": 581,
            "ranking": 13161,
            "num": 387
        },

        {
            "score": 580,
            "ranking": 13549,
            "num": 388
        },

        {
            "score": 579,
            "ranking": 13936,
            "num": 387
        },

        {
            "score": 578,
            "ranking": 14358,
            "num": 422
        },

        {
            "score": 577,
            "ranking": 14743,
            "num": 385
        },

        {
            "score": 576,
            "ranking": 15197,
            "num": 454
        },

        {
            "score": 575,
            "ranking": 15587,
            "num": 390
        },

        {
            "score": 574,
            "ranking": 16049,
            "num": 462
        },

        {
            "score": 573,
            "ranking": 16479,
            "num": 430
        },

        {
            "score": 572,
            "ranking": 16897,
            "num": 418
        },

        {
            "score": 571,
            "ranking": 17352,
            "num": 455
        },

        {
            "score": 570,
            "ranking": 17781,
            "num": 429
        },

        {
            "score": 569,
            "ranking": 18265,
            "num": 484
        },

        {
            "score": 568,
            "ranking": 18740,
            "num": 475
        },

        {
            "score": 567,
            "ranking": 19244,
            "num": 504
        },

        {
            "score": 566,
            "ranking": 19731,
            "num": 487
        },

        {
            "score": 565,
            "ranking": 20210,
            "num": 479
        },

        {
            "score": 564,
            "ranking": 20716,
            "num": 506
        },

        {
            "score": 563,
            "ranking": 21190,
            "num": 474
        },

        {
            "score": 562,
            "ranking": 21699,
            "num": 509
        },

        {
            "score": 561,
            "ranking": 22210,
            "num": 511
        },

        {
            "score": 560,
            "ranking": 22754,
            "num": 544
        },

        {
            "score": 559,
            "ranking": 23318,
            "num": 564
        },

        {
            "score": 558,
            "ranking": 23848,
            "num": 530
        },

        {
            "score": 557,
            "ranking": 24410,
            "num": 562
        },

        {
            "score": 556,
            "ranking": 25007,
            "num": 597
        },

        {
            "score": 555,
            "ranking": 25533,
            "num": 526
        },

        {
            "score": 554,
            "ranking": 26093,
            "num": 560
        },

        {
            "score": 553,
            "ranking": 26681,
            "num": 588
        },

        {
            "score": 552,
            "ranking": 27258,
            "num": 577
        },

        {
            "score": 551,
            "ranking": 27863,
            "num": 605
        },

        {
            "score": 550,
            "ranking": 28512,
            "num": 649
        },

        {
            "score": 549,
            "ranking": 29156,
            "num": 644
        },

        {
            "score": 548,
            "ranking": 29805,
            "num": 649
        },

        {
            "score": 547,
            "ranking": 30474,
            "num": 669
        },

        {
            "score": 546,
            "ranking": 31135,
            "num": 661
        },

        {
            "score": 545,
            "ranking": 31818,
            "num": 683
        },

        {
            "score": 544,
            "ranking": 32478,
            "num": 660
        },

        {
            "score": 543,
            "ranking": 33135,
            "num": 657
        },

        {
            "score": 542,
            "ranking": 33844,
            "num": 709
        },

        {
            "score": 541,
            "ranking": 34502,
            "num": 658
        },

        {
            "score": 540,
            "ranking": 35233,
            "num": 731
        },

        {
            "score": 539,
            "ranking": 35870,
            "num": 637
        },

        {
            "score": 538,
            "ranking": 36597,
            "num": 727
        },

        {
            "score": 537,
            "ranking": 37276,
            "num": 679
        },

        {
            "score": 536,
            "ranking": 38034,
            "num": 758
        },

        {
            "score": 535,
            "ranking": 38770,
            "num": 736
        },

        {
            "score": 534,
            "ranking": 39472,
            "num": 702
        },

        {
            "score": 533,
            "ranking": 40222,
            "num": 750
        },

        {
            "score": 532,
            "ranking": 41026,
            "num": 804
        },

        {
            "score": 531,
            "ranking": 41790,
            "num": 764
        },

        {
            "score": 530,
            "ranking": 42570,
            "num": 780
        },

        {
            "score": 529,
            "ranking": 43306,
            "num": 736
        },

        {
            "score": 528,
            "ranking": 44062,
            "num": 756
        },

        {
            "score": 527,
            "ranking": 44856,
            "num": 794
        },

        {
            "score": 526,
            "ranking": 45681,
            "num": 825
        },

        {
            "score": 525,
            "ranking": 46474,
            "num": 793
        },

        {
            "score": 524,
            "ranking": 47284,
            "num": 810
        },

        {
            "score": 523,
            "ranking": 48116,
            "num": 832
        },

        {
            "score": 522,
            "ranking": 48911,
            "num": 795
        },

        {
            "score": 521,
            "ranking": 49710,
            "num": 799
        },

        {
            "score": 520,
            "ranking": 50536,
            "num": 826
        },

        {
            "score": 519,
            "ranking": 51363,
            "num": 827
        },

        {
            "score": 518,
            "ranking": 52168,
            "num": 805
        },

        {
            "score": 517,
            "ranking": 52986,
            "num": 818
        },

        {
            "score": 516,
            "ranking": 53804,
            "num": 818
        },

        {
            "score": 515,
            "ranking": 54663,
            "num": 859
        },

        {
            "score": 514,
            "ranking": 55546,
            "num": 883
        },

        {
            "score": 513,
            "ranking": 56437,
            "num": 891
        },

        {
            "score": 512,
            "ranking": 57297,
            "num": 860
        },

        {
            "score": 511,
            "ranking": 58183,
            "num": 886
        },

        {
            "score": 510,
            "ranking": 59092,
            "num": 909
        },

        {
            "score": 509,
            "ranking": 59993,
            "num": 901
        },

        {
            "score": 508,
            "ranking": 60944,
            "num": 951
        },

        {
            "score": 507,
            "ranking": 61855,
            "num": 911
        },

        {
            "score": 506,
            "ranking": 62794,
            "num": 939
        },

        {
            "score": 505,
            "ranking": 63722,
            "num": 928
        },

        {
            "score": 504,
            "ranking": 64674,
            "num": 952
        },

        {
            "score": 503,
            "ranking": 65637,
            "num": 963
        },

        {
            "score": 502,
            "ranking": 66578,
            "num": 941
        },

        {
            "score": 501,
            "ranking": 67539,
            "num": 961
        },

        {
            "score": 500,
            "ranking": 68464,
            "num": 925
        },

        {
            "score": 499,
            "ranking": 69405,
            "num": 941
        },

        {
            "score": 498,
            "ranking": 70430,
            "num": 1025
        },

        {
            "score": 497,
            "ranking": 71482,
            "num": 1052
        },

        {
            "score": 496,
            "ranking": 72457,
            "num": 975
        },

        {
            "score": 495,
            "ranking": 73470,
            "num": 1013
        },

        {
            "score": 494,
            "ranking": 74478,
            "num": 1008
        },

        {
            "score": 493,
            "ranking": 75509,
            "num": 1031
        },

        {
            "score": 492,
            "ranking": 76579,
            "num": 1070
        },

        {
            "score": 491,
            "ranking": 77638,
            "num": 1059
        },

        {
            "score": 490,
            "ranking": 78633,
            "num": 995
        },

        {
            "score": 489,
            "ranking": 79696,
            "num": 1063
        },

        {
            "score": 488,
            "ranking": 80816,
            "num": 1120
        },

        {
            "score": 487,
            "ranking": 81919,
            "num": 1103
        },

        {
            "score": 486,
            "ranking": 83016,
            "num": 1097
        },

        {
            "score": 485,
            "ranking": 84084,
            "num": 1068
        },

        {
            "score": 484,
            "ranking": 85142,
            "num": 1058
        },

        {
            "score": 483,
            "ranking": 86229,
            "num": 1087
        },

        {
            "score": 482,
            "ranking": 87270,
            "num": 1041
        },

        {
            "score": 481,
            "ranking": 88395,
            "num": 1125
        },

        {
            "score": 480,
            "ranking": 89544,
            "num": 1149
        },

        {
            "score": 479,
            "ranking": 90665,
            "num": 1121
        },

        {
            "score": 478,
            "ranking": 91807,
            "num": 1142
        },

        {
            "score": 477,
            "ranking": 92959,
            "num": 1152
        },

        {
            "score": 476,
            "ranking": 94127,
            "num": 1168
        },

        {
            "score": 475,
            "ranking": 95249,
            "num": 1122
        },

        {
            "score": 474,
            "ranking": 96438,
            "num": 1189
        },

        {
            "score": 473,
            "ranking": 97599,
            "num": 1161
        },

        {
            "score": 472,
            "ranking": 98741,
            "num": 1142
        },

        {
            "score": 471,
            "ranking": 99938,
            "num": 1197
        },

        {
            "score": 470,
            "ranking": 101077,
            "num": 1139
        },

        {
            "score": 469,
            "ranking": 102355,
            "num": 1278
        },

        {
            "score": 468,
            "ranking": 103612,
            "num": 1257
        },

        {
            "score": 467,
            "ranking": 104754,
            "num": 1142
        },

        {
            "score": 466,
            "ranking": 105972,
            "num": 1218
        },

        {
            "score": 465,
            "ranking": 107188,
            "num": 1216
        },

        {
            "score": 464,
            "ranking": 108360,
            "num": 1172
        },

        {
            "score": 463,
            "ranking": 109551,
            "num": 1191
        },

        {
            "score": 462,
            "ranking": 110810,
            "num": 1259
        },

        {
            "score": 461,
            "ranking": 112073,
            "num": 1263
        },

        {
            "score": 460,
            "ranking": 113302,
            "num": 1229
        },

        {
            "score": 459,
            "ranking": 114586,
            "num": 1284
        },

        {
            "score": 458,
            "ranking": 115820,
            "num": 1234
        },

        {
            "score": 457,
            "ranking": 116990,
            "num": 1170
        },

        {
            "score": 456,
            "ranking": 118247,
            "num": 1257
        },

        {
            "score": 455,
            "ranking": 119499,
            "num": 1252
        },

        {
            "score": 454,
            "ranking": 120745,
            "num": 1246
        },

        {
            "score": 453,
            "ranking": 121994,
            "num": 1249
        },

        {
            "score": 452,
            "ranking": 123240,
            "num": 1246
        },

        {
            "score": 451,
            "ranking": 124488,
            "num": 1248
        },

        {
            "score": 450,
            "ranking": 125749,
            "num": 1261
        },

        {
            "score": 449,
            "ranking": 127030,
            "num": 1281
        },

        {
            "score": 448,
            "ranking": 128280,
            "num": 1250
        },

        {
            "score": 447,
            "ranking": 129580,
            "num": 1300
        },

        {
            "score": 446,
            "ranking": 130905,
            "num": 1325
        },

        {
            "score": 445,
            "ranking": 132176,
            "num": 1271
        },

        {
            "score": 444,
            "ranking": 133484,
            "num": 1308
        },

        {
            "score": 443,
            "ranking": 134821,
            "num": 1337
        },

        {
            "score": 442,
            "ranking": 136154,
            "num": 1333
        },

        {
            "score": 441,
            "ranking": 137486,
            "num": 1332
        },

        {
            "score": 440,
            "ranking": 138797,
            "num": 1311
        },

        {
            "score": 439,
            "ranking": 140090,
            "num": 1293
        },

        {
            "score": 438,
            "ranking": 141401,
            "num": 1311
        },

        {
            "score": 437,
            "ranking": 142717,
            "num": 1316
        },

        {
            "score": 436,
            "ranking": 144009,
            "num": 1292
        },

        {
            "score": 435,
            "ranking": 145330,
            "num": 1321
        },

        {
            "score": 434,
            "ranking": 146666,
            "num": 1336
        },

        {
            "score": 433,
            "ranking": 147954,
            "num": 1288
        },

        {
            "score": 432,
            "ranking": 149264,
            "num": 1310
        },

        {
            "score": 431,
            "ranking": 150662,
            "num": 1398
        },

        {
            "score": 430,
            "ranking": 152038,
            "num": 1376
        },

        {
            "score": 429,
            "ranking": 153391,
            "num": 1353
        },

        {
            "score": 428,
            "ranking": 154750,
            "num": 1359
        },

        {
            "score": 427,
            "ranking": 156110,
            "num": 1360
        },

        {
            "score": 426,
            "ranking": 157415,
            "num": 1305
        },

        {
            "score": 425,
            "ranking": 158692,
            "num": 1277
        },

        {
            "score": 424,
            "ranking": 160061,
            "num": 1369
        },

        {
            "score": 423,
            "ranking": 161415,
            "num": 1354
        },

        {
            "score": 422,
            "ranking": 162718,
            "num": 1303
        },

        {
            "score": 421,
            "ranking": 164009,
            "num": 1291
        },

        {
            "score": 420,
            "ranking": 165297,
            "num": 1288
        },

        {
            "score": 419,
            "ranking": 166587,
            "num": 1290
        },

        {
            "score": 418,
            "ranking": 167915,
            "num": 1328
        },

        {
            "score": 417,
            "ranking": 169165,
            "num": 1250
        },

        {
            "score": 416,
            "ranking": 170472,
            "num": 1307
        },

        {
            "score": 415,
            "ranking": 171775,
            "num": 1303
        },

        {
            "score": 414,
            "ranking": 173111,
            "num": 1336
        },

        {
            "score": 413,
            "ranking": 174435,
            "num": 1324
        },

        {
            "score": 412,
            "ranking": 175678,
            "num": 1243
        },

        {
            "score": 411,
            "ranking": 176960,
            "num": 1282
        },

        {
            "score": 410,
            "ranking": 178298,
            "num": 1338
        },

        {
            "score": 409,
            "ranking": 179649,
            "num": 1351
        },

        {
            "score": 408,
            "ranking": 180995,
            "num": 1346
        },

        {
            "score": 407,
            "ranking": 182265,
            "num": 1270
        },

        {
            "score": 406,
            "ranking": 183594,
            "num": 1329
        },

        {
            "score": 405,
            "ranking": 184879,
            "num": 1285
        },

        {
            "score": 404,
            "ranking": 186140,
            "num": 1261
        },

        {
            "score": 403,
            "ranking": 187480,
            "num": 1340
        },

        {
            "score": 402,
            "ranking": 188865,
            "num": 1385
        },

        {
            "score": 401,
            "ranking": 190199,
            "num": 1334
        },

        {
            "score": 400,
            "ranking": 191494,
            "num": 1295
        },

        {
            "score": 399,
            "ranking": 192768,
            "num": 1274
        },

        {
            "score": 398,
            "ranking": 194034,
            "num": 1266
        },

        {
            "score": 397,
            "ranking": 195300,
            "num": 1266
        },

        {
            "score": 396,
            "ranking": 196567,
            "num": 1267
        },

        {
            "score": 395,
            "ranking": 197820,
            "num": 1253
        },

        {
            "score": 394,
            "ranking": 199075,
            "num": 1255
        },

        {
            "score": 393,
            "ranking": 200354,
            "num": 1279
        },

        {
            "score": 392,
            "ranking": 201626,
            "num": 1272
        },

        {
            "score": 391,
            "ranking": 202904,
            "num": 1278
        },

        {
            "score": 390,
            "ranking": 204233,
            "num": 1329
        },

        {
            "score": 389,
            "ranking": 205550,
            "num": 1317
        },

        {
            "score": 388,
            "ranking": 206754,
            "num": 1204
        },

        {
            "score": 387,
            "ranking": 208011,
            "num": 1257
        },

        {
            "score": 386,
            "ranking": 209343,
            "num": 1332
        },

        {
            "score": 385,
            "ranking": 210636,
            "num": 1293
        },

        {
            "score": 384,
            "ranking": 211839,
            "num": 1203
        },

        {
            "score": 383,
            "ranking": 213090,
            "num": 1251
        },

        {
            "score": 382,
            "ranking": 214356,
            "num": 1266
        },

        {
            "score": 381,
            "ranking": 215567,
            "num": 1211
        },

        {
            "score": 380,
            "ranking": 216850,
            "num": 1283
        },

        {
            "score": 379,
            "ranking": 218091,
            "num": 1241
        },

        {
            "score": 378,
            "ranking": 219274,
            "num": 1183
        },

        {
            "score": 377,
            "ranking": 220481,
            "num": 1207
        },

        {
            "score": 376,
            "ranking": 221686,
            "num": 1205
        },

        {
            "score": 375,
            "ranking": 222903,
            "num": 1217
        },

        {
            "score": 374,
            "ranking": 224167,
            "num": 1264
        },

        {
            "score": 373,
            "ranking": 225425,
            "num": 1258
        },

        {
            "score": 372,
            "ranking": 226678,
            "num": 1253
        },

        {
            "score": 371,
            "ranking": 227874,
            "num": 1196
        },

        {
            "score": 370,
            "ranking": 229133,
            "num": 1259
        },

        {
            "score": 369,
            "ranking": 230381,
            "num": 1248
        },

        {
            "score": 368,
            "ranking": 231585,
            "num": 1204
        },

        {
            "score": 367,
            "ranking": 232766,
            "num": 1181
        },

        {
            "score": 366,
            "ranking": 234011,
            "num": 1245
        },

        {
            "score": 365,
            "ranking": 235169,
            "num": 1158
        },

        {
            "score": 364,
            "ranking": 236337,
            "num": 1168
        },

        {
            "score": 363,
            "ranking": 237432,
            "num": 1095
        },

        {
            "score": 362,
            "ranking": 238587,
            "num": 1155
        },

        {
            "score": 361,
            "ranking": 239708,
            "num": 1121
        },

        {
            "score": 360,
            "ranking": 240880,
            "num": 1172
        },

        {
            "score": 359,
            "ranking": 241986,
            "num": 1106
        },

        {
            "score": 358,
            "ranking": 243098,
            "num": 1112
        },

        {
            "score": 357,
            "ranking": 244261,
            "num": 1163
        },

        {
            "score": 356,
            "ranking": 245509,
            "num": 1248
        },

        {
            "score": 355,
            "ranking": 246709,
            "num": 1200
        },

        {
            "score": 354,
            "ranking": 247811,
            "num": 1102
        },

        {
            "score": 353,
            "ranking": 248971,
            "num": 1160
        },

        {
            "score": 352,
            "ranking": 250171,
            "num": 1200
        },

        {
            "score": 351,
            "ranking": 251349,
            "num": 1178
        },

        {
            "score": 350,
            "ranking": 252432,
            "num": 1083
        },

        {
            "score": 349,
            "ranking": 253600,
            "num": 1168
        },

        {
            "score": 348,
            "ranking": 254687,
            "num": 1087
        },

        {
            "score": 347,
            "ranking": 255748,
            "num": 1061
        },

        {
            "score": 346,
            "ranking": 256856,
            "num": 1108
        },

        {
            "score": 345,
            "ranking": 257985,
            "num": 1129
        },

        {
            "score": 344,
            "ranking": 259120,
            "num": 1135
        },

        {
            "score": 343,
            "ranking": 260180,
            "num": 1060
        },

        {
            "score": 342,
            "ranking": 261217,
            "num": 1037
        },

        {
            "score": 341,
            "ranking": 262335,
            "num": 1118
        },

        {
            "score": 340,
            "ranking": 263416,
            "num": 1081
        },

        {
            "score": 339,
            "ranking": 264512,
            "num": 1096
        },

        {
            "score": 338,
            "ranking": 265561,
            "num": 1049
        },

        {
            "score": 337,
            "ranking": 266605,
            "num": 1044
        },

        {
            "score": 336,
            "ranking": 267604,
            "num": 999
        },

        {
            "score": 335,
            "ranking": 268657,
            "num": 1053
        },

        {
            "score": 334,
            "ranking": 269734,
            "num": 1077
        },

        {
            "score": 333,
            "ranking": 270796,
            "num": 1062
        },

        {
            "score": 332,
            "ranking": 271808,
            "num": 1012
        },

        {
            "score": 331,
            "ranking": 272799,
            "num": 991
        },

        {
            "score": 330,
            "ranking": 273856,
            "num": 1057
        },

        {
            "score": 329,
            "ranking": 274954,
            "num": 1098
        },

        {
            "score": 328,
            "ranking": 276010,
            "num": 1056
        },

        {
            "score": 327,
            "ranking": 276989,
            "num": 979
        },

        {
            "score": 326,
            "ranking": 278034,
            "num": 1045
        },

        {
            "score": 325,
            "ranking": 278994,
            "num": 960
        },

        {
            "score": 324,
            "ranking": 280007,
            "num": 1013
        },

        {
            "score": 323,
            "ranking": 280995,
            "num": 988
        },

        {
            "score": 322,
            "ranking": 281999,
            "num": 1004
        },

        {
            "score": 321,
            "ranking": 282991,
            "num": 992
        },

        {
            "score": 320,
            "ranking": 284005,
            "num": 1014
        },

        {
            "score": 319,
            "ranking": 284974,
            "num": 969
        },

        {
            "score": 318,
            "ranking": 285935,
            "num": 961
        },

        {
            "score": 317,
            "ranking": 286916,
            "num": 981
        },

        {
            "score": 316,
            "ranking": 287885,
            "num": 969
        },

        {
            "score": 315,
            "ranking": 288813,
            "num": 928
        },

        {
            "score": 314,
            "ranking": 289774,
            "num": 961
        },

        {
            "score": 313,
            "ranking": 290661,
            "num": 887
        },

        {
            "score": 312,
            "ranking": 291650,
            "num": 989
        },

        {
            "score": 311,
            "ranking": 292614,
            "num": 964
        },

        {
            "score": 310,
            "ranking": 293562,
            "num": 948
        },

        {
            "score": 309,
            "ranking": 294453,
            "num": 891
        },

        {
            "score": 308,
            "ranking": 295376,
            "num": 923
        },

        {
            "score": 307,
            "ranking": 296273,
            "num": 897
        },

        {
            "score": 306,
            "ranking": 297161,
            "num": 888
        },

        {
            "score": 305,
            "ranking": 298077,
            "num": 916
        },

        {
            "score": 304,
            "ranking": 299016,
            "num": 939
        },

        {
            "score": 303,
            "ranking": 299942,
            "num": 926
        },

        {
            "score": 302,
            "ranking": 300892,
            "num": 950
        },

        {
            "score": 301,
            "ranking": 301799,
            "num": 907
        },

        {
            "score": 300,
            "ranking": 302681,
            "num": 882
        },

        {
            "score": 299,
            "ranking": 303591,
            "num": 910
        },

        {
            "score": 298,
            "ranking": 304408,
            "num": 817
        },

        {
            "score": 297,
            "ranking": 305273,
            "num": 865
        },

        {
            "score": 296,
            "ranking": 306115,
            "num": 842
        },

        {
            "score": 295,
            "ranking": 306988,
            "num": 873
        },

        {
            "score": 294,
            "ranking": 307836,
            "num": 848
        },

        {
            "score": 293,
            "ranking": 308741,
            "num": 905
        },

        {
            "score": 292,
            "ranking": 309597,
            "num": 856
        },

        {
            "score": 291,
            "ranking": 310484,
            "num": 887
        },

        {
            "score": 290,
            "ranking": 311344,
            "num": 860
        },

        {
            "score": 289,
            "ranking": 312162,
            "num": 818
        },

        {
            "score": 288,
            "ranking": 312988,
            "num": 826
        },

        {
            "score": 287,
            "ranking": 313824,
            "num": 836
        },

        {
            "score": 286,
            "ranking": 314656,
            "num": 832
        },

        {
            "score": 285,
            "ranking": 315474,
            "num": 818
        },

        {
            "score": 284,
            "ranking": 316293,
            "num": 819
        },

        {
            "score": 283,
            "ranking": 317087,
            "num": 794
        },

        {
            "score": 282,
            "ranking": 317885,
            "num": 798
        },

        {
            "score": 281,
            "ranking": 318693,
            "num": 808
        },

        {
            "score": 280,
            "ranking": 319452,
            "num": 759
        },

        {
            "score": 279,
            "ranking": 320214,
            "num": 762
        },

        {
            "score": 278,
            "ranking": 320991,
            "num": 777
        },

        {
            "score": 277,
            "ranking": 321743,
            "num": 752
        },

        {
            "score": 276,
            "ranking": 322479,
            "num": 736
        },

        {
            "score": 275,
            "ranking": 323259,
            "num": 780
        },

        {
            "score": 274,
            "ranking": 323982,
            "num": 723
        },

        {
            "score": 273,
            "ranking": 324746,
            "num": 764
        },

        {
            "score": 272,
            "ranking": 325453,
            "num": 707
        },

        {
            "score": 271,
            "ranking": 326189,
            "num": 736
        },

        {
            "score": 270,
            "ranking": 326904,
            "num": 715
        },

        {
            "score": 269,
            "ranking": 327610,
            "num": 706
        },

        {
            "score": 268,
            "ranking": 328306,
            "num": 696
        },

        {
            "score": 267,
            "ranking": 329021,
            "num": 715
        },

        {
            "score": 266,
            "ranking": 329682,
            "num": 661
        },

        {
            "score": 265,
            "ranking": 330387,
            "num": 705
        },

        {
            "score": 264,
            "ranking": 331068,
            "num": 681
        },

        {
            "score": 263,
            "ranking": 331809,
            "num": 741
        },

        {
            "score": 262,
            "ranking": 332535,
            "num": 726
        },

        {
            "score": 261,
            "ranking": 333174,
            "num": 639
        },

        {
            "score": 260,
            "ranking": 333795,
            "num": 621
        },

        {
            "score": 259,
            "ranking": 334501,
            "num": 706
        },

        {
            "score": 258,
            "ranking": 335123,
            "num": 622
        },

        {
            "score": 257,
            "ranking": 335758,
            "num": 635
        },

        {
            "score": 256,
            "ranking": 336441,
            "num": 683
        },

        {
            "score": 255,
            "ranking": 337102,
            "num": 661
        },

        {
            "score": 254,
            "ranking": 337721,
            "num": 619
        },

        {
            "score": 253,
            "ranking": 338355,
            "num": 634
        },

        {
            "score": 252,
            "ranking": 338994,
            "num": 639
        },

        {
            "score": 251,
            "ranking": 339634,
            "num": 640
        },

        {
            "score": 250,
            "ranking": 340251,
            "num": 617
        },

        {
            "score": 249,
            "ranking": 340876,
            "num": 625
        },

        {
            "score": 248,
            "ranking": 341509,
            "num": 633
        },

        {
            "score": 247,
            "ranking": 342121,
            "num": 612
        },

        {
            "score": 246,
            "ranking": 342690,
            "num": 569
        },

        {
            "score": 245,
            "ranking": 343286,
            "num": 596
        },

        {
            "score": 244,
            "ranking": 343852,
            "num": 566
        },

        {
            "score": 243,
            "ranking": 344414,
            "num": 562
        },

        {
            "score": 242,
            "ranking": 344984,
            "num": 570
        },

        {
            "score": 241,
            "ranking": 345559,
            "num": 575
        },

        {
            "score": 240,
            "ranking": 346102,
            "num": 543
        },

        {
            "score": 239,
            "ranking": 346612,
            "num": 510
        },

        {
            "score": 238,
            "ranking": 347123,
            "num": 511
        },

        {
            "score": 237,
            "ranking": 347662,
            "num": 539
        },

        {
            "score": 236,
            "ranking": 348216,
            "num": 554
        },

        {
            "score": 235,
            "ranking": 348736,
            "num": 520
        },

        {
            "score": 234,
            "ranking": 349213,
            "num": 477
        },

        {
            "score": 233,
            "ranking": 349722,
            "num": 509
        },

        {
            "score": 232,
            "ranking": 350234,
            "num": 512
        },

        {
            "score": 231,
            "ranking": 350763,
            "num": 529
        },

        {
            "score": 230,
            "ranking": 351265,
            "num": 502
        },

        {
            "score": 229,
            "ranking": 351701,
            "num": 436
        },

        {
            "score": 228,
            "ranking": 352170,
            "num": 469
        },

        {
            "score": 227,
            "ranking": 352659,
            "num": 489
        },

        {
            "score": 226,
            "ranking": 353118,
            "num": 459
        },

        {
            "score": 225,
            "ranking": 353571,
            "num": 453
        },

        {
            "score": 224,
            "ranking": 354077,
            "num": 506
        },

        {
            "score": 223,
            "ranking": 354492,
            "num": 415
        },

        {
            "score": 222,
            "ranking": 354957,
            "num": 465
        },

        {
            "score": 221,
            "ranking": 355376,
            "num": 419
        },

        {
            "score": 220,
            "ranking": 355799,
            "num": 423
        },

        {
            "score": 219,
            "ranking": 356233,
            "num": 434
        },

        {
            "score": 218,
            "ranking": 356639,
            "num": 406
        },

        {
            "score": 217,
            "ranking": 357026,
            "num": 387
        },

        {
            "score": 216,
            "ranking": 357442,
            "num": 416
        },

        {
            "score": 215,
            "ranking": 357799,
            "num": 357
        },

        {
            "score": 214,
            "ranking": 358171,
            "num": 372
        },

        {
            "score": 213,
            "ranking": 358551,
            "num": 380
        },

        {
            "score": 212,
            "ranking": 358901,
            "num": 350
        },

        {
            "score": 211,
            "ranking": 359254,
            "num": 353
        },

        {
            "score": 210,
            "ranking": 359649,
            "num": 395
        },

        {
            "score": 209,
            "ranking": 360008,
            "num": 359
        },

        {
            "score": 208,
            "ranking": 360364,
            "num": 356
        },

        {
            "score": 207,
            "ranking": 360658,
            "num": 294
        },

        {
            "score": 206,
            "ranking": 360998,
            "num": 340
        },

        {
            "score": 205,
            "ranking": 361323,
            "num": 325
        },

        {
            "score": 204,
            "ranking": 361626,
            "num": 303
        },

        {
            "score": 203,
            "ranking": 361965,
            "num": 339
        },

        {
            "score": 202,
            "ranking": 362301,
            "num": 336
        },

        {
            "score": 201,
            "ranking": 362602,
            "num": 301
        },

        {
            "score": 200,
            "ranking": 362907,
            "num": 305
        },

        {
            "score": 199,
            "ranking": 363217,
            "num": 310
        },

        {
            "score": 198,
            "ranking": 363510,
            "num": 293
        },

        {
            "score": 197,
            "ranking": 363821,
            "num": 311
        },

        {
            "score": 196,
            "ranking": 364098,
            "num": 277
        },

        {
            "score": 195,
            "ranking": 364398,
            "num": 300
        },

        {
            "score": 194,
            "ranking": 364651,
            "num": 253
        },

        {
            "score": 193,
            "ranking": 364944,
            "num": 293
        },

        {
            "score": 192,
            "ranking": 365225,
            "num": 281
        },

        {
            "score": 191,
            "ranking": 365486,
            "num": 261
        },

        {
            "score": 190,
            "ranking": 365717,
            "num": 231
        },

        {
            "score": 189,
            "ranking": 365976,
            "num": 259
        },

        {
            "score": 188,
            "ranking": 366226,
            "num": 250
        },

        {
            "score": 187,
            "ranking": 366462,
            "num": 236
        },

        {
            "score": 186,
            "ranking": 366678,
            "num": 216
        },

        {
            "score": 185,
            "ranking": 366921,
            "num": 243
        },

        {
            "score": 184,
            "ranking": 367151,
            "num": 230
        },

        {
            "score": 183,
            "ranking": 367377,
            "num": 226
        },

        {
            "score": 182,
            "ranking": 367582,
            "num": 205
        },

        {
            "score": 181,
            "ranking": 367782,
            "num": 200
        },

        {
            "score": 180,
            "ranking": 367984,
            "num": 202
        },

        {
            "score": 179,
            "ranking": 368194,
            "num": 210
        },

        {
            "score": 178,
            "ranking": 368403,
            "num": 209
        },

        {
            "score": 177,
            "ranking": 368609,
            "num": 206
        },

        {
            "score": 176,
            "ranking": 368771,
            "num": 162
        },

        {
            "score": 175,
            "ranking": 368957,
            "num": 186
        },

        {
            "score": 174,
            "ranking": 369123,
            "num": 166
        },

        {
            "score": 173,
            "ranking": 369269,
            "num": 146
        },

        {
            "score": 172,
            "ranking": 369436,
            "num": 167
        },

        {
            "score": 171,
            "ranking": 369581,
            "num": 145
        },

        {
            "score": 170,
            "ranking": 369750,
            "num": 169
        },

        {
            "score": 169,
            "ranking": 369890,
            "num": 140
        },

        {
            "score": 168,
            "ranking": 370044,
            "num": 154
        },

        {
            "score": 167,
            "ranking": 370169,
            "num": 125
        },

        {
            "score": 166,
            "ranking": 370293,
            "num": 124
        },

        {
            "score": 165,
            "ranking": 370435,
            "num": 142
        },

        {
            "score": 164,
            "ranking": 370550,
            "num": 115
        },

        {
            "score": 163,
            "ranking": 370689,
            "num": 139
        },

        {
            "score": 162,
            "ranking": 370808,
            "num": 119
        },

        {
            "score": 161,
            "ranking": 370930,
            "num": 122
        },

        {
            "score": 160,
            "ranking": 371027,
            "num": 97
        },

        {
            "score": 159,
            "ranking": 371119,
            "num": 92
        },

        {
            "score": 158,
            "ranking": 371217,
            "num": 98
        },

        {
            "score": 157,
            "ranking": 371300,
            "num": 83
        },

        {
            "score": 156,
            "ranking": 371392,
            "num": 92
        },

        {
            "score": 155,
            "ranking": 371476,
            "num": 84
        },

        {
            "score": 154,
            "ranking": 371560,
            "num": 84
        },

        {
            "score": 153,
            "ranking": 371641,
            "num": 81
        },

        {
            "score": 152,
            "ranking": 371705,
            "num": 64
        },

        {
            "score": 151,
            "ranking": 371786,
            "num": 81
        },

        {
            "score": 150,
            "ranking": 371860,
            "num": 74
        },

        {
            "score": 149,
            "ranking": 371921,
            "num": 61
        },

        {
            "score": 148,
            "ranking": 371996,
            "num": 75
        },

        {
            "score": 147,
            "ranking": 372062,
            "num": 66
        },

        {
            "score": 146,
            "ranking": 372126,
            "num": 64
        },

        {
            "score": 145,
            "ranking": 372202,
            "num": 76
        },

        {
            "score": 144,
            "ranking": 372253,
            "num": 51
        },

        {
            "score": 143,
            "ranking": 372308,
            "num": 55
        },

        {
            "score": 142,
            "ranking": 372348,
            "num": 40
        },

        {
            "score": 141,
            "ranking": 372400,
            "num": 52
        },

        {
            "score": 140,
            "ranking": 372448,
            "num": 48
        },

        {
            "score": 139,
            "ranking": 372495,
            "num": 47
        },

        {
            "score": 138,
            "ranking": 372542,
            "num": 47
        },

        {
            "score": 137,
            "ranking": 372582,
            "num": 40
        },

        {
            "score": 136,
            "ranking": 372620,
            "num": 38
        },

        {
            "score": 135,
            "ranking": 372659,
            "num": 39
        },

        {
            "score": 134,
            "ranking": 372691,
            "num": 32
        },

        {
            "score": 133,
            "ranking": 372727,
            "num": 36
        },

        {
            "score": 132,
            "ranking": 372755,
            "num": 28
        },

        {
            "score": 131,
            "ranking": 372781,
            "num": 26
        },

        {
            "score": 130,
            "ranking": 372811,
            "num": 30
        },

        {
            "score": 129,
            "ranking": 372837,
            "num": 26
        },

        {
            "score": 128,
            "ranking": 372872,
            "num": 35
        },

        {
            "score": 127,
            "ranking": 372893,
            "num": 21
        },

        {
            "score": 126,
            "ranking": 372915,
            "num": 22
        }
    ]
}